import { openBlock as l, createElementBlock as c, withModifiers as Ke, renderSlot as H, normalizeClass as G, createCommentVNode as v, createElementVNode as p, toDisplayString as U, resolveComponent as b, createBlock as F, withCtx as C, createVNode as D, defineComponent as ke, Fragment as te, renderList as oe, createTextVNode as B, withDirectives as Ye, vModelCheckbox as Ta, reactive as Pl, vShow as ki, resolveDynamicComponent as Et, createSlots as Ml, normalizeProps as Bo, mergeProps as Pn, vModelRadio as Nl, nextTick as yi, h as Ia, vModelText as Lo, resolveDirective as Ui, ref as me, computed as Pe, defineAsyncComponent as Da, isRef as Ki, unref as ie, toRaw as mo, normalizeStyle as Ei, guardReactiveProps as Oa, useModel as Bl, mergeModels as Ll, toRefs as Mn, onMounted as _a, Teleport as xl, getCurrentScope as ql, onScopeDispose as Vl, createStaticVNode as jl, watch as bi, onBeforeMount as Hl, onBeforeUnmount as Gl } from "vue";
import { RouterLink as Ql } from "vue-router";
function Pa(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: $l } = Object.prototype, { getPrototypeOf: xo } = Object, { iterator: Si, toStringTag: Ma } = Symbol, Ti = /* @__PURE__ */ ((e) => (n) => {
  const t = $l.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Kt = (e) => (e = e.toLowerCase(), (n) => Ti(n) === e), Ii = (e) => (n) => typeof n === e, { isArray: pn } = Array, rn = Ii("undefined");
function Nn(e) {
  return e !== null && !rn(e) && e.constructor !== null && !rn(e.constructor) && Qe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Na = Kt("ArrayBuffer");
function Jl(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Na(e.buffer), n;
}
const zl = Ii("string"), Qe = Ii("function"), Ba = Ii("number"), Bn = (e) => e !== null && typeof e == "object", Yl = (e) => e === !0 || e === !1, si = (e) => {
  if (Ti(e) !== "object")
    return !1;
  const n = xo(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Ma in e) && !(Si in e);
}, Wl = (e) => {
  if (!Bn(e) || Nn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Xl = Kt("Date"), Zl = Kt("File"), eu = (e) => !!(e && typeof e.uri < "u"), tu = (e) => e && typeof e.getParts < "u", nu = Kt("Blob"), iu = Kt("FileList"), ou = (e) => Bn(e) && Qe(e.pipe);
function ru() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Fr = ru(), Rr = typeof Fr.FormData < "u" ? Fr.FormData : void 0, au = (e) => {
  let n;
  return e && (Rr && e instanceof Rr || Qe(e.append) && ((n = Ti(e)) === "formdata" || // detect form-data instance
  n === "object" && Qe(e.toString) && e.toString() === "[object FormData]"));
}, su = Kt("URLSearchParams"), [lu, uu, du, cu] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Kt), fu = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ln(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, i;
  if (typeof e != "object" && (e = [e]), pn(e))
    for (o = 0, i = e.length; o < i; o++)
      n.call(null, e[o], o, e);
  else {
    if (Nn(e))
      return;
    const r = t ? Object.getOwnPropertyNames(e) : Object.keys(e), a = r.length;
    let s;
    for (o = 0; o < a; o++)
      s = r[o], n.call(null, e[s], s, e);
  }
}
function La(e, n) {
  if (Nn(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let o = t.length, i;
  for (; o-- > 0; )
    if (i = t[o], n === i.toLowerCase())
      return i;
  return null;
}
const Bt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, xa = (e) => !rn(e) && e !== Bt;
function Ao() {
  const { caseless: e, skipUndefined: n } = xa(this) && this || {}, t = {}, o = (i, r) => {
    if (r === "__proto__" || r === "constructor" || r === "prototype")
      return;
    const a = e && La(t, r) || r;
    si(t[a]) && si(i) ? t[a] = Ao(t[a], i) : si(i) ? t[a] = Ao({}, i) : pn(i) ? t[a] = i.slice() : (!n || !rn(i)) && (t[a] = i);
  };
  for (let i = 0, r = arguments.length; i < r; i++)
    arguments[i] && Ln(arguments[i], o);
  return t;
}
const pu = (e, n, t, { allOwnKeys: o } = {}) => (Ln(
  n,
  (i, r) => {
    t && Qe(i) ? Object.defineProperty(e, r, {
      value: Pa(i, t),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, r, {
      value: i,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: o }
), e), hu = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), mu = (e, n, t, o) => {
  e.prototype = Object.create(n.prototype, o), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, Au = (e, n, t, o) => {
  let i, r, a;
  const s = {};
  if (n = n || {}, e == null) return n;
  do {
    for (i = Object.getOwnPropertyNames(e), r = i.length; r-- > 0; )
      a = i[r], (!o || o(a, e, n)) && !s[a] && (n[a] = e[a], s[a] = !0);
    e = t !== !1 && xo(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, gu = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const o = e.indexOf(n, t);
  return o !== -1 && o === t;
}, yu = (e) => {
  if (!e) return null;
  if (pn(e)) return e;
  let n = e.length;
  if (!Ba(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, Ku = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && xo(Uint8Array)), bu = (e, n) => {
  const o = (e && e[Si]).call(e);
  let i;
  for (; (i = o.next()) && !i.done; ) {
    const r = i.value;
    n.call(e, r[0], r[1]);
  }
}, vu = (e, n) => {
  let t;
  const o = [];
  for (; (t = e.exec(n)) !== null; )
    o.push(t);
  return o;
}, Cu = Kt("HTMLFormElement"), wu = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, o, i) {
  return o.toUpperCase() + i;
}), kr = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), Fu = Kt("RegExp"), qa = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), o = {};
  Ln(t, (i, r) => {
    let a;
    (a = n(i, r, e)) !== !1 && (o[r] = a || i);
  }), Object.defineProperties(e, o);
}, Ru = (e) => {
  qa(e, (n, t) => {
    if (Qe(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const o = e[t];
    if (Qe(o)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, ku = (e, n) => {
  const t = {}, o = (i) => {
    i.forEach((r) => {
      t[r] = !0;
    });
  };
  return pn(e) ? o(e) : o(String(e).split(n)), t;
}, Uu = () => {
}, Eu = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function Su(e) {
  return !!(e && Qe(e.append) && e[Ma] === "FormData" && e[Si]);
}
const Tu = (e) => {
  const n = new Array(10), t = (o, i) => {
    if (Bn(o)) {
      if (n.indexOf(o) >= 0)
        return;
      if (Nn(o))
        return o;
      if (!("toJSON" in o)) {
        n[i] = o;
        const r = pn(o) ? [] : {};
        return Ln(o, (a, s) => {
          const u = t(a, i + 1);
          !rn(u) && (r[s] = u);
        }), n[i] = void 0, r;
      }
    }
    return o;
  };
  return t(e, 0);
}, Iu = Kt("AsyncFunction"), Du = (e) => e && (Bn(e) || Qe(e)) && Qe(e.then) && Qe(e.catch), Va = ((e, n) => e ? setImmediate : n ? ((t, o) => (Bt.addEventListener(
  "message",
  ({ source: i, data: r }) => {
    i === Bt && r === t && o.length && o.shift()();
  },
  !1
), (i) => {
  o.push(i), Bt.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(typeof setImmediate == "function", Qe(Bt.postMessage)), Ou = typeof queueMicrotask < "u" ? queueMicrotask.bind(Bt) : typeof process < "u" && process.nextTick || Va, _u = (e) => e != null && Qe(e[Si]), T = {
  isArray: pn,
  isArrayBuffer: Na,
  isBuffer: Nn,
  isFormData: au,
  isArrayBufferView: Jl,
  isString: zl,
  isNumber: Ba,
  isBoolean: Yl,
  isObject: Bn,
  isPlainObject: si,
  isEmptyObject: Wl,
  isReadableStream: lu,
  isRequest: uu,
  isResponse: du,
  isHeaders: cu,
  isUndefined: rn,
  isDate: Xl,
  isFile: Zl,
  isReactNativeBlob: eu,
  isReactNative: tu,
  isBlob: nu,
  isRegExp: Fu,
  isFunction: Qe,
  isStream: ou,
  isURLSearchParams: su,
  isTypedArray: Ku,
  isFileList: iu,
  forEach: Ln,
  merge: Ao,
  extend: pu,
  trim: fu,
  stripBOM: hu,
  inherits: mu,
  toFlatObject: Au,
  kindOf: Ti,
  kindOfTest: Kt,
  endsWith: gu,
  toArray: yu,
  forEachEntry: bu,
  matchAll: vu,
  isHTMLForm: Cu,
  hasOwnProperty: kr,
  hasOwnProp: kr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: qa,
  freezeMethods: Ru,
  toObjectSet: ku,
  toCamelCase: wu,
  noop: Uu,
  toFiniteNumber: Eu,
  findKey: La,
  global: Bt,
  isContextDefined: xa,
  isSpecCompliantForm: Su,
  toJSONObject: Tu,
  isAsyncFn: Iu,
  isThenable: Du,
  setImmediate: Va,
  asap: Ou,
  isIterable: _u
};
let ae = class ja extends Error {
  static from(n, t, o, i, r, a) {
    const s = new ja(n.message, t || n.code, o, i, r);
    return s.cause = n, s.name = n.name, n.status != null && s.status == null && (s.status = n.status), a && Object.assign(s, a), s;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, t, o, i, r) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), o && (this.config = o), i && (this.request = i), r && (this.response = r, this.status = r.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: T.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
ae.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
ae.ERR_BAD_OPTION = "ERR_BAD_OPTION";
ae.ECONNABORTED = "ECONNABORTED";
ae.ETIMEDOUT = "ETIMEDOUT";
ae.ERR_NETWORK = "ERR_NETWORK";
ae.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
ae.ERR_DEPRECATED = "ERR_DEPRECATED";
ae.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
ae.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
ae.ERR_CANCELED = "ERR_CANCELED";
ae.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
ae.ERR_INVALID_URL = "ERR_INVALID_URL";
const Pu = null;
function go(e) {
  return T.isPlainObject(e) || T.isArray(e);
}
function Ha(e) {
  return T.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function $i(e, n, t) {
  return e ? e.concat(n).map(function(i, r) {
    return i = Ha(i), !t && r ? "[" + i + "]" : i;
  }).join(t ? "." : "") : n;
}
function Mu(e) {
  return T.isArray(e) && !e.some(go);
}
const Nu = T.toFlatObject(T, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Di(e, n, t) {
  if (!T.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = T.toFlatObject(
    t,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(m, g) {
      return !T.isUndefined(g[m]);
    }
  );
  const o = t.metaTokens, i = t.visitor || f, r = t.dots, a = t.indexes, u = (t.Blob || typeof Blob < "u" && Blob) && T.isSpecCompliantForm(n);
  if (!T.isFunction(i))
    throw new TypeError("visitor must be a function");
  function d(y) {
    if (y === null) return "";
    if (T.isDate(y))
      return y.toISOString();
    if (T.isBoolean(y))
      return y.toString();
    if (!u && T.isBlob(y))
      throw new ae("Blob is not supported. Use a Buffer instead.");
    return T.isArrayBuffer(y) || T.isTypedArray(y) ? u && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function f(y, m, g) {
    let I = y;
    if (T.isReactNative(n) && T.isReactNativeBlob(y))
      return n.append($i(g, m, r), d(y)), !1;
    if (y && !g && typeof y == "object") {
      if (T.endsWith(m, "{}"))
        m = o ? m : m.slice(0, -2), y = JSON.stringify(y);
      else if (T.isArray(y) && Mu(y) || (T.isFileList(y) || T.endsWith(m, "[]")) && (I = T.toArray(y)))
        return m = Ha(m), I.forEach(function(E, _) {
          !(T.isUndefined(E) || E === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? $i([m], _, r) : a === null ? m : m + "[]",
            d(E)
          );
        }), !1;
    }
    return go(y) ? !0 : (n.append($i(g, m, r), d(y)), !1);
  }
  const K = [], w = Object.assign(Nu, {
    defaultVisitor: f,
    convertValue: d,
    isVisitable: go
  });
  function k(y, m) {
    if (!T.isUndefined(y)) {
      if (K.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      K.push(y), T.forEach(y, function(I, x) {
        (!(T.isUndefined(I) || I === null) && i.call(n, I, T.isString(x) ? x.trim() : x, m, w)) === !0 && k(I, m ? m.concat(x) : [x]);
      }), K.pop();
    }
  }
  if (!T.isObject(e))
    throw new TypeError("data must be an object");
  return k(e), n;
}
function Ur(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return n[o];
  });
}
function qo(e, n) {
  this._pairs = [], e && Di(e, this, n);
}
const Ga = qo.prototype;
Ga.append = function(n, t) {
  this._pairs.push([n, t]);
};
Ga.toString = function(n) {
  const t = n ? function(o) {
    return n.call(this, o, Ur);
  } : Ur;
  return this._pairs.map(function(i) {
    return t(i[0]) + "=" + t(i[1]);
  }, "").join("&");
};
function Bu(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Qa(e, n, t) {
  if (!n)
    return e;
  const o = t && t.encode || Bu, i = T.isFunction(t) ? {
    serialize: t
  } : t, r = i && i.serialize;
  let a;
  if (r ? a = r(n, i) : a = T.isURLSearchParams(n) ? n.toString() : new qo(n, i).toString(o), a) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Er {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, o) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    T.forEach(this.handlers, function(o) {
      o !== null && n(o);
    });
  }
}
const Vo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, Lu = typeof URLSearchParams < "u" ? URLSearchParams : qo, xu = typeof FormData < "u" ? FormData : null, qu = typeof Blob < "u" ? Blob : null, Vu = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Lu,
    FormData: xu,
    Blob: qu
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, jo = typeof window < "u" && typeof document < "u", yo = typeof navigator == "object" && navigator || void 0, ju = jo && (!yo || ["ReactNative", "NativeScript", "NS"].indexOf(yo.product) < 0), Hu = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Gu = jo && window.location.href || "http://localhost", Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: jo,
  hasStandardBrowserEnv: ju,
  hasStandardBrowserWebWorkerEnv: Hu,
  navigator: yo,
  origin: Gu
}, Symbol.toStringTag, { value: "Module" })), qe = {
  ...Qu,
  ...Vu
};
function $u(e, n) {
  return Di(e, new qe.classes.URLSearchParams(), {
    visitor: function(t, o, i, r) {
      return qe.isNode && T.isBuffer(t) ? (this.append(o, t.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function Ju(e) {
  return T.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function zu(e) {
  const n = {}, t = Object.keys(e);
  let o;
  const i = t.length;
  let r;
  for (o = 0; o < i; o++)
    r = t[o], n[r] = e[r];
  return n;
}
function $a(e) {
  function n(t, o, i, r) {
    let a = t[r++];
    if (a === "__proto__") return !0;
    const s = Number.isFinite(+a), u = r >= t.length;
    return a = !a && T.isArray(i) ? i.length : a, u ? (T.hasOwnProp(i, a) ? i[a] = [i[a], o] : i[a] = o, !s) : ((!i[a] || !T.isObject(i[a])) && (i[a] = []), n(t, o, i[a], r) && T.isArray(i[a]) && (i[a] = zu(i[a])), !s);
  }
  if (T.isFormData(e) && T.isFunction(e.entries)) {
    const t = {};
    return T.forEachEntry(e, (o, i) => {
      n(Ju(o), i, t, 0);
    }), t;
  }
  return null;
}
function Yu(e, n, t) {
  if (T.isString(e))
    try {
      return (n || JSON.parse)(e), T.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (t || JSON.stringify)(e);
}
const xn = {
  transitional: Vo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, t) {
      const o = t.getContentType() || "", i = o.indexOf("application/json") > -1, r = T.isObject(n);
      if (r && T.isHTMLForm(n) && (n = new FormData(n)), T.isFormData(n))
        return i ? JSON.stringify($a(n)) : n;
      if (T.isArrayBuffer(n) || T.isBuffer(n) || T.isStream(n) || T.isFile(n) || T.isBlob(n) || T.isReadableStream(n))
        return n;
      if (T.isArrayBufferView(n))
        return n.buffer;
      if (T.isURLSearchParams(n))
        return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let s;
      if (r) {
        if (o.indexOf("application/x-www-form-urlencoded") > -1)
          return $u(n, this.formSerializer).toString();
        if ((s = T.isFileList(n)) || o.indexOf("multipart/form-data") > -1) {
          const u = this.env && this.env.FormData;
          return Di(
            s ? { "files[]": n } : n,
            u && new u(),
            this.formSerializer
          );
        }
      }
      return r || i ? (t.setContentType("application/json", !1), Yu(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const t = this.transitional || xn.transitional, o = t && t.forcedJSONParsing, i = this.responseType === "json";
      if (T.isResponse(n) || T.isReadableStream(n))
        return n;
      if (n && T.isString(n) && (o && !this.responseType || i)) {
        const a = !(t && t.silentJSONParsing) && i;
        try {
          return JSON.parse(n, this.parseReviver);
        } catch (s) {
          if (a)
            throw s.name === "SyntaxError" ? ae.from(s, ae.ERR_BAD_RESPONSE, this, null, this.response) : s;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: qe.classes.FormData,
    Blob: qe.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
T.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  xn.headers[e] = {};
});
const Wu = T.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Xu = (e) => {
  const n = {};
  let t, o, i;
  return e && e.split(`
`).forEach(function(a) {
    i = a.indexOf(":"), t = a.substring(0, i).trim().toLowerCase(), o = a.substring(i + 1).trim(), !(!t || n[t] && Wu[t]) && (t === "set-cookie" ? n[t] ? n[t].push(o) : n[t] = [o] : n[t] = n[t] ? n[t] + ", " + o : o);
  }), n;
}, Sr = /* @__PURE__ */ Symbol("internals"), Zu = (e) => !/[\r\n]/.test(e);
function Ja(e, n) {
  if (!(e === !1 || e == null)) {
    if (T.isArray(e)) {
      e.forEach((t) => Ja(t, n));
      return;
    }
    if (!Zu(String(e)))
      throw new Error(`Invalid character in header content ["${n}"]`);
  }
}
function vn(e) {
  return e && String(e).trim().toLowerCase();
}
function ed(e) {
  let n = e.length;
  for (; n > 0; ) {
    const t = e.charCodeAt(n - 1);
    if (t !== 10 && t !== 13)
      break;
    n -= 1;
  }
  return n === e.length ? e : e.slice(0, n);
}
function li(e) {
  return e === !1 || e == null ? e : T.isArray(e) ? e.map(li) : ed(String(e));
}
function td(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = t.exec(e); )
    n[o[1]] = o[2];
  return n;
}
const nd = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ji(e, n, t, o, i) {
  if (T.isFunction(o))
    return o.call(this, n, t);
  if (i && (n = t), !!T.isString(n)) {
    if (T.isString(o))
      return n.indexOf(o) !== -1;
    if (T.isRegExp(o))
      return o.test(n);
  }
}
function id(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, o) => t.toUpperCase() + o);
}
function od(e, n) {
  const t = T.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + t, {
      value: function(i, r, a) {
        return this[o].call(this, n, i, r, a);
      },
      configurable: !0
    });
  });
}
let $e = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, o) {
    const i = this;
    function r(s, u, d) {
      const f = vn(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const K = T.findKey(i, f);
      (!K || i[K] === void 0 || d === !0 || d === void 0 && i[K] !== !1) && (Ja(s, u), i[K || u] = li(s));
    }
    const a = (s, u) => T.forEach(s, (d, f) => r(d, f, u));
    if (T.isPlainObject(n) || n instanceof this.constructor)
      a(n, t);
    else if (T.isString(n) && (n = n.trim()) && !nd(n))
      a(Xu(n), t);
    else if (T.isObject(n) && T.isIterable(n)) {
      let s = {}, u, d;
      for (const f of n) {
        if (!T.isArray(f))
          throw TypeError("Object iterator must return a key-value pair");
        s[d = f[0]] = (u = s[d]) ? T.isArray(u) ? [...u, f[1]] : [u, f[1]] : f[1];
      }
      a(s, t);
    } else
      n != null && r(t, n, o);
    return this;
  }
  get(n, t) {
    if (n = vn(n), n) {
      const o = T.findKey(this, n);
      if (o) {
        const i = this[o];
        if (!t)
          return i;
        if (t === !0)
          return td(i);
        if (T.isFunction(t))
          return t.call(this, i, o);
        if (T.isRegExp(t))
          return t.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = vn(n), n) {
      const o = T.findKey(this, n);
      return !!(o && this[o] !== void 0 && (!t || Ji(this, this[o], o, t)));
    }
    return !1;
  }
  delete(n, t) {
    const o = this;
    let i = !1;
    function r(a) {
      if (a = vn(a), a) {
        const s = T.findKey(o, a);
        s && (!t || Ji(o, o[s], s, t)) && (delete o[s], i = !0);
      }
    }
    return T.isArray(n) ? n.forEach(r) : r(n), i;
  }
  clear(n) {
    const t = Object.keys(this);
    let o = t.length, i = !1;
    for (; o--; ) {
      const r = t[o];
      (!n || Ji(this, this[r], r, n, !0)) && (delete this[r], i = !0);
    }
    return i;
  }
  normalize(n) {
    const t = this, o = {};
    return T.forEach(this, (i, r) => {
      const a = T.findKey(o, r);
      if (a) {
        t[a] = li(i), delete t[r];
        return;
      }
      const s = n ? id(r) : String(r).trim();
      s !== r && delete t[r], t[s] = li(i), o[s] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return T.forEach(this, (o, i) => {
      o != null && o !== !1 && (t[i] = n && T.isArray(o) ? o.join(", ") : o);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const o = new this(n);
    return t.forEach((i) => o.set(i)), o;
  }
  static accessor(n) {
    const o = (this[Sr] = this[Sr] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function r(a) {
      const s = vn(a);
      o[s] || (od(i, a), o[s] = !0);
    }
    return T.isArray(n) ? n.forEach(r) : r(n), this;
  }
};
$e.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
T.reduceDescriptors($e.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(o) {
      this[t] = o;
    }
  };
});
T.freezeMethods($e);
function zi(e, n) {
  const t = this || xn, o = n || t, i = $e.from(o.headers);
  let r = o.data;
  return T.forEach(e, function(s) {
    r = s.call(t, r, i.normalize(), n ? n.status : void 0);
  }), i.normalize(), r;
}
function za(e) {
  return !!(e && e.__CANCEL__);
}
let qn = class extends ae {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, t, o) {
    super(n ?? "canceled", ae.ERR_CANCELED, t, o), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Ya(e, n, t) {
  const o = t.config.validateStatus;
  !t.status || !o || o(t.status) ? e(t) : n(
    new ae(
      "Request failed with status code " + t.status,
      [ae.ERR_BAD_REQUEST, ae.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
      t.config,
      t.request,
      t
    )
  );
}
function rd(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function ad(e, n) {
  e = e || 10;
  const t = new Array(e), o = new Array(e);
  let i = 0, r = 0, a;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const d = Date.now(), f = o[r];
    a || (a = d), t[i] = u, o[i] = d;
    let K = r, w = 0;
    for (; K !== i; )
      w += t[K++], K = K % e;
    if (i = (i + 1) % e, i === r && (r = (r + 1) % e), d - a < n)
      return;
    const k = f && d - f;
    return k ? Math.round(w * 1e3 / k) : void 0;
  };
}
function sd(e, n) {
  let t = 0, o = 1e3 / n, i, r;
  const a = (d, f = Date.now()) => {
    t = f, i = null, r && (clearTimeout(r), r = null), e(...d);
  };
  return [(...d) => {
    const f = Date.now(), K = f - t;
    K >= o ? a(d, f) : (i = d, r || (r = setTimeout(() => {
      r = null, a(i);
    }, o - K)));
  }, () => i && a(i)];
}
const vi = (e, n, t = 3) => {
  let o = 0;
  const i = ad(50, 250);
  return sd((r) => {
    const a = r.loaded, s = r.lengthComputable ? r.total : void 0, u = a - o, d = i(u), f = a <= s;
    o = a;
    const K = {
      loaded: a,
      total: s,
      progress: s ? a / s : void 0,
      bytes: u,
      rate: d || void 0,
      estimated: d && s && f ? (s - a) / d : void 0,
      event: r,
      lengthComputable: s != null,
      [n ? "download" : "upload"]: !0
    };
    e(K);
  }, t);
}, Tr = (e, n) => {
  const t = e != null;
  return [
    (o) => n[0]({
      lengthComputable: t,
      total: e,
      loaded: o
    }),
    n[1]
  ];
}, Ir = (e) => (...n) => T.asap(() => e(...n)), ld = qe.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, qe.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(qe.origin),
  qe.navigator && /(msie|trident)/i.test(qe.navigator.userAgent)
) : () => !0, ud = qe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, o, i, r, a) {
      if (typeof document > "u") return;
      const s = [`${e}=${encodeURIComponent(n)}`];
      T.isNumber(t) && s.push(`expires=${new Date(t).toUTCString()}`), T.isString(o) && s.push(`path=${o}`), T.isString(i) && s.push(`domain=${i}`), r === !0 && s.push("secure"), T.isString(a) && s.push(`SameSite=${a}`), document.cookie = s.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function dd(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cd(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Wa(e, n, t) {
  let o = !dd(n);
  return e && (o || t == !1) ? cd(e, n) : n;
}
const Dr = (e) => e instanceof $e ? { ...e } : e;
function Vt(e, n) {
  n = n || {};
  const t = {};
  function o(d, f, K, w) {
    return T.isPlainObject(d) && T.isPlainObject(f) ? T.merge.call({ caseless: w }, d, f) : T.isPlainObject(f) ? T.merge({}, f) : T.isArray(f) ? f.slice() : f;
  }
  function i(d, f, K, w) {
    if (T.isUndefined(f)) {
      if (!T.isUndefined(d))
        return o(void 0, d, K, w);
    } else return o(d, f, K, w);
  }
  function r(d, f) {
    if (!T.isUndefined(f))
      return o(void 0, f);
  }
  function a(d, f) {
    if (T.isUndefined(f)) {
      if (!T.isUndefined(d))
        return o(void 0, d);
    } else return o(void 0, f);
  }
  function s(d, f, K) {
    if (K in n)
      return o(d, f);
    if (K in e)
      return o(void 0, d);
  }
  const u = {
    url: r,
    method: r,
    data: r,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (d, f, K) => i(Dr(d), Dr(f), K, !0)
  };
  return T.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const K = T.hasOwnProp(u, f) ? u[f] : i, w = K(e[f], n[f], f);
    T.isUndefined(w) && K !== s || (t[f] = w);
  }), t;
}
const Xa = (e) => {
  const n = Vt({}, e);
  let { data: t, withXSRFToken: o, xsrfHeaderName: i, xsrfCookieName: r, headers: a, auth: s } = n;
  if (n.headers = a = $e.from(a), n.url = Qa(
    Wa(n.baseURL, n.url, n.allowAbsoluteUrls),
    e.params,
    e.paramsSerializer
  ), s && a.set(
    "Authorization",
    "Basic " + btoa(
      (s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : "")
    )
  ), T.isFormData(t)) {
    if (qe.hasStandardBrowserEnv || qe.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if (T.isFunction(t.getHeaders)) {
      const u = t.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(u).forEach(([f, K]) => {
        d.includes(f.toLowerCase()) && a.set(f, K);
      });
    }
  }
  if (qe.hasStandardBrowserEnv && (o && T.isFunction(o) && (o = o(n)), o || o !== !1 && ld(n.url))) {
    const u = i && r && ud.read(r);
    u && a.set(i, u);
  }
  return n;
}, fd = typeof XMLHttpRequest < "u", pd = fd && function(e) {
  return new Promise(function(t, o) {
    const i = Xa(e);
    let r = i.data;
    const a = $e.from(i.headers).normalize();
    let { responseType: s, onUploadProgress: u, onDownloadProgress: d } = i, f, K, w, k, y;
    function m() {
      k && k(), y && y(), i.cancelToken && i.cancelToken.unsubscribe(f), i.signal && i.signal.removeEventListener("abort", f);
    }
    let g = new XMLHttpRequest();
    g.open(i.method.toUpperCase(), i.url, !0), g.timeout = i.timeout;
    function I() {
      if (!g)
        return;
      const E = $e.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), q = {
        data: !s || s === "text" || s === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: E,
        config: e,
        request: g
      };
      Ya(
        function(L) {
          t(L), m();
        },
        function(L) {
          o(L), m();
        },
        q
      ), g = null;
    }
    "onloadend" in g ? g.onloadend = I : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(I);
    }, g.onabort = function() {
      g && (o(new ae("Request aborted", ae.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function(_) {
      const q = _ && _.message ? _.message : "Network Error", V = new ae(q, ae.ERR_NETWORK, e, g);
      V.event = _ || null, o(V), g = null;
    }, g.ontimeout = function() {
      let _ = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const q = i.transitional || Vo;
      i.timeoutErrorMessage && (_ = i.timeoutErrorMessage), o(
        new ae(
          _,
          q.clarifyTimeoutError ? ae.ETIMEDOUT : ae.ECONNABORTED,
          e,
          g
        )
      ), g = null;
    }, r === void 0 && a.setContentType(null), "setRequestHeader" in g && T.forEach(a.toJSON(), function(_, q) {
      g.setRequestHeader(q, _);
    }), T.isUndefined(i.withCredentials) || (g.withCredentials = !!i.withCredentials), s && s !== "json" && (g.responseType = i.responseType), d && ([w, y] = vi(d, !0), g.addEventListener("progress", w)), u && g.upload && ([K, k] = vi(u), g.upload.addEventListener("progress", K), g.upload.addEventListener("loadend", k)), (i.cancelToken || i.signal) && (f = (E) => {
      g && (o(!E || E.type ? new qn(null, e, g) : E), g.abort(), g = null);
    }, i.cancelToken && i.cancelToken.subscribe(f), i.signal && (i.signal.aborted ? f() : i.signal.addEventListener("abort", f)));
    const x = rd(i.url);
    if (x && qe.protocols.indexOf(x) === -1) {
      o(
        new ae(
          "Unsupported protocol " + x + ":",
          ae.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    g.send(r || null);
  });
}, hd = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let o = new AbortController(), i;
    const r = function(d) {
      if (!i) {
        i = !0, s();
        const f = d instanceof Error ? d : this.reason;
        o.abort(
          f instanceof ae ? f : new qn(f instanceof Error ? f.message : f)
        );
      }
    };
    let a = n && setTimeout(() => {
      a = null, r(new ae(`timeout of ${n}ms exceeded`, ae.ETIMEDOUT));
    }, n);
    const s = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(r) : d.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", r));
    const { signal: u } = o;
    return u.unsubscribe = () => T.asap(s), u;
  }
}, md = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let o = 0, i;
  for (; o < t; )
    i = o + n, yield e.slice(o, i), o = i;
}, Ad = async function* (e, n) {
  for await (const t of gd(e))
    yield* md(t, n);
}, gd = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: o } = await n.read();
      if (t)
        break;
      yield o;
    }
  } finally {
    await n.cancel();
  }
}, Or = (e, n, t, o) => {
  const i = Ad(e, n);
  let r = 0, a, s = (u) => {
    a || (a = !0, o && o(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: d, value: f } = await i.next();
          if (d) {
            s(), u.close();
            return;
          }
          let K = f.byteLength;
          if (t) {
            let w = r += K;
            t(w);
          }
          u.enqueue(new Uint8Array(f));
        } catch (d) {
          throw s(d), d;
        }
      },
      cancel(u) {
        return s(u), i.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, _r = 64 * 1024, { isFunction: ei } = T, yd = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(T.global), { ReadableStream: Pr, TextEncoder: Mr } = T.global, Nr = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, Kd = (e) => {
  e = T.merge.call(
    {
      skipUndefined: !0
    },
    yd,
    e
  );
  const { fetch: n, Request: t, Response: o } = e, i = n ? ei(n) : typeof fetch == "function", r = ei(t), a = ei(o);
  if (!i)
    return !1;
  const s = i && ei(Pr), u = i && (typeof Mr == "function" ? /* @__PURE__ */ ((y) => (m) => y.encode(m))(new Mr()) : async (y) => new Uint8Array(await new t(y).arrayBuffer())), d = r && s && Nr(() => {
    let y = !1;
    const m = new Pr(), g = new t(qe.origin, {
      body: m,
      method: "POST",
      get duplex() {
        return y = !0, "half";
      }
    }).headers.has("Content-Type");
    return m.cancel(), y && !g;
  }), f = a && s && Nr(() => T.isReadableStream(new o("").body)), K = {
    stream: f && ((y) => y.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((y) => {
    !K[y] && (K[y] = (m, g) => {
      let I = m && m[y];
      if (I)
        return I.call(m);
      throw new ae(
        `Response type '${y}' is not supported`,
        ae.ERR_NOT_SUPPORT,
        g
      );
    });
  });
  const w = async (y) => {
    if (y == null)
      return 0;
    if (T.isBlob(y))
      return y.size;
    if (T.isSpecCompliantForm(y))
      return (await new t(qe.origin, {
        method: "POST",
        body: y
      }).arrayBuffer()).byteLength;
    if (T.isArrayBufferView(y) || T.isArrayBuffer(y))
      return y.byteLength;
    if (T.isURLSearchParams(y) && (y = y + ""), T.isString(y))
      return (await u(y)).byteLength;
  }, k = async (y, m) => {
    const g = T.toFiniteNumber(y.getContentLength());
    return g ?? w(m);
  };
  return async (y) => {
    let {
      url: m,
      method: g,
      data: I,
      signal: x,
      cancelToken: E,
      timeout: _,
      onDownloadProgress: q,
      onUploadProgress: V,
      responseType: L,
      headers: $,
      withCredentials: J = "same-origin",
      fetchOptions: W
    } = Xa(y), se = n || fetch;
    L = L ? (L + "").toLowerCase() : "text";
    let fe = hd(
      [x, E && E.toAbortSignal()],
      _
    ), j = null;
    const ye = fe && fe.unsubscribe && (() => {
      fe.unsubscribe();
    });
    let S;
    try {
      if (V && d && g !== "get" && g !== "head" && (S = await k($, I)) !== 0) {
        let Ee = new t(m, {
          method: "POST",
          body: I,
          duplex: "half"
        }), De;
        if (T.isFormData(I) && (De = Ee.headers.get("content-type")) && $.setContentType(De), Ee.body) {
          const [Be, be] = Tr(
            S,
            vi(Ir(V))
          );
          I = Or(Ee.body, _r, Be, be);
        }
      }
      T.isString(J) || (J = J ? "include" : "omit");
      const M = r && "credentials" in t.prototype, ee = {
        ...W,
        signal: fe,
        method: g.toUpperCase(),
        headers: $.normalize().toJSON(),
        body: I,
        duplex: "half",
        credentials: M ? J : void 0
      };
      j = r && new t(m, ee);
      let re = await (r ? se(j, W) : se(m, ee));
      const Ae = f && (L === "stream" || L === "response");
      if (f && (q || Ae && ye)) {
        const Ee = {};
        ["status", "statusText", "headers"].forEach((we) => {
          Ee[we] = re[we];
        });
        const De = T.toFiniteNumber(re.headers.get("content-length")), [Be, be] = q && Tr(
          De,
          vi(Ir(q), !0)
        ) || [];
        re = new o(
          Or(re.body, _r, Be, () => {
            be && be(), ye && ye();
          }),
          Ee
        );
      }
      L = L || "text";
      let ue = await K[T.findKey(K, L) || "text"](
        re,
        y
      );
      return !Ae && ye && ye(), await new Promise((Ee, De) => {
        Ya(Ee, De, {
          data: ue,
          headers: $e.from(re.headers),
          status: re.status,
          statusText: re.statusText,
          config: y,
          request: j
        });
      });
    } catch (M) {
      throw ye && ye(), M && M.name === "TypeError" && /Load failed|fetch/i.test(M.message) ? Object.assign(
        new ae(
          "Network Error",
          ae.ERR_NETWORK,
          y,
          j,
          M && M.response
        ),
        {
          cause: M.cause || M
        }
      ) : ae.from(M, M && M.code, y, j, M && M.response);
    }
  };
}, bd = /* @__PURE__ */ new Map(), Za = (e) => {
  let n = e && e.env || {};
  const { fetch: t, Request: o, Response: i } = n, r = [o, i, t];
  let a = r.length, s = a, u, d, f = bd;
  for (; s--; )
    u = r[s], d = f.get(u), d === void 0 && f.set(u, d = s ? /* @__PURE__ */ new Map() : Kd(n)), f = d;
  return d;
};
Za();
const Ho = {
  http: Pu,
  xhr: pd,
  fetch: {
    get: Za
  }
};
T.forEach(Ho, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Br = (e) => `- ${e}`, vd = (e) => T.isFunction(e) || e === null || e === !1;
function Cd(e, n) {
  e = T.isArray(e) ? e : [e];
  const { length: t } = e;
  let o, i;
  const r = {};
  for (let a = 0; a < t; a++) {
    o = e[a];
    let s;
    if (i = o, !vd(o) && (i = Ho[(s = String(o)).toLowerCase()], i === void 0))
      throw new ae(`Unknown adapter '${s}'`);
    if (i && (T.isFunction(i) || (i = i.get(n))))
      break;
    r[s || "#" + a] = i;
  }
  if (!i) {
    const a = Object.entries(r).map(
      ([u, d]) => `adapter ${u} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let s = t ? a.length > 1 ? `since :
` + a.map(Br).join(`
`) : " " + Br(a[0]) : "as no adapter specified";
    throw new ae(
      "There is no suitable adapter to dispatch the request " + s,
      "ERR_NOT_SUPPORT"
    );
  }
  return i;
}
const es = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Cd,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ho
};
function Yi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new qn(null, e);
}
function Lr(e) {
  return Yi(e), e.headers = $e.from(e.headers), e.data = zi.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), es.getAdapter(e.adapter || xn.adapter, e)(e).then(
    function(o) {
      return Yi(e), o.data = zi.call(e, e.transformResponse, o), o.headers = $e.from(o.headers), o;
    },
    function(o) {
      return za(o) || (Yi(e), o && o.response && (o.response.data = zi.call(
        e,
        e.transformResponse,
        o.response
      ), o.response.headers = $e.from(o.response.headers))), Promise.reject(o);
    }
  );
}
const ts = "1.15.0", Oi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Oi[e] = function(o) {
    return typeof o === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const xr = {};
Oi.transitional = function(n, t, o) {
  function i(r, a) {
    return "[Axios v" + ts + "] Transitional option '" + r + "'" + a + (o ? ". " + o : "");
  }
  return (r, a, s) => {
    if (n === !1)
      throw new ae(
        i(a, " has been removed" + (t ? " in " + t : "")),
        ae.ERR_DEPRECATED
      );
    return t && !xr[a] && (xr[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(r, a, s) : !0;
  };
};
Oi.spelling = function(n) {
  return (t, o) => (console.warn(`${o} is likely a misspelling of ${n}`), !0);
};
function wd(e, n, t) {
  if (typeof e != "object")
    throw new ae("options must be an object", ae.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let i = o.length;
  for (; i-- > 0; ) {
    const r = o[i], a = n[r];
    if (a) {
      const s = e[r], u = s === void 0 || a(s, r, e);
      if (u !== !0)
        throw new ae(
          "option " + r + " must be " + u,
          ae.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (t !== !0)
      throw new ae("Unknown option " + r, ae.ERR_BAD_OPTION);
  }
}
const ui = {
  assertOptions: wd,
  validators: Oi
}, st = ui.validators;
let xt = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Er(),
      response: new Er()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (o) {
      if (o instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const r = (() => {
          if (!i.stack)
            return "";
          const a = i.stack.indexOf(`
`);
          return a === -1 ? "" : i.stack.slice(a + 1);
        })();
        try {
          if (!o.stack)
            o.stack = r;
          else if (r) {
            const a = r.indexOf(`
`), s = a === -1 ? -1 : r.indexOf(`
`, a + 1), u = s === -1 ? "" : r.slice(s + 1);
            String(o.stack).endsWith(u) || (o.stack += `
` + r);
          }
        } catch {
        }
      }
      throw o;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = Vt(this.defaults, t);
    const { transitional: o, paramsSerializer: i, headers: r } = t;
    o !== void 0 && ui.assertOptions(
      o,
      {
        silentJSONParsing: st.transitional(st.boolean),
        forcedJSONParsing: st.transitional(st.boolean),
        clarifyTimeoutError: st.transitional(st.boolean),
        legacyInterceptorReqResOrdering: st.transitional(st.boolean)
      },
      !1
    ), i != null && (T.isFunction(i) ? t.paramsSerializer = {
      serialize: i
    } : ui.assertOptions(
      i,
      {
        encode: st.function,
        serialize: st.function
      },
      !0
    )), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), ui.assertOptions(
      t,
      {
        baseUrl: st.spelling("baseURL"),
        withXsrfToken: st.spelling("withXSRFToken")
      },
      !0
    ), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let a = r && T.merge(r.common, r[t.method]);
    r && T.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (y) => {
      delete r[y];
    }), t.headers = $e.concat(a, r);
    const s = [];
    let u = !0;
    this.interceptors.request.forEach(function(m) {
      if (typeof m.runWhen == "function" && m.runWhen(t) === !1)
        return;
      u = u && m.synchronous;
      const g = t.transitional || Vo;
      g && g.legacyInterceptorReqResOrdering ? s.unshift(m.fulfilled, m.rejected) : s.push(m.fulfilled, m.rejected);
    });
    const d = [];
    this.interceptors.response.forEach(function(m) {
      d.push(m.fulfilled, m.rejected);
    });
    let f, K = 0, w;
    if (!u) {
      const y = [Lr.bind(this), void 0];
      for (y.unshift(...s), y.push(...d), w = y.length, f = Promise.resolve(t); K < w; )
        f = f.then(y[K++], y[K++]);
      return f;
    }
    w = s.length;
    let k = t;
    for (; K < w; ) {
      const y = s[K++], m = s[K++];
      try {
        k = y(k);
      } catch (g) {
        m.call(this, g);
        break;
      }
    }
    try {
      f = Lr.call(this, k);
    } catch (y) {
      return Promise.reject(y);
    }
    for (K = 0, w = d.length; K < w; )
      f = f.then(d[K++], d[K++]);
    return f;
  }
  getUri(n) {
    n = Vt(this.defaults, n);
    const t = Wa(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Qa(t, n.params, n.paramsSerializer);
  }
};
T.forEach(["delete", "get", "head", "options"], function(n) {
  xt.prototype[n] = function(t, o) {
    return this.request(
      Vt(o || {}, {
        method: n,
        url: t,
        data: (o || {}).data
      })
    );
  };
});
T.forEach(["post", "put", "patch"], function(n) {
  function t(o) {
    return function(r, a, s) {
      return this.request(
        Vt(s || {}, {
          method: n,
          headers: o ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: r,
          data: a
        })
      );
    };
  }
  xt.prototype[n] = t(), xt.prototype[n + "Form"] = t(!0);
});
let Fd = class ns {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(r) {
      t = r;
    });
    const o = this;
    this.promise.then((i) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](i);
      o._listeners = null;
    }), this.promise.then = (i) => {
      let r;
      const a = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(i);
      return a.cancel = function() {
        o.unsubscribe(r);
      }, a;
    }, n(function(r, a, s) {
      o.reason || (o.reason = new qn(r, a, s), t(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (o) => {
      n.abort(o);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new ns(function(i) {
        n = i;
      }),
      cancel: n
    };
  }
};
function Rd(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function kd(e) {
  return T.isObject(e) && e.isAxiosError === !0;
}
const Ko = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Ko).forEach(([e, n]) => {
  Ko[n] = e;
});
function is(e) {
  const n = new xt(e), t = Pa(xt.prototype.request, n);
  return T.extend(t, xt.prototype, n, { allOwnKeys: !0 }), T.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(i) {
    return is(Vt(e, i));
  }, t;
}
const Fe = is(xn);
Fe.Axios = xt;
Fe.CanceledError = qn;
Fe.CancelToken = Fd;
Fe.isCancel = za;
Fe.VERSION = ts;
Fe.toFormData = Di;
Fe.AxiosError = ae;
Fe.Cancel = Fe.CanceledError;
Fe.all = function(n) {
  return Promise.all(n);
};
Fe.spread = Rd;
Fe.isAxiosError = kd;
Fe.mergeConfig = Vt;
Fe.AxiosHeaders = $e;
Fe.formToJSON = (e) => $a(T.isHTMLForm(e) ? new FormData(e) : e);
Fe.getAdapter = es.getAdapter;
Fe.HttpStatusCode = Ko;
Fe.default = Fe;
const {
  Axios: dR,
  AxiosError: cR,
  CanceledError: fR,
  isCancel: pR,
  CancelToken: hR,
  VERSION: mR,
  all: AR,
  Cancel: gR,
  isAxiosError: yR,
  spread: KR,
  toFormData: bR,
  AxiosHeaders: vR,
  HttpStatusCode: CR,
  formToJSON: wR,
  getAdapter: FR,
  mergeConfig: RR
} = Fe, Tt = {
  CODE_0: 48,
  CODE_9: 57,
  CODE_COMMA: 44,
  CODE_PERIOD: 46,
  CODE_MINUS: 45,
  SCHEMA_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][-a-zA-Z0-9 _]{0,62}$/,
  TABLE_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,30}$/,
  COLUMN_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,62}$/,
  EMAIL_REGEX: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/,
  HYPERLINK_REGEX: /^((https?):\/\/)(www.)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%._\\+~#?&//=()]*)\/?$|^$/,
  PERIOD_REGEX: /^P(?=\d+Y|\d+M|\d+D)(\d+Y)?(\d+M)?(\d+D)?$/,
  UUID_REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  SELECT_QUOTED_REGEX: /'(?:[^'\\]|\\')*'/g,
  MAX_INT: 2147483647,
  MIN_INT: -2147483648,
  MIN_NON_NEGATIVE_INT: 0,
  MAX_LONG: "9223372036854775807",
  MIN_LONG: "-9223372036854775807",
  IS_CHAPTERS_ENABLED_FIELD_NAME: "isChaptersEnabled",
  AUTO_ID: "AUTO_ID",
  HEADING: "HEADING",
  SECTION: "SECTION"
}, os = "Level 1", rs = "Level 2", as = "Level 3", ss = "Level 4", ls = "Custom", Ud = "PrivacyPolicyLevel", Ed = "PrivacyPolicyText", Sd = {
  [os]: "No privacy data",
  [rs]: "Pseudomized data",
  [as]: "Privacy data",
  [ss]: "Privacy data + medical",
  [ls]: ""
}, Td = {
  LEVEL_1: os,
  LEVEL_2: rs,
  LEVEL_3: as,
  LEVEL_4: ss,
  CUSTOM: ls,
  POLICY_LEVEL_KEY: Ud,
  POLICY_TEXT_KEY: Ed,
  PREFABS: Sd
}, {
  EMAIL_REGEX: Id,
  HYPERLINK_REGEX: Dd,
  PERIOD_REGEX: Od,
  UUID_REGEX: _d,
  AUTO_ID: Pd,
  HEADING: Md,
  SECTION: Nd,
  MIN_INT: us,
  MIN_NON_NEGATIVE_INT: ds,
  MAX_INT: _i,
  MIN_LONG: cs,
  MAX_LONG: fs
} = Tt, qr = `Invalid long: must be value from ${cs} to ${fs}`, Vr = `Invalid integer: must be value from ${us} to ${_i}`, Wi = 'must start with a P and should contain at least a Y(year), M(month) or D(day): e.g. "P1Y3M14D"', Xi = 'must use a valid UUID format (rfc9562): e.g. "123e4567-e89b-12d3-a456-426614174000"', ps = `Invalid non negative integer: must be value from ${ds} to ${_i}`;
function Bd(e, n) {
  return e.columns.reduce(
    (t, o) => {
      const i = Ld(o, n, e);
      return i && (t[o.id] = i), t;
    },
    {}
  );
}
function Ld(e, n, t) {
  const o = n?.[e.id], i = e.columnType, r = ms(o);
  try {
    if (!Qo(e, n, t))
      return;
  } catch (a) {
    return a;
  }
  if (!(e.columnType === Pd || e.columnType === Md || e.columnType === Nd)) {
    if (e.required)
      if (Vn(e.required)) {
        const a = xd(i, o);
        if (r || a)
          return e.label + " is required";
      } else {
        const a = qd(
          e.required,
          n,
          t
        );
        if (a && r)
          return a;
      }
    if (!(o === void 0 || !i.includes("_ARRAY") && r)) {
      if (i === "EMAIL" && gs(o))
        return "Invalid email address";
      if (i === "EMAIL_ARRAY") {
        const a = Gd(o);
        return Cn(
          a,
          " is an invalid email address",
          " are invalid email addresses"
        );
      }
      if (i === "HYPERLINK" && As(o))
        return "Invalid hyperlink";
      if (i === "HYPERLINK_ARRAY") {
        const a = jd(o);
        return Cn(
          a,
          " is an invalid hyperlink",
          " are invalid hyperlinks"
        );
      }
      if (i === "PERIOD" && ys(o))
        return "Invalid Period: " + Wi;
      if (i === "PERIOD_ARRAY") {
        const a = Qd(o);
        return Cn(
          a,
          " is an invalid Period: " + Wi,
          " are invalid Periods: " + Wi
        );
      }
      if (i === "UUID" && Ks(o))
        return "Invalid UUID: " + Xi;
      if (i === "UUID_ARRAY") {
        const a = $d(o);
        return Cn(
          a,
          " is an invalid UUID: " + Xi,
          " are invalid UUIDs: " + Xi
        );
      }
      if (i === "JSON")
        try {
          if (typeof o == "string" && !bs(JSON.parse(o)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
      if (i === "LONG" && o !== null && jr(o) || i === "LONG_ARRAY" && Array.isArray(o) && o?.length && o?.some(jr))
        return qr;
      if (i === "DECIMAL" && isNaN(parseFloat(o)) || i === "DECIMAL_ARRAY" && o?.some(
        (a) => a && isNaN(parseFloat(a))
      ))
        return "Invalid number";
      if (i === "INT" && Hr(o) || i === "INT_ARRAY" && o?.some(Hr))
        return Vr;
      if (i === "NON_NEGATIVE_INT" && Go(o))
        return ps;
      if (i === "NON_NEGATIVE_INT_ARRAY") {
        const a = Hd(o);
        return Cn(
          a.map(
            (s) => s?.toString() ?? "[non-parsable value]"
          ),
          " is an invalid non negative integer",
          " are invalid non negative integers"
        );
      }
      if (e.validation)
        return Vd(e.validation, n, t);
    }
  }
}
function Cn(e, n, t) {
  const o = e.map(
    (i) => typeof i == "string" ? i.toString().replaceAll("'", "\\'") : i?.toString() ?? "[non-parsable value]"
  );
  return o.length === 0 ? "" : o.length === 1 ? `'${o[0]}' ${n}` : `'${o.slice(0, o.length - 1).join("', '")}' and '${o[o.length - 1]}' ${t}`;
}
function jr(e) {
  const n = /^-?\d+$/;
  return e && n.test(e) ? BigInt(e) > BigInt(fs) || BigInt(e) < BigInt(cs) : !0;
}
function hs(e, n, t) {
  return typeof e != "number" || isNaN(e) || e < n || e > t;
}
function Hr(e) {
  return hs(e, us, _i);
}
function Go(e) {
  return hs(e, ds, _i);
}
function ms(e) {
  return Array.isArray(e) ? !e.length || e.some((n) => ms(n)) : e == null || e === "";
}
function Vn(e) {
  return typeof e == "string" ? e.toLowerCase() === "true" : e === !0;
}
function xd(e, n) {
  return ["DECIMAL", "INT"].includes(e) ? n === void 0 || typeof n == "number" && isNaN(n) : !1;
}
function qd(e, n, t) {
  try {
    const o = an(e, n, t);
    return o === !0 ? `Field is required when: ${e}` : o === !1 || o === void 0 ? void 0 : o;
  } catch (o) {
    return `Invalid expression '${e}', reason: ${o}`;
  }
}
function Vd(e, n, t) {
  try {
    const o = an(e, n, t);
    return o === !1 ? e : o === !0 || o === void 0 ? void 0 : o;
  } catch (o) {
    return `Invalid validation expression '${e}', reason: ${o}`;
  }
}
function an(e, n, t) {
  const o = Ve(n);
  t.columns.forEach((a) => {
    o.hasOwnProperty(a.id) || (o[a.id] = null);
  }), o.mg_tableclass || (o.mg_tableclass = `${t.id}.${t.label}`);
  let i = function(a, s, u) {
    let d = new XMLHttpRequest();
    return d.open(
      "POST",
      u ? "/" + u + "/graphql" : "graphql",
      !1
    ), d.send(
      `{"query":"${a}", "variables":${JSON.stringify(s)}}`
    ), JSON.parse(d.responseText).data;
  };
  return new Function(
    "simplePostClient",
    //@ts-ignore
    Object.keys(o),
    "return eval(`" + e.replaceAll("`", "\\`") + "`)"
  )(i, ...Object.values(o));
}
function As(e) {
  return e && (typeof e != "string" || !Dd.test(e));
}
function jd(e) {
  return Array.isArray(e) ? e.filter(
    (n) => As(n)
  ) : [];
}
function Hd(e) {
  return Array.isArray(e) ? e.filter((n) => Go(n)) : [];
}
function gs(e) {
  return typeof e != "string" || !Id.test(e);
}
function Gd(e) {
  return Array.isArray(e) ? e.filter((n) => gs(n)) : [];
}
function ys(e) {
  return e == null || e === "" ? !1 : typeof e != "string" || !Od.test(e);
}
function Qd(e) {
  return Array.isArray(e) ? e.filter((n) => ys(n)) : [];
}
function Ks(e) {
  return e == null || e === "" ? !1 : typeof e != "string" || !_d.test(e);
}
function $d(e) {
  return Array.isArray(e) ? e.filter((n) => Ks(n)) : [];
}
function bs(e) {
  return typeof e == "object" && e !== null;
}
function Jd(e, n) {
  const t = e?.columns?.filter((o) => o.key === 1).map((o) => o.id);
  return oc(n, (o) => !t?.includes(o));
}
function zd(e, n) {
  return n ? e.filter((t) => n.includes(t.id)) : e;
}
function Qo(e, n, t) {
  const o = e.visible;
  if (o !== void 0)
    try {
      return an(o, n || {}, t);
    } catch (i) {
      throw `Invalid visibility expression, reason: ${i}`;
    }
  else
    return !0;
}
function Yd(e) {
  return e.reduce((n, t) => (t.columnType === "HEADING" ? n.push([t.id]) : (n.length === 0 && n.push([]), n[n.length - 1]?.push(t.id)), n), []);
}
function Wd(e, n) {
  return e.filter(
    (o) => !!n[o]
  ).length ? { color: "red" } : {};
}
function Xd(e) {
  const n = Object.values(e).filter(
    (t) => t
  ).length;
  return n > 0 ? `There are ${n} error(s) preventing saving` : "";
}
function Zd(e, n, t) {
  let o = Ve(e);
  return n && n.forEach((i) => {
    const r = i.conditions ? i.conditions.filter(
      (a) => a !== "" && a !== void 0
    ) : [];
    r.length && (i.columnType.startsWith("AUTO_ID") || i.columnType.startsWith("STRING") || i.columnType.startsWith("TEXT") || i.columnType.startsWith("JSON") ? o[i.id] = { like: r } : i.columnType.startsWith("BOOL") || i.columnType.startsWith("CHECKBOX") || i.columnType.startsWith("REF") || i.columnType.startsWith("ONTOLOGY") || i.columnType.startsWith("RADIO") || i.columnType.startsWith("MULTISELECT") || i.columnType.startsWith("SELECT") ? o[i.id] = { equals: r.flat() } : ["DECIMAL", "DECIMAL_ARRAY", "INT", "INT_ARRAY"].includes(
      i.columnType
    ) ? o[i.id] = {
      between: r.flat().map((a) => parseFloat(a))
    } : [
      "LONG",
      "LONG_ARRAY",
      "DATE",
      "DATE_ARRAY",
      "DATETIME",
      "DATETIME_ARRAY"
    ].includes(i.columnType) ? o[i.id] = {
      between: r.flat()
    } : t(
      `filter unsupported for column type ${i.columnType} (please report a bug)`
    ));
  }), o;
}
const { CODE_0: ec, CODE_9: tc, CODE_PERIOD: nc, AUTO_ID: ic } = Tt;
function Ci(e) {
  return [
    "REF",
    "REF_ARRAY",
    "REFBACK",
    "ONTOLOGY",
    "ONTOLOGY_ARRAY",
    "RADIO",
    "SELECT",
    "CHECKBOX",
    "MULTISELECT"
  ].includes(e);
}
function $o(e) {
  const n = e.which ?? e.keyCode;
  return n >= ec && n <= tc || n === nc;
}
function sn(e) {
  if (typeof e == "object") {
    let n = "";
    return Object.keys(e).forEach((t) => {
      e[t] !== null && (typeof e[t] == "object" ? n += sn(e[t]) : n += " " + e[t]);
    }), n;
  } else
    return e;
}
async function Zt(e, n, t) {
  const i = await We.newClient(t).fetchTableMetaData(n);
  if (i?.columns)
    return await i.columns.reduce(
      async (r, a) => {
        let s = await r;
        const u = e[a.id];
        return a.key === 1 && (u || u === 0) && (s[a.id] = await vs(
          u,
          a,
          a.refSchemaId || t
        )), s;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
async function vs(e, n, t) {
  if (typeof e == "string" || typeof e == "number")
    return e;
  if (n.refTableId)
    return await Zt(
      e,
      n.refTableId,
      t
    );
  throw new Error("Unexpected key type");
}
function Ve(e) {
  return JSON.parse(JSON.stringify(e));
}
function oc(e, n) {
  return Object.keys(e).reduce(
    (t, o) => (n(o) && (t[o] = e[o]), t),
    {}
  );
}
function Jo(e) {
  switch (e) {
    case "-":
      return "";
    case null:
      return "-";
    default:
      return e.charAt(0) === "-" ? e.substring(1) : "-" + e;
  }
}
function jt(e, n) {
  if (e == null)
    return "";
  const t = Object.keys(e), o = Object.values(e);
  try {
    const i = new Function(...t, "return `" + n + "`;")(
      ...o
    );
    if (i)
      return i;
  } catch (i) {
    console.log(
      i.message + " we got keys:" + JSON.stringify(t) + " vals:" + JSON.stringify(o) + " and template: " + n
    );
  }
  return e.hasOwnProperty("primaryKey") ? sn(e.primaryKey) : e.hasOwnProperty("name") ? e.name : e.hasOwnProperty("id") ? e.id : sn(e);
}
function tn(e, n) {
  const t = Object.keys(e), o = Object.keys(n);
  if (t.length !== o.length)
    return !1;
  for (const i of t) {
    const r = e[i], a = n[i], s = Gr(r) && Gr(a);
    if (s && !tn(r, a) || !s && r !== a)
      return !1;
  }
  return !0;
}
function Gr(e) {
  return e !== null && typeof e == "object";
}
function Cs(e, n) {
  return e?.map((t) => n.columns.reduce((o, i) => {
    if (i.computed && i.columnType !== ic)
      try {
        o[i.id] = an(
          i.computed,
          t,
          n
        );
      } catch (r) {
        console.log("Computed expression failed: ", r), o[i.id] = "error: could not compute value: " + r;
      }
    else t.hasOwnProperty(i.id) && (o[i.id] = t[i.id]);
    return o;
  }, {}));
}
const ws = async (e, n, t, o = !0) => {
  const i = await Dt(e);
  let r = "";
  for (const a of rc(e, n, i.tables))
    if (t > 0 || a.key) {
      if (!o && [
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY_ARRAY",
        "CHECKBOX",
        "MULTISELECT"
      ].includes(a.columnType))
        continue;
      [
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "CHECKBOX",
        "MULTISELECT",
        "SELECT",
        "RADIO"
      ].includes(a.columnType) ? r = r + " " + a.id + " {" + await ws(
        a.refSchemaId || e,
        a.refTableId || n,
        //indicate that sub queries should not be expanded on ref_array, refback, ontology_array
        t - 1,
        !1
      ) + " }" : ["ONTOLOGY", "ONTOLOGY_ARRAY"].includes(a.columnType) ? r = r + " " + a.id + " {name, label}" : a.columnType === "FILE" ? r += ` ${a.id} { id, size, filename, extension, url }` : ["HEADING", "SECTION"].includes(a.columnType) || (r += ` ${a.id}`);
    }
  return r;
}, rc = (e, n, t) => t.find((i) => i.id === n)?.columns || [], Fs = (e) => {
  if (!FormData)
    throw "Files can only be uploaded via a browser client";
  const n = new FormData(), t = {}, o = {};
  for (const [i, r] of Object.entries(e))
    ac(r) ? o[i] = r : t[i] = r;
  for (const [i, r] of Object.entries(o)) {
    const a = Math.random().toString(36);
    n.append(a, r), t[i] = a;
  }
  return n.append("variables", JSON.stringify({ value: [t] })), n;
}, ac = (e) => {
  if (window && "File" in window)
    return e instanceof File;
  throw "Files can only be uploaded via a browser client";
}, Fn = /* @__PURE__ */ new Map(), We = {
  newClient: (e) => ({
    insertDataRow: uc,
    updateDataRow: dc,
    deleteRow: async (n, t) => cc(n, t, e),
    deleteAllTableData: async (n) => fc(n, e),
    fetchSchemaMetaData: async () => Dt(e),
    fetchTableMetaData: async (n) => {
      const t = await Dt(e);
      return Ve(t).tables.find(
        (o) => o.id === n
      );
    },
    fetchTableData: async (n, t = {}) => {
      const o = await Dt(e);
      return Zi(n, t, o);
    },
    fetchTableDataValues: async (n, t = {}) => {
      const o = await Dt(e);
      return (await Zi(
        n,
        t,
        o
      ))[n];
    },
    fetchRowData: async (n, t, o = 2) => {
      const i = await Dt(e), a = i.tables.find(
        (u) => u.id === n
      )?.columns?.filter((u) => u.key === 1).reduce((u, d) => (u[d.id] = { equals: t[d.id] }, u), {}), s = (await Zi(
        n,
        {
          filter: a,
          expandLevel: o
        },
        i
      ))[n];
      if (!(!s.length || s.length !== 1))
        return s[0];
    },
    fetchAggregateData: async (n, t, o, i, r, a) => {
      const s = `
        query ${n}_groupBy($filter: ${n}Filter){
          ${n}_groupBy(filter: $filter) {
            ${r} ${r === "_sum" ? `{ ${a} }` : ""},
            ${t.id} {
              ${t.column}
            },
            ${o.id} {
              ${o.column}
            }
          }
        }`;
      return Me(gt(e), s, { filter: i });
    },
    saveTableSettings: async (n) => Me(
      gt(e),
      "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
      { settings: n }
    ),
    fetchSettings: async () => Qr(e),
    fetchSettingValue: async (n) => {
      const o = (await Qr(e)).find(
        (i) => i.key === n
      );
      if (o)
        return JSON.parse(o.value);
    },
    saveSetting: async (n, t) => {
      const o = `mutation change($settings: [MolgenisSettingsInput]) {
            change(settings: $settings) {
              message
            }
          }`, i = {
        settings: {
          key: n,
          value: JSON.stringify(t)
        }
      };
      await Me(gt(e), o, i).catch(
        (r) => {
          console.error(r);
        }
      );
    },
    clearCache: () => {
      Fn.clear();
    },
    convertRowToPrimaryKey: async (n, t) => jn(n, t, e),
    fetchOntologyOptions: async (n) => pc(n, e),
    getPrimaryKeyFields: sc
  })
};
async function sc(e, n) {
  return Dt(e).then((t) => {
    const o = t.tables.find((r) => r.id === n);
    if (!o)
      throw new Error(`Table ${n} not found in schema ${e}`);
    return o.columns.filter((r) => r.key === 1).map((r) => r.id);
  });
}
const lc = `{
  _schema {
    id,
    tables {
      id,
      name,
      label, 
      description,
      tableType,
      semantics,
      columns {
        id,
        name,
        label,
        formLabel,
        description,
        columnType,
        key,
        refTableId,
        refSchemaId,
        refLinkId,
        refLabel,
        refLabelDefault,
        refBackId,
        required,
        defaultValue,
        readonly,
        semantics,
        position,
        computed,
        visible,
        validation
      }
      settings { 
        key,
        value 
      }
    }
  }
}`, gt = (e) => e ? "/" + e + "/graphql" : "graphql", uc = (e, n, t) => {
  const o = Fs(e), i = `mutation insert($value:[${n}Input]){insert(${n}:$value){message}}`;
  return o.append("query", i), Fe.post(gt(t), o);
}, dc = (e, n, t) => {
  const o = Fs(e), i = `mutation update($value:[${n}Input]){update(${n}:$value){message}}`;
  return o.append("query", i), Fe.post(gt(t), o);
}, cc = async (e, n, t) => {
  const o = `mutation delete($pkey:[${n}Input]){delete(${n}:$pkey){message}}`, r = { pkey: [await jn(e, n, t)] };
  return Fe.post(gt(t), { query: o, variables: r });
}, fc = (e, n) => {
  const t = `mutation {truncate(tables:"${e}" async:true){taskId message}}`;
  return Fe.post(gt(n), { query: t });
}, Dt = async (e) => {
  const n = e || "CACHE_OF_CURRENT_SCHEMA";
  if (Fn.has(n))
    return Fn.get(n);
  const t = Fe.post(gt(e), { query: lc }).then((o) => {
    const i = o.data.data._schema;
    return Ve(i);
  }).catch((o) => {
    throw console.log(o), Fn.delete(n), o;
  });
  return Fn.set(n, t), t;
}, Zi = async (e, n, t) => {
  const o = n.limit ? n.limit : 20, i = n.offset ? n.offset : 0, r = n.expandLevel ?? 2, a = n.searchTerms ? ',search:"' + n.searchTerms.trim() + '"' : "", s = t.id, u = await ws(s, e, r), d = `query ${e}( $filter:${e}Filter, $orderby:[${e}orderby] ) {
        ${e}(
          filter:$filter,
          limit:${o}, 
          offset:${i}${a},
          orderby:$orderby
          )
          {
            ${u}
          }
          ${e}_agg( filter:$filter${a} ) {
            count
          }
        }`, f = n.filter ? n.filter : {}, K = n.orderby ? [n.orderby] : [];
  return (await Fe.post(gt(s), {
    query: d,
    variables: { filter: f, orderby: K }
  }).catch((k) => {
    throw console.log(k), k;
  }))?.data.data;
}, pc = async (e, n) => {
  const t = `query ${e} {
        ${e}(
          limit:100000
          orderby: { order: ASC }
          )
          {
          	order 
            name 
            label 
            parent { order name label } 
            children { order name label parent { name } } 
          }
        }`;
  return (await Fe.post(gt(n), {
    query: t
  }).catch((i) => {
    throw console.log(i), i;
  }))?.data.data[e];
}, Qr = async (e) => (await Me(gt(e), "{_settings{key, value}}"))._settings, Me = async (e, n, t) => {
  const o = { query: n };
  return t && (o.variables = t), Fe.post(e, o).then((i) => i?.data?.data).catch((i) => {
    throw i.response?.data?.errors?.map((a) => a.message).join(". ") || i.message;
  });
};
async function jn(e, n, t) {
  const o = await Dt(t), i = o.tables.find(
    (r) => r.id === n
  );
  if (i?.columns)
    return await i.columns.reduce(
      async (r, a) => {
        let s = await r;
        const u = e[a.id];
        return a.key === 1 && (u || u === 0) && (s[a.id] = await vs(
          u,
          a,
          a.refSchemaId || o.id
        )), s;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
const zo = JSON, hc = (e) => e.toUpperCase(), mc = (e) => {
  const n = {};
  return e.forEach((t, o) => {
    n[o] = t;
  }), n;
}, Ac = (e, n, t) => e.document ? e : {
  document: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, gc = (e, n, t) => e.query ? e : {
  query: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, yc = (e, n) => e.documents ? e : {
  documents: e,
  requestHeaders: n,
  signal: void 0
}, Kc = (e, n, ...t) => {
  const [o, i] = t;
  return e.document ? e : {
    url: e,
    document: n,
    variables: o,
    requestHeaders: i,
    signal: void 0
  };
};
function di(e, n) {
  if (!!!e)
    throw new Error(n);
}
function bc(e) {
  return typeof e == "object" && e !== null;
}
function vc(e, n) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Cc = /\r\n|[\n\r]/g;
function bo(e, n) {
  let t = 0, o = 1;
  for (const i of e.body.matchAll(Cc)) {
    if (typeof i.index == "number" || vc(!1), i.index >= n)
      break;
    t = i.index + i[0].length, o += 1;
  }
  return {
    line: o,
    column: n + 1 - t
  };
}
function wc(e) {
  return Rs(
    e.source,
    bo(e.source, e.start)
  );
}
function Rs(e, n) {
  const t = e.locationOffset.column - 1, o = "".padStart(t) + e.body, i = n.line - 1, r = e.locationOffset.line - 1, a = n.line + r, s = n.line === 1 ? t : 0, u = n.column + s, d = `${e.name}:${a}:${u}
`, f = o.split(/\r\n|[\n\r]/g), K = f[i];
  if (K.length > 120) {
    const w = Math.floor(u / 80), k = u % 80, y = [];
    for (let m = 0; m < K.length; m += 80)
      y.push(K.slice(m, m + 80));
    return d + $r([
      [`${a} |`, y[0]],
      ...y.slice(1, w + 1).map((m) => ["|", m]),
      ["|", "^".padStart(k)],
      ["|", y[w + 1]]
    ]);
  }
  return d + $r([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, f[i - 1]],
    [`${a} |`, K],
    ["|", "^".padStart(u)],
    [`${a + 1} |`, f[i + 1]]
  ]);
}
function $r(e) {
  const n = e.filter(([o, i]) => i !== void 0), t = Math.max(...n.map(([o]) => o.length));
  return n.map(([o, i]) => o.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function Fc(e) {
  const n = e[0];
  return n == null || "kind" in n || "length" in n ? {
    nodes: n,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : n;
}
class Yo extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(n, ...t) {
    var o, i, r;
    const { nodes: a, source: s, positions: u, path: d, originalError: f, extensions: K } = Fc(t);
    super(n), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = f ?? void 0, this.nodes = Jr(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const w = Jr(
      (o = this.nodes) === null || o === void 0 ? void 0 : o.map((y) => y.loc).filter((y) => y != null)
    );
    this.source = s ?? (w == null || (i = w[0]) === null || i === void 0 ? void 0 : i.source), this.positions = u ?? w?.map((y) => y.start), this.locations = u && s ? u.map((y) => bo(s, y)) : w?.map((y) => bo(y.source, y.start));
    const k = bc(
      f?.extensions
    ) ? f?.extensions : void 0;
    this.extensions = (r = K ?? k) !== null && r !== void 0 ? r : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), f != null && f.stack ? Object.defineProperty(this, "stack", {
      value: f.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Yo) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let n = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (n += `

` + wc(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        n += `

` + Rs(this.source, t);
    return n;
  }
  toJSON() {
    const n = {
      message: this.message
    };
    return this.locations != null && (n.locations = this.locations), this.path != null && (n.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (n.extensions = this.extensions), n;
  }
}
function Jr(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function _e(e, n, t) {
  return new Yo(`Syntax Error: ${t}`, {
    source: e,
    positions: [n]
  });
}
class Rc {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(n, t, o) {
    this.start = n.start, this.end = t.end, this.startToken = n, this.endToken = t, this.source = o;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ks {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(n, t, o, i, r, a) {
    this.kind = n, this.start = t, this.end = o, this.line = i, this.column = r, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Us = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, kc = new Set(Object.keys(Us));
function zr(e) {
  const n = e?.kind;
  return typeof n == "string" && kc.has(n);
}
var en;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(en || (en = {}));
var vo;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(vo || (vo = {}));
var ne;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(ne || (ne = {}));
function Co(e) {
  return e === 9 || e === 32;
}
function In(e) {
  return e >= 48 && e <= 57;
}
function Es(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Ss(e) {
  return Es(e) || e === 95;
}
function Uc(e) {
  return Es(e) || In(e) || e === 95;
}
function Ec(e) {
  var n;
  let t = Number.MAX_SAFE_INTEGER, o = null, i = -1;
  for (let a = 0; a < e.length; ++a) {
    var r;
    const s = e[a], u = Sc(s);
    u !== s.length && (o = (r = o) !== null && r !== void 0 ? r : a, i = a, a !== 0 && u < t && (t = u));
  }
  return e.map((a, s) => s === 0 ? a : a.slice(t)).slice(
    (n = o) !== null && n !== void 0 ? n : 0,
    i + 1
  );
}
function Sc(e) {
  let n = 0;
  for (; n < e.length && Co(e.charCodeAt(n)); )
    ++n;
  return n;
}
function Tc(e, n) {
  const t = e.replace(/"""/g, '\\"""'), o = t.split(/\r\n|[\n\r]/g), i = o.length === 1, r = o.length > 1 && o.slice(1).every((k) => k.length === 0 || Co(k.charCodeAt(0))), a = t.endsWith('\\"""'), s = e.endsWith('"') && !a, u = e.endsWith("\\"), d = s || u, f = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || d || r || a
  );
  let K = "";
  const w = i && Co(e.charCodeAt(0));
  return (f && !w || r) && (K += `
`), K += t, (f || d) && (K += `
`), '"""' + K + '"""';
}
var N;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(N || (N = {}));
class Ic {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(n) {
    const t = new ks(N.SOF, 0, 0, 0, 0);
    this.source = n, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let n = this.token;
    if (n.kind !== N.EOF)
      do
        if (n.next)
          n = n.next;
        else {
          const t = Oc(this, n.end);
          n.next = t, t.prev = n, n = t;
        }
      while (n.kind === N.COMMENT);
    return n;
  }
}
function Dc(e) {
  return e === N.BANG || e === N.DOLLAR || e === N.AMP || e === N.PAREN_L || e === N.PAREN_R || e === N.DOT || e === N.SPREAD || e === N.COLON || e === N.EQUALS || e === N.AT || e === N.BRACKET_L || e === N.BRACKET_R || e === N.BRACE_L || e === N.PIPE || e === N.BRACE_R;
}
function hn(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Pi(e, n) {
  return Ts(e.charCodeAt(n)) && Is(e.charCodeAt(n + 1));
}
function Ts(e) {
  return e >= 55296 && e <= 56319;
}
function Is(e) {
  return e >= 56320 && e <= 57343;
}
function Ht(e, n) {
  const t = e.source.body.codePointAt(n);
  if (t === void 0)
    return N.EOF;
  if (t >= 32 && t <= 126) {
    const o = String.fromCodePoint(t);
    return o === '"' ? `'"'` : `"${o}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function Oe(e, n, t, o, i) {
  const r = e.line, a = 1 + t - e.lineStart;
  return new ks(n, t, o, r, a, i);
}
function Oc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    switch (r) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++i;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      // Comment
      case 35:
        return _c(e, i);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return Oe(e, N.BANG, i, i + 1);
      case 36:
        return Oe(e, N.DOLLAR, i, i + 1);
      case 38:
        return Oe(e, N.AMP, i, i + 1);
      case 40:
        return Oe(e, N.PAREN_L, i, i + 1);
      case 41:
        return Oe(e, N.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return Oe(e, N.SPREAD, i, i + 3);
        break;
      case 58:
        return Oe(e, N.COLON, i, i + 1);
      case 61:
        return Oe(e, N.EQUALS, i, i + 1);
      case 64:
        return Oe(e, N.AT, i, i + 1);
      case 91:
        return Oe(e, N.BRACKET_L, i, i + 1);
      case 93:
        return Oe(e, N.BRACKET_R, i, i + 1);
      case 123:
        return Oe(e, N.BRACE_L, i, i + 1);
      case 124:
        return Oe(e, N.PIPE, i, i + 1);
      case 125:
        return Oe(e, N.BRACE_R, i, i + 1);
      // StringValue
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? xc(e, i) : Mc(e, i);
    }
    if (In(r) || r === 45)
      return Pc(e, i, r);
    if (Ss(r))
      return qc(e, i);
    throw _e(
      e.source,
      i,
      r === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : hn(r) || Pi(t, i) ? `Unexpected character: ${Ht(e, i)}.` : `Invalid character: ${Ht(e, i)}.`
    );
  }
  return Oe(e, N.EOF, o, o);
}
function _c(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    if (r === 10 || r === 13)
      break;
    if (hn(r))
      ++i;
    else if (Pi(t, i))
      i += 2;
    else
      break;
  }
  return Oe(
    e,
    N.COMMENT,
    n,
    i,
    t.slice(n + 1, i)
  );
}
function Pc(e, n, t) {
  const o = e.source.body;
  let i = n, r = t, a = !1;
  if (r === 45 && (r = o.charCodeAt(++i)), r === 48) {
    if (r = o.charCodeAt(++i), In(r))
      throw _e(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Ht(
          e,
          i
        )}.`
      );
  } else
    i = eo(e, i, r), r = o.charCodeAt(i);
  if (r === 46 && (a = !0, r = o.charCodeAt(++i), i = eo(e, i, r), r = o.charCodeAt(i)), (r === 69 || r === 101) && (a = !0, r = o.charCodeAt(++i), (r === 43 || r === 45) && (r = o.charCodeAt(++i)), i = eo(e, i, r), r = o.charCodeAt(i)), r === 46 || Ss(r))
    throw _e(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Ht(
        e,
        i
      )}.`
    );
  return Oe(
    e,
    a ? N.FLOAT : N.INT,
    n,
    i,
    o.slice(n, i)
  );
}
function eo(e, n, t) {
  if (!In(t))
    throw _e(
      e.source,
      n,
      `Invalid number, expected digit but got: ${Ht(
        e,
        n
      )}.`
    );
  const o = e.source.body;
  let i = n + 1;
  for (; In(o.charCodeAt(i)); )
    ++i;
  return i;
}
function Mc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1, r = i, a = "";
  for (; i < o; ) {
    const s = t.charCodeAt(i);
    if (s === 34)
      return a += t.slice(r, i), Oe(e, N.STRING, n, i + 1, a);
    if (s === 92) {
      a += t.slice(r, i);
      const u = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? Nc(e, i) : Bc(e, i) : Lc(e, i);
      a += u.value, i += u.size, r = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (hn(s))
      ++i;
    else if (Pi(t, i))
      i += 2;
    else
      throw _e(
        e.source,
        i,
        `Invalid character within String: ${Ht(
          e,
          i
        )}.`
      );
  }
  throw _e(e.source, i, "Unterminated string.");
}
function Nc(e, n) {
  const t = e.source.body;
  let o = 0, i = 3;
  for (; i < 12; ) {
    const r = t.charCodeAt(n + i++);
    if (r === 125) {
      if (i < 5 || !hn(o))
        break;
      return {
        value: String.fromCodePoint(o),
        size: i
      };
    }
    if (o = o << 4 | Rn(r), o < 0)
      break;
  }
  throw _e(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(
      n,
      n + i
    )}".`
  );
}
function Bc(e, n) {
  const t = e.source.body, o = Yr(t, n + 2);
  if (hn(o))
    return {
      value: String.fromCodePoint(o),
      size: 6
    };
  if (Ts(o) && t.charCodeAt(n + 6) === 92 && t.charCodeAt(n + 7) === 117) {
    const i = Yr(t, n + 8);
    if (Is(i))
      return {
        value: String.fromCodePoint(o, i),
        size: 12
      };
  }
  throw _e(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(n, n + 6)}".`
  );
}
function Yr(e, n) {
  return Rn(e.charCodeAt(n)) << 12 | Rn(e.charCodeAt(n + 1)) << 8 | Rn(e.charCodeAt(n + 2)) << 4 | Rn(e.charCodeAt(n + 3));
}
function Rn(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Lc(e, n) {
  const t = e.source.body;
  switch (t.charCodeAt(n + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw _e(
    e.source,
    n,
    `Invalid character escape sequence: "${t.slice(
      n,
      n + 2
    )}".`
  );
}
function xc(e, n) {
  const t = e.source.body, o = t.length;
  let i = e.lineStart, r = n + 3, a = r, s = "";
  const u = [];
  for (; r < o; ) {
    const d = t.charCodeAt(r);
    if (d === 34 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34) {
      s += t.slice(a, r), u.push(s);
      const f = Oe(
        e,
        N.BLOCK_STRING,
        n,
        r + 3,
        // Return a string of the lines joined with U+000A.
        Ec(u).join(`
`)
      );
      return e.line += u.length - 1, e.lineStart = i, f;
    }
    if (d === 92 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34 && t.charCodeAt(r + 3) === 34) {
      s += t.slice(a, r), a = r + 1, r += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      s += t.slice(a, r), u.push(s), d === 13 && t.charCodeAt(r + 1) === 10 ? r += 2 : ++r, s = "", a = r, i = r;
      continue;
    }
    if (hn(d))
      ++r;
    else if (Pi(t, r))
      r += 2;
    else
      throw _e(
        e.source,
        r,
        `Invalid character within String: ${Ht(
          e,
          r
        )}.`
      );
  }
  throw _e(e.source, r, "Unterminated string.");
}
function qc(e, n) {
  const t = e.source.body, o = t.length;
  let i = n + 1;
  for (; i < o; ) {
    const r = t.charCodeAt(i);
    if (Uc(r))
      ++i;
    else
      break;
  }
  return Oe(
    e,
    N.NAME,
    n,
    i,
    t.slice(n, i)
  );
}
const Vc = 10, Ds = 2;
function Wo(e) {
  return Mi(e, []);
}
function Mi(e, n) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return jc(e, n);
    default:
      return String(e);
  }
}
function jc(e, n) {
  if (e === null)
    return "null";
  if (n.includes(e))
    return "[Circular]";
  const t = [...n, e];
  if (Hc(e)) {
    const o = e.toJSON();
    if (o !== e)
      return typeof o == "string" ? o : Mi(o, t);
  } else if (Array.isArray(e))
    return Qc(e, t);
  return Gc(e, t);
}
function Hc(e) {
  return typeof e.toJSON == "function";
}
function Gc(e, n) {
  const t = Object.entries(e);
  return t.length === 0 ? "{}" : n.length > Ds ? "[" + $c(e) + "]" : "{ " + t.map(
    ([i, r]) => i + ": " + Mi(r, n)
  ).join(", ") + " }";
}
function Qc(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > Ds)
    return "[Array]";
  const t = Math.min(Vc, e.length), o = e.length - t, i = [];
  for (let r = 0; r < t; ++r)
    i.push(Mi(e[r], n));
  return o === 1 ? i.push("... 1 more item") : o > 1 && i.push(`... ${o} more items`), "[" + i.join(", ") + "]";
}
function $c(e) {
  const n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    const t = e.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return n;
}
const Jc = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", zc = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  Jc ? function(n, t) {
    return n instanceof t;
  } : function(n, t) {
    if (n instanceof t)
      return !0;
    if (typeof n == "object" && n !== null) {
      var o;
      const i = t.prototype[Symbol.toStringTag], r = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in n ? n[Symbol.toStringTag] : (o = n.constructor) === null || o === void 0 ? void 0 : o.name
      );
      if (i === r) {
        const a = Wo(n);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Os {
  constructor(n, t = "GraphQL request", o = {
    line: 1,
    column: 1
  }) {
    typeof n == "string" || di(!1, `Body must be a string. Received: ${Wo(n)}.`), this.body = n, this.name = t, this.locationOffset = o, this.locationOffset.line > 0 || di(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || di(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Yc(e) {
  return zc(e, Os);
}
function Wc(e, n) {
  const t = new Xc(e, n), o = t.parseDocument();
  return Object.defineProperty(o, "tokenCount", {
    enumerable: !1,
    value: t.tokenCount
  }), o;
}
class Xc {
  constructor(n, t = {}) {
    const { lexer: o, ...i } = t;
    if (o)
      this._lexer = o;
    else {
      const r = Yc(n) ? n : new Os(n);
      this._lexer = new Ic(r);
    }
    this._options = i, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const n = this.expectToken(N.NAME);
    return this.node(n, {
      kind: ne.NAME,
      value: n.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ne.DOCUMENT,
      definitions: this.many(
        N.SOF,
        this.parseDefinition,
        N.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(N.BRACE_L))
      return this.parseOperationDefinition();
    const n = this.peekDescription(), t = n ? this._lexer.lookahead() : this._lexer.token;
    if (n && t.kind === N.BRACE_L)
      throw _e(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (t.kind === N.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (n)
        throw _e(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (t.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const n = this._lexer.token;
    if (this.peek(N.BRACE_L))
      return this.node(n, {
        kind: ne.OPERATION_DEFINITION,
        operation: en.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseDescription(), o = this.parseOperationType();
    let i;
    return this.peek(N.NAME) && (i = this.parseName()), this.node(n, {
      kind: ne.OPERATION_DEFINITION,
      operation: o,
      description: t,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const n = this.expectToken(N.NAME);
    switch (n.value) {
      case "query":
        return en.QUERY;
      case "mutation":
        return en.MUTATION;
      case "subscription":
        return en.SUBSCRIPTION;
    }
    throw this.unexpected(n);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      N.PAREN_L,
      this.parseVariableDefinition,
      N.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ne.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(N.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(N.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const n = this._lexer.token;
    return this.expectToken(N.DOLLAR), this.node(n, {
      kind: ne.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ne.SELECTION_SET,
      selections: this.many(
        N.BRACE_L,
        this.parseSelection,
        N.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(N.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const n = this._lexer.token, t = this.parseName();
    let o, i;
    return this.expectOptionalToken(N.COLON) ? (o = t, i = this.parseName()) : i = t, this.node(n, {
      kind: ne.FIELD,
      alias: o,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(N.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(n) {
    const t = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(N.PAREN_L, t, N.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(n = !1) {
    const t = this._lexer.token, o = this.parseName();
    return this.expectToken(N.COLON), this.node(t, {
      kind: ne.ARGUMENT,
      name: o,
      value: this.parseValueLiteral(n)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const n = this._lexer.token;
    this.expectToken(N.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(N.NAME) ? this.node(n, {
      kind: ne.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(n, {
      kind: ne.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(n, {
      kind: ne.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: ne.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(n) {
    const t = this._lexer.token;
    switch (t.kind) {
      case N.BRACKET_L:
        return this.parseList(n);
      case N.BRACE_L:
        return this.parseObject(n);
      case N.INT:
        return this.advanceLexer(), this.node(t, {
          kind: ne.INT,
          value: t.value
        });
      case N.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: ne.FLOAT,
          value: t.value
        });
      case N.STRING:
      case N.BLOCK_STRING:
        return this.parseStringLiteral();
      case N.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: ne.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: ne.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: ne.NULL
            });
          default:
            return this.node(t, {
              kind: ne.ENUM,
              value: t.value
            });
        }
      case N.DOLLAR:
        if (n)
          if (this.expectToken(N.DOLLAR), this._lexer.token.kind === N.NAME) {
            const o = this._lexer.token.value;
            throw _e(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${o}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const n = this._lexer.token;
    return this.advanceLexer(), this.node(n, {
      kind: ne.STRING,
      value: n.value,
      block: n.kind === N.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(n) {
    const t = () => this.parseValueLiteral(n);
    return this.node(this._lexer.token, {
      kind: ne.LIST,
      values: this.any(N.BRACKET_L, t, N.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(n) {
    const t = () => this.parseObjectField(n);
    return this.node(this._lexer.token, {
      kind: ne.OBJECT,
      fields: this.any(N.BRACE_L, t, N.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(n) {
    const t = this._lexer.token, o = this.parseName();
    return this.expectToken(N.COLON), this.node(t, {
      kind: ne.OBJECT_FIELD,
      name: o,
      value: this.parseValueLiteral(n)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(n) {
    const t = [];
    for (; this.peek(N.AT); )
      t.push(this.parseDirective(n));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(n) {
    const t = this._lexer.token;
    return this.expectToken(N.AT), this.node(t, {
      kind: ne.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const n = this._lexer.token;
    let t;
    if (this.expectOptionalToken(N.BRACKET_L)) {
      const o = this.parseTypeReference();
      this.expectToken(N.BRACKET_R), t = this.node(n, {
        kind: ne.LIST_TYPE,
        type: o
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(N.BANG) ? this.node(n, {
      kind: ne.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ne.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(N.STRING) || this.peek(N.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const o = this.parseConstDirectives(), i = this.many(
      N.BRACE_L,
      this.parseOperationTypeDefinition,
      N.BRACE_R
    );
    return this.node(n, {
      kind: ne.SCHEMA_DEFINITION,
      description: t,
      directives: o,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const n = this._lexer.token, t = this.parseOperationType();
    this.expectToken(N.COLON);
    const o = this.parseNamedType();
    return this.node(n, {
      kind: ne.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: o
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const o = this.parseName(), i = this.parseConstDirectives();
    return this.node(n, {
      kind: ne.SCALAR_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const o = this.parseName(), i = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(n, {
      kind: ne.OBJECT_TYPE_DEFINITION,
      description: t,
      name: o,
      interfaces: i,
      directives: r,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(N.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      N.BRACE_L,
      this.parseFieldDefinition,
      N.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(N.COLON);
    const r = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(n, {
      kind: ne.FIELD_DEFINITION,
      description: t,
      name: o,
      arguments: i,
      type: r,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      N.PAREN_L,
      this.parseInputValueDef,
      N.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseName();
    this.expectToken(N.COLON);
    const i = this.parseTypeReference();
    let r;
    this.expectOptionalToken(N.EQUALS) && (r = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(n, {
      kind: ne.INPUT_VALUE_DEFINITION,
      description: t,
      name: o,
      type: i,
      defaultValue: r,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const o = this.parseName(), i = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(n, {
      kind: ne.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: o,
      interfaces: i,
      directives: r,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseUnionMemberTypes();
    return this.node(n, {
      kind: ne.UNION_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      types: r
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(N.EQUALS) ? this.delimitedMany(N.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseEnumValuesDefinition();
    return this.node(n, {
      kind: ne.ENUM_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      values: r
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      N.BRACE_L,
      this.parseEnumValueDefinition,
      N.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), o = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(n, {
      kind: ne.ENUM_VALUE_DEFINITION,
      description: t,
      name: o,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw _e(
        this._lexer.source,
        this._lexer.token.start,
        `${ti(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const o = this.parseName(), i = this.parseConstDirectives(), r = this.parseInputFieldsDefinition();
    return this.node(n, {
      kind: ne.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: o,
      directives: i,
      fields: r
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      N.BRACE_L,
      this.parseInputValueDef,
      N.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const n = this._lexer.lookahead();
    if (n.kind === N.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), o = this.optionalMany(
      N.BRACE_L,
      this.parseOperationTypeDefinition,
      N.BRACE_R
    );
    if (t.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: o
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), o = this.parseConstDirectives();
    if (o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: o
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (o.length === 0 && i.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: o,
      directives: i,
      fields: r
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (o.length === 0 && i.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: o,
      directives: i,
      fields: r
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.UNION_TYPE_EXTENSION,
      name: t,
      directives: o,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.ENUM_TYPE_EXTENSION,
      name: t,
      directives: o,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), o = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: ne.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: o,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(N.AT);
    const o = this.parseName(), i = this.parseArgumentDefs(), r = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(n, {
      kind: ne.DIRECTIVE_DEFINITION,
      description: t,
      name: o,
      arguments: i,
      repeatable: r,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(N.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const n = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(vo, t.value))
      return t;
    throw this.unexpected(n);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const n = this._lexer.token, t = this.expectOptionalToken(N.AT), o = this.parseName();
    let i;
    !t && this.expectOptionalToken(N.DOT) && (i = this.parseName());
    let r;
    return (t || i) && this.expectOptionalToken(N.PAREN_L) && (r = this.parseName(), this.expectToken(N.COLON), this.expectToken(N.PAREN_R)), t ? r ? this.node(n, {
      kind: ne.DIRECTIVE_ARGUMENT_COORDINATE,
      name: o,
      argumentName: r
    }) : this.node(n, {
      kind: ne.DIRECTIVE_COORDINATE,
      name: o
    }) : i ? r ? this.node(n, {
      kind: ne.ARGUMENT_COORDINATE,
      name: o,
      fieldName: i,
      argumentName: r
    }) : this.node(n, {
      kind: ne.MEMBER_COORDINATE,
      name: o,
      memberName: i
    }) : this.node(n, {
      kind: ne.TYPE_COORDINATE,
      name: o
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(n, t) {
    return this._options.noLocation !== !0 && (t.loc = new Rc(
      n,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(n) {
    return this._lexer.token.kind === n;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(n) {
    const t = this._lexer.token;
    if (t.kind === n)
      return this.advanceLexer(), t;
    throw _e(
      this._lexer.source,
      t.start,
      `Expected ${_s(n)}, found ${ti(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(n) {
    return this._lexer.token.kind === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(n) {
    const t = this._lexer.token;
    if (t.kind === N.NAME && t.value === n)
      this.advanceLexer();
    else
      throw _e(
        this._lexer.source,
        t.start,
        `Expected "${n}", found ${ti(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(n) {
    const t = this._lexer.token;
    return t.kind === N.NAME && t.value === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(n) {
    const t = n ?? this._lexer.token;
    return _e(
      this._lexer.source,
      t.start,
      `Unexpected ${ti(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(n, t, o) {
    this.expectToken(n);
    const i = [];
    for (; !this.expectOptionalToken(o); )
      i.push(t.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(n, t, o) {
    if (this.expectOptionalToken(n)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(o));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(n, t, o) {
    this.expectToken(n);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(o));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(n, t) {
    this.expectOptionalToken(n);
    const o = [];
    do
      o.push(t.call(this));
    while (this.expectOptionalToken(n));
    return o;
  }
  advanceLexer() {
    const { maxTokens: n } = this._options, t = this._lexer.advance();
    if (t.kind !== N.EOF && (++this._tokenCounter, n !== void 0 && this._tokenCounter > n))
      throw _e(
        this._lexer.source,
        t.start,
        `Document contains more that ${n} tokens. Parsing aborted.`
      );
  }
}
function ti(e) {
  const n = e.value;
  return _s(e.kind) + (n != null ? ` "${n}"` : "");
}
function _s(e) {
  return Dc(e) ? `"${e}"` : e;
}
function Zc(e) {
  return `"${e.replace(ef, tf)}"`;
}
const ef = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function tf(e) {
  return nf[e.charCodeAt(0)];
}
const nf = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], of = Object.freeze({});
function rf(e, n, t = Us) {
  const o = /* @__PURE__ */ new Map();
  for (const I of Object.values(ne))
    o.set(I, af(n, I));
  let i, r = Array.isArray(e), a = [e], s = -1, u = [], d = e, f, K;
  const w = [], k = [];
  do {
    s++;
    const I = s === a.length, x = I && u.length !== 0;
    if (I) {
      if (f = k.length === 0 ? void 0 : w[w.length - 1], d = K, K = k.pop(), x)
        if (r) {
          d = d.slice();
          let _ = 0;
          for (const [q, V] of u) {
            const L = q - _;
            V === null ? (d.splice(L, 1), _++) : d[L] = V;
          }
        } else {
          d = { ...d };
          for (const [_, q] of u)
            d[_] = q;
        }
      s = i.index, a = i.keys, u = i.edits, r = i.inArray, i = i.prev;
    } else if (K) {
      if (f = r ? s : a[s], d = K[f], d == null)
        continue;
      w.push(f);
    }
    let E;
    if (!Array.isArray(d)) {
      var y, m;
      zr(d) || di(!1, `Invalid AST Node: ${Wo(d)}.`);
      const _ = I ? (y = o.get(d.kind)) === null || y === void 0 ? void 0 : y.leave : (m = o.get(d.kind)) === null || m === void 0 ? void 0 : m.enter;
      if (E = _?.call(n, d, f, K, w, k), E === of)
        break;
      if (E === !1) {
        if (!I) {
          w.pop();
          continue;
        }
      } else if (E !== void 0 && (u.push([f, E]), !I))
        if (zr(E))
          d = E;
        else {
          w.pop();
          continue;
        }
    }
    if (E === void 0 && x && u.push([f, d]), I)
      w.pop();
    else {
      var g;
      i = {
        inArray: r,
        index: s,
        keys: a,
        edits: u,
        prev: i
      }, r = Array.isArray(d), a = r ? d : (g = t[d.kind]) !== null && g !== void 0 ? g : [], s = -1, u = [], K && k.push(K), K = d;
    }
  } while (i !== void 0);
  return u.length !== 0 ? u[u.length - 1][1] : e;
}
function af(e, n) {
  const t = e[n];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function sf(e) {
  return rf(e, uf);
}
const lf = 80, uf = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Y(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const n = to(e.variableDefinitions) ? ce(`(
`, Y(e.variableDefinitions, `
`), `
)`) : ce("(", Y(e.variableDefinitions, ", "), ")"), t = ce("", e.description, `
`) + Y(
        [
          e.operation,
          Y([e.name, n]),
          Y(e.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: n, defaultValue: t, directives: o, description: i }) => ce("", i, `
`) + e + ": " + n + ce(" = ", t) + ce(" ", Y(o, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => mt(e)
  },
  Field: {
    leave({ alias: e, name: n, arguments: t, directives: o, selectionSet: i }) {
      const r = ce("", e, ": ") + n;
      let a = r + ce("(", Y(t, ", "), ")");
      return a.length > lf && (a = r + ce(`(
`, ci(Y(t, `
`)), `
)`)), Y([a, Y(o, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: n }) => "..." + e + ce(" ", Y(n, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: n, selectionSet: t }) => Y(
      [
        "...",
        ce("on ", e),
        Y(n, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: n,
      variableDefinitions: t,
      directives: o,
      selectionSet: i,
      description: r
    }) => ce("", r, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${ce("(", Y(t, ", "), ")")} on ${n} ${ce("", Y(o, " "), " ")}` + i
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: n }) => n ? Tc(e) : Zc(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Y(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Y(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: n }) => "@" + e + ce("(", Y(n, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: n, operationTypes: t }) => ce("", e, `
`) + Y(["schema", Y(n, " "), mt(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: n }) => e + ": " + n
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: n, directives: t }) => ce("", e, `
`) + Y(["scalar", n, Y(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: o, fields: i }) => ce("", e, `
`) + Y(
      [
        "type",
        n,
        ce("implements ", Y(t, " & ")),
        Y(o, " "),
        mt(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: n, arguments: t, type: o, directives: i }) => ce("", e, `
`) + n + (to(t) ? ce(`(
`, ci(Y(t, `
`)), `
)`) : ce("(", Y(t, ", "), ")")) + ": " + o + ce(" ", Y(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: n, type: t, defaultValue: o, directives: i }) => ce("", e, `
`) + Y(
      [n + ": " + t, ce("= ", o), Y(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: o, fields: i }) => ce("", e, `
`) + Y(
      [
        "interface",
        n,
        ce("implements ", Y(t, " & ")),
        Y(o, " "),
        mt(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, types: o }) => ce("", e, `
`) + Y(
      ["union", n, Y(t, " "), ce("= ", Y(o, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, values: o }) => ce("", e, `
`) + Y(["enum", n, Y(t, " "), mt(o)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: n, directives: t }) => ce("", e, `
`) + Y([n, Y(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, fields: o }) => ce("", e, `
`) + Y(["input", n, Y(t, " "), mt(o)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: n, arguments: t, repeatable: o, locations: i }) => ce("", e, `
`) + "directive @" + n + (to(t) ? ce(`(
`, ci(Y(t, `
`)), `
)`) : ce("(", Y(t, ", "), ")")) + (o ? " repeatable" : "") + " on " + Y(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: n }) => Y(
      ["extend schema", Y(e, " "), mt(n)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: n }) => Y(["extend scalar", e, Y(n, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: o }) => Y(
      [
        "extend type",
        e,
        ce("implements ", Y(n, " & ")),
        Y(t, " "),
        mt(o)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: o }) => Y(
      [
        "extend interface",
        e,
        ce("implements ", Y(n, " & ")),
        Y(t, " "),
        mt(o)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: n, types: t }) => Y(
      [
        "extend union",
        e,
        Y(n, " "),
        ce("= ", Y(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: n, values: t }) => Y(["extend enum", e, Y(n, " "), mt(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: n, fields: t }) => Y(["extend input", e, Y(n, " "), mt(t)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: n }) => Y([e, ce(".", n)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: n, argumentName: t }) => Y([e, ce(".", n), ce("(", t, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => Y(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: n }) => Y(["@", e, ce("(", n, ":)")])
  }
};
function Y(e, n = "") {
  var t;
  return (t = e?.filter((o) => o).join(n)) !== null && t !== void 0 ? t : "";
}
function mt(e) {
  return ce(`{
`, ci(Y(e, `
`)), `
}`);
}
function ce(e, n, t = "") {
  return n != null && n !== "" ? e + n + t : "";
}
function ci(e) {
  return ce("  ", e.replace(/\n/g, `
  `));
}
function to(e) {
  var n;
  return (n = e?.some((t) => t.includes(`
`))) !== null && n !== void 0 ? n : !1;
}
const Wr = (e) => {
  let n;
  const t = e.definitions.filter((o) => o.kind === "OperationDefinition");
  return t.length === 1 && (n = t[0]?.name?.value), n;
}, no = (e) => {
  if (typeof e == "string") {
    let t;
    try {
      const o = Wc(e);
      t = Wr(o);
    } catch {
    }
    return { query: e, operationName: t };
  }
  const n = Wr(e);
  return { query: sf(e), operationName: n };
};
class kn extends Error {
  constructor(n, t) {
    const o = `${kn.extractMessage(n)}: ${JSON.stringify({
      response: n,
      request: t
    })}`;
    super(o), Object.setPrototypeOf(this, kn.prototype), this.response = n, this.request = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, kn);
  }
  static extractMessage(n) {
    return n.errors?.[0]?.message ?? `GraphQL Error (Code: ${n.status})`;
  }
}
var ni = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ps(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ii = { exports: {} }, Xr;
function df() {
  return Xr || (Xr = 1, (function(e, n) {
    var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof ni < "u" && ni, o = (function() {
      function r() {
        this.fetch = !1, this.DOMException = t.DOMException;
      }
      return r.prototype = t, new r();
    })();
    (function(r) {
      (function(a) {
        var s = typeof r < "u" && r || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof ni < "u" && ni || {}, u = {
          searchParams: "URLSearchParams" in s,
          iterable: "Symbol" in s && "iterator" in Symbol,
          blob: "FileReader" in s && "Blob" in s && (function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          })(),
          formData: "FormData" in s,
          arrayBuffer: "ArrayBuffer" in s
        };
        function d(S) {
          return S && DataView.prototype.isPrototypeOf(S);
        }
        if (u.arrayBuffer)
          var f = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], K = ArrayBuffer.isView || function(S) {
            return S && f.indexOf(Object.prototype.toString.call(S)) > -1;
          };
        function w(S) {
          if (typeof S != "string" && (S = String(S)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(S) || S === "")
            throw new TypeError('Invalid character in header field name: "' + S + '"');
          return S.toLowerCase();
        }
        function k(S) {
          return typeof S != "string" && (S = String(S)), S;
        }
        function y(S) {
          var M = {
            next: function() {
              var ee = S.shift();
              return { done: ee === void 0, value: ee };
            }
          };
          return u.iterable && (M[Symbol.iterator] = function() {
            return M;
          }), M;
        }
        function m(S) {
          this.map = {}, S instanceof m ? S.forEach(function(M, ee) {
            this.append(ee, M);
          }, this) : Array.isArray(S) ? S.forEach(function(M) {
            if (M.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + M.length);
            this.append(M[0], M[1]);
          }, this) : S && Object.getOwnPropertyNames(S).forEach(function(M) {
            this.append(M, S[M]);
          }, this);
        }
        m.prototype.append = function(S, M) {
          S = w(S), M = k(M);
          var ee = this.map[S];
          this.map[S] = ee ? ee + ", " + M : M;
        }, m.prototype.delete = function(S) {
          delete this.map[w(S)];
        }, m.prototype.get = function(S) {
          return S = w(S), this.has(S) ? this.map[S] : null;
        }, m.prototype.has = function(S) {
          return this.map.hasOwnProperty(w(S));
        }, m.prototype.set = function(S, M) {
          this.map[w(S)] = k(M);
        }, m.prototype.forEach = function(S, M) {
          for (var ee in this.map)
            this.map.hasOwnProperty(ee) && S.call(M, this.map[ee], ee, this);
        }, m.prototype.keys = function() {
          var S = [];
          return this.forEach(function(M, ee) {
            S.push(ee);
          }), y(S);
        }, m.prototype.values = function() {
          var S = [];
          return this.forEach(function(M) {
            S.push(M);
          }), y(S);
        }, m.prototype.entries = function() {
          var S = [];
          return this.forEach(function(M, ee) {
            S.push([ee, M]);
          }), y(S);
        }, u.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
        function g(S) {
          if (!S._noBody) {
            if (S.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            S.bodyUsed = !0;
          }
        }
        function I(S) {
          return new Promise(function(M, ee) {
            S.onload = function() {
              M(S.result);
            }, S.onerror = function() {
              ee(S.error);
            };
          });
        }
        function x(S) {
          var M = new FileReader(), ee = I(M);
          return M.readAsArrayBuffer(S), ee;
        }
        function E(S) {
          var M = new FileReader(), ee = I(M), re = /charset=([A-Za-z0-9_-]+)/.exec(S.type), Ae = re ? re[1] : "utf-8";
          return M.readAsText(S, Ae), ee;
        }
        function _(S) {
          for (var M = new Uint8Array(S), ee = new Array(M.length), re = 0; re < M.length; re++)
            ee[re] = String.fromCharCode(M[re]);
          return ee.join("");
        }
        function q(S) {
          if (S.slice)
            return S.slice(0);
          var M = new Uint8Array(S.byteLength);
          return M.set(new Uint8Array(S)), M.buffer;
        }
        function V() {
          return this.bodyUsed = !1, this._initBody = function(S) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = S, S ? typeof S == "string" ? this._bodyText = S : u.blob && Blob.prototype.isPrototypeOf(S) ? this._bodyBlob = S : u.formData && FormData.prototype.isPrototypeOf(S) ? this._bodyFormData = S : u.searchParams && URLSearchParams.prototype.isPrototypeOf(S) ? this._bodyText = S.toString() : u.arrayBuffer && u.blob && d(S) ? (this._bodyArrayBuffer = q(S.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(S) || K(S)) ? this._bodyArrayBuffer = q(S) : this._bodyText = S = Object.prototype.toString.call(S) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof S == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(S) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, u.blob && (this.blob = function() {
            var S = g(this);
            if (S)
              return S;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var S = g(this);
              return S || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (u.blob)
                return this.blob().then(x);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var S = g(this);
            if (S)
              return S;
            if (this._bodyBlob)
              return E(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(_(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, u.formData && (this.formData = function() {
            return this.text().then(W);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var L = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function $(S) {
          var M = S.toUpperCase();
          return L.indexOf(M) > -1 ? M : S;
        }
        function J(S, M) {
          if (!(this instanceof J))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          M = M || {};
          var ee = M.body;
          if (S instanceof J) {
            if (S.bodyUsed)
              throw new TypeError("Already read");
            this.url = S.url, this.credentials = S.credentials, M.headers || (this.headers = new m(S.headers)), this.method = S.method, this.mode = S.mode, this.signal = S.signal, !ee && S._bodyInit != null && (ee = S._bodyInit, S.bodyUsed = !0);
          } else
            this.url = String(S);
          if (this.credentials = M.credentials || this.credentials || "same-origin", (M.headers || !this.headers) && (this.headers = new m(M.headers)), this.method = $(M.method || this.method || "GET"), this.mode = M.mode || this.mode || null, this.signal = M.signal || this.signal || (function() {
            if ("AbortController" in s) {
              var ue = new AbortController();
              return ue.signal;
            }
          })(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && ee)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(ee), (this.method === "GET" || this.method === "HEAD") && (M.cache === "no-store" || M.cache === "no-cache")) {
            var re = /([?&])_=[^&]*/;
            if (re.test(this.url))
              this.url = this.url.replace(re, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var Ae = /\?/;
              this.url += (Ae.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        J.prototype.clone = function() {
          return new J(this, { body: this._bodyInit });
        };
        function W(S) {
          var M = new FormData();
          return S.trim().split("&").forEach(function(ee) {
            if (ee) {
              var re = ee.split("="), Ae = re.shift().replace(/\+/g, " "), ue = re.join("=").replace(/\+/g, " ");
              M.append(decodeURIComponent(Ae), decodeURIComponent(ue));
            }
          }), M;
        }
        function se(S) {
          var M = new m(), ee = S.replace(/\r?\n[\t ]+/g, " ");
          return ee.split("\r").map(function(re) {
            return re.indexOf(`
`) === 0 ? re.substr(1, re.length) : re;
          }).forEach(function(re) {
            var Ae = re.split(":"), ue = Ae.shift().trim();
            if (ue) {
              var Ee = Ae.join(":").trim();
              try {
                M.append(ue, Ee);
              } catch (De) {
                console.warn("Response " + De.message);
              }
            }
          }), M;
        }
        V.call(J.prototype);
        function fe(S, M) {
          if (!(this instanceof fe))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (M || (M = {}), this.type = "default", this.status = M.status === void 0 ? 200 : M.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = M.statusText === void 0 ? "" : "" + M.statusText, this.headers = new m(M.headers), this.url = M.url || "", this._initBody(S);
        }
        V.call(fe.prototype), fe.prototype.clone = function() {
          return new fe(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new m(this.headers),
            url: this.url
          });
        }, fe.error = function() {
          var S = new fe(null, { status: 200, statusText: "" });
          return S.ok = !1, S.status = 0, S.type = "error", S;
        };
        var j = [301, 302, 303, 307, 308];
        fe.redirect = function(S, M) {
          if (j.indexOf(M) === -1)
            throw new RangeError("Invalid status code");
          return new fe(null, { status: M, headers: { location: S } });
        }, a.DOMException = s.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(M, ee) {
            this.message = M, this.name = ee;
            var re = Error(M);
            this.stack = re.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function ye(S, M) {
          return new Promise(function(ee, re) {
            var Ae = new J(S, M);
            if (Ae.signal && Ae.signal.aborted)
              return re(new a.DOMException("Aborted", "AbortError"));
            var ue = new XMLHttpRequest();
            function Ee() {
              ue.abort();
            }
            ue.onload = function() {
              var be = {
                statusText: ue.statusText,
                headers: se(ue.getAllResponseHeaders() || "")
              };
              Ae.url.indexOf("file://") === 0 && (ue.status < 200 || ue.status > 599) ? be.status = 200 : be.status = ue.status, be.url = "responseURL" in ue ? ue.responseURL : be.headers.get("X-Request-URL");
              var we = "response" in ue ? ue.response : ue.responseText;
              setTimeout(function() {
                ee(new fe(we, be));
              }, 0);
            }, ue.onerror = function() {
              setTimeout(function() {
                re(new TypeError("Network request failed"));
              }, 0);
            }, ue.ontimeout = function() {
              setTimeout(function() {
                re(new TypeError("Network request timed out"));
              }, 0);
            }, ue.onabort = function() {
              setTimeout(function() {
                re(new a.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function De(be) {
              try {
                return be === "" && s.location.href ? s.location.href : be;
              } catch {
                return be;
              }
            }
            if (ue.open(Ae.method, De(Ae.url), !0), Ae.credentials === "include" ? ue.withCredentials = !0 : Ae.credentials === "omit" && (ue.withCredentials = !1), "responseType" in ue && (u.blob ? ue.responseType = "blob" : u.arrayBuffer && (ue.responseType = "arraybuffer")), M && typeof M.headers == "object" && !(M.headers instanceof m || s.Headers && M.headers instanceof s.Headers)) {
              var Be = [];
              Object.getOwnPropertyNames(M.headers).forEach(function(be) {
                Be.push(w(be)), ue.setRequestHeader(be, k(M.headers[be]));
              }), Ae.headers.forEach(function(be, we) {
                Be.indexOf(we) === -1 && ue.setRequestHeader(we, be);
              });
            } else
              Ae.headers.forEach(function(be, we) {
                ue.setRequestHeader(we, be);
              });
            Ae.signal && (Ae.signal.addEventListener("abort", Ee), ue.onreadystatechange = function() {
              ue.readyState === 4 && Ae.signal.removeEventListener("abort", Ee);
            }), ue.send(typeof Ae._bodyInit > "u" ? null : Ae._bodyInit);
          });
        }
        return ye.polyfill = !0, s.fetch || (s.fetch = ye, s.Headers = m, s.Request = J, s.Response = fe), a.Headers = m, a.Request = J, a.Response = fe, a.fetch = ye, Object.defineProperty(a, "__esModule", { value: !0 }), a;
      })({});
    })(o), o.fetch.ponyfill = !0, delete o.fetch.polyfill;
    var i = t.fetch ? t : o;
    n = i.fetch, n.default = i.fetch, n.fetch = i.fetch, n.Headers = i.Headers, n.Request = i.Request, n.Response = i.Response, e.exports = n;
  })(ii, ii.exports)), ii.exports;
}
var wo = df();
const fi = /* @__PURE__ */ Ps(wo), cf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fi
}, Symbol.toStringTag, { value: "Module" })), Xt = (e) => {
  let n = {};
  return e && (typeof Headers < "u" && e instanceof Headers || cf && wo.Headers && e instanceof wo.Headers ? n = mc(e) : Array.isArray(e) ? e.forEach(([t, o]) => {
    t && o !== void 0 && (n[t] = o);
  }) : n = e), n;
}, Zr = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), ff = (e) => {
  if (!Array.isArray(e.query)) {
    const o = e, i = [`query=${encodeURIComponent(Zr(o.query))}`];
    return e.variables && i.push(`variables=${encodeURIComponent(o.jsonSerializer.stringify(o.variables))}`), o.operationName && i.push(`operationName=${encodeURIComponent(o.operationName)}`), i.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const n = e, t = e.query.reduce((o, i, r) => (o.push({
    query: Zr(i),
    variables: n.variables ? n.jsonSerializer.stringify(n.variables[r]) : void 0
  }), o), []);
  return `query=${encodeURIComponent(n.jsonSerializer.stringify(t))}`;
}, pf = (e) => async (n) => {
  const { url: t, query: o, variables: i, operationName: r, fetch: a, fetchOptions: s, middleware: u } = n, d = { ...n.headers };
  let f = "", K;
  e === "POST" ? (K = mf(o, i, r, s.jsonSerializer), typeof K == "string" && (d["Content-Type"] = "application/json")) : f = ff({
    query: o,
    variables: i,
    operationName: r,
    jsonSerializer: s.jsonSerializer ?? zo
  });
  const w = {
    method: e,
    headers: d,
    body: K,
    ...s
  };
  let k = t, y = w;
  if (u) {
    const m = await Promise.resolve(u({ ...w, url: t, operationName: r, variables: i })), { url: g, ...I } = m;
    k = g, y = I;
  }
  return f && (k = `${k}?${f}`), await a(k, y);
};
class hf {
  constructor(n, t = {}) {
    this.url = n, this.requestConfig = t, this.rawRequest = async (...o) => {
      const [i, r, a] = o, s = gc(i, r, a), { headers: u, fetch: d = fi, method: f = "POST", requestMiddleware: K, responseMiddleware: w, ...k } = this.requestConfig, { url: y } = this;
      s.signal !== void 0 && (k.signal = s.signal);
      const { operationName: m } = no(s.query);
      return io({
        url: y,
        query: s.query,
        variables: s.variables,
        headers: {
          ...Xt(ro(u)),
          ...Xt(s.requestHeaders)
        },
        operationName: m,
        fetch: d,
        method: f,
        fetchOptions: k,
        middleware: K
      }).then((g) => (w && w(g), g)).catch((g) => {
        throw w && w(g), g;
      });
    };
  }
  async request(n, ...t) {
    const [o, i] = t, r = Ac(n, o, i), { headers: a, fetch: s = fi, method: u = "POST", requestMiddleware: d, responseMiddleware: f, ...K } = this.requestConfig, { url: w } = this;
    r.signal !== void 0 && (K.signal = r.signal);
    const { query: k, operationName: y } = no(r.document);
    return io({
      url: w,
      query: k,
      variables: r.variables,
      headers: {
        ...Xt(ro(a)),
        ...Xt(r.requestHeaders)
      },
      operationName: y,
      fetch: s,
      method: u,
      fetchOptions: K,
      middleware: d
    }).then((m) => (f && f(m), m.data)).catch((m) => {
      throw f && f(m), m;
    });
  }
  // prettier-ignore
  batchRequests(n, t) {
    const o = yc(n, t), { headers: i, ...r } = this.requestConfig;
    o.signal !== void 0 && (r.signal = o.signal);
    const a = o.documents.map(({ document: u }) => no(u).query), s = o.documents.map(({ variables: u }) => u);
    return io({
      url: this.url,
      query: a,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: s,
      headers: {
        ...Xt(ro(i)),
        ...Xt(o.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? fi,
      method: this.requestConfig.method || "POST",
      fetchOptions: r,
      middleware: this.requestConfig.requestMiddleware
    }).then((u) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u.data)).catch((u) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(u), u;
    });
  }
  setHeaders(n) {
    return this.requestConfig.headers = n, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(n, t) {
    const { headers: o } = this.requestConfig;
    return o ? o[n] = t : this.requestConfig.headers = { [n]: t }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(n) {
    return this.url = n, this;
  }
}
const io = async (e) => {
  const { query: n, variables: t, fetchOptions: o } = e, i = pf(hc(e.method ?? "post")), r = Array.isArray(e.query), a = await i(e), s = await Af(a, o.jsonSerializer ?? zo), u = Array.isArray(s) ? !s.some(({ data: f }) => !f) : !!s.data, d = Array.isArray(s) || !s.errors || Array.isArray(s.errors) && !s.errors.length || o.errorPolicy === "all" || o.errorPolicy === "ignore";
  if (a.ok && d && u) {
    const { errors: f, ...K } = (Array.isArray(s), s), w = o.errorPolicy === "ignore" ? K : s;
    return {
      ...r ? { data: w } : w,
      headers: a.headers,
      status: a.status
    };
  } else {
    const f = typeof s == "string" ? {
      error: s
    } : s;
    throw new kn(
      // @ts-expect-error TODO
      { ...f, status: a.status, headers: a.headers },
      { query: n, variables: t }
    );
  }
};
async function oo(e, n, ...t) {
  const o = Kc(e, n, ...t);
  return new hf(o.url).request({
    ...o
  });
}
const mf = (e, n, t, o) => {
  const i = o ?? zo;
  if (!Array.isArray(e))
    return i.stringify({ query: e, variables: n, operationName: t });
  if (typeof n < "u" && !Array.isArray(n))
    throw new Error("Cannot create request body with given variable type, array expected");
  const r = e.reduce((a, s, u) => (a.push({ query: s, variables: n ? n[u] : void 0 }), a), []);
  return i.stringify(r);
}, Af = async (e, n) => {
  let t;
  return e.headers.forEach((o, i) => {
    i.toLowerCase() === "content-type" && (t = o);
  }), t && (t.toLowerCase().startsWith("application/json") || t.toLowerCase().startsWith("application/graphql+json") || t.toLowerCase().startsWith("application/graphql-response+json")) ? n.parse(await e.text()) : e.text();
}, ro = (e) => typeof e == "function" ? e() : e;
class kR {
  tableId = "";
  filters = {};
  column = "";
  _schemaTablesInformation = {};
  selection = ["id", "name"];
  graphqlUrl = "";
  branch = "root";
  limits = {};
  orderings = {};
  findInAllColumns = "";
  page = {};
  aggregateQuery = !1;
  type = "";
  orCount = 0;
  searchFieldsByProperty = {};
  searchValue = "";
  /**
   * @param {string} graphqlUrl the endpoint to query
   */
  constructor(n) {
    this.graphqlUrl = n;
  }
  table(n) {
    return this.tableId = n, this;
  }
  /**
   * @param {string | string[]} columns
   * When you supply an object the Key is the table or REF property and the value is a string or string array
   */
  select(n) {
    let t = [];
    return Array.isArray(n) ? n ? t = this._createPathFromObject("", n) : t = this.selection : t = [n], t.forEach((o) => o.toLowerCase()), this.selection = t, this;
  }
  /**
   * Builds a query for use in EMX2 GraphQL api
   * @param {string} tableId
   * @param {string[]} columns
   * @param {object[]} filters
   * @returns GraphQL query string
   */
  async execute() {
    if (!this.tableId)
      throw Error(
        `You need to provide ${this.tableId ? "columns" : "a table id"}`
      );
    if (this.selection.length === 0) {
      const n = await this.getColumnsForTable(this.tableId);
      this.selection = n;
    }
    return await oo(
      this.graphqlUrl,
      this.aggregateQuery ? this.getAggregateQuery() : this.getQuery()
    );
  }
  /** Executes the query as aggregate */
  aggregate() {
    return this.aggregateQuery = !0, this;
  }
  getQuery() {
    return this._createQuery(this.tableId, this.selection);
  }
  getAggregateQuery() {
    const n = Object.assign([], this.selection);
    return n.push("count"), this._createQuery(`${this.tableId}_agg`, n);
  }
  /**
   * Gets the table information for the current schema
   */
  async getSchemaTablesInformation() {
    if (Object.keys(this._schemaTablesInformation).length)
      return this._schemaTablesInformation;
    const n = await oo(
      this.graphqlUrl,
      `
        {
            _schema {
              tables {
                name,
                columns {
                name,
                columnType
                }
              }
            }
          }
        `
    );
    return this._schemaTablesInformation = n._schema.tables, this._schemaTablesInformation;
  }
  async saveSetting(n, t) {
    const o = typeof t == "string" ? t : JSON.stringify(t);
    return (await oo(
      this.graphqlUrl,
      `
      mutation{
        change(
            settings: {
              key: "${n}",
              value: "${encodeURI(o)}"
            }
        ){
            message
        }
    }
      `
    )).change.message;
  }
  /** returns the columns with adjusted names so it can directly be used to query. */
  async getColumnsForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.filter(
      (t) => !t.columnType.includes("REF") && !t.columnType.includes("ONTOLOGY")
    );
  }
  /** returns the correct column names and their types. */
  async getColumnsMetadataForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.map((t) => ({
      id: t.id,
      columnType: t.columnType
    }));
  }
  /**
   * If you want to create a nested query, for example { collections: { name: { like: 'lifelines' } } }
   * then column = 'collections', subcolumn = 'name'
   * @param {string} columnId
   * @returns
   */
  where(n) {
    return this.type = "_and", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  orWhere(n) {
    return this.orCount = this.orCount + 1, this.type = "_or", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  /**
   * Works as where, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  filter(n) {
    this.type = "_and";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /**
   * Works as orWhere, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  orFilter(n) {
    this.type = "_or";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /** Resets all filters, useful for when you want to add filters dynamically */
  resetAllFilters() {
    return this.filters = {}, this.findInAllColumns = "", this.page = {}, this.searchFieldsByProperty = {}, this.searchValue = "", this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the amount you want to return
   * @returns
   */
  limit(n, t) {
    let o = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.limits[o] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the page you want to have starting at 0
   * @returns
   */
  offset(n, t) {
    let o = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.page[o] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {string} columnId the name of the column to apply the order to
   * @param {string} direction "asc" or "dsc"
   */
  orderBy(n, t, o) {
    let i = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : this._toCamelCase(n);
    return this.orderings[i] = { column: t, direction: o }, this;
  }
  /**
   * Additional function, which does the same as search but might be more semantic
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  find(n) {
    return this.findInAllColumns = n, this;
  }
  /**
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  search(n) {
    return this.findInAllColumns = n, this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  equals(n) {
    return this._createFilter("equals", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  in(n) {
    return this._createFilter("in", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  notEquals(n) {
    return this._createFilter("not_equals", n), this;
  }
  /** Text, String, Url, Filter */
  orLike(n) {
    return this._createFilter("orLike", n);
  }
  /** Text, String, Url, Filter */
  like(n) {
    return this._createFilter("like", n);
  }
  /** Text, String, Url, Filter */
  notLike(n) {
    return this._createFilter("not_like", n), this;
  }
  /** Text, String, Url, Filter */
  triagramSearch(n) {
    return this._createFilter("triagram_search", n), this;
  }
  /** Text, String, Url, Filter */
  textSearch(n) {
    return this._createFilter("text_search", n), this;
  }
  /** Int, DateTime Filter */
  between(n) {
    return this._createFilter("between", n), this;
  }
  /** Int, DateTime Filter */
  notBetween(n) {
    return this._createFilter("not_between", n), this;
  }
  _toPascalCase(n) {
    return n[0].toUpperCase() + n.substring(1);
  }
  _toCamelCase(n) {
    return n[0].toLowerCase() + n.substring(1);
  }
  _createQuery(n, t) {
    const o = this._generateModifiers("root");
    let i = `{
${n}${o} {
`, r = this._createBranches(t);
    return i = this._generateOutput(r, 1, this.filters, i), i += `  }
}`, i;
  }
  // the best query would be for example"
  // Biobanks(orderby: { name: ASC }, filter: {collections: {_and: [{materials: {name: {like: "BUFFY_COAT"}}}, {materials: {name: {like: "CELL_LINES"}}}]}})
  // but this requires another rewrite ;)
  _createFilterString(n, t) {
    let o = "";
    const i = n && n._and ? n._and.length : 0, r = n && n._or ? n._or.length : 0;
    if (i + r > 1) {
      let a = "";
      n._and.length && n._and.forEach((s) => {
        a.length && (a += ", "), a += `{ _and: [ ${s} ] }`;
      }), n._or.length && (a.length && (a += ", "), n._or.forEach((s) => {
        a.length && !a.endsWith(", ") && (a += ", "), a += `{ _or: [ ${s} ] }`;
      })), o += `_and: [ ${a} ]`;
    } else if (i === 1) {
      const a = n._and;
      o += `_and: [ ${a} ]`;
    } else if (r === 1) {
      const a = n._or;
      o += `_or: [ ${a} ]`;
    }
    if (this.searchValue && Object.keys(this.searchFieldsByProperty).includes(t) && this.searchFieldsByProperty[t].length) {
      let a = "";
      this.searchFieldsByProperty[t].forEach((s) => {
        a.length && (a += ", "), a += this.buildExpandedLike(s, this.searchValue);
      }), o = o.length ? `_and: [ { _or: [ ${a} ] } , { ${o} } ]` : `_or: [ ${a} ]`;
    }
    return o;
  }
  buildExpandedLike(n, t) {
    const o = n.split(".");
    return o.reduce((r, a) => r + `{ ${a}: `, "") + `{ like: "${t}" } }` + " }".repeat(o.length - 1);
  }
  /** Create a nested object to represent the branches and their properties */
  _createBranches(n) {
    let t = {};
    for (let o of n) {
      let i = o.split("."), r = t;
      for (let s = 0; s < i.length - 1; s++) {
        let u = this._toCamelCase(i[s].trim());
        r[u] || (r[u] = {}), r = r[u];
      }
      let a = this._toCamelCase(i[i.length - 1].trim());
      a.indexOf(".") >= 0 ? r[a] = {} : (r.properties || (r.properties = {}), r.properties[a] = !0);
    }
    return t;
  }
  /** Generate the bit inside parentheses */
  _generateModifiers(n) {
    const t = [];
    t.push(
      this.findInAllColumns.length && n === "root" ? `search: "${this.findInAllColumns}"` : ""
    ), t.push(
      this.limits[n] ? `limit: ${this.limits[n]}` : ""
    ), t.push(
      this.page[n] ? `offset: ${this.page[n]}` : ""
    ), t.push(
      this.orderings[n] ? `orderby: { ${this.orderings[n].column}: ${this.orderings[n].direction.toUpperCase()} }` : ""
    );
    const o = this._createFilterString(
      this.filters[n],
      n
    );
    o.length && t.push(`filter: { ${o} }`);
    const i = t.filter((r) => r.length > 0);
    return i.length ? `(${i.join(", ")})` : "";
  }
  _createFilterFromPath(n, t, o) {
    const i = Array.isArray(o) ? o : [o], r = this._getGqlOperator(t), a = n.split(".").reverse();
    if (this.type === "_or" && r === "equals") {
      let s = `{ ${r}: [${i.map(
        (u) => typeof u == "boolean" ? `${u}` : `"${u}"`
      )}] }`;
      for (const u of a)
        s = `{ ${u}: ${s} }`;
      this.filters[this.branch][this.type].push(s);
    } else
      for (const s of i) {
        let u = typeof s == "boolean" ? `${s}` : `"${s}"`, d = `{ ${r}: ${u} }`;
        for (const f of a)
          d = `{ ${f}: ${d} }`;
        this.filters[this.branch][this.type].push(d);
      }
  }
  _getGqlOperator(n) {
    switch (n) {
      case "in":
        return "equals";
      case "orLike":
        return "like";
      default:
        return n;
    }
  }
  /** Private function to create the correct filter syntax. */
  _createFilter(n, t) {
    return this.filters[this.branch] || (this.filters[this.branch] = {
      _and: [],
      _or: []
    }), this._createFilterFromPath(this.column, n, t), this.column = "", this;
  }
  /** Recursively generate the output string for the branches and their properties */
  _generateOutput(n, t, o, i) {
    let r = "    ".repeat(t);
    if (n.properties) {
      let a = n.properties;
      for (let s in a)
        a[s] === !0 && (i += `${r}${s},
`);
      i = `${i.substring(0, i.length - 2)}
`;
    }
    for (let a in n) {
      let s = n[a];
      if (a !== "properties") {
        i = `${i.substring(0, i.length - 1)},
`;
        const u = this._generateModifiers(a);
        i += `${r}${a}${u || ""} {
`, i = this._generateOutput(
          s,
          t + 1,
          o,
          i
        ), i += r + `}
`;
      }
    }
    return i;
  }
  _createPathFromObject(n, t, o = []) {
    for (const i of t)
      if (typeof i == "object") {
        const r = Object.keys(i)[0], a = n ? `${n}.${r}` : r;
        this._createPathFromObject(
          a,
          i[r],
          o
        );
      } else
        !n || n.length === 0 ? o.push(i) : o.push(`${n}.${i}`);
    return o;
  }
}
const P = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, i] of n)
    t[o] = i;
  return t;
}, gf = {
  name: "ButtonAction",
  props: {
    href: { type: String, required: !1 },
    icon: { type: String, required: !1 },
    target: { type: String, required: !1 },
    disabled: { type: Boolean, required: !1 }
  },
  methods: {
    onClick() {
      window && window.open && this.href ? window.open(this.href, this.target ? this.target : "_self") : this.$emit("click");
    }
  },
  emits: ["click"]
}, yf = ["disabled"];
function Kf(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: "btn btn-primary",
    disabled: t.disabled,
    onClick: n[0] || (n[0] = Ke((...a) => r.onClick && r.onClick(...a), ["prevent"]))
  }, [
    H(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : v("", !0)
  ], 8, yf);
}
const He = /* @__PURE__ */ P(gf, [["render", Kf]]), bf = {
  name: "ButtonAlt",
  extends: He,
  props: {
    light: { type: Boolean, default: !1 },
    icon: {
      type: String,
      required: !1,
      default: () => null
    }
  }
};
function vf(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: G(["btn border-0", t.light ? "btn-outline-light" : "btn-outline-primary"]),
    onClick: n[0] || (n[0] = Ke((...a) => e.onClick && e.onClick(...a), ["prevent"]))
  }, [
    H(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G("fa fa-fw fa-" + t.icon)
    }, null, 2)) : v("", !0)
  ], 2);
}
const ot = /* @__PURE__ */ P(bf, [["render", vf]]), Cf = {}, wf = {
  class: "alert alert-danger",
  role: "alert"
};
function Ff(e, n) {
  return l(), c("div", wf, [
    H(e.$slots, "default")
  ]);
}
const rt = /* @__PURE__ */ P(Cf, [["render", Ff]]), Rf = {}, kf = {
  class: "alert alert-success",
  role: "alert"
};
function Uf(e, n) {
  return l(), c("div", kf, [
    H(e.$slots, "default")
  ]);
}
const mn = /* @__PURE__ */ P(Rf, [["render", Uf]]), Ef = {}, Sf = {
  class: "spinner-border",
  role: "status"
};
function Tf(e, n) {
  return l(), c("div", Sf, [...n[0] || (n[0] = [
    p("span", { class: "sr-only" }, "Loading...", -1)
  ])]);
}
const bt = /* @__PURE__ */ P(Ef, [["render", Tf]]), If = {
  name: "LayoutModal",
  props: {
    /** When true the modal will be shown */
    show: {
      type: Boolean,
      default: !0
    },
    /** Shown as the title of the model */
    title: { type: String, default: "" },
    isCloseButtonShown: { type: Boolean, default: !0 }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    escapeKeyHandler(e) {
      e.key === "Escape" && this.close();
    }
  },
  beforeMount() {
    document && document.addEventListener && document.addEventListener("keydown", this.escapeKeyHandler);
  },
  beforeDestroy() {
    document && document.removeEventListener && document.removeEventListener("keydown", this.escapeKeyHandler);
  },
  emits: ["close"]
}, Df = {
  key: 0,
  class: "modal fade show",
  role: "dialog",
  style: { display: "block", overflow: "scroll" },
  tabindex: "-1",
  "aria-modal": "true"
}, Of = {
  key: 0,
  class: "modal-dialog modal-xl",
  role: "document"
}, _f = { class: "modal-content" }, Pf = { class: "modal-header" }, Mf = { class: "modal-title" }, Nf = { class: "modal-body bg-light" }, Bf = { class: "modal-footer" };
function Lf(e, n, t, o, i, r) {
  return l(), c("div", null, [
    t.show ? (l(), c("div", Df, [
      t.show ? (l(), c("div", Of, [
        p("div", _f, [
          p("div", Pf, [
            p("h5", Mf, U(t.title), 1),
            t.isCloseButtonShown ? (l(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: n[0] || (n[0] = Ke((...a) => r.close && r.close(...a), ["prevent"]))
            }, [...n[1] || (n[1] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : v("", !0)
          ]),
          p("div", Nf, [
            H(e.$slots, "body", {}, void 0, !0)
          ]),
          p("div", Bf, [
            H(e.$slots, "footer", {}, void 0, !0)
          ])
        ])
      ])) : v("", !0)
    ])) : v("", !0)
  ]);
}
const vt = /* @__PURE__ */ P(If, [["render", Lf], ["__scopeId", "data-v-84d87320"]]), Ce = {
  name: "BaseInput",
  props: {
    /**
     * Unique identifier https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
     * Has no direct EMX2 implementation but can be constructed by concatenating the table name with the field name
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * Name of the element. For example used by the server to identify the fields in form submits.
     * relates to EMX2 columnId
     */
    name: {
      type: String,
      required: !1
    },
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    },
    /**
     * Caption for an item in a user interface.
     * relates to EMX2 label
     */
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    /**
     * EMX2 description
     */
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [Boolean, String],
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      required: !1,
      default: () => null
    }
  },
  computed: {
    placeholderValue() {
      return this.placeholder;
    }
  },
  emits: ["update:modelValue"]
}, xf = {
  name: "FormGroup",
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [String, Boolean],
      required: !1,
      default: () => !1
    },
    errorMessage: {
      type: String,
      required: !1
    }
  },
  methods: {
    isRequired: Vn,
    hasDescription(e) {
      return e != null && e.length;
    }
  }
}, qf = { class: "form-group" }, Vf = ["for"], jf = {
  key: 1,
  class: "float-right"
}, Hf = {
  key: 2,
  class: "text-danger form-text"
}, Gf = ["id"];
function Qf(e, n, t, o, i, r) {
  return l(), c("div", qf, [
    t.label !== null && t.label !== void 0 ? (l(), c("label", {
      key: 0,
      for: t.id
    }, [
      p("b", null, U(t.label), 1)
    ], 8, Vf)) : v("", !0),
    r.isRequired(t.required) ? (l(), c("span", jf, " (required) ")) : v("", !0),
    H(e.$slots, "default"),
    t.errorMessage ? (l(), c("small", Hf, U(t.errorMessage), 1)) : v("", !0),
    r.hasDescription(t.description) ? (l(), c("small", {
      key: 3,
      id: t.id + "-help-text",
      class: "form-text text-muted"
    }, U(t.description), 9, Gf)) : v("", !0)
  ]);
}
const Ue = /* @__PURE__ */ P(xf, [["render", Qf]]), $f = {
  name: "InputPassword",
  components: { FormGroup: Ue },
  extends: Ce
}, Jf = ["id", "name", "value", "aria-describedby", "placeholder"];
function zf(e, n, t, o, i, r) {
  const a = b("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      p("input", {
        id: e.id,
        name: e.name,
        value: e.modelValue,
        onInput: n[0] || (n[0] = (s) => e.$emit("update:modelValue", s.target.value)),
        type: "password",
        class: G(["form-control", { "is-invalid": e.errorMessage }]),
        "aria-describedby": e.id,
        placeholder: e.label
      }, null, 42, Jf)
    ]),
    _: 1
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Xo = /* @__PURE__ */ P($f, [["render", zf]]);
var Je = "top", dt = "bottom", ct = "right", ze = "left", Zo = "auto", Hn = [Je, dt, ct, ze], ln = "start", Dn = "end", Yf = "clippingParents", Ms = "viewport", wn = "popper", Wf = "reference", ea = /* @__PURE__ */ Hn.reduce(function(e, n) {
  return e.concat([n + "-" + ln, n + "-" + Dn]);
}, []), Ns = /* @__PURE__ */ [].concat(Hn, [Zo]).reduce(function(e, n) {
  return e.concat([n, n + "-" + ln, n + "-" + Dn]);
}, []), Xf = "beforeRead", Zf = "read", ep = "afterRead", tp = "beforeMain", np = "main", ip = "afterMain", op = "beforeWrite", rp = "write", ap = "afterWrite", sp = [Xf, Zf, ep, tp, np, ip, op, rp, ap];
function Rt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function it(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function Gt(e) {
  var n = it(e).Element;
  return e instanceof n || e instanceof Element;
}
function ut(e) {
  var n = it(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function er(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = it(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function lp(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var o = n.styles[t] || {}, i = n.attributes[t] || {}, r = n.elements[t];
    !ut(r) || !Rt(r) || (Object.assign(r.style, o), Object.keys(i).forEach(function(a) {
      var s = i[a];
      s === !1 ? r.removeAttribute(a) : r.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function up(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(o) {
      var i = n.elements[o], r = n.attributes[o] || {}, a = Object.keys(n.styles.hasOwnProperty(o) ? n.styles[o] : t[o]), s = a.reduce(function(u, d) {
        return u[d] = "", u;
      }, {});
      !ut(i) || !Rt(i) || (Object.assign(i.style, s), Object.keys(r).forEach(function(u) {
        i.removeAttribute(u);
      }));
    });
  };
}
const dp = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: lp,
  effect: up,
  requires: ["computeStyles"]
};
function Ft(e) {
  return e.split("-")[0];
}
var qt = Math.max, wi = Math.min, un = Math.round;
function Fo() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function Bs() {
  return !/^((?!chrome|android).)*safari/i.test(Fo());
}
function dn(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var o = e.getBoundingClientRect(), i = 1, r = 1;
  n && ut(e) && (i = e.offsetWidth > 0 && un(o.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && un(o.height) / e.offsetHeight || 1);
  var a = Gt(e) ? it(e) : window, s = a.visualViewport, u = !Bs() && t, d = (o.left + (u && s ? s.offsetLeft : 0)) / i, f = (o.top + (u && s ? s.offsetTop : 0)) / r, K = o.width / i, w = o.height / r;
  return {
    width: K,
    height: w,
    top: f,
    right: d + K,
    bottom: f + w,
    left: d,
    x: d,
    y: f
  };
}
function tr(e) {
  var n = dn(e), t = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - o) <= 1 && (o = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: o
  };
}
function Ls(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && er(t)) {
    var o = n;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function St(e) {
  return it(e).getComputedStyle(e);
}
function cp(e) {
  return ["table", "td", "th"].indexOf(Rt(e)) >= 0;
}
function Ot(e) {
  return ((Gt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ni(e) {
  return Rt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (er(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ot(e)
  );
}
function ta(e) {
  return !ut(e) || // https://github.com/popperjs/popper-core/issues/837
  St(e).position === "fixed" ? null : e.offsetParent;
}
function fp(e) {
  var n = /firefox/i.test(Fo()), t = /Trident/i.test(Fo());
  if (t && ut(e)) {
    var o = St(e);
    if (o.position === "fixed")
      return null;
  }
  var i = Ni(e);
  for (er(i) && (i = i.host); ut(i) && ["html", "body"].indexOf(Rt(i)) < 0; ) {
    var r = St(i);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Gn(e) {
  for (var n = it(e), t = ta(e); t && cp(t) && St(t).position === "static"; )
    t = ta(t);
  return t && (Rt(t) === "html" || Rt(t) === "body" && St(t).position === "static") ? n : t || fp(e) || n;
}
function nr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Un(e, n, t) {
  return qt(e, wi(n, t));
}
function pp(e, n, t) {
  var o = Un(e, n, t);
  return o > t ? t : o;
}
function xs() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function qs(e) {
  return Object.assign({}, xs(), e);
}
function Vs(e, n) {
  return n.reduce(function(t, o) {
    return t[o] = e, t;
  }, {});
}
var hp = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, qs(typeof n != "number" ? n : Vs(n, Hn));
};
function mp(e) {
  var n, t = e.state, o = e.name, i = e.options, r = t.elements.arrow, a = t.modifiersData.popperOffsets, s = Ft(t.placement), u = nr(s), d = [ze, ct].indexOf(s) >= 0, f = d ? "height" : "width";
  if (!(!r || !a)) {
    var K = hp(i.padding, t), w = tr(r), k = u === "y" ? Je : ze, y = u === "y" ? dt : ct, m = t.rects.reference[f] + t.rects.reference[u] - a[u] - t.rects.popper[f], g = a[u] - t.rects.reference[u], I = Gn(r), x = I ? u === "y" ? I.clientHeight || 0 : I.clientWidth || 0 : 0, E = m / 2 - g / 2, _ = K[k], q = x - w[f] - K[y], V = x / 2 - w[f] / 2 + E, L = Un(_, V, q), $ = u;
    t.modifiersData[o] = (n = {}, n[$] = L, n.centerOffset = L - V, n);
  }
}
function Ap(e) {
  var n = e.state, t = e.options, o = t.element, i = o === void 0 ? "[data-popper-arrow]" : o;
  i != null && (typeof i == "string" && (i = n.elements.popper.querySelector(i), !i) || Ls(n.elements.popper, i) && (n.elements.arrow = i));
}
const gp = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: mp,
  effect: Ap,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function cn(e) {
  return e.split("-")[1];
}
var yp = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Kp(e, n) {
  var t = e.x, o = e.y, i = n.devicePixelRatio || 1;
  return {
    x: un(t * i) / i || 0,
    y: un(o * i) / i || 0
  };
}
function na(e) {
  var n, t = e.popper, o = e.popperRect, i = e.placement, r = e.variation, a = e.offsets, s = e.position, u = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, K = e.isFixed, w = a.x, k = w === void 0 ? 0 : w, y = a.y, m = y === void 0 ? 0 : y, g = typeof f == "function" ? f({
    x: k,
    y: m
  }) : {
    x: k,
    y: m
  };
  k = g.x, m = g.y;
  var I = a.hasOwnProperty("x"), x = a.hasOwnProperty("y"), E = ze, _ = Je, q = window;
  if (d) {
    var V = Gn(t), L = "clientHeight", $ = "clientWidth";
    if (V === it(t) && (V = Ot(t), St(V).position !== "static" && s === "absolute" && (L = "scrollHeight", $ = "scrollWidth")), V = V, i === Je || (i === ze || i === ct) && r === Dn) {
      _ = dt;
      var J = K && V === q && q.visualViewport ? q.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        V[L]
      );
      m -= J - o.height, m *= u ? 1 : -1;
    }
    if (i === ze || (i === Je || i === dt) && r === Dn) {
      E = ct;
      var W = K && V === q && q.visualViewport ? q.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        V[$]
      );
      k -= W - o.width, k *= u ? 1 : -1;
    }
  }
  var se = Object.assign({
    position: s
  }, d && yp), fe = f === !0 ? Kp({
    x: k,
    y: m
  }, it(t)) : {
    x: k,
    y: m
  };
  if (k = fe.x, m = fe.y, u) {
    var j;
    return Object.assign({}, se, (j = {}, j[_] = x ? "0" : "", j[E] = I ? "0" : "", j.transform = (q.devicePixelRatio || 1) <= 1 ? "translate(" + k + "px, " + m + "px)" : "translate3d(" + k + "px, " + m + "px, 0)", j));
  }
  return Object.assign({}, se, (n = {}, n[_] = x ? m + "px" : "", n[E] = I ? k + "px" : "", n.transform = "", n));
}
function bp(e) {
  var n = e.state, t = e.options, o = t.gpuAcceleration, i = o === void 0 ? !0 : o, r = t.adaptive, a = r === void 0 ? !0 : r, s = t.roundOffsets, u = s === void 0 ? !0 : s, d = {
    placement: Ft(n.placement),
    variation: cn(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: i,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, na(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: a,
    roundOffsets: u
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, na(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const vp = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: bp,
  data: {}
};
var oi = {
  passive: !0
};
function Cp(e) {
  var n = e.state, t = e.instance, o = e.options, i = o.scroll, r = i === void 0 ? !0 : i, a = o.resize, s = a === void 0 ? !0 : a, u = it(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(f) {
    f.addEventListener("scroll", t.update, oi);
  }), s && u.addEventListener("resize", t.update, oi), function() {
    r && d.forEach(function(f) {
      f.removeEventListener("scroll", t.update, oi);
    }), s && u.removeEventListener("resize", t.update, oi);
  };
}
const wp = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Cp,
  data: {}
};
var Fp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function pi(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return Fp[n];
  });
}
var Rp = {
  start: "end",
  end: "start"
};
function ia(e) {
  return e.replace(/start|end/g, function(n) {
    return Rp[n];
  });
}
function ir(e) {
  var n = it(e), t = n.pageXOffset, o = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: o
  };
}
function or(e) {
  return dn(Ot(e)).left + ir(e).scrollLeft;
}
function kp(e, n) {
  var t = it(e), o = Ot(e), i = t.visualViewport, r = o.clientWidth, a = o.clientHeight, s = 0, u = 0;
  if (i) {
    r = i.width, a = i.height;
    var d = Bs();
    (d || !d && n === "fixed") && (s = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: s + or(e),
    y: u
  };
}
function Up(e) {
  var n, t = Ot(e), o = ir(e), i = (n = e.ownerDocument) == null ? void 0 : n.body, r = qt(t.scrollWidth, t.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = qt(t.scrollHeight, t.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -o.scrollLeft + or(e), u = -o.scrollTop;
  return St(i || t).direction === "rtl" && (s += qt(t.clientWidth, i ? i.clientWidth : 0) - r), {
    width: r,
    height: a,
    x: s,
    y: u
  };
}
function rr(e) {
  var n = St(e), t = n.overflow, o = n.overflowX, i = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + i + o);
}
function js(e) {
  return ["html", "body", "#document"].indexOf(Rt(e)) >= 0 ? e.ownerDocument.body : ut(e) && rr(e) ? e : js(Ni(e));
}
function En(e, n) {
  var t;
  n === void 0 && (n = []);
  var o = js(e), i = o === ((t = e.ownerDocument) == null ? void 0 : t.body), r = it(o), a = i ? [r].concat(r.visualViewport || [], rr(o) ? o : []) : o, s = n.concat(a);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(En(Ni(a)))
  );
}
function Ro(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ep(e, n) {
  var t = dn(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function oa(e, n, t) {
  return n === Ms ? Ro(kp(e, t)) : Gt(n) ? Ep(n, t) : Ro(Up(Ot(e)));
}
function Sp(e) {
  var n = En(Ni(e)), t = ["absolute", "fixed"].indexOf(St(e).position) >= 0, o = t && ut(e) ? Gn(e) : e;
  return Gt(o) ? n.filter(function(i) {
    return Gt(i) && Ls(i, o) && Rt(i) !== "body";
  }) : [];
}
function Tp(e, n, t, o) {
  var i = n === "clippingParents" ? Sp(e) : [].concat(n), r = [].concat(i, [t]), a = r[0], s = r.reduce(function(u, d) {
    var f = oa(e, d, o);
    return u.top = qt(f.top, u.top), u.right = wi(f.right, u.right), u.bottom = wi(f.bottom, u.bottom), u.left = qt(f.left, u.left), u;
  }, oa(e, a, o));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Hs(e) {
  var n = e.reference, t = e.element, o = e.placement, i = o ? Ft(o) : null, r = o ? cn(o) : null, a = n.x + n.width / 2 - t.width / 2, s = n.y + n.height / 2 - t.height / 2, u;
  switch (i) {
    case Je:
      u = {
        x: a,
        y: n.y - t.height
      };
      break;
    case dt:
      u = {
        x: a,
        y: n.y + n.height
      };
      break;
    case ct:
      u = {
        x: n.x + n.width,
        y: s
      };
      break;
    case ze:
      u = {
        x: n.x - t.width,
        y: s
      };
      break;
    default:
      u = {
        x: n.x,
        y: n.y
      };
  }
  var d = i ? nr(i) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (r) {
      case ln:
        u[d] = u[d] - (n[f] / 2 - t[f] / 2);
        break;
      case Dn:
        u[d] = u[d] + (n[f] / 2 - t[f] / 2);
        break;
    }
  }
  return u;
}
function On(e, n) {
  n === void 0 && (n = {});
  var t = n, o = t.placement, i = o === void 0 ? e.placement : o, r = t.strategy, a = r === void 0 ? e.strategy : r, s = t.boundary, u = s === void 0 ? Yf : s, d = t.rootBoundary, f = d === void 0 ? Ms : d, K = t.elementContext, w = K === void 0 ? wn : K, k = t.altBoundary, y = k === void 0 ? !1 : k, m = t.padding, g = m === void 0 ? 0 : m, I = qs(typeof g != "number" ? g : Vs(g, Hn)), x = w === wn ? Wf : wn, E = e.rects.popper, _ = e.elements[y ? x : w], q = Tp(Gt(_) ? _ : _.contextElement || Ot(e.elements.popper), u, f, a), V = dn(e.elements.reference), L = Hs({
    reference: V,
    element: E,
    placement: i
  }), $ = Ro(Object.assign({}, E, L)), J = w === wn ? $ : V, W = {
    top: q.top - J.top + I.top,
    bottom: J.bottom - q.bottom + I.bottom,
    left: q.left - J.left + I.left,
    right: J.right - q.right + I.right
  }, se = e.modifiersData.offset;
  if (w === wn && se) {
    var fe = se[i];
    Object.keys(W).forEach(function(j) {
      var ye = [ct, dt].indexOf(j) >= 0 ? 1 : -1, S = [Je, dt].indexOf(j) >= 0 ? "y" : "x";
      W[j] += fe[S] * ye;
    });
  }
  return W;
}
function Ip(e, n) {
  n === void 0 && (n = {});
  var t = n, o = t.placement, i = t.boundary, r = t.rootBoundary, a = t.padding, s = t.flipVariations, u = t.allowedAutoPlacements, d = u === void 0 ? Ns : u, f = cn(o), K = f ? s ? ea : ea.filter(function(y) {
    return cn(y) === f;
  }) : Hn, w = K.filter(function(y) {
    return d.indexOf(y) >= 0;
  });
  w.length === 0 && (w = K);
  var k = w.reduce(function(y, m) {
    return y[m] = On(e, {
      placement: m,
      boundary: i,
      rootBoundary: r,
      padding: a
    })[Ft(m)], y;
  }, {});
  return Object.keys(k).sort(function(y, m) {
    return k[y] - k[m];
  });
}
function Dp(e) {
  if (Ft(e) === Zo)
    return [];
  var n = pi(e);
  return [ia(e), n, ia(n)];
}
function Op(e) {
  var n = e.state, t = e.options, o = e.name;
  if (!n.modifiersData[o]._skip) {
    for (var i = t.mainAxis, r = i === void 0 ? !0 : i, a = t.altAxis, s = a === void 0 ? !0 : a, u = t.fallbackPlacements, d = t.padding, f = t.boundary, K = t.rootBoundary, w = t.altBoundary, k = t.flipVariations, y = k === void 0 ? !0 : k, m = t.allowedAutoPlacements, g = n.options.placement, I = Ft(g), x = I === g, E = u || (x || !y ? [pi(g)] : Dp(g)), _ = [g].concat(E).reduce(function(be, we) {
      return be.concat(Ft(we) === Zo ? Ip(n, {
        placement: we,
        boundary: f,
        rootBoundary: K,
        padding: d,
        flipVariations: y,
        allowedAutoPlacements: m
      }) : we);
    }, []), q = n.rects.reference, V = n.rects.popper, L = /* @__PURE__ */ new Map(), $ = !0, J = _[0], W = 0; W < _.length; W++) {
      var se = _[W], fe = Ft(se), j = cn(se) === ln, ye = [Je, dt].indexOf(fe) >= 0, S = ye ? "width" : "height", M = On(n, {
        placement: se,
        boundary: f,
        rootBoundary: K,
        altBoundary: w,
        padding: d
      }), ee = ye ? j ? ct : ze : j ? dt : Je;
      q[S] > V[S] && (ee = pi(ee));
      var re = pi(ee), Ae = [];
      if (r && Ae.push(M[fe] <= 0), s && Ae.push(M[ee] <= 0, M[re] <= 0), Ae.every(function(be) {
        return be;
      })) {
        J = se, $ = !1;
        break;
      }
      L.set(se, Ae);
    }
    if ($)
      for (var ue = y ? 3 : 1, Ee = function(we) {
        var at = _.find(function(pt) {
          var de = L.get(pt);
          if (de)
            return de.slice(0, we).every(function(pe) {
              return pe;
            });
        });
        if (at)
          return J = at, "break";
      }, De = ue; De > 0; De--) {
        var Be = Ee(De);
        if (Be === "break") break;
      }
    n.placement !== J && (n.modifiersData[o]._skip = !0, n.placement = J, n.reset = !0);
  }
}
const _p = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Op,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ra(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function aa(e) {
  return [Je, ct, dt, ze].some(function(n) {
    return e[n] >= 0;
  });
}
function Pp(e) {
  var n = e.state, t = e.name, o = n.rects.reference, i = n.rects.popper, r = n.modifiersData.preventOverflow, a = On(n, {
    elementContext: "reference"
  }), s = On(n, {
    altBoundary: !0
  }), u = ra(a, o), d = ra(s, i, r), f = aa(u), K = aa(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: K
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": K
  });
}
const Mp = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Pp
};
function Np(e, n, t) {
  var o = Ft(e), i = [ze, Je].indexOf(o) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, a = r[0], s = r[1];
  return a = a || 0, s = (s || 0) * i, [ze, ct].indexOf(o) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function Bp(e) {
  var n = e.state, t = e.options, o = e.name, i = t.offset, r = i === void 0 ? [0, 0] : i, a = Ns.reduce(function(f, K) {
    return f[K] = Np(K, n.rects, r), f;
  }, {}), s = a[n.placement], u = s.x, d = s.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += u, n.modifiersData.popperOffsets.y += d), n.modifiersData[o] = a;
}
const Lp = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Bp
};
function xp(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = Hs({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const qp = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: xp,
  data: {}
};
function Vp(e) {
  return e === "x" ? "y" : "x";
}
function jp(e) {
  var n = e.state, t = e.options, o = e.name, i = t.mainAxis, r = i === void 0 ? !0 : i, a = t.altAxis, s = a === void 0 ? !1 : a, u = t.boundary, d = t.rootBoundary, f = t.altBoundary, K = t.padding, w = t.tether, k = w === void 0 ? !0 : w, y = t.tetherOffset, m = y === void 0 ? 0 : y, g = On(n, {
    boundary: u,
    rootBoundary: d,
    padding: K,
    altBoundary: f
  }), I = Ft(n.placement), x = cn(n.placement), E = !x, _ = nr(I), q = Vp(_), V = n.modifiersData.popperOffsets, L = n.rects.reference, $ = n.rects.popper, J = typeof m == "function" ? m(Object.assign({}, n.rects, {
    placement: n.placement
  })) : m, W = typeof J == "number" ? {
    mainAxis: J,
    altAxis: J
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, J), se = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, fe = {
    x: 0,
    y: 0
  };
  if (V) {
    if (r) {
      var j, ye = _ === "y" ? Je : ze, S = _ === "y" ? dt : ct, M = _ === "y" ? "height" : "width", ee = V[_], re = ee + g[ye], Ae = ee - g[S], ue = k ? -$[M] / 2 : 0, Ee = x === ln ? L[M] : $[M], De = x === ln ? -$[M] : -L[M], Be = n.elements.arrow, be = k && Be ? tr(Be) : {
        width: 0,
        height: 0
      }, we = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : xs(), at = we[ye], pt = we[S], de = Un(0, L[M], be[M]), pe = E ? L[M] / 2 - ue - de - at - W.mainAxis : Ee - de - at - W.mainAxis, Te = E ? -L[M] / 2 + ue + de + pt + W.mainAxis : De + de + pt + W.mainAxis, Le = n.elements.arrow && Gn(n.elements.arrow), It = Le ? _ === "y" ? Le.clientTop || 0 : Le.clientLeft || 0 : 0, ht = (j = se?.[_]) != null ? j : 0, An = ee + pe - ht - It, Jn = ee + Te - ht, zn = Un(k ? wi(re, An) : re, ee, k ? qt(Ae, Jn) : Ae);
      V[_] = zn, fe[_] = zn - ee;
    }
    if (s) {
      var gn, Yn = _ === "x" ? Je : ze, $t = _ === "x" ? dt : ct, kt = V[q], Jt = q === "y" ? "height" : "width", yn = kt + g[Yn], zt = kt - g[$t], Yt = [Je, ze].indexOf(I) !== -1, _t = (gn = se?.[q]) != null ? gn : 0, Wn = Yt ? yn : kt - L[Jt] - $[Jt] - _t + W.altAxis, Kn = Yt ? kt + L[Jt] + $[Jt] - _t - W.altAxis : zt, Xn = k && Yt ? pp(Wn, kt, Kn) : Un(k ? Wn : yn, kt, k ? Kn : zt);
      V[q] = Xn, fe[q] = Xn - kt;
    }
    n.modifiersData[o] = fe;
  }
}
const Hp = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: jp,
  requiresIfExists: ["offset"]
};
function Gp(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Qp(e) {
  return e === it(e) || !ut(e) ? ir(e) : Gp(e);
}
function $p(e) {
  var n = e.getBoundingClientRect(), t = un(n.width) / e.offsetWidth || 1, o = un(n.height) / e.offsetHeight || 1;
  return t !== 1 || o !== 1;
}
function Jp(e, n, t) {
  t === void 0 && (t = !1);
  var o = ut(n), i = ut(n) && $p(n), r = Ot(n), a = dn(e, i, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (o || !o && !t) && ((Rt(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  rr(r)) && (s = Qp(n)), ut(n) ? (u = dn(n, !0), u.x += n.clientLeft, u.y += n.clientTop) : r && (u.x = or(r))), {
    x: a.left + s.scrollLeft - u.x,
    y: a.top + s.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function zp(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function i(r) {
    t.add(r.name);
    var a = [].concat(r.requires || [], r.requiresIfExists || []);
    a.forEach(function(s) {
      if (!t.has(s)) {
        var u = n.get(s);
        u && i(u);
      }
    }), o.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || i(r);
  }), o;
}
function Yp(e) {
  var n = zp(e);
  return sp.reduce(function(t, o) {
    return t.concat(n.filter(function(i) {
      return i.phase === o;
    }));
  }, []);
}
function Wp(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function Xp(e) {
  var n = e.reduce(function(t, o) {
    var i = t[o.name];
    return t[o.name] = i ? Object.assign({}, i, o, {
      options: Object.assign({}, i.options, o.options),
      data: Object.assign({}, i.data, o.data)
    }) : o, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var sa = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function la() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function Zp(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, o = t === void 0 ? [] : t, i = n.defaultOptions, r = i === void 0 ? sa : i;
  return function(s, u, d) {
    d === void 0 && (d = r);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, sa, r),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, K = [], w = !1, k = {
      state: f,
      setOptions: function(I) {
        var x = typeof I == "function" ? I(f.options) : I;
        m(), f.options = Object.assign({}, r, f.options, x), f.scrollParents = {
          reference: Gt(s) ? En(s) : s.contextElement ? En(s.contextElement) : [],
          popper: En(u)
        };
        var E = Yp(Xp([].concat(o, f.options.modifiers)));
        return f.orderedModifiers = E.filter(function(_) {
          return _.enabled;
        }), y(), k.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!w) {
          var I = f.elements, x = I.reference, E = I.popper;
          if (la(x, E)) {
            f.rects = {
              reference: Jp(x, Gn(E), f.options.strategy === "fixed"),
              popper: tr(E)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(W) {
              return f.modifiersData[W.name] = Object.assign({}, W.data);
            });
            for (var _ = 0; _ < f.orderedModifiers.length; _++) {
              if (f.reset === !0) {
                f.reset = !1, _ = -1;
                continue;
              }
              var q = f.orderedModifiers[_], V = q.fn, L = q.options, $ = L === void 0 ? {} : L, J = q.name;
              typeof V == "function" && (f = V({
                state: f,
                options: $,
                name: J,
                instance: k
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Wp(function() {
        return new Promise(function(g) {
          k.forceUpdate(), g(f);
        });
      }),
      destroy: function() {
        m(), w = !0;
      }
    };
    if (!la(s, u))
      return k;
    k.setOptions(d).then(function(g) {
      !w && d.onFirstUpdate && d.onFirstUpdate(g);
    });
    function y() {
      f.orderedModifiers.forEach(function(g) {
        var I = g.name, x = g.options, E = x === void 0 ? {} : x, _ = g.effect;
        if (typeof _ == "function") {
          var q = _({
            state: f,
            name: I,
            instance: k,
            options: E
          }), V = function() {
          };
          K.push(q || V);
        }
      });
    }
    function m() {
      K.forEach(function(g) {
        return g();
      }), K = [];
    }
    return k;
  };
}
var eh = [wp, qp, vp, dp, Lp, _p, Hp, gp, Mp], Gs = /* @__PURE__ */ Zp({
  defaultModifiers: eh
});
const th = {
  props: {
    /** the value of the tooltip. If left empty no tooltip is rendered */
    value: String,
    /** placement of the tooltip conform popperjs. Also determines where the tooltip will stick in case screen is too small.
     * See https://popper.js.org/docs/v1/#popperplacements--codeenumcode
     */
    placement: { type: String, default: "auto-end" }
  },
  data() {
    return {
      popperInstance: null,
      display: !1
    };
  },
  methods: {
    async showTooltip() {
      this.display = !0, await this.$nextTick();
      const e = this.$refs.tooltipContainer, n = this.$refs.toolTip;
      e && n && (this.popperInstance = Gs(e, n, {
        strategy: "fixed",
        placement: this.placement
      }));
    },
    async destroyTooltip() {
      this.popperInstance?.destroy(), this.display = !1;
    }
  }
}, nh = {
  key: 0,
  ref: "toolTip"
}, ih = { class: "mg-tooltip m-1" };
function oh(e, n, t, o, i, r) {
  return l(), c("span", {
    class: "mg-tooltip-container",
    onMouseenter: n[0] || (n[0] = (...a) => r.showTooltip && r.showTooltip(...a)),
    onMouseleave: n[1] || (n[1] = (...a) => r.destroyTooltip && r.destroyTooltip(...a)),
    ref: "tooltipContainer"
  }, [
    H(e.$slots, "default"),
    t.value && i.display ? (l(), c("div", nh, [
      p("div", ih, U(t.value), 1)
    ], 512)) : v("", !0)
  ], 544);
}
const fn = /* @__PURE__ */ P(th, [["render", oh]]), rh = {
  extends: He,
  components: {
    Tooltip: fn
  },
  props: {
    label: String,
    icon: String,
    tooltip: String
  }
}, ah = {
  key: 0,
  class: "mr-2"
};
function sh(e, n, t, o, i, r) {
  const a = b("Tooltip");
  return l(), c("button", {
    class: "btn p-0 m-0 btn-outline-primary border-0",
    onClick: n[0] || (n[0] = Ke((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    D(a, {
      value: t.tooltip,
      class: "mt-n1 mb-n1 p-1"
    }, {
      default: C(() => [
        t.label ? (l(), c("span", ah, U(t.label), 1)) : v("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + t.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const ft = /* @__PURE__ */ P(rh, [["render", sh]]), lh = {
  extends: ft
}, uh = {
  key: 0,
  class: "mr-2"
};
function dh(e, n, t, o, i, r) {
  const a = b("Tooltip");
  return l(), c("button", {
    class: "btn p-0 m-0 btn-outline-danger border-0",
    onClick: n[0] || (n[0] = (...s) => e.onClick && e.onClick(...s))
  }, [
    D(a, {
      value: e.tooltip,
      class: "p-1 mt-n1 mb-n1"
    }, {
      default: C(() => [
        e.label ? (l(), c("span", uh, U(e.label), 1)) : v("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + e.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const ar = /* @__PURE__ */ P(lh, [["render", dh]]), ch = {}, fh = { class: "input-group" }, ph = {
  key: 0,
  class: "input-group-prepend"
}, hh = {
  key: 1,
  class: "input-group-append"
};
function mh(e, n) {
  return l(), c("div", fh, [
    e.$slots.prepend ? (l(), c("div", ph, [
      H(e.$slots, "prepend")
    ])) : v("", !0),
    H(e.$slots, "default"),
    e.$slots.append ? (l(), c("div", hh, [
      H(e.$slots, "append")
    ])) : v("", !0)
  ]);
}
const Ne = /* @__PURE__ */ P(ch, [["render", mh]]), Ah = {
  name: "InputString",
  components: { FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    stringLength: {
      type: Number,
      default: 255
    }
  },
  computed: {
    stringError() {
      return this.modelValue && this.modelValue.length && this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.errorMessage;
    }
  }
}, gh = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function yh(e, n, t, o, i, r) {
  const a = b("InputGroup"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: C(() => [
      D(a, null, {
        prepend: C(() => [
          H(e.$slots, "prepend", {}, void 0, !0)
        ]),
        append: C(() => [
          H(e.$slots, "append", {}, void 0, !0)
        ]),
        default: C(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholderValue,
            readonly: e.readonly
          }, null, 42, gh)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const yt = /* @__PURE__ */ P(Ah, [["render", yh], ["__scopeId", "data-v-eb9c2ec3"]]), Kh = "{_session { email, token, settings{key,value}}}", bh = `mutation change($users:[UsersInput]){
        change(users:$users){
            message
          }
        }`, vh = `mutation createToken($email:String,$tokenName:String){
        createToken(email:$email,tokenName:$tokenName){
            message,token
          }
        }`, Ch = ke({
  components: {
    ButtonAction: He,
    InputString: yt,
    IconDanger: ar,
    MessageSuccess: mn,
    MessageError: rt,
    Tooltip: fn
  },
  data() {
    return {
      session: null,
      tokenName: "",
      lastTokenValue: "",
      errorMessage: "",
      successMessage: ""
    };
  },
  computed: {
    accessTokens() {
      const e = this.session?.settings?.find(
        (n) => n.key === "access-tokens" && !!n.value
      );
      return e ? e.value.split(",").filter((n) => n !== "") : [];
    },
    duplicateNameMessage() {
      return this.accessTokens.includes(this.tokenName) ? "Duplicate token name" : "";
    }
  },
  methods: {
    async fetchSession() {
      const e = await Me("/api/graphql", Kh);
      this.session = e._session;
    },
    clean() {
      this.errorMessage = "", this.successMessage = "", this.lastTokenValue = "";
    },
    async deleteToken(e) {
      this.clean();
      let n = this.accessTokens;
      n.splice(e, 1);
      const t = {
        users: {
          email: this.session?.email,
          settings: {
            key: "access-tokens",
            value: n.join(",")
          }
        }
      };
      Me("/api/graphql", bh, t).then(() => {
        this.successMessage = "Token removed", this.lastTokenValue = "", this.fetchSession();
      }).catch((o) => {
        this.errorMessage = o.message;
      });
    },
    async createToken() {
      this.clean();
      const e = {
        email: this.session?.email,
        tokenName: this.tokenName
      };
      Me("/api/graphql", vh, e).then((n) => {
        this.successMessage = n.createToken.message, this.lastTokenValue = n.createToken.token, this.tokenName = "", this.fetchSession();
      }).catch((n) => {
        this.errorMessage = n.message;
      });
    },
    copyToClipboard(e) {
      navigator.clipboard.writeText(e);
    }
  },
  mounted() {
    this.fetchSession();
  }
}), wh = { key: 0 }, Fh = {
  key: 0,
  style: { cursor: "pointer" }
}, Rh = { class: "form-inline" };
function kh(e, n, t, o, i, r) {
  const a = b("IconDanger"), s = b("Tooltip"), u = b("MessageSuccess"), d = b("MessageError"), f = b("ButtonAction"), K = b("InputString");
  return l(), c("div", null, [
    e.accessTokens.length ? (l(), c("div", wh, [
      n[3] || (n[3] = p("label", null, [
        p("b", null, "Access tokens")
      ], -1)),
      p("ul", null, [
        (l(!0), c(te, null, oe(e.accessTokens, (w, k) => (l(), c("li", { key: w }, [
          B(U(w) + " ", 1),
          D(a, {
            onClick: (y) => e.deleteToken(k),
            icon: "times"
          }, null, 8, ["onClick"])
        ]))), 128))
      ])
    ])) : v("", !0),
    e.successMessage ? (l(), F(u, { key: 1 }, {
      default: C(() => [
        B(U(e.successMessage) + ". ", 1),
        e.lastTokenValue ? (l(), c("div", Fh, [
          p("label", null, [
            p("b", null, [
              n[5] || (n[5] = B(" New token. Please copy for use: ", -1)),
              D(s, {
                value: "Click to copy to clipboard",
                placement: "top",
                onClick: n[0] || (n[0] = Ke((w) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
              }, {
                default: C(() => [...n[4] || (n[4] = [
                  p("i", {
                    id: "copy-icon",
                    class: "fa fa-clipboard"
                  }, null, -1)
                ])]),
                _: 1
              })
            ])
          ]),
          p("pre", {
            onClick: n[1] || (n[1] = Ke((w) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
          }, "          " + U(e.lastTokenValue) + `
        `, 1)
        ])) : v("", !0)
      ]),
      _: 1
    })) : v("", !0),
    e.errorMessage ? (l(), F(d, { key: 2 }, {
      default: C(() => [
        B(U(e.errorMessage), 1)
      ]),
      _: 1
    })) : v("", !0),
    n[7] || (n[7] = p("label", null, [
      p("b", null, "Create a token")
    ], -1)),
    p("form", Rh, [
      e.tokenName ? (l(), F(f, {
        key: e.tokenName,
        disabled: !!e.duplicateNameMessage,
        onClick: e.createToken
      }, {
        default: C(() => [...n[6] || (n[6] = [
          B(" Create token ", -1)
        ])]),
        _: 1
      }, 8, ["disabled", "onClick"])) : v("", !0),
      D(K, {
        id: "token-name",
        placeholder: "new token name",
        modelValue: e.tokenName,
        "onUpdate:modelValue": n[2] || (n[2] = (w) => e.tokenName = w),
        errorMessage: e.duplicateNameMessage
      }, null, 8, ["modelValue", "errorMessage"])
    ])
  ]);
}
const Uh = /* @__PURE__ */ P(Ch, [["render", kh]]), Eh = ke({
  components: {
    LayoutModal: vt,
    ButtonAlt: ot,
    ButtonAction: He,
    InputPassword: Xo,
    MessageError: rt,
    MessageSuccess: mn,
    Spinner: bt,
    TokenManager: Uh
  },
  props: {
    user: String
  },
  data() {
    return {
      password: null,
      password2: null,
      loading: !1,
      graphqlError: null,
      success: null,
      error: null
    };
  },
  methods: {
    async updatePassword() {
      if (this.password !== this.password2)
        this.error = "Error: Passwords entered must be the same";
      else {
        this.error = null, this.loading = !0;
        const e = await Me(
          "graphql",
          `mutation{changePassword(password: "${this.password}"){status,message}}`
        ).catch((n) => {
          this.graphqlError = JSON.stringify(n);
        });
        e.changePassword.status === "SUCCESS" ? this.success = "Success. Password changed" : this.error = "Password change failed: " + e.changePassword.message, this.loading = !1;
      }
    },
    close() {
      this.error = null, this.$emit("cancel");
    }
  },
  emits: ["cancel"]
});
function Sh(e, n, t, o, i, r) {
  const a = b("Spinner"), s = b("MessageSuccess"), u = b("MessageError"), d = b("InputPassword"), f = b("ButtonAction"), K = b("TokenManager"), w = b("LayoutForm"), k = b("ButtonAlt"), y = b("LayoutModal");
  return e.loading ? (l(), F(a, { key: 0 })) : (l(), F(y, {
    key: 1,
    title: "Change account",
    show: !0,
    onClose: e.close
  }, {
    body: C(() => [
      D(w, null, {
        default: C(() => [
          n[3] || (n[3] = p("h2", null, "Change password", -1)),
          e.success ? (l(), F(s, { key: 0 }, {
            default: C(() => [
              B(U(e.success), 1)
            ]),
            _: 1
          })) : v("", !0),
          e.graphqlError ? (l(), F(u, { key: 1 }, {
            default: C(() => [
              B(U(e.graphqlError), 1)
            ]),
            _: 1
          })) : v("", !0),
          D(d, {
            id: "account-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[0] || (n[0] = (m) => e.password = m),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          D(d, {
            id: "account-password2",
            modelValue: e.password2,
            "onUpdate:modelValue": n[1] || (n[1] = (m) => e.password2 = m),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          D(f, { onClick: e.updatePassword }, {
            default: C(() => [...n[2] || (n[2] = [
              B("Update password", -1)
            ])]),
            _: 1
          }, 8, ["onClick"]),
          n[4] || (n[4] = p("h2", { class: "mt-4" }, "Manage tokens", -1)),
          D(K)
        ]),
        _: 1
      })
    ]),
    footer: C(() => [
      D(k, { onClick: e.close }, {
        default: C(() => [...n[5] || (n[5] = [
          B("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const Th = /* @__PURE__ */ P(Eh, [["render", Sh]]), Ih = {
  name: "ButtonOutline",
  extends: He,
  props: {
    light: { type: Boolean, default: !1 }
  }
}, Dh = ["disabled"];
function Oh(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: G(t.light ? "btn btn-outline-light" : "btn btn-outline-primary"),
    disabled: e.disabled,
    onClick: n[0] || (n[0] = Ke((...a) => e.onClick && e.onClick(...a), ["prevent"]))
  }, [
    e.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa-" + e.icon, "fa fa-fw mr-2 ml-0"])
    }, null, 2)) : v("", !0),
    H(e.$slots, "default")
  ], 10, Dh);
}
const Bi = /* @__PURE__ */ P(Ih, [["render", Oh]]), _h = {
  name: "ButtonAction",
  props: {
    href: String,
    icon: String,
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Ph = ["disabled"];
function Mh(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "submit",
    class: "btn btn-primary",
    disabled: t.disabled
  }, [
    H(e.$slots, "default"),
    t.icon ? (l(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : v("", !0)
  ], 8, Ph);
}
const Nh = /* @__PURE__ */ P(_h, [["render", Mh]]), Bh = {};
function Lh(e, n) {
  return l(), c("form", {
    onSubmit: n[0] || (n[0] = Ke((t) => e.$emit("submit"), ["prevent"]))
  }, [
    H(e.$slots, "default")
  ], 32);
}
const xh = /* @__PURE__ */ P(Bh, [["render", Lh]]), qh = {
  extends: Ce,
  components: {
    FormGroup: Ue
  },
  props: {
    options: Array,
    hideClearButton: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      result: this.modelValue ? [...this.modelValue] : []
    };
  }
}, Vh = ["id", "value", "aria-describedby"], jh = ["for"];
function Hh(e, n, t, o, i, r) {
  const a = b("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "checkbox-form-group",
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      (l(!0), c(te, null, oe(t.options, (s, u) => (l(), c("div", {
        key: u,
        class: "form-check form-check-inline"
      }, [
        Ye(p("input", {
          id: `${e.id}-${u}`,
          "onUpdate:modelValue": n[0] || (n[0] = (d) => i.result = d),
          class: "form-check-input",
          type: "checkbox",
          value: s,
          onChange: n[1] || (n[1] = (d) => e.$emit(
            "update:modelValue",
            i.result.filter((f) => f !== null)
          )),
          "aria-describedby": `${e.id}-help`
        }, null, 40, Vh), [
          [Ta, i.result]
        ]),
        p("label", {
          class: "form-check-label",
          for: `${e.id}-${u}`
        }, U(s), 9, jh)
      ]))), 128)),
      t.hideClearButton ? v("", !0) : (l(), c("button", {
        key: 0,
        class: "checkbox-clear-value btn-link btn m-0 p-0",
        onClick: n[2] || (n[2] = Ke((s) => {
          i.result = [], e.$emit("update:modelValue", i.result);
        }, ["prevent"]))
      }, " clear "))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Gh = /* @__PURE__ */ P(qh, [["render", Hh]]), { POLICY_TEXT_KEY: Qh } = Td, $h = ke({
  name: "MolgenisSignin",
  components: {
    ButtonAlt: ot,
    InputPassword: Xo,
    InputString: yt,
    MessageError: rt,
    MessageSuccess: mn,
    FormMolgenis: xh,
    LayoutModal: vt,
    ButtonSubmit: Nh,
    InputCheckbox: Gh
  },
  data: function() {
    return {
      email: "",
      password: "",
      error: "",
      success: null,
      loading: !1,
      userAgrees: [],
      privacyPolicyLabel: "Agree with privacy policy",
      privacyPolicy: "",
      isPrivacyPolicyEnabled: !1,
      privacyError: "Please agree with the privacy policy"
    };
  },
  methods: {
    async signin() {
      !this.email || !this.password ? this.error = "Email and password should be filled in" : this.isPrivacyPolicyEnabled && this.userAgrees[0] !== this.privacyPolicyLabel ? this.error = this.privacyError : (this.error = "", this.loading = !0, Me(
        "/api/graphql",
        `mutation{signin(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then(
        (e) => {
          e.signin.status === "SUCCESS" ? (this.success = "Signed in with " + this.email, this.$emit("signin", this.email)) : this.error = e.signin.message;
        }
      ).catch(
        (e) => this.error = "internal server graphqlError" + e
      ), this.loading = !1);
    },
    onSignInFailed(e) {
      this.error = e, this.$emit("signInFailed", this.email);
    },
    onCancel() {
      this.error = "", this.$emit("cancel");
    },
    async fetchPrivacyPolicy() {
      const e = await Me(
        "graphql",
        "{_settings{key, value}}"
      ), n = e._settings.find(
        (o) => o.key === Qh
      );
      this.privacyPolicy = n?.value;
      const t = e._settings.find((o) => o.key === "isPrivacyPolicyEnabled");
      this.isPrivacyPolicyEnabled = t?.value === "true";
    }
  },
  watch: {
    async show(e) {
      e === !0 && await this.$nextTick(), this.$refs.email.$el.children[1].focus();
    }
  },
  emits: ["cancel", "signInFailed", "signin"],
  mounted() {
    this.fetchPrivacyPolicy();
  }
}), Jh = { key: 0 };
function zh(e, n, t, o, i, r) {
  const a = b("MessageSuccess"), s = b("ButtonAlt"), u = b("MessageError"), d = b("InputString"), f = b("InputPassword"), K = b("InputCheckbox"), w = b("FormMolgenis"), k = b("ButtonSubmit"), y = b("LayoutModal");
  return e.success ? (l(), c("div", Jh, [
    D(a, null, {
      default: C(() => [
        B(U(e.success), 1)
      ]),
      _: 1
    }),
    D(s, { onClick: e.onCancel }, {
      default: C(() => [...n[3] || (n[3] = [
        B("Close", -1)
      ])]),
      _: 1
    }, 8, ["onClick"])
  ])) : (l(), F(y, {
    key: 1,
    title: "Sign in",
    show: !0,
    onClose: e.onCancel
  }, {
    body: C(() => [
      D(w, {
        id: "signin-form",
        onSubmit: e.signin
      }, {
        default: C(() => [
          e.error ? (l(), F(u, { key: 0 }, {
            default: C(() => [
              B(U(e.error), 1)
            ]),
            _: 1
          })) : v("", !0),
          D(d, {
            id: "signInFormEmail",
            ref: "email",
            name: "email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (m) => e.email = m),
            label: "Username",
            placeholder: "Enter username",
            description: "Please enter username",
            autofocus: ""
          }, null, 8, ["modelValue"]),
          D(f, {
            id: "signInFormPassword",
            name: "password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (m) => e.password = m),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the provided password",
            onEnterPressed: e.signin
          }, null, 8, ["modelValue", "onEnterPressed"]),
          e.isPrivacyPolicyEnabled ? (l(), c("div", {
            key: 1,
            class: G(["alert", e.error === e.privacyError ? "alert-danger" : "alert-info"]),
            role: "alert"
          }, [
            n[4] || (n[4] = p("b", null, "Privacy policy", -1)),
            p("p", null, U(e.privacyPolicy), 1),
            D(K, {
              class: "mb-0",
              id: "privacy-agreement",
              name: "privacy-agreement",
              required: !0,
              options: [e.privacyPolicyLabel],
              hideClearButton: !0,
              modelValue: e.userAgrees,
              "onUpdate:modelValue": n[2] || (n[2] = (m) => e.userAgrees = m)
            }, null, 8, ["options", "modelValue"])
          ], 2)) : v("", !0)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    footer: C(() => [
      D(s, { onClick: e.onCancel }, {
        default: C(() => [...n[5] || (n[5] = [
          B("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      D(k, { form: "signin-form" }, {
        default: C(() => [...n[6] || (n[6] = [
          B(" Sign in ", -1)
        ])]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const Yh = /* @__PURE__ */ P($h, [["render", zh]]), Wh = {};
function Xh(e, n, t, o, i, r) {
  return l(), c("form", null, [
    H(e.$slots, "default")
  ]);
}
const Zh = /* @__PURE__ */ P(Wh, [["render", Xh]]), em = ke({
  components: {
    ButtonAction: He,
    ButtonAlt: ot,
    InputPassword: Xo,
    InputString: yt,
    MessageError: rt,
    MessageSuccess: mn,
    LayoutForm: Zh,
    Spinner: bt,
    LayoutModal: vt
  },
  data: function() {
    return {
      email: null,
      password: null,
      passwordRepeat: null,
      loading: !1,
      error: null,
      success: null
    };
  },
  methods: {
    signup() {
      this.email === null || this.password === null || this.passwordRepeat === null ? this.error = "Error: valid email address and password should be filled in" : this.password !== this.passwordRepeat ? this.error = "Error: Passwords entered must be the same" : (this.error = null, this.loading = !0, Me(
        "/api/graphql",
        `mutation{signup(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then((e) => {
        e.signup.status === "SUCCESS" ? this.success = "Success. Signed up with email: " + this.email : this.error = "Signup failed: " + e.signup.message;
      }).catch((e) => {
        this.error = "Sign up failed: " + e.response.message;
      }), this.loading = !1);
    },
    close() {
      this.error = null, this.$emit("close");
    }
  },
  emits: ["close"]
});
function tm(e, n, t, o, i, r) {
  const a = b("Spinner"), s = b("MessageSuccess"), u = b("ButtonAlt"), d = b("LayoutModal"), f = b("MessageError"), K = b("InputString"), w = b("InputPassword"), k = b("LayoutForm"), y = b("ButtonAction");
  return e.loading ? (l(), F(a, { key: 0 })) : e.success ? (l(), F(d, {
    key: 1,
    title: "Sign up",
    show: !0
  }, {
    body: C(() => [
      D(s, null, {
        default: C(() => [
          B(U(e.success), 1)
        ]),
        _: 1
      })
    ]),
    footer: C(() => [
      D(u, { onClick: e.close }, {
        default: C(() => [...n[3] || (n[3] = [
          B("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  })) : (l(), F(d, {
    key: 2,
    title: "Sign up",
    show: !0,
    onClose: e.close
  }, {
    body: C(() => [
      D(k, null, {
        default: C(() => [
          e.error ? (l(), F(f, { key: 0 }, {
            default: C(() => [
              B(U(e.error), 1)
            ]),
            _: 1
          })) : v("", !0),
          D(K, {
            id: "signup-email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (m) => e.email = m),
            label: "Email address",
            placeholder: "Enter valid email address",
            description: "Please enter your email address"
          }, null, 8, ["modelValue"]),
          D(w, {
            id: "signup-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (m) => e.password = m),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"]),
          D(w, {
            id: "signup-password-repeat",
            modelValue: e.passwordRepeat,
            "onUpdate:modelValue": n[2] || (n[2] = (m) => e.passwordRepeat = m),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"])
        ]),
        _: 1
      })
    ]),
    footer: C(() => [
      D(u, { onClick: e.close }, {
        default: C(() => [...n[4] || (n[4] = [
          B("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      D(y, { onClick: e.signup }, {
        default: C(() => [...n[5] || (n[5] = [
          B("Sign up", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const nm = /* @__PURE__ */ P(em, [["render", tm]]);
var ua = {
  expireTimes: "1d",
  path: "; path=/",
  domain: "",
  secure: !1,
  sameSite: "; SameSite=Lax"
}, im = (
  /** @class */
  (function() {
    function e() {
      this.current_default_config = ua;
    }
    return e.prototype.config = function(n) {
      for (var t in this.current_default_config)
        this.current_default_config[t] = n[t] ? n[t] : ua[t];
    }, e.prototype.get = function(n) {
      var t = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      if (t && t.substring(0, 1) === "{" && t.substring(t.length - 1, t.length) === "}")
        try {
          t = JSON.parse(t);
        } catch {
          return t;
        }
      return t;
    }, e.prototype.set = function(n, t, o, i, r, a, s) {
      if (n) {
        if (/^(?:expires|max-age|path|domain|secure|SameSite)$/i.test(n))
          throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + n);
      } else throw new Error("Cookie name is not found in the first argument.");
      t && t.constructor === Object && (t = JSON.stringify(t));
      var u = "";
      if (o == null && (o = this.current_default_config.expireTimes ? this.current_default_config.expireTimes : ""), o && o != 0)
        switch (o.constructor) {
          case Number:
            o === 1 / 0 || o === -1 ? u = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : u = "; max-age=" + o;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(o)) {
              var d = o.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
              switch (o.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                // Frequency sorting
                case "m":
                  u = "; max-age=" + +d * 2592e3;
                  break;
                // 60 * 60 * 24 * 30
                case "d":
                  u = "; max-age=" + +d * 86400;
                  break;
                // 60 * 60 * 24
                case "h":
                  u = "; max-age=" + +d * 3600;
                  break;
                // 60 * 60
                case "min":
                  u = "; max-age=" + +d * 60;
                  break;
                // 60
                case "s":
                  u = "; max-age=" + d;
                  break;
                case "y":
                  u = "; max-age=" + +d * 31104e3;
                  break;
              }
            } else
              u = "; expires=" + o;
            break;
          case Date:
            u = "; expires=" + o.toUTCString();
            break;
        }
      return document.cookie = encodeURIComponent(n) + "=" + encodeURIComponent(t) + u + (r ? "; domain=" + r : this.current_default_config.domain ? this.current_default_config.domain : "") + (i ? "; path=" + i : this.current_default_config.path ? this.current_default_config.path : "; path=/") + (a == null ? this.current_default_config.secure ? "; Secure" : "" : a ? "; Secure" : "") + (s == null ? this.current_default_config.sameSite ? "; SameSute=" + this.current_default_config.sameSite : "" : s ? "; SameSite=" + s : ""), this;
    }, e.prototype.remove = function(n, t, o) {
      return !n || !this.isKey(n) ? !1 : (document.cookie = encodeURIComponent(n) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (o ? "; domain=" + o : this.current_default_config.domain ? this.current_default_config.domain : "") + (t ? "; path=" + t : this.current_default_config.path ? this.current_default_config.path : "; path=/") + "; SameSite=Lax", !0);
    }, e.prototype.isKey = function(n) {
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    }, e.prototype.keys = function() {
      if (!document.cookie)
        return [];
      for (var n = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), t = 0; t < n.length; t++)
        n[t] = decodeURIComponent(n[t]);
      return n;
    }, e;
  })()
), ao = null;
function Qs() {
  ao == null && (ao = new im());
  var e = Pl(ao);
  return { cookies: e };
}
const { cookies: om } = Qs(), rm = {
  name: "LocaleSwitch",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    locales: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      cookies: null
    };
  },
  methods: {
    emit(e) {
      e.target.value !== void 0 ? (om.set("MOLGENIS.locale", e.target.value), this.$emit("update:modelValue", e.target.value)) : this.$emit("update:modelValue", "en");
    }
  },
  emits: ["update:modelValue"]
}, am = { class: "d-inline-flex from-group" }, sm = ["modelValue"], lm = ["selected"];
function um(e, n, t, o, i, r) {
  return l(), c("div", am, [
    p("select", {
      class: "form-control bg-primary text-white border-0 mr-2 pl-0 pr-0",
      modelValue: t.modelValue,
      onInput: n[0] || (n[0] = (...a) => r.emit && r.emit(...a))
    }, [
      (l(!0), c(te, null, oe(t.locales, (a) => (l(), c("option", {
        key: a,
        selected: a === t.modelValue
      }, U(a), 9, lm))), 128))
    ], 40, sm)
  ]);
}
const dm = /* @__PURE__ */ P(rm, [["render", um]]), { cookies: cm } = Qs(), da = `{
  _session { email, admin, roles, tablePermissions{name,id,canView,canInsert,canUpdate,canDelete}, schemas, token, settings{key,value} },
  _settings (keys: ["menu", "page.", "cssURL", "logoURL", "isOidcEnabled","locales", "additionalCss", "additionalFooterHtml", "additionalJs"]){ key, value },
  _manifest { ImplementationVersion,SpecificationVersion,DatabaseVersion }
}`, ca = { locale: "en", settings: {} }, fm = ke({
  components: {
    ButtonOutline: Bi,
    MolgenisSignin: Yh,
    SignupForm: nm,
    MolgenisAccount: Th,
    Spinner: bt,
    ButtonAlt: ot,
    LocaleSwitch: dm
  },
  props: {
    graphql: {
      default: "graphql",
      type: String
    }
  },
  data: function() {
    return {
      showSigninForm: !1,
      showSignupForm: !1,
      showChangePasswordForm: !1,
      error: null,
      loading: !1,
      session: ca,
      version: null
    };
  },
  watch: {
    email() {
      this.showSigninForm = !1, this.showSignupForm = !1;
    }
  },
  created() {
    this.reload();
  },
  computed: {
    isOidcEnabled() {
      return this.session?.settings?.isOidcEnabled === "true";
    },
    oidcLoginUrl() {
      return "/_login" + (window?.location?.href ? `?redirect=${encodeURIComponent(window.location.href)}` : "");
    },
    locales() {
      if (this.session?.settings?.locales) {
        if (Array.isArray(this.session.settings.locales))
          return this.session.settings.locales;
        this.error = 'locales should be array similar to ["en"] but instead was ' + JSON.stringify(this.session.settings.locales);
      }
      return ["en"];
    }
  },
  methods: {
    loadSettings(e) {
      e._settings.forEach((n) => {
        const t = n.value?.startsWith("[") || n.value?.startsWith("{") ? this.parseJson(n.value) : n.value;
        this.session.settings === void 0 && (this.session.settings = {}), this.session.settings[n.key] = t;
      });
    },
    async reload() {
      this.loading = !0;
      const e = await Promise.allSettled([
        Me("/apps/central/graphql", da),
        Me(this.graphql, da)
      ]), n = e[0].status === "fulfilled" ? e[0].value : this.handleError(e[0].reason), t = e[1].status === "fulfilled" ? e[1].value : this.handleError(e[1].reason);
      if (t && t._session ? this.session = t._session : this.session = ca, n && n._settings && (this.loadSettings(n), this.session.manifest = n._manifest), t && t._settings && (this.loadSettings(t), this.session.settings && t._settings.find((o) => o.key === "menu") === void 0 && n?._settings.find((o) => o.key === "menu") !== void 0 && delete this.session.settings.menu, this.session.manifest = t._manifest), this.session.locale === void 0) {
        const o = cm.get("MOLGENIS.locale");
        o && (this.session.locale = o);
      }
      this.loading = !1, this.$emit("update:modelValue", this.session);
    },
    handleError(e) {
      this.error = "internal server error " + e, e?.response?.data?.errors[0]?.message ? this.$emit("error", e.response.data.errors[0].message) : this.$emit("error", this.error);
    },
    parseJson(e) {
      try {
        return JSON.parse(e);
      } catch (n) {
        return this.error = "Parsing of settings failed: " + n + ". value: " + e, null;
      }
    },
    changed() {
      this.reload(), this.showSigninForm = !1, this.$emit("update:modelValue", this.session);
    },
    closeSigninForm() {
      this.showSigninForm = !1, this.error = null;
    },
    closeSignupForm() {
      this.showSignupForm = !1, this.error = null;
    },
    async signout() {
      this.loading = !0, this.showSigninForm = !1, (await Me("graphql", "mutation{signout{status}}").catch(
        (n) => this.error = "internal server error" + n
      )).signout.status === "SUCCESS" ? this.session = {} : this.error = "sign out failed", this.loading = !1, this.$emit("update:modelValue", this.session), this.reload();
    }
  },
  emits: ["update:modelValue", "error"]
}), pm = { key: 1 }, hm = { key: 0 }, mm = { key: 1 };
function Am(e, n, t, o, i, r) {
  const a = b("Spinner"), s = b("ButtonAlt"), u = b("MolgenisAccount"), d = b("ButtonOutline"), f = b("SignupForm"), K = b("MolgenisSignin"), w = b("LocaleSwitch");
  return e.loading ? (l(), F(a, { key: 0 })) : (l(), c("div", pm, [
    p("div", null, [
      e.session.email && e.session.email != "anonymous" ? (l(), c("span", hm, [
        D(s, {
          onClick: n[0] || (n[0] = (k) => e.showChangePasswordForm = !0),
          class: "text-light"
        }, {
          default: C(() => [
            B(" Hi " + U(e.session.email), 1)
          ]),
          _: 1
        }),
        n[6] || (n[6] = B("  ", -1)),
        e.showChangePasswordForm ? (l(), F(u, {
          key: 0,
          error: e.error,
          onCancel: n[1] || (n[1] = (k) => e.showChangePasswordForm = !1)
        }, null, 8, ["error"])) : v("", !0),
        D(d, {
          onClick: e.signout,
          light: !0
        }, {
          default: C(() => [...n[5] || (n[5] = [
            B("Sign out", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ])) : (l(), c("span", mm, [
        Ye(D(s, {
          onClick: n[2] || (n[2] = (k) => e.showSignupForm = !0),
          light: !0
        }, {
          default: C(() => [...n[7] || (n[7] = [
            B(" Sign up ", -1)
          ])]),
          _: 1
        }, 512), [
          [ki, !e.isOidcEnabled]
        ]),
        e.showSignupForm ? (l(), F(f, {
          key: 0,
          error: e.error,
          onClose: e.closeSignupForm
        }, null, 8, ["error", "onClose"])) : v("", !0),
        e.isOidcEnabled ? (l(), F(d, {
          key: 1,
          href: e.oidcLoginUrl,
          light: !0
        }, {
          default: C(() => [...n[8] || (n[8] = [
            B(" Sign in", -1)
          ])]),
          _: 1
        }, 8, ["href"])) : (l(), F(d, {
          key: 2,
          onClick: n[3] || (n[3] = (k) => e.showSigninForm = !0),
          light: !0
        }, {
          default: C(() => [...n[9] || (n[9] = [
            B(" Sign in", -1)
          ])]),
          _: 1
        })),
        e.showSigninForm ? (l(), F(K, {
          key: 3,
          onSignin: e.changed,
          onCancel: e.closeSigninForm
        }, null, 8, ["onSignin", "onCancel"])) : v("", !0)
      ])),
      e.locales.length > 1 ? (l(), F(w, {
        key: 2,
        class: "ml-2",
        modelValue: e.session.locale,
        "onUpdate:modelValue": n[4] || (n[4] = (k) => e.session.locale = k),
        locales: e.locales
      }, null, 8, ["modelValue", "locales"])) : v("", !0)
    ]),
    (l(), F(Et("style"), null, {
      default: C(() => [
        B(U(e.session?.settings?.additionalCss), 1)
      ]),
      _: 1
    }))
  ]));
}
const gm = /* @__PURE__ */ P(fm, [["render", Am]]), ym = {
  name: "PersonDetails",
  computed: {
    imgSrc() {
      return `
        data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQ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        `;
    }
  }
}, Km = { class: "card" }, bm = { class: "row no-gutters" }, vm = { class: "col-8 small" }, Cm = { class: "col-4" }, wm = ["src"];
function Fm(e, n, t, o, i, r) {
  return l(), c("div", Km, [
    p("div", bm, [
      p("div", vm, [
        H(e.$slots, "details", {}, () => [
          n[0] || (n[0] = p("strong", null, "Anonymous", -1))
        ], !0)
      ]),
      p("div", Cm, [
        H(e.$slots, "image", {}, () => [
          p("img", {
            src: r.imgSrc,
            alt: "person-place-holder-image",
            class: "img-thumbnail"
          }, null, 8, wm)
        ], !0)
      ])
    ])
  ]);
}
const Rm = /* @__PURE__ */ P(ym, [["render", Fm], ["__scopeId", "data-v-283371f3"]]), km = {
  name: "ContactDisplay",
  components: { PersonDetails: Rm },
  props: {
    contact: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    contributionType: {
      type: Array,
      required: !1,
      default: () => []
    },
    contributionDescription: {
      type: String,
      required: !1
    }
  },
  computed: {
    contributions() {
      return [...this.contributionType].sort((e, n) => e.order - n.order).map((e) => e.name).join(",");
    },
    imgSrc() {
      return this.contact.photo && this.contact.photo.url ? this.contact.photo.url : null;
    }
  }
}, Um = { key: 0 }, Em = { key: 1 }, Sm = { key: 2 }, Tm = { key: 3 }, Im = { key: 4 }, Dm = { key: 0 }, Om = { key: 1 }, _m = {
  key: 2,
  class: "mt-3"
}, Pm = {
  key: 3,
  class: "mt-3"
}, Mm = ["src", "alt"];
function Nm(e, n, t, o, i, r) {
  const a = b("person-details");
  return l(), F(a, null, Ml({
    details: C(() => [
      p("strong", null, [
        t.contact.title && t.contact.title.name ? (l(), c("span", Um, U(t.contact.title.name), 1)) : v("", !0),
        t.contact.initials ? (l(), c("span", Em, U(t.contact.initials), 1)) : v("", !0),
        t.contact.firstName && t.contact.initials ? (l(), c("span", Sm, " (" + U(t.contact.firstName) + ") ", 1)) : t.contact.firstName ? (l(), c("span", Tm, U(t.contact.firstName), 1)) : v("", !0),
        t.contact.surname ? (l(), c("span", Im, U(t.contact.surname), 1)) : v("", !0)
      ]),
      r.contributions.length ? (l(), c("div", Dm, U(r.contributions), 1)) : v("", !0),
      t.contact.email ? (l(), c("div", Om, U(t.contact.email), 1)) : v("", !0),
      t.contributionDescription ? (l(), c("div", _m, [
        p("p", null, U(t.contributionDescription), 1)
      ])) : v("", !0),
      t.contact.department ? (l(), c("div", Pm, [
        p("p", null, U(t.contact.department), 1)
      ])) : v("", !0)
    ]),
    _: 2
  }, [
    r.imgSrc ? {
      name: "image",
      fn: C(() => [
        p("img", {
          src: r.imgSrc,
          alt: t.contact.surname + "-image",
          class: "img-thumbnail"
        }, null, 8, Mm)
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const UR = /* @__PURE__ */ P(km, [["render", Nm], ["__scopeId", "data-v-5583439c"]]), Bm = {
  name: "GridBlock",
  props: {
    heading: {
      type: String,
      required: !1
    }
  }
}, Lm = { class: "card block" }, xm = { key: 0 };
function qm(e, n, t, o, i, r) {
  return l(), c("div", Lm, [
    t.heading ? (l(), c("h3", xm, U(t.heading), 1)) : v("", !0),
    H(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Vm = /* @__PURE__ */ P(Bm, [["render", qm], ["__scopeId", "data-v-7318de25"]]), jm = {
  name: "ImageCard",
  props: {
    title: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    linkUrl: {
      type: String,
      required: !1
    },
    linkText: {
      type: String,
      required: !1,
      default: () => "LEARN MORE"
    }
  }
}, Hm = { class: "card image-card" }, Gm = { class: "card-body" }, Qm = {
  key: 0,
  class: "card-title"
}, $m = {
  key: 1,
  class: "card-text"
}, Jm = {
  key: 2,
  class: "card-text"
}, zm = { class: "text-muted" }, Ym = ["href"];
function Wm(e, n, t, o, i, r) {
  return l(), c("div", Hm, [
    H(e.$slots, "image"),
    p("div", Gm, [
      H(e.$slots, "body", {}, () => [
        t.title ? (l(), c("h5", Qm, U(t.title), 1)) : v("", !0),
        t.description ? (l(), c("p", $m, U(t.description), 1)) : v("", !0),
        t.linkUrl ? (l(), c("p", Jm, [
          p("small", zm, [
            p("a", {
              href: t.linkUrl,
              class: "stretched-link"
            }, U(t.linkText), 9, Ym)
          ])
        ])) : v("", !0)
      ])
    ])
  ]);
}
const ER = /* @__PURE__ */ P(jm, [["render", Wm]]), Xm = {
  name: "ImageDisplay",
  props: {
    url: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !1,
      default: () => "image"
    },
    id: {
      type: String,
      required: !1
    },
    size: {
      type: Number,
      required: !1
    },
    extension: {
      type: String,
      required: !1
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, Zm = ["src", "alt"];
function eA(e, n, t, o, i, r) {
  return l(), c("img", {
    src: t.url,
    alt: t.alt,
    class: G(["img-thumbnail", { clickable: t.isClickable }]),
    onClick: n[0] || (n[0] = (a) => e.$emit("clicked", t.id))
  }, null, 10, Zm);
}
const SR = /* @__PURE__ */ P(Xm, [["render", eA], ["__scopeId", "data-v-b58d7d8b"]]), tA = {
  props: {
    text: String,
    length: {
      type: Number,
      default: () => 20
    }
  },
  data() {
    return {
      expand: !1
    };
  }
}, nA = { key: 0 }, iA = { key: 1 }, oA = { key: 2 }, rA = { key: 3 };
function aA(e, n, t, o, i, r) {
  return l(), c("div", null, [
    t.text === "undefined" ? (l(), c("span", nA)) : t.text.length <= t.length ? (l(), c("span", iA, U(t.text), 1)) : i.expand ? (l(), c("span", oA, [
      B(U(t.text) + " ", 1),
      p("a", {
        onClick: n[0] || (n[0] = Ke((a) => i.expand = !1, ["stop", "prevent"])),
        href: "#"
      }, "...show less ")
    ])) : (l(), c("span", rA, [
      B(U(t.text.slice(0, t.length)) + " ", 1),
      p("a", {
        onClick: n[1] || (n[1] = Ke((a) => i.expand = !0, ["stop", "prevent"])),
        href: "#",
        title: "Expand text"
      }, " ...show more ")
    ]))
  ]);
}
const $s = /* @__PURE__ */ P(tA, [["render", aA]]), sA = {
  name: "KeyValueBlock",
  components: { GridBlock: Vm, ReadMore: $s },
  props: {
    heading: {
      type: String,
      required: !1
    },
    /**
     * List of items
     * Item has:
     * key: String (required)
     * label: String (required)
     * value: String, Number, Boolean, Object
     */
    items: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    computedHeading() {
      return this.heading ? this.heading : this.items.length === 1 ? this.items[0].label : null;
    }
  }
}, lA = { key: 1 }, uA = {
  key: 0,
  class: "list-unstyled"
}, dA = { key: 1 };
function cA(e, n, t, o, i, r) {
  const a = b("read-more"), s = b("grid-block");
  return l(), F(s, { heading: r.computedHeading }, {
    default: C(() => [
      t.items.length === 1 && t.items[0].value ? (l(), F(a, {
        key: 0,
        text: t.items[0].value,
        length: 750
      }, null, 8, ["text"])) : t.items.length > 1 ? (l(), c("div", lA, [
        (l(!0), c(te, null, oe(t.items, (u, d) => (l(), c("div", { key: d }, [
          p("strong", null, U(u.label), 1),
          Array.isArray(u.value) ? (l(), c("ul", uA, [
            (l(!0), c(te, null, oe(u.value, (f, K) => (l(), c("li", { key: K }, U(f), 1))), 128))
          ])) : (l(), c("p", dA, U(u.value), 1))
        ]))), 128))
      ])) : v("", !0)
    ]),
    _: 1
  }, 8, ["heading"]);
}
const TR = /* @__PURE__ */ P(sA, [["render", cA]]), fA = {
  name: "LinksList",
  props: {
    /**
     * List of link items
     * Link item has:
     * label: String
     * href: String (required)
     * text: String
     */
    items: {
      type: Array,
      required: !0
    },
    isHorizontal: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  }
}, pA = {
  key: 0,
  class: "font-weight-bold pr-1"
}, hA = ["href"], mA = ["href"];
function AA(e, n, t, o, i, r) {
  return l(), c("ul", {
    class: G(["list-group", { "list-group-horizontal": t.isHorizontal }])
  }, [
    (l(!0), c(te, null, oe(t.items, (a, s) => (l(), c("li", {
      class: "list-group-item",
      key: s
    }, [
      a.label ? (l(), c("span", pA, U(a.label), 1)) : v("", !0),
      a.text ? (l(), c("a", {
        key: 1,
        href: a.href
      }, U(a.text), 9, hA)) : (l(), c("a", {
        key: 2,
        href: a.href
      }, U(a.href), 9, mA))
    ]))), 128))
  ], 2);
}
const IR = /* @__PURE__ */ P(fA, [["render", AA], ["__scopeId", "data-v-191b287c"]]), gA = {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    subTitle: {
      type: String,
      required: !1
    },
    subTitleLink: {
      type: [String, Object],
      required: !1
    },
    logoUrl: {
      type: String,
      required: !1
    }
  },
  computed: {
    nTitleColumns() {
      return this.logoUrl ? 9 : 12;
    },
    isVueRouterLink() {
      return this.subTitleLink && typeof this.subTitleLink == "object" || typeof this.subTitleLink == "string" && !(this.subTitleLink.startsWith("http://") || this.subTitleLink.startsWith("https://"));
    }
  }
}, yA = { class: "row" }, KA = {
  key: 0,
  class: "col-3 d-flex flex-row-reverse"
}, bA = ["src"], vA = { key: 0 }, CA = { class: "text-muted" }, wA = ["href"];
function FA(e, n, t, o, i, r) {
  const a = b("router-link");
  return l(), c("div", null, [
    p("div", yA, [
      p("div", {
        class: G("col-" + r.nTitleColumns)
      }, [
        p("h1", null, U(t.title), 1)
      ], 2),
      t.logoUrl ? (l(), c("div", KA, [
        p("img", {
          class: "justify-content-center align-self-center",
          src: t.logoUrl,
          alt: "page logo"
        }, null, 8, bA)
      ])) : v("", !0)
    ]),
    t.subTitle ? (l(), c("h3", vA, [
      p("small", CA, [
        t.subTitleLink && r.isVueRouterLink ? (l(), F(a, Bo(Pn({ key: 0 }, t.subTitleLink)), {
          default: C(() => [
            B(U(t.subTitle), 1)
          ]),
          _: 1
        }, 16)) : t.subTitleLink && !r.isVueRouterLink ? (l(), c("a", {
          key: 1,
          href: t.subTitleLink
        }, U(t.subTitle), 9, wA)) : (l(), c(te, { key: 2 }, [
          B(U(t.subTitle), 1)
        ], 64))
      ])
    ])) : v("", !0)
  ]);
}
const DR = /* @__PURE__ */ P(gA, [["render", FA], ["__scopeId", "data-v-1dd47602"]]), RA = {
  name: "TableDisplay",
  props: {
    /**
     * List of column objects, each object has a label and name
     */
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * List of row objects, each row is a key value object, where the keys refer to the column.name property
     */
    rows: {
      type: Array,
      default: () => []
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, kA = ["onClick"];
function UA(e, n, t, o, i, r) {
  return l(), c("table", {
    class: G(["table", { "table-hover": t.isClickable }])
  }, [
    p("thead", null, [
      p("tr", null, [
        (l(!0), c(te, null, oe(t.columns, (a, s) => (l(), c("th", {
          key: s,
          scope: "col"
        }, U(a.label), 1))), 128))
      ])
    ]),
    p("tbody", null, [
      (l(!0), c(te, null, oe(t.rows, (a, s) => (l(), c("tr", {
        key: s,
        onClick: (u) => e.$emit("row-click", a)
      }, [
        (l(!0), c(te, null, oe(t.columns, (u, d) => (l(), c("td", { key: d }, U(a[u.name]), 1))), 128))
      ], 8, kA))), 128))
    ])
  ], 2);
}
const OR = /* @__PURE__ */ P(RA, [["render", UA]]), EA = {
  components: {
    IconAction: ft
  },
  data() {
    return {
      expandedState: this.expanded
    };
  },
  props: {
    title: String,
    conditions: Array,
    expanded: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    count() {
      return Array.isArray(this.conditions) ? this.conditions.length : null;
    }
  }
}, SA = { class: "mb-2 pt-2 border-top bg-white" }, TA = { class: "mb-0 font-weight-bold p-2" }, IA = {
  key: 0,
  class: "badge badge-secondary"
}, DA = {
  key: 0,
  class: "p-2"
};
function OA(e, n, t, o, i, r) {
  const a = b("IconAction");
  return l(), c("div", SA, [
    p("div", {
      class: "filter-header d-flex flex-row justify-content-between",
      onClick: n[0] || (n[0] = (s) => i.expandedState = !i.expandedState)
    }, [
      p("h6", TA, [
        B(U(t.title) + " ", 1),
        r.count > 0 ? (l(), c("span", IA, U(r.count), 1)) : v("", !0)
      ]),
      D(a, {
        class: "ml-auto",
        icon: i.expandedState ? "angle-up" : "angle-down"
      }, null, 8, ["icon"])
    ]),
    H(e.$slots, "header", {}, void 0, !0),
    i.expandedState ? (l(), c("div", DA, [
      H(e.$slots, "default", {}, void 0, !0)
    ])) : v("", !0)
  ]);
}
const _A = /* @__PURE__ */ P(EA, [["render", OA], ["__scopeId", "data-v-6316fb7d"]]), PA = {
  name: "InputRadio",
  extends: Ce,
  components: { FormGroup: Ue },
  props: {
    options: {
      type: Array,
      required: !0
    },
    isClearable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    direction: {
      type: String,
      required: !1,
      default: "horizontal"
    }
  },
  data() {
    return {
      radioValue: this.modelValue,
      isMouseOver: !1
    };
  },
  watch: {
    radioValue() {
      this.$emit("update:modelValue", this.radioValue);
    },
    modelValue(e) {
      this.radioValue = e;
    }
  },
  computed: {
    isClearShown() {
      return this.isClearable !== void 0 && this.isClearable === !1 ? !1 : this.isMouseOver && this.radioValue !== null && this.radioValue !== void 0;
    }
  }
}, MA = ["id", "aria-describedby", "value"], NA = ["for"], BA = { class: "input-group-append" };
function LA(e, n, t, o, i, r) {
  const a = b("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "radio-form-group",
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      p("div", {
        onMouseenter: n[2] || (n[2] = (s) => i.isMouseOver = !0),
        onMouseleave: n[3] || (n[3] = (s) => i.isMouseOver = !1),
        class: G(["input-group", t.direction === "vertical" ? "flex-column" : "flex-row"])
      }, [
        (l(!0), c(te, null, oe(t.options, (s, u) => (l(), c("div", {
          key: u,
          class: "form-check form-check-inline"
        }, [
          Ye(p("input", {
            class: G(["form-check-input", { "is-invalid": e.errorMessage }]),
            type: "radio",
            id: e.id + u,
            "aria-describedby": e.id + "Help",
            value: s,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => i.radioValue = d)
          }, null, 10, MA), [
            [Nl, i.radioValue]
          ]),
          p("label", {
            class: "form-check-label",
            for: e.id + u
          }, U(s), 9, NA)
        ]))), 128)),
        p("div", BA, [
          Ye(p("button", {
            class: "btn btn-link radio-clear-value",
            onClick: n[1] || (n[1] = (s) => i.radioValue = null)
          }, " clear ", 512), [
            [ki, r.isClearShown]
          ])
        ])
      ], 34)
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const sr = /* @__PURE__ */ P(PA, [["render", LA], ["__scopeId", "data-v-ac59342c"]]), xA = {
  name: "InputBoolean",
  components: { InputRadio: sr },
  extends: Ce,
  props: {
    inplace: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !0 }
  },
  methods: {
    insertValue(e) {
      return e === !0 ? "Yes" : e === !1 ? "No" : null;
    },
    returnValue(e) {
      return e === "Yes" ? !0 : e === "No" ? !1 : null;
    }
  }
}, qA = { key: 0 }, VA = ["id", "checked", "aria-describedby"], jA = ["for"];
function HA(e, n, t, o, i, r) {
  const a = b("InputRadio");
  return t.inplace ? (l(), c("div", qA, [
    p("input", {
      id: e.id,
      checked: e.modelValue,
      type: "checkbox",
      "aria-describedby": e.id + "Help",
      onChange: n[0] || (n[0] = (s) => e.$emit("update:modelValue", s.target.checked))
    }, null, 40, VA),
    p("label", {
      class: "ml-1",
      for: e.id
    }, U(e.label), 9, jA)
  ])) : (l(), F(a, Pn({ key: 1 }, e.$props, {
    id: e.id,
    modelValue: r.insertValue(e.modelValue),
    options: ["Yes", "No"],
    isClearable: t.isClearable,
    "onUpdate:modelValue": n[1] || (n[1] = (s) => e.$emit("update:modelValue", r.returnValue(s)))
  }), null, 16, ["id", "modelValue", "isClearable"]));
}
const Li = /* @__PURE__ */ P(xA, [["render", HA]]), GA = {
  name: "BooleanFilter",
  components: { InputBoolean: Li },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Boolean,
      required: !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function QA(e, n, t, o, i, r) {
  const a = b("InputBoolean");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    onClearCondition: n[0] || (n[0] = (s) => e.$emit("clearCondition"))
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const ko = /* @__PURE__ */ P(GA, [["render", QA]]);
var so = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], nn = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(e) {
    return typeof console < "u" && console.warn(e);
  },
  getWeek: function(e) {
    var n = new Date(e.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var t = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, _n = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(e) {
    var n = e % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Ge = function(e, n) {
  return n === void 0 && (n = 2), ("000" + e).slice(n * -1);
}, lt = function(e) {
  return e === !0 ? 1 : 0;
};
function fa(e, n) {
  var t;
  return function() {
    var o = this, i = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return e.apply(o, i);
    }, n);
  };
}
var lo = function(e) {
  return e instanceof Array ? e : [e];
};
function je(e, n, t) {
  if (t === !0)
    return e.classList.add(n);
  e.classList.remove(n);
}
function ve(e, n, t) {
  var o = window.document.createElement(e);
  return n = n || "", t = t || "", o.className = n, t !== void 0 && (o.textContent = t), o;
}
function ri(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
function Js(e, n) {
  if (n(e))
    return e;
  if (e.parentNode)
    return Js(e.parentNode, n);
}
function ai(e, n) {
  var t = ve("div", "numInputWrapper"), o = ve("input", "numInput " + e), i = ve("span", "arrowUp"), r = ve("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? o.type = "number" : (o.type = "text", o.pattern = "\\d*"), n !== void 0)
    for (var a in n)
      o.setAttribute(a, n[a]);
  return t.appendChild(o), t.appendChild(i), t.appendChild(r), t;
}
function Ze(e) {
  try {
    if (typeof e.composedPath == "function") {
      var n = e.composedPath();
      return n[0];
    }
    return e.target;
  } catch {
    return e.target;
  }
}
var uo = function() {
}, Fi = function(e, n, t) {
  return t.months[n ? "shorthand" : "longhand"][e];
}, $A = {
  D: uo,
  F: function(e, n, t) {
    e.setMonth(t.months.longhand.indexOf(n));
  },
  G: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(e, n) {
    e.setHours(parseFloat(n));
  },
  J: function(e, n) {
    e.setDate(parseFloat(n));
  },
  K: function(e, n, t) {
    e.setHours(e.getHours() % 12 + 12 * lt(new RegExp(t.amPM[1], "i").test(n)));
  },
  M: function(e, n, t) {
    e.setMonth(t.months.shorthand.indexOf(n));
  },
  S: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  U: function(e, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(e, n, t) {
    var o = parseInt(n), i = new Date(e.getFullYear(), 0, 2 + (o - 1) * 7, 0, 0, 0, 0);
    return i.setDate(i.getDate() - i.getDay() + t.firstDayOfWeek), i;
  },
  Y: function(e, n) {
    e.setFullYear(parseFloat(n));
  },
  Z: function(e, n) {
    return new Date(n);
  },
  d: function(e, n) {
    e.setDate(parseFloat(n));
  },
  h: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(e, n) {
    e.setMinutes(parseFloat(n));
  },
  j: function(e, n) {
    e.setDate(parseFloat(n));
  },
  l: uo,
  m: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  n: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  s: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  u: function(e, n) {
    return new Date(parseFloat(n));
  },
  w: uo,
  y: function(e, n) {
    e.setFullYear(2e3 + parseFloat(n));
  }
}, Mt = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, Sn = {
  Z: function(e) {
    return e.toISOString();
  },
  D: function(e, n, t) {
    return n.weekdays.shorthand[Sn.w(e, n, t)];
  },
  F: function(e, n, t) {
    return Fi(Sn.n(e, n, t) - 1, !1, n);
  },
  G: function(e, n, t) {
    return Ge(Sn.h(e, n, t));
  },
  H: function(e) {
    return Ge(e.getHours());
  },
  J: function(e, n) {
    return n.ordinal !== void 0 ? e.getDate() + n.ordinal(e.getDate()) : e.getDate();
  },
  K: function(e, n) {
    return n.amPM[lt(e.getHours() > 11)];
  },
  M: function(e, n) {
    return Fi(e.getMonth(), !0, n);
  },
  S: function(e) {
    return Ge(e.getSeconds());
  },
  U: function(e) {
    return e.getTime() / 1e3;
  },
  W: function(e, n, t) {
    return t.getWeek(e);
  },
  Y: function(e) {
    return Ge(e.getFullYear(), 4);
  },
  d: function(e) {
    return Ge(e.getDate());
  },
  h: function(e) {
    return e.getHours() % 12 ? e.getHours() % 12 : 12;
  },
  i: function(e) {
    return Ge(e.getMinutes());
  },
  j: function(e) {
    return e.getDate();
  },
  l: function(e, n) {
    return n.weekdays.longhand[e.getDay()];
  },
  m: function(e) {
    return Ge(e.getMonth() + 1);
  },
  n: function(e) {
    return e.getMonth() + 1;
  },
  s: function(e) {
    return e.getSeconds();
  },
  u: function(e) {
    return e.getTime();
  },
  w: function(e) {
    return e.getDay();
  },
  y: function(e) {
    return String(e.getFullYear()).substring(2);
  }
}, zs = function(e) {
  var n = e.config, t = n === void 0 ? nn : n, o = e.l10n, i = o === void 0 ? _n : o, r = e.isMobile, a = r === void 0 ? !1 : r;
  return function(s, u, d) {
    var f = d || i;
    return t.formatDate !== void 0 && !a ? t.formatDate(s, u, f) : u.split("").map(function(K, w, k) {
      return Sn[K] && k[w - 1] !== "\\" ? Sn[K](s, f, t) : K !== "\\" ? K : "";
    }).join("");
  };
}, Uo = function(e) {
  var n = e.config, t = n === void 0 ? nn : n, o = e.l10n, i = o === void 0 ? _n : o;
  return function(r, a, s, u) {
    if (!(r !== 0 && !r)) {
      var d = u || i, f, K = r;
      if (r instanceof Date)
        f = new Date(r.getTime());
      else if (typeof r != "string" && r.toFixed !== void 0)
        f = new Date(r);
      else if (typeof r == "string") {
        var w = a || (t || nn).dateFormat, k = String(r).trim();
        if (k === "today")
          f = /* @__PURE__ */ new Date(), s = !0;
        else if (t && t.parseDate)
          f = t.parseDate(r, w);
        else if (/Z$/.test(k) || /GMT$/.test(k))
          f = new Date(r);
        else {
          for (var y = void 0, m = [], g = 0, I = 0, x = ""; g < w.length; g++) {
            var E = w[g], _ = E === "\\", q = w[g - 1] === "\\" || _;
            if (Mt[E] && !q) {
              x += Mt[E];
              var V = new RegExp(x).exec(r);
              V && (y = !0) && m[E !== "Y" ? "push" : "unshift"]({
                fn: $A[E],
                val: V[++I]
              });
            } else _ || (x += ".");
          }
          f = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), m.forEach(function(L) {
            var $ = L.fn, J = L.val;
            return f = $(f, J, d) || f;
          }), f = y ? f : void 0;
        }
      }
      if (!(f instanceof Date && !isNaN(f.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + K));
        return;
      }
      return s === !0 && f.setHours(0, 0, 0, 0), f;
    }
  };
};
function et(e, n, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : e.getTime() - n.getTime();
}
var JA = function(e, n, t) {
  return e > Math.min(n, t) && e < Math.max(n, t);
}, co = function(e, n, t) {
  return e * 3600 + n * 60 + t;
}, zA = function(e) {
  var n = Math.floor(e / 3600), t = (e - n * 3600) / 60;
  return [n, t, e - n * 3600 - t * 60];
}, YA = {
  DAY: 864e5
};
function fo(e) {
  var n = e.defaultHour, t = e.defaultMinute, o = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var i = e.minDate.getHours(), r = e.minDate.getMinutes(), a = e.minDate.getSeconds();
    n < i && (n = i), n === i && t < r && (t = r), n === i && t === r && o < a && (o = e.minDate.getSeconds());
  }
  if (e.maxDate !== void 0) {
    var s = e.maxDate.getHours(), u = e.maxDate.getMinutes();
    n = Math.min(n, s), n === s && (t = Math.min(u, t)), n === s && t === u && (o = e.maxDate.getSeconds());
  }
  return { hours: n, minutes: t, seconds: o };
}
typeof Object.assign != "function" && (Object.assign = function(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  if (!e)
    throw TypeError("Cannot convert undefined or null to object");
  for (var o = function(s) {
    s && Object.keys(s).forEach(function(u) {
      return e[u] = s[u];
    });
  }, i = 0, r = n; i < r.length; i++) {
    var a = r[i];
    o(a);
  }
  return e;
});
var xe = function() {
  return xe = Object.assign || function(e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) {
      n = arguments[t];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, xe.apply(this, arguments);
}, pa = function() {
  for (var e = 0, n = 0, t = arguments.length; n < t; n++) e += arguments[n].length;
  for (var o = Array(e), i = 0, n = 0; n < t; n++)
    for (var r = arguments[n], a = 0, s = r.length; a < s; a++, i++)
      o[i] = r[a];
  return o;
}, WA = 300;
function XA(e, n) {
  var t = {
    config: xe(xe({}, nn), Ie.defaultConfig),
    l10n: _n
  };
  t.parseDate = Uo({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = m, t._setHoursFromDate = w, t._positionCalendar = $t, t.changeMonth = Ee, t.changeYear = pt, t.clear = De, t.close = Be, t.onMouseOver = It, t._createElement = ve, t.createDay = V, t.destroy = be, t.isEnabled = de, t.jumpToDate = x, t.updateValue = Ut, t.open = An, t.redraw = yn, t.set = Wn, t.setDate = Xn, t.toggle = Cl;
  function o() {
    t.utils = {
      getDaysInMonth: function(h, A) {
        return h === void 0 && (h = t.currentMonth), A === void 0 && (A = t.currentYear), h === 1 && (A % 4 === 0 && A % 100 !== 0 || A % 400 === 0) ? 29 : t.l10n.daysInMonth[h];
      }
    };
  }
  function i() {
    t.element = t.input = e, t.isOpen = !1, zn(), Yn(), bl(), Kl(), o(), t.isMobile || q(), I(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && w(t.config.noCalendar ? t.latestSelectedDateObj : void 0), Ut(!1)), s();
    var h = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && h && $t(), Se("onReady");
  }
  function r() {
    var h;
    return ((h = t.calendarContainer) === null || h === void 0 ? void 0 : h.getRootNode()).activeElement || document.activeElement;
  }
  function a(h) {
    return h.bind(t);
  }
  function s() {
    var h = t.config;
    h.weekNumbers === !1 && h.showMonths === 1 || h.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var A = (t.days.offsetWidth + 1) * h.showMonths;
        t.daysContainer.style.width = A + "px", t.calendarContainer.style.width = A + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function u(h) {
    if (t.selectedDates.length === 0) {
      var A = t.config.minDate === void 0 || et(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), R = fo(t.config);
      A.setHours(R.hours, R.minutes, R.seconds, A.getMilliseconds()), t.selectedDates = [A], t.latestSelectedDateObj = A;
    }
    h !== void 0 && h.type !== "blur" && Rl(h);
    var O = t._input.value;
    K(), Ut(), t._input.value !== O && t._debouncedChange();
  }
  function d(h, A) {
    return h % 12 + 12 * lt(A === t.l10n.amPM[1]);
  }
  function f(h) {
    switch (h % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return h % 12;
    }
  }
  function K() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var h = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, A = (parseInt(t.minuteElement.value, 10) || 0) % 60, R = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (h = d(h, t.amPM.textContent));
      var O = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && et(t.latestSelectedDateObj, t.config.minDate, !0) === 0, Q = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && et(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var z = co(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), he = co(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), Z = co(h, A, R);
        if (Z > he && Z < z) {
          var ge = zA(z);
          h = ge[0], A = ge[1], R = ge[2];
        }
      } else {
        if (Q) {
          var X = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          h = Math.min(h, X.getHours()), h === X.getHours() && (A = Math.min(A, X.getMinutes())), A === X.getMinutes() && (R = Math.min(R, X.getSeconds()));
        }
        if (O) {
          var le = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          h = Math.max(h, le.getHours()), h === le.getHours() && A < le.getMinutes() && (A = le.getMinutes()), A === le.getMinutes() && (R = Math.max(R, le.getSeconds()));
        }
      }
      k(h, A, R);
    }
  }
  function w(h) {
    var A = h || t.latestSelectedDateObj;
    A && A instanceof Date && k(A.getHours(), A.getMinutes(), A.getSeconds());
  }
  function k(h, A, R) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(h % 24, A, R || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = Ge(t.config.time_24hr ? h : (12 + h) % 12 + 12 * lt(h % 12 === 0)), t.minuteElement.value = Ge(A), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[lt(h >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = Ge(R)));
  }
  function y(h) {
    var A = Ze(h), R = parseInt(A.value) + (h.delta || 0);
    (R / 1e3 > 1 || h.key === "Enter" && !/[^\d]/.test(R.toString())) && pt(R);
  }
  function m(h, A, R, O) {
    if (A instanceof Array)
      return A.forEach(function(Q) {
        return m(h, Q, R, O);
      });
    if (h instanceof Array)
      return h.forEach(function(Q) {
        return m(Q, A, R, O);
      });
    h.addEventListener(A, R, O), t._handlers.push({
      remove: function() {
        return h.removeEventListener(A, R, O);
      }
    });
  }
  function g() {
    Se("onChange");
  }
  function I() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(R) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + R + "]"), function(O) {
        return m(O, "click", t[R]);
      });
    }), t.isMobile) {
      vl();
      return;
    }
    var h = fa(ht, 50);
    if (t._debouncedChange = fa(g, WA), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && m(t.daysContainer, "mouseover", function(R) {
      t.config.mode === "range" && It(Ze(R));
    }), m(t._input, "keydown", Le), t.calendarContainer !== void 0 && m(t.calendarContainer, "keydown", Le), !t.config.inline && !t.config.static && m(window, "resize", h), window.ontouchstart !== void 0 ? m(window.document, "touchstart", at) : m(window.document, "mousedown", at), m(window.document, "focus", at, { capture: !0 }), t.config.clickOpens === !0 && (m(t._input, "focus", t.open), m(t._input, "click", t.open)), t.daysContainer !== void 0 && (m(t.monthNav, "click", Fl), m(t.monthNav, ["keyup", "increment"], y), m(t.daysContainer, "click", Yt)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var A = function(R) {
        return Ze(R).select();
      };
      m(t.timeContainer, ["increment"], u), m(t.timeContainer, "blur", u, { capture: !0 }), m(t.timeContainer, "click", E), m([t.hourElement, t.minuteElement], ["focus", "click"], A), t.secondElement !== void 0 && m(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && m(t.amPM, "click", function(R) {
        u(R);
      });
    }
    t.config.allowInput && m(t._input, "blur", Te);
  }
  function x(h, A) {
    var R = h !== void 0 ? t.parseDate(h) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), O = t.currentYear, Q = t.currentMonth;
    try {
      R !== void 0 && (t.currentYear = R.getFullYear(), t.currentMonth = R.getMonth());
    } catch (z) {
      z.message = "Invalid date supplied: " + R, t.config.errorHandler(z);
    }
    A && t.currentYear !== O && (Se("onYearChange"), j()), A && (t.currentYear !== O || t.currentMonth !== Q) && Se("onMonthChange"), t.redraw();
  }
  function E(h) {
    var A = Ze(h);
    ~A.className.indexOf("arrow") && _(h, A.classList.contains("arrowUp") ? 1 : -1);
  }
  function _(h, A, R) {
    var O = h && Ze(h), Q = R || O && O.parentNode && O.parentNode.firstChild, z = ji("increment");
    z.delta = A, Q && Q.dispatchEvent(z);
  }
  function q() {
    var h = window.document.createDocumentFragment();
    if (t.calendarContainer = ve("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (h.appendChild(M()), t.innerContainer = ve("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var A = ue(), R = A.weekWrapper, O = A.weekNumbers;
        t.innerContainer.appendChild(R), t.weekNumbers = O, t.weekWrapper = R;
      }
      t.rContainer = ve("div", "flatpickr-rContainer"), t.rContainer.appendChild(re()), t.daysContainer || (t.daysContainer = ve("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), fe(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), h.appendChild(t.innerContainer);
    }
    t.config.enableTime && h.appendChild(ee()), je(t.calendarContainer, "rangeMode", t.config.mode === "range"), je(t.calendarContainer, "animate", t.config.animate === !0), je(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(h);
    var Q = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!Q && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var z = ve("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(z, t.element), z.appendChild(t.element), t.altInput && z.appendChild(t.altInput), z.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function V(h, A, R, O) {
    var Q = de(A, !0), z = ve("span", h, A.getDate().toString());
    return z.dateObj = A, z.$i = O, z.setAttribute("aria-label", t.formatDate(A, t.config.ariaDateFormat)), h.indexOf("hidden") === -1 && et(A, t.now) === 0 && (t.todayDateElem = z, z.classList.add("today"), z.setAttribute("aria-current", "date")), Q ? (z.tabIndex = -1, Hi(A) && (z.classList.add("selected"), t.selectedDateElem = z, t.config.mode === "range" && (je(z, "startRange", t.selectedDates[0] && et(A, t.selectedDates[0], !0) === 0), je(z, "endRange", t.selectedDates[1] && et(A, t.selectedDates[1], !0) === 0), h === "nextMonthDay" && z.classList.add("inRange")))) : z.classList.add("flatpickr-disabled"), t.config.mode === "range" && wl(A) && !Hi(A) && z.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && h !== "prevMonthDay" && O % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(A) + "</span>"), Se("onDayCreate", z), z;
  }
  function L(h) {
    h.focus(), t.config.mode === "range" && It(h);
  }
  function $(h) {
    for (var A = h > 0 ? 0 : t.config.showMonths - 1, R = h > 0 ? t.config.showMonths : -1, O = A; O != R; O += h)
      for (var Q = t.daysContainer.children[O], z = h > 0 ? 0 : Q.children.length - 1, he = h > 0 ? Q.children.length : -1, Z = z; Z != he; Z += h) {
        var ge = Q.children[Z];
        if (ge.className.indexOf("hidden") === -1 && de(ge.dateObj))
          return ge;
      }
  }
  function J(h, A) {
    for (var R = h.className.indexOf("Month") === -1 ? h.dateObj.getMonth() : t.currentMonth, O = A > 0 ? t.config.showMonths : -1, Q = A > 0 ? 1 : -1, z = R - t.currentMonth; z != O; z += Q)
      for (var he = t.daysContainer.children[z], Z = R - t.currentMonth === z ? h.$i + A : A < 0 ? he.children.length - 1 : 0, ge = he.children.length, X = Z; X >= 0 && X < ge && X != (A > 0 ? ge : -1); X += Q) {
        var le = he.children[X];
        if (le.className.indexOf("hidden") === -1 && de(le.dateObj) && Math.abs(h.$i - X) >= Math.abs(A))
          return L(le);
      }
    t.changeMonth(Q), W($(Q), 0);
  }
  function W(h, A) {
    var R = r(), O = pe(R || document.body), Q = h !== void 0 ? h : O ? R : t.selectedDateElem !== void 0 && pe(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && pe(t.todayDateElem) ? t.todayDateElem : $(A > 0 ? 1 : -1);
    Q === void 0 ? t._input.focus() : O ? J(Q, A) : L(Q);
  }
  function se(h, A) {
    for (var R = (new Date(h, A, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, O = t.utils.getDaysInMonth((A - 1 + 12) % 12, h), Q = t.utils.getDaysInMonth(A, h), z = window.document.createDocumentFragment(), he = t.config.showMonths > 1, Z = he ? "prevMonthDay hidden" : "prevMonthDay", ge = he ? "nextMonthDay hidden" : "nextMonthDay", X = O + 1 - R, le = 0; X <= O; X++, le++)
      z.appendChild(V("flatpickr-day " + Z, new Date(h, A - 1, X), X, le));
    for (X = 1; X <= Q; X++, le++)
      z.appendChild(V("flatpickr-day", new Date(h, A, X), X, le));
    for (var Re = Q + 1; Re <= 42 - R && (t.config.showMonths === 1 || le % 7 !== 0); Re++, le++)
      z.appendChild(V("flatpickr-day " + ge, new Date(h, A + 1, Re % Q), Re, le));
    var wt = ve("div", "dayContainer");
    return wt.appendChild(z), wt;
  }
  function fe() {
    if (t.daysContainer !== void 0) {
      ri(t.daysContainer), t.weekNumbers && ri(t.weekNumbers);
      for (var h = document.createDocumentFragment(), A = 0; A < t.config.showMonths; A++) {
        var R = new Date(t.currentYear, t.currentMonth, 1);
        R.setMonth(t.currentMonth + A), h.appendChild(se(R.getFullYear(), R.getMonth()));
      }
      t.daysContainer.appendChild(h), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && It();
    }
  }
  function j() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var h = function(O) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && O < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && O > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var A = 0; A < 12; A++)
        if (h(A)) {
          var R = ve("option", "flatpickr-monthDropdown-month");
          R.value = new Date(t.currentYear, A).getMonth().toString(), R.textContent = Fi(A, t.config.shorthandCurrentMonth, t.l10n), R.tabIndex = -1, t.currentMonth === A && (R.selected = !0), t.monthsDropdownContainer.appendChild(R);
        }
    }
  }
  function ye() {
    var h = ve("div", "flatpickr-month"), A = window.document.createDocumentFragment(), R;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? R = ve("span", "cur-month") : (t.monthsDropdownContainer = ve("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), m(t.monthsDropdownContainer, "change", function(he) {
      var Z = Ze(he), ge = parseInt(Z.value, 10);
      t.changeMonth(ge - t.currentMonth), Se("onMonthChange");
    }), j(), R = t.monthsDropdownContainer);
    var O = ai("cur-year", { tabindex: "-1" }), Q = O.getElementsByTagName("input")[0];
    Q.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && Q.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (Q.setAttribute("max", t.config.maxDate.getFullYear().toString()), Q.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var z = ve("div", "flatpickr-current-month");
    return z.appendChild(R), z.appendChild(O), A.appendChild(z), h.appendChild(A), {
      container: h,
      yearElement: Q,
      monthElement: R
    };
  }
  function S() {
    ri(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var h = t.config.showMonths; h--; ) {
      var A = ye();
      t.yearElements.push(A.yearElement), t.monthElements.push(A.monthElement), t.monthNav.appendChild(A.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function M() {
    return t.monthNav = ve("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = ve("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = ve("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, S(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(h) {
        t.__hidePrevMonthArrow !== h && (je(t.prevMonthNav, "flatpickr-disabled", h), t.__hidePrevMonthArrow = h);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(h) {
        t.__hideNextMonthArrow !== h && (je(t.nextMonthNav, "flatpickr-disabled", h), t.__hideNextMonthArrow = h);
      }
    }), t.currentYearElement = t.yearElements[0], Zn(), t.monthNav;
  }
  function ee() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var h = fo(t.config);
    t.timeContainer = ve("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var A = ve("span", "flatpickr-time-separator", ":"), R = ai("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = R.getElementsByTagName("input")[0];
    var O = ai("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = O.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = Ge(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? h.hours : f(h.hours)), t.minuteElement.value = Ge(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : h.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(R), t.timeContainer.appendChild(A), t.timeContainer.appendChild(O), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var Q = ai("flatpickr-second");
      t.secondElement = Q.getElementsByTagName("input")[0], t.secondElement.value = Ge(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : h.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(ve("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(Q);
    }
    return t.config.time_24hr || (t.amPM = ve("span", "flatpickr-am-pm", t.l10n.amPM[lt((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function re() {
    t.weekdayContainer ? ri(t.weekdayContainer) : t.weekdayContainer = ve("div", "flatpickr-weekdays");
    for (var h = t.config.showMonths; h--; ) {
      var A = ve("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(A);
    }
    return Ae(), t.weekdayContainer;
  }
  function Ae() {
    if (t.weekdayContainer) {
      var h = t.l10n.firstDayOfWeek, A = pa(t.l10n.weekdays.shorthand);
      h > 0 && h < A.length && (A = pa(A.splice(h, A.length), A.splice(0, h)));
      for (var R = t.config.showMonths; R--; )
        t.weekdayContainer.children[R].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + A.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function ue() {
    t.calendarContainer.classList.add("hasWeeks");
    var h = ve("div", "flatpickr-weekwrapper");
    h.appendChild(ve("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var A = ve("div", "flatpickr-weeks");
    return h.appendChild(A), {
      weekWrapper: h,
      weekNumbers: A
    };
  }
  function Ee(h, A) {
    A === void 0 && (A = !0);
    var R = A ? h : h - t.currentMonth;
    R < 0 && t._hidePrevMonthArrow === !0 || R > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += R, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, Se("onYearChange"), j()), fe(), Se("onMonthChange"), Zn());
  }
  function De(h, A) {
    if (h === void 0 && (h = !0), A === void 0 && (A = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, A === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var R = fo(t.config), O = R.hours, Q = R.minutes, z = R.seconds;
      k(O, Q, z);
    }
    t.redraw(), h && Se("onChange");
  }
  function Be() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), Se("onClose");
  }
  function be() {
    t.config !== void 0 && Se("onDestroy");
    for (var h = t._handlers.length; h--; )
      t._handlers[h].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var A = t.calendarContainer.parentNode;
        if (A.lastChild && A.removeChild(A.lastChild), A.parentNode) {
          for (; A.firstChild; )
            A.parentNode.insertBefore(A.firstChild, A);
          A.parentNode.removeChild(A);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(R) {
      try {
        delete t[R];
      } catch {
      }
    });
  }
  function we(h) {
    return t.calendarContainer.contains(h);
  }
  function at(h) {
    if (t.isOpen && !t.config.inline) {
      var A = Ze(h), R = we(A), O = A === t.input || A === t.altInput || t.element.contains(A) || h.path && h.path.indexOf && (~h.path.indexOf(t.input) || ~h.path.indexOf(t.altInput)), Q = !O && !R && !we(h.relatedTarget), z = !t.config.ignoredFocusElements.some(function(he) {
        return he.contains(A);
      });
      Q && z && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && u(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function pt(h) {
    if (!(!h || t.config.minDate && h < t.config.minDate.getFullYear() || t.config.maxDate && h > t.config.maxDate.getFullYear())) {
      var A = h, R = t.currentYear !== A;
      t.currentYear = A || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), R && (t.redraw(), Se("onYearChange"), j());
    }
  }
  function de(h, A) {
    var R;
    A === void 0 && (A = !0);
    var O = t.parseDate(h, void 0, A);
    if (t.config.minDate && O && et(O, t.config.minDate, A !== void 0 ? A : !t.minDateHasTime) < 0 || t.config.maxDate && O && et(O, t.config.maxDate, A !== void 0 ? A : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (O === void 0)
      return !1;
    for (var Q = !!t.config.enable, z = (R = t.config.enable) !== null && R !== void 0 ? R : t.config.disable, he = 0, Z = void 0; he < z.length; he++) {
      if (Z = z[he], typeof Z == "function" && Z(O))
        return Q;
      if (Z instanceof Date && O !== void 0 && Z.getTime() === O.getTime())
        return Q;
      if (typeof Z == "string") {
        var ge = t.parseDate(Z, void 0, !0);
        return ge && ge.getTime() === O.getTime() ? Q : !Q;
      } else if (typeof Z == "object" && O !== void 0 && Z.from && Z.to && O.getTime() >= Z.from.getTime() && O.getTime() <= Z.to.getTime())
        return Q;
    }
    return !Q;
  }
  function pe(h) {
    return t.daysContainer !== void 0 ? h.className.indexOf("hidden") === -1 && h.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(h) : !1;
  }
  function Te(h) {
    var A = h.target === t._input, R = t._input.value.trimEnd() !== Gi();
    A && R && !(h.relatedTarget && we(h.relatedTarget)) && t.setDate(t._input.value, !0, h.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function Le(h) {
    var A = Ze(h), R = t.config.wrap ? e.contains(A) : A === t._input, O = t.config.allowInput, Q = t.isOpen && (!O || !R), z = t.config.inline && R && !O;
    if (h.keyCode === 13 && R) {
      if (O)
        return t.setDate(t._input.value, !0, A === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), A.blur();
      t.open();
    } else if (we(A) || Q || z) {
      var he = !!t.timeContainer && t.timeContainer.contains(A);
      switch (h.keyCode) {
        case 13:
          he ? (h.preventDefault(), u(), zt()) : Yt(h);
          break;
        case 27:
          h.preventDefault(), zt();
          break;
        case 8:
        case 46:
          R && !t.config.allowInput && (h.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!he && !R) {
            h.preventDefault();
            var Z = r();
            if (t.daysContainer !== void 0 && (O === !1 || Z && pe(Z))) {
              var ge = h.keyCode === 39 ? 1 : -1;
              h.ctrlKey ? (h.stopPropagation(), Ee(ge), W($(1), 0)) : W(void 0, ge);
            }
          } else t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          h.preventDefault();
          var X = h.keyCode === 40 ? 1 : -1;
          t.daysContainer && A.$i !== void 0 || A === t.input || A === t.altInput ? h.ctrlKey ? (h.stopPropagation(), pt(t.currentYear - X), W($(1), 0)) : he || W(void 0, X * 7) : A === t.currentYearElement ? pt(t.currentYear - X) : t.config.enableTime && (!he && t.hourElement && t.hourElement.focus(), u(h), t._debouncedChange());
          break;
        case 9:
          if (he) {
            var le = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(Xe) {
              return Xe;
            }), Re = le.indexOf(A);
            if (Re !== -1) {
              var wt = le[Re + (h.shiftKey ? -1 : 1)];
              h.preventDefault(), (wt || t._input).focus();
            }
          } else !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(A) && h.shiftKey && (h.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && A === t.amPM)
      switch (h.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], K(), Ut();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], K(), Ut();
          break;
      }
    (R || we(A)) && Se("onKeyDown", h);
  }
  function It(h, A) {
    if (A === void 0 && (A = "flatpickr-day"), !(t.selectedDates.length !== 1 || h && (!h.classList.contains(A) || h.classList.contains("flatpickr-disabled")))) {
      for (var R = h ? h.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), O = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), Q = Math.min(R, t.selectedDates[0].getTime()), z = Math.max(R, t.selectedDates[0].getTime()), he = !1, Z = 0, ge = 0, X = Q; X < z; X += YA.DAY)
        de(new Date(X), !0) || (he = he || X > Q && X < z, X < O && (!Z || X > Z) ? Z = X : X > O && (!ge || X < ge) && (ge = X));
      var le = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + A));
      le.forEach(function(Re) {
        var wt = Re.dateObj, Xe = wt.getTime(), bn = Z > 0 && Xe < Z || ge > 0 && Xe > ge;
        if (bn) {
          Re.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(Wt) {
            Re.classList.remove(Wt);
          });
          return;
        } else if (he && !bn)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(Wt) {
          Re.classList.remove(Wt);
        }), h !== void 0 && (h.classList.add(R <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), O < R && Xe === O ? Re.classList.add("startRange") : O > R && Xe === O && Re.classList.add("endRange"), Xe >= Z && (ge === 0 || Xe <= ge) && JA(Xe, O, R) && Re.classList.add("inRange"));
      });
    }
  }
  function ht() {
    t.isOpen && !t.config.static && !t.config.inline && $t();
  }
  function An(h, A) {
    if (A === void 0 && (A = t._positionElement), t.isMobile === !0) {
      if (h) {
        h.preventDefault();
        var R = Ze(h);
        R && R.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), Se("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var O = t.isOpen;
    t.isOpen = !0, O || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), Se("onOpen"), $t(A)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (h === void 0 || !t.timeContainer.contains(h.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function Jn(h) {
    return function(A) {
      var R = t.config["_" + h + "Date"] = t.parseDate(A, t.config.dateFormat), O = t.config["_" + (h === "min" ? "max" : "min") + "Date"];
      R !== void 0 && (t[h === "min" ? "minDateHasTime" : "maxDateHasTime"] = R.getHours() > 0 || R.getMinutes() > 0 || R.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(Q) {
        return de(Q);
      }), !t.selectedDates.length && h === "min" && w(R), Ut()), t.daysContainer && (yn(), R !== void 0 ? t.currentYearElement[h] = R.getFullYear().toString() : t.currentYearElement.removeAttribute(h), t.currentYearElement.disabled = !!O && R !== void 0 && O.getFullYear() === R.getFullYear());
    };
  }
  function zn() {
    var h = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], A = xe(xe({}, JSON.parse(JSON.stringify(e.dataset || {}))), n), R = {};
    t.config.parseDate = A.parseDate, t.config.formatDate = A.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(le) {
        t.config._enable = Cr(le);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(le) {
        t.config._disable = Cr(le);
      }
    });
    var O = A.mode === "time";
    if (!A.dateFormat && (A.enableTime || O)) {
      var Q = Ie.defaultConfig.dateFormat || nn.dateFormat;
      R.dateFormat = A.noCalendar || O ? "H:i" + (A.enableSeconds ? ":S" : "") : Q + " H:i" + (A.enableSeconds ? ":S" : "");
    }
    if (A.altInput && (A.enableTime || O) && !A.altFormat) {
      var z = Ie.defaultConfig.altFormat || nn.altFormat;
      R.altFormat = A.noCalendar || O ? "h:i" + (A.enableSeconds ? ":S K" : " K") : z + (" h:i" + (A.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: Jn("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: Jn("max")
    });
    var he = function(le) {
      return function(Re) {
        t.config[le === "min" ? "_minTime" : "_maxTime"] = t.parseDate(Re, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: he("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: he("max")
    }), A.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, R, A);
    for (var Z = 0; Z < h.length; Z++)
      t.config[h[Z]] = t.config[h[Z]] === !0 || t.config[h[Z]] === "true";
    so.filter(function(le) {
      return t.config[le] !== void 0;
    }).forEach(function(le) {
      t.config[le] = lo(t.config[le] || []).map(a);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var Z = 0; Z < t.config.plugins.length; Z++) {
      var ge = t.config.plugins[Z](t) || {};
      for (var X in ge)
        so.indexOf(X) > -1 ? t.config[X] = lo(ge[X]).map(a).concat(t.config[X]) : typeof A[X] > "u" && (t.config[X] = ge[X]);
    }
    A.altInputClass || (t.config.altInputClass = gn().className + " " + t.config.altInputClass), Se("onParseConfig");
  }
  function gn() {
    return t.config.wrap ? e.querySelector("[data-input]") : e;
  }
  function Yn() {
    typeof t.config.locale != "object" && typeof Ie.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = xe(xe({}, Ie.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? Ie.l10ns[t.config.locale] : void 0), Mt.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", Mt.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", Mt.M = "(" + t.l10n.months.shorthand.join("|") + ")", Mt.F = "(" + t.l10n.months.longhand.join("|") + ")", Mt.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var h = xe(xe({}, n), JSON.parse(JSON.stringify(e.dataset || {})));
    h.time_24hr === void 0 && Ie.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = zs(t), t.parseDate = Uo({ config: t.config, l10n: t.l10n });
  }
  function $t(h) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, h);
    if (t.calendarContainer !== void 0) {
      Se("onPreCalendarPosition");
      var A = h || t._positionElement, R = Array.prototype.reduce.call(t.calendarContainer.children, (function(Ol, _l) {
        return Ol + _l.offsetHeight;
      }), 0), O = t.calendarContainer.offsetWidth, Q = t.config.position.split(" "), z = Q[0], he = Q.length > 1 ? Q[1] : null, Z = A.getBoundingClientRect(), ge = window.innerHeight - Z.bottom, X = z === "above" || z !== "below" && ge < R && Z.top > R, le = window.pageYOffset + Z.top + (X ? -R - 2 : A.offsetHeight + 2);
      if (je(t.calendarContainer, "arrowTop", !X), je(t.calendarContainer, "arrowBottom", X), !t.config.inline) {
        var Re = window.pageXOffset + Z.left, wt = !1, Xe = !1;
        he === "center" ? (Re -= (O - Z.width) / 2, wt = !0) : he === "right" && (Re -= O - Z.width, Xe = !0), je(t.calendarContainer, "arrowLeft", !wt && !Xe), je(t.calendarContainer, "arrowCenter", wt), je(t.calendarContainer, "arrowRight", Xe);
        var bn = window.document.body.offsetWidth - (window.pageXOffset + Z.right), Wt = Re + O > window.document.body.offsetWidth, kl = bn + O > window.document.body.offsetWidth;
        if (je(t.calendarContainer, "rightMost", Wt), !t.config.static)
          if (t.calendarContainer.style.top = le + "px", !Wt)
            t.calendarContainer.style.left = Re + "px", t.calendarContainer.style.right = "auto";
          else if (!kl)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = bn + "px";
          else {
            var Qi = kt();
            if (Qi === void 0)
              return;
            var Ul = window.document.body.offsetWidth, El = Math.max(0, Ul / 2 - O / 2), Sl = ".flatpickr-calendar.centerMost:before", Tl = ".flatpickr-calendar.centerMost:after", Il = Qi.cssRules.length, Dl = "{left:" + Z.left + "px;right:auto;}";
            je(t.calendarContainer, "rightMost", !1), je(t.calendarContainer, "centerMost", !0), Qi.insertRule(Sl + "," + Tl + Dl, Il), t.calendarContainer.style.left = El + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function kt() {
    for (var h = null, A = 0; A < document.styleSheets.length; A++) {
      var R = document.styleSheets[A];
      if (R.cssRules) {
        try {
          R.cssRules;
        } catch {
          continue;
        }
        h = R;
        break;
      }
    }
    return h ?? Jt();
  }
  function Jt() {
    var h = document.createElement("style");
    return document.head.appendChild(h), h.sheet;
  }
  function yn() {
    t.config.noCalendar || t.isMobile || (j(), Zn(), fe());
  }
  function zt() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function Yt(h) {
    h.preventDefault(), h.stopPropagation();
    var A = function(le) {
      return le.classList && le.classList.contains("flatpickr-day") && !le.classList.contains("flatpickr-disabled") && !le.classList.contains("notAllowed");
    }, R = Js(Ze(h), A);
    if (R !== void 0) {
      var O = R, Q = t.latestSelectedDateObj = new Date(O.dateObj.getTime()), z = (Q.getMonth() < t.currentMonth || Q.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = O, t.config.mode === "single")
        t.selectedDates = [Q];
      else if (t.config.mode === "multiple") {
        var he = Hi(Q);
        he ? t.selectedDates.splice(parseInt(he), 1) : t.selectedDates.push(Q);
      } else t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = Q, t.selectedDates.push(Q), et(Q, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(le, Re) {
        return le.getTime() - Re.getTime();
      }));
      if (K(), z) {
        var Z = t.currentYear !== Q.getFullYear();
        t.currentYear = Q.getFullYear(), t.currentMonth = Q.getMonth(), Z && (Se("onYearChange"), j()), Se("onMonthChange");
      }
      if (Zn(), fe(), Ut(), !z && t.config.mode !== "range" && t.config.showMonths === 1 ? L(O) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var ge = t.config.mode === "single" && !t.config.enableTime, X = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (ge || X) && zt();
      }
      g();
    }
  }
  var _t = {
    locale: [Yn, Ae],
    showMonths: [S, s, re],
    minDate: [x],
    maxDate: [x],
    positionElement: [wr],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (m(t._input, "focus", t.open), m(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function Wn(h, A) {
    if (h !== null && typeof h == "object") {
      Object.assign(t.config, h);
      for (var R in h)
        _t[R] !== void 0 && _t[R].forEach(function(O) {
          return O();
        });
    } else
      t.config[h] = A, _t[h] !== void 0 ? _t[h].forEach(function(O) {
        return O();
      }) : so.indexOf(h) > -1 && (t.config[h] = lo(A));
    t.redraw(), Ut(!0);
  }
  function Kn(h, A) {
    var R = [];
    if (h instanceof Array)
      R = h.map(function(O) {
        return t.parseDate(O, A);
      });
    else if (h instanceof Date || typeof h == "number")
      R = [t.parseDate(h, A)];
    else if (typeof h == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          R = [t.parseDate(h, A)];
          break;
        case "multiple":
          R = h.split(t.config.conjunction).map(function(O) {
            return t.parseDate(O, A);
          });
          break;
        case "range":
          R = h.split(t.l10n.rangeSeparator).map(function(O) {
            return t.parseDate(O, A);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(h)));
    t.selectedDates = t.config.allowInvalidPreload ? R : R.filter(function(O) {
      return O instanceof Date && de(O, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(O, Q) {
      return O.getTime() - Q.getTime();
    });
  }
  function Xn(h, A, R) {
    if (A === void 0 && (A = !1), R === void 0 && (R = t.config.dateFormat), h !== 0 && !h || h instanceof Array && h.length === 0)
      return t.clear(A);
    Kn(h, R), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), x(void 0, A), w(), t.selectedDates.length === 0 && t.clear(!1), Ut(A), A && Se("onChange");
  }
  function Cr(h) {
    return h.slice().map(function(A) {
      return typeof A == "string" || typeof A == "number" || A instanceof Date ? t.parseDate(A, void 0, !0) : A && typeof A == "object" && A.from && A.to ? {
        from: t.parseDate(A.from, void 0),
        to: t.parseDate(A.to, void 0)
      } : A;
    }).filter(function(A) {
      return A;
    });
  }
  function Kl() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var h = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    h && Kn(h, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function bl() {
    if (t.input = gn(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = ve(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), wr();
  }
  function wr() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function vl() {
    var h = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = ve("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = h, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = h === "datetime-local" ? "Y-m-d\\TH:i:S" : h === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    m(t.mobileInput, "change", function(A) {
      t.setDate(Ze(A).value, !1, t.mobileFormatStr), Se("onChange"), Se("onClose");
    });
  }
  function Cl(h) {
    if (t.isOpen === !0)
      return t.close();
    t.open(h);
  }
  function Se(h, A) {
    if (t.config !== void 0) {
      var R = t.config[h];
      if (R !== void 0 && R.length > 0)
        for (var O = 0; R[O] && O < R.length; O++)
          R[O](t.selectedDates, t.input.value, t, A);
      h === "onChange" && (t.input.dispatchEvent(ji("change")), t.input.dispatchEvent(ji("input")));
    }
  }
  function ji(h) {
    var A = document.createEvent("Event");
    return A.initEvent(h, !0, !0), A;
  }
  function Hi(h) {
    for (var A = 0; A < t.selectedDates.length; A++) {
      var R = t.selectedDates[A];
      if (R instanceof Date && et(R, h) === 0)
        return "" + A;
    }
    return !1;
  }
  function wl(h) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : et(h, t.selectedDates[0]) >= 0 && et(h, t.selectedDates[1]) <= 0;
  }
  function Zn() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(h, A) {
      var R = new Date(t.currentYear, t.currentMonth, 1);
      R.setMonth(t.currentMonth + A), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[A].textContent = Fi(R.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = R.getMonth().toString(), h.value = R.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function Gi(h) {
    var A = h || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(R) {
      return t.formatDate(R, A);
    }).filter(function(R, O, Q) {
      return t.config.mode !== "range" || t.config.enableTime || Q.indexOf(R) === O;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function Ut(h) {
    h === void 0 && (h = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = Gi(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = Gi(t.config.altFormat)), h !== !1 && Se("onValueUpdate");
  }
  function Fl(h) {
    var A = Ze(h), R = t.prevMonthNav.contains(A), O = t.nextMonthNav.contains(A);
    R || O ? Ee(R ? -1 : 1) : t.yearElements.indexOf(A) >= 0 ? A.select() : A.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : A.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function Rl(h) {
    h.preventDefault();
    var A = h.type === "keydown", R = Ze(h), O = R;
    t.amPM !== void 0 && R === t.amPM && (t.amPM.textContent = t.l10n.amPM[lt(t.amPM.textContent === t.l10n.amPM[0])]);
    var Q = parseFloat(O.getAttribute("min")), z = parseFloat(O.getAttribute("max")), he = parseFloat(O.getAttribute("step")), Z = parseInt(O.value, 10), ge = h.delta || (A ? h.which === 38 ? 1 : -1 : 0), X = Z + he * ge;
    if (typeof O.value < "u" && O.value.length === 2) {
      var le = O === t.hourElement, Re = O === t.minuteElement;
      X < Q ? (X = z + X + lt(!le) + (lt(le) && lt(!t.amPM)), Re && _(void 0, -1, t.hourElement)) : X > z && (X = O === t.hourElement ? X - z - lt(!t.amPM) : Q, Re && _(void 0, 1, t.hourElement)), t.amPM && le && (he === 1 ? X + Z === 23 : Math.abs(X - Z) > he) && (t.amPM.textContent = t.l10n.amPM[lt(t.amPM.textContent === t.l10n.amPM[0])]), O.value = Ge(X);
    }
  }
  return i(), t;
}
function on(e, n) {
  for (var t = Array.prototype.slice.call(e).filter(function(a) {
    return a instanceof HTMLElement;
  }), o = [], i = 0; i < t.length; i++) {
    var r = t[i];
    try {
      if (r.getAttribute("data-fp-omit") !== null)
        continue;
      r._flatpickr !== void 0 && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = XA(r, n || {}), o.push(r._flatpickr);
    } catch (a) {
      console.error(a);
    }
  }
  return o.length === 1 ? o[0] : o;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(e) {
  return on(this, e);
}, HTMLElement.prototype.flatpickr = function(e) {
  return on([this], e);
});
var Ie = function(e, n) {
  return typeof e == "string" ? on(window.document.querySelectorAll(e), n) : e instanceof Node ? on([e], n) : on(e, n);
};
Ie.defaultConfig = {};
Ie.l10ns = {
  en: xe({}, _n),
  default: xe({}, _n)
};
Ie.localize = function(e) {
  Ie.l10ns.default = xe(xe({}, Ie.l10ns.default), e);
};
Ie.setDefaults = function(e) {
  Ie.defaultConfig = xe(xe({}, Ie.defaultConfig), e);
};
Ie.parseDate = Uo({});
Ie.formatDate = zs({});
Ie.compareDates = et;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(e) {
  return on(this, e);
});
Date.prototype.fp_incr = function(e) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof e == "string" ? parseInt(e, 10) : e));
};
typeof window < "u" && (window.flatpickr = Ie);
const Ys = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], ZA = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function ha(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function ma(e) {
  return e instanceof Array ? e : [e];
}
function po(e) {
  return e && e.length ? e : null;
}
const Aa = [...Ys, ...ZA], eg = ["locale", "showMonths"], tg = ke({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return Ia("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...Aa.map(ha)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => Ys
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = Ie(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let e = Object.assign({}, this.config);
      this.events.forEach((t) => {
        let o = Ie.defaultConfig[t] || [], i = (...r) => {
          this.$emit(ha(t), ...r);
        };
        e[t] = ma(e[t] || []).concat(o, i);
      });
      const n = this.onClose.bind(this);
      return e.onClose = ma(e.onClose || []).concat(n), e.defaultDate = this.modelValue || e.defaultDate, e;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(e) {
      const n = e.target;
      yi().then(() => {
        this.$emit("update:modelValue", po(n.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(e) {
      this.$emit("blur", po(e.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(e, n) {
      this.$emit("update:modelValue", n);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(e) {
      e ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(e) {
        if (!this.fp)
          return;
        let n = Object.assign({}, e);
        Aa.forEach((t) => {
          delete n[t];
        }), this.fp.set(n), eg.forEach((t) => {
          typeof n[t] < "u" && this.fp.set(t, n[t]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(e) {
      var n;
      !this.$el || e === po(this.$el.value) || (n = this.fp) === null || n === void 0 || n.setDate(e, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
}), ng = {
  extends: Ce,
  components: {
    FlatPickr: tg
  },
  props: {
    readonly: { type: Boolean, default: !1 },
    config: {
      type: Object,
      required: !0
    }
  }
}, ig = ["id", "required"];
function og(e, n, t, o, i, r) {
  const a = b("FlatPickr");
  return t.readonly ? Ye((l(), c("input", {
    key: 0,
    id: e.id,
    readonly: "",
    "onUpdate:modelValue": n[0] || (n[0] = (s) => e.modelValue = s),
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    required: e.required
  }, null, 10, ig)), [
    [Lo, e.modelValue]
  ]) : (l(), F(a, {
    key: 1,
    id: e.id,
    modelValue: e.modelValue,
    style: { background: "white" },
    class: "form-control active",
    config: t.config,
    placeholder: e.placeholder,
    disabled: t.readonly,
    onInput: n[1] || (n[1] = (s) => e.$emit("update:modelValue", s.target.value))
  }, null, 8, ["id", "modelValue", "config", "placeholder", "disabled"]));
}
const Ws = /* @__PURE__ */ P(ng, [["render", og]]), rg = {
  components: { BaseInputDate: Ws, FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    },
    readonly: { type: Boolean, default: !1 }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function ag(e, n, t, o, i, r) {
  const a = b("BaseInputDate"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, { class: "d-flex" }, {
        prepend: C(() => [
          H(e.$slots, "prepend")
        ]),
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"]),
          D(a, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Xs = /* @__PURE__ */ P(rg, [["render", ag]]), sg = {
  name: "DateFilter",
  components: { InputRangeDate: Xs },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function lg(e, n, t, o, i, r) {
  const a = b("InputRangeDate");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Eo = /* @__PURE__ */ P(sg, [["render", lg]]), ug = {
  extends: Ce,
  components: {
    BaseInputDate: Ws,
    FormGroup: Ue,
    InputGroup: Ne
  },
  props: {
    readonly: { type: Boolean, default: !1 }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function dg(e, n, t, o, i, r) {
  const a = b("BaseInputDate"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, null, {
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: t.readonly,
            class: G({ "is-invalid": e.errorMessage }),
            required: e.required,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "class", "required", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const xi = /* @__PURE__ */ P(ug, [["render", dg]]), qi = {
  name: "InputDateTime",
  extends: xi,
  computed: {
    config() {
      return {
        wrap: !0,
        dateFormat: "Y-m-dTH:i:S",
        allowInput: !1,
        enableTime: !0,
        clickOpens: !this.readonly
      };
    }
  }
}, cg = {
  components: { InputDateTime: qi, FormGroup: Ue },
  extends: Xs
}, fg = { class: "d-flex" };
function pg(e, n, t, o, i, r) {
  const a = b("InputDateTime"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      p("div", fg, [
        D(a, {
          id: e.id + "-from",
          modelValue: e.modelValue[0],
          readonly: e.readonly,
          "onUpdate:modelValue": n[0] || (n[0] = (u) => e.emitValue(u, 0)),
          placeholder: "from",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"]),
        D(a, {
          id: e.id + "-to",
          modelValue: e.modelValue[1],
          readonly: e.readonly,
          "onUpdate:modelValue": n[1] || (n[1] = (u) => e.emitValue(u, 1)),
          placeholder: "to",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"])
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const hg = /* @__PURE__ */ P(cg, [["render", pg]]), mg = {
  name: "DateTimeFilter",
  components: { InputRangeDateTime: hg },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  }
};
function Ag(e, n, t, o, i, r) {
  const a = b("InputRangeDateTime");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const So = /* @__PURE__ */ P(mg, [["render", Ag]]), { CODE_MINUS: gg, CODE_PERIOD: yg } = Tt, Kg = {
  extends: Ce,
  methods: {
    handleInputChanged(e) {
      const n = e.target?.value;
      n ? this.emitIfValid(n) : this.$emit("update:modelValue", null);
    },
    emitIfValid(e) {
      if (e === null) {
        this.$emit("update:modelValue", null);
        return;
      }
      const n = e.replace(",", ""), t = parseFloat(n);
      isNaN(t) ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", t);
    },
    handleKeyValidity(e) {
      const n = e.which ?? e.keyCode;
      if (n === gg) {
        const t = Jo(e.target?.value);
        this.emitIfValid(t);
      }
      n === yg && e.target?.value.indexOf(".") > -1 && e.preventDefault(), $o(e) || e.preventDefault();
    },
    isRequired: Vn
  }
}, bg = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function vg(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    type: "text",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...a) => r.handleKeyValidity && r.handleKeyValidity(...a)),
    onInput: n[1] || (n[1] = (...a) => r.handleInputChanged && r.handleInputChanged(...a))
  }, null, 42, bg);
}
const Zs = /* @__PURE__ */ P(Kg, [["render", vg]]), Cg = {
  components: { FormGroup: Ue, BaseInputDecimal: Zs, InputGroup: Ne },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  }
};
function wg(e, n, t, o, i, r) {
  const a = b("BaseInputDecimal"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, { class: "d-flex" }, {
        prepend: C(() => [
          H(e.$slots, "prepend")
        ]),
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          D(a, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Fg = /* @__PURE__ */ P(Cg, [["render", wg]]), Rg = {
  name: "DecimalFilter",
  components: { InputRangeDecimal: Fg },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function kg(e, n, t, o, i, r) {
  const a = b("InputRangeDecimal");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const To = /* @__PURE__ */ P(Rg, [["render", kg]]), { CODE_MINUS: Ug } = Tt, Eg = {
  extends: Ce,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      isNaN(n) || !n ? this.$emit("update:modelValue", null) : this.$emit("update:modelValue", parseInt(n));
    },
    handleKeyValidity(e) {
      if ((e.which ? e.which : e.keyCode) === Ug) {
        const t = Jo(e.target.value);
        typeof t == "string" ? this.$emit("update:modelValue", parseInt(t)) : this.$emit("update:modelValue", t);
      }
      (!$o(e) || e.key === ".") && e.preventDefault();
    },
    isRequired: Vn
  }
}, Sg = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function Tg(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    type: "number",
    step: "1",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...a) => r.handleKeyValidity && r.handleKeyValidity(...a)),
    onInput: n[1] || (n[1] = (...a) => r.emitIfValid && r.emitIfValid(...a))
  }, null, 42, Sg);
}
const lr = /* @__PURE__ */ P(Eg, [["render", Tg]]), Ig = {
  components: { BaseIntInput: lr, FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : parseInt(e), this.$emit("update:modelValue", t);
    }
  }
};
function Dg(e, n, t, o, i, r) {
  const a = b("BaseIntInput"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, { class: "d-flex" }, {
        prepend: C(() => [
          H(e.$slots, "prepend")
        ]),
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          D(a, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Og = /* @__PURE__ */ P(Ig, [["render", Dg]]), _g = {
  name: "IntegerFilter",
  components: { InputRangeInt: Og },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function Pg(e, n, t, o, i, r) {
  const a = b("InputRangeInt");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Io = /* @__PURE__ */ P(_g, [["render", Pg]]), { CODE_MINUS: Mg } = Tt, Ng = {
  extends: Ce,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      n?.length ? this.$emit("update:modelValue", n) : this.$emit("update:modelValue", null);
    },
    handleKeyValidity(e) {
      (e.which ?? e.keyCode) === Mg && this.$emit("update:modelValue", Jo(e.target.value)), $o(e) || e.preventDefault();
    },
    isRequired: Vn
  },
  emits: ["update:modelValue"]
}, Bg = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function Lg(e, n, t, o, i, r) {
  return l(), c("input", {
    id: e.id,
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (a) => r.handleKeyValidity(a)),
    onInput: n[1] || (n[1] = (a) => r.emitIfValid(a))
  }, null, 42, Bg);
}
const el = /* @__PURE__ */ P(Ng, [["render", Lg]]), xg = {
  components: { BaseInputLong: el, FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : e, this.$emit("update:modelValue", t);
    }
  }
};
function qg(e, n, t, o, i, r) {
  const a = b("BaseInputLong"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, { class: "d-flex" }, {
        prepend: C(() => [
          H(e.$slots, "prepend")
        ]),
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          D(a, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Vg = /* @__PURE__ */ P(xg, [["render", qg]]), jg = {
  name: "LongFilter",
  components: { InputRangeLong: Vg },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function Hg(e, n, t, o, i, r) {
  const a = b("InputRangeLong");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const ga = /* @__PURE__ */ P(jg, [["render", Hg]]), Gg = {
  name: "InputOntologySubtree",
  props: {
    terms: {
      type: Array,
      required: !0,
      default: () => []
    },
    isMultiSelect: { type: Boolean, default: !1 }
  },
  methods: {
    countVisibleChildren(e) {
      return e.children ? e.children.filter((n) => n.visible).length : 0;
    },
    getExpandState(e) {
      return this.countVisibleChildren(e) == 0 ? "fas fa-angle-right invisible" : e.expanded ? "fas fa-angle-down" : "fas fa-angle-right";
    },
    //expensive?
    getAllChildNames(e) {
      let n = [];
      return e.children && e.children.forEach((t) => {
        n.push(t.name), n = n.concat(this.getAllChildNames(t));
      }), n;
    },
    getSelectState(e) {
      return e.selected === "complete" ? this.isMultiSelect ? "fas fa-check-square" : "fas fa-check-circle" : e.selected === "partial" ? this.isMultiSelect ? "far fa-check-square" : "far fa-circle" : this.isMultiSelect ? "far fa-square" : "far fa-circle";
    },
    toggleExpandOrSelect(e) {
      e.children ? this.toggleExpand(e) : this.toggleSelect(e);
    },
    toggleSelect(e) {
      e.selected === "complete" ? this.$emit("deselect", e.name) : this.$emit("select", e.name);
    },
    toggleExpand(e) {
      this.$emit("toggleExpand", e.name);
    }
  }
}, Qg = { style: { "list-style-type": "none" } }, $g = ["onClick"], Jg = ["onClick"], zg = ["onClick"], Yg = { key: 0 }, Wg = { key: 0 }, Xg = {
  key: 1,
  class: "text-muted"
}, Zg = { key: 2 };
function ey(e, n, t, o, i, r) {
  const a = b("InputOntologySubtree", !0);
  return l(), c("ul", Qg, [
    (l(!0), c(te, null, oe(t.terms.filter((s) => s.visible).sort((s, u) => s.order - u.order), (s) => (l(), c("li", {
      key: s.name + s.selected + s.expanded
    }, [
      p("span", {
        onClick: Ke((u) => r.toggleExpand(s), ["stop"])
      }, [
        p("i", {
          class: G(["fa-fw pl-2 pt-1 ml-3", r.getExpandState(s)]),
          role: "button"
        }, null, 2)
      ], 8, $g),
      p("span", {
        onClick: Ke((u) => r.toggleSelect(s), ["stop"])
      }, [
        s.selectable ? (l(), c("i", {
          key: 0,
          class: G(["fa-fw text-primary pl-2 pt-1", r.getSelectState(s)]),
          role: "button"
        }, null, 2)) : v("", !0)
      ], 8, Jg),
      p("span", {
        onClick: Ke((u) => r.toggleExpandOrSelect(s), ["stop"]),
        class: "flex-grow-1 pl-2",
        role: "button"
      }, [
        B(U(s.label ? s.label : s.name) + " ", 1),
        s.code ? (l(), c("span", Yg, [
          n[3] || (n[3] = B(" (", -1)),
          s.codesystem ? (l(), c("span", Wg, U(s.codesystem) + ": ", 1)) : v("", !0),
          B(" " + U(s.code) + ") ", 1)
        ])) : v("", !0),
        s.definition ? (l(), c("small", Xg, [
          p("i", null, " - " + U(s.definition), 1)
        ])) : v("", !0),
        s.children && r.countVisibleChildren(s) > 0 ? (l(), c("span", Zg, " (" + U(r.countVisibleChildren(s)) + ") ", 1)) : v("", !0)
      ], 8, zg),
      s.expanded ? (l(), F(a, {
        key: 0,
        terms: s.children,
        isMultiSelect: t.isMultiSelect,
        onSelect: n[0] || (n[0] = (u) => e.$emit("select", u)),
        onDeselect: n[1] || (n[1] = (u) => e.$emit("deselect", u)),
        onToggleExpand: n[2] || (n[2] = (u) => e.$emit("toggleExpand", u))
      }, null, 8, ["terms", "isMultiSelect"])) : v("", !0)
    ]))), 128))
  ]);
}
const ty = /* @__PURE__ */ P(Gg, [["render", ey]]);
var hi = { exports: {} }, ny = hi.exports, ya;
function iy() {
  return ya || (ya = 1, (function(e, n) {
    (function(t, o) {
      e.exports = o();
    })(ny, function() {
      var t = "__v-click-outside", o = typeof window < "u", i = typeof navigator < "u", r = o && ("ontouchstart" in window || i && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"], a = function(f) {
        var K = f.event, w = f.handler;
        (0, f.middleware)(K) && w(K);
      }, s = function(f, K) {
        var w = (function(x) {
          var E = typeof x == "function";
          if (!E && typeof x != "object") throw new Error("v-click-outside: Binding value must be a function or an object");
          return { handler: E ? x : x.handler, middleware: x.middleware || function(_) {
            return _;
          }, events: x.events || r, isActive: x.isActive !== !1, detectIframe: x.detectIframe !== !1, capture: !!x.capture };
        })(K.value), k = w.handler, y = w.middleware, m = w.detectIframe, g = w.capture;
        if (w.isActive) {
          if (f[t] = w.events.map(function(x) {
            return { event: x, srcTarget: document.documentElement, handler: function(E) {
              return (function(_) {
                var q = _.el, V = _.event, L = _.handler, $ = _.middleware, J = V.path || V.composedPath && V.composedPath();
                (J ? J.indexOf(q) < 0 : !q.contains(V.target)) && a({ event: V, handler: L, middleware: $ });
              })({ el: f, event: E, handler: k, middleware: y });
            }, capture: g };
          }), m) {
            var I = { event: "blur", srcTarget: window, handler: function(x) {
              return (function(E) {
                var _ = E.el, q = E.event, V = E.handler, L = E.middleware;
                setTimeout(function() {
                  var $ = document.activeElement;
                  $ && $.tagName === "IFRAME" && !_.contains($) && a({ event: q, handler: V, middleware: L });
                }, 0);
              })({ el: f, event: x, handler: k, middleware: y });
            }, capture: g };
            f[t] = [].concat(f[t], [I]);
          }
          f[t].forEach(function(x) {
            var E = x.event, _ = x.srcTarget, q = x.handler;
            return setTimeout(function() {
              f[t] && _.addEventListener(E, q, g);
            }, 0);
          });
        }
      }, u = function(f) {
        (f[t] || []).forEach(function(K) {
          return K.srcTarget.removeEventListener(K.event, K.handler, K.capture);
        }), delete f[t];
      }, d = o ? { beforeMount: s, updated: function(f, K) {
        var w = K.value, k = K.oldValue;
        JSON.stringify(w) !== JSON.stringify(k) && (u(f), s(f, { value: w }));
      }, unmounted: u } : {};
      return { install: function(f) {
        f.directive("click-outside", d);
      }, directive: d };
    });
  })(hi)), hi.exports;
}
var oy = iy();
const Vi = /* @__PURE__ */ Ps(oy), ry = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    InputOntologySubtree: ty,
    MessageError: rt,
    Spinner: bt
  },
  directives: {
    clickOutside: Vi.directive
  },
  props: {
    /** if you don't want to use autoload using table you can provide options via 'items'. Should be format [{name:a, parent:b},{name:b}]
     */
    options: {
      type: Array,
      default: null
    },
    /** show as pulldown. When false, shows always expanded*/
    showExpanded: {
      type: Boolean,
      default: !1
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      error: null,
      // used for drop down focus state
      focus: !1,
      //huge object with all the terms, flattened
      //includes also its children
      terms: {},
      search: null,
      //we use key to force updates
      key: 1,
      //use to block to many search results
      searchResultCount: 0,
      data: [],
      loading: !0
    };
  },
  computed: {
    rootTerms() {
      return this.terms ? Object.values(this.terms).filter(
        (n) => !n.parent && n.visible
      ) : [];
    },
    selectionWithoutChildren() {
      let e = [];
      return this.key && this.rootTerms.forEach((n) => {
        e.push(...tl(n));
      }), e;
    }
  },
  methods: {
    toggleExpand(e) {
      this.terms[e].expanded = !this.terms[e].expanded, this.key++;
    },
    loseFocusWhenClickedOutside() {
      this.focus && !this.showExpanded && (this.focus = !1);
    },
    toggleFocus() {
      this.showExpanded || (this.focus = !this.focus, this.focus && this.$refs.search.focus());
    },
    getParents(e) {
      let n = [], t = e.parent;
      for (; t; )
        n.push(this.terms[t.name]), this.terms[t.name].parent && //check for parent that are indirect parent of themselves
        !n.includes(this.terms[t.name].parent.name) ? t = this.terms[t.name].parent : t = null;
      return n;
    },
    getChildren(e) {
      return this.data.filter(
        (n) => n.parent?.name === e
      );
    },
    getAllChildren(e) {
      let n = [];
      return e.children && (n = e.children, e.children.forEach(
        (t) => n = n.concat(this.getAllChildren(t))
      )), n;
    },
    select(e) {
      this.isMultiSelect || Object.keys(this.terms).forEach(
        (t) => this.terms[t].selected = "unselected"
      );
      let n = this.terms[e];
      n.selected = "complete", this.isMultiSelect && (this.getAllChildren(n).forEach(
        (t) => t.selected = "complete"
      ), this.getParents(n).forEach((t) => {
        t.children.every(
          (o) => o.selected === "complete"
        ) ? t.selected = "complete" : t.selected = "partial";
      })), this.emitValue(), this.$refs.search.focus(), this.isMultiSelect || (this.focus = !1), this.key++, this.search = null;
    },
    deselect(e) {
      if (this.isMultiSelect) {
        let n = this.terms[e];
        n.selected = "unselected", this.getAllChildren(this.terms[e]).forEach(
          (t) => t.selected = "unselected"
        ), this.getParents(n).forEach((t) => {
          t.children.some(
            (o) => o.selected === "complete"
          ) ? t.selected = "partial" : t.selected = "unselected";
        });
      } else
        Object.keys(this.terms).forEach(
          (n) => this.terms[n].selected = "unselected"
        );
      this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    clearSelection() {
      this.terms && Object.values(this.terms).forEach(
        (e) => e.selected = "unselected"
      ), this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    emitValue() {
      let e = Object.values(this.terms).filter((n) => n.selected === "complete").map((n) => ({ name: n.name }));
      this.isMultiSelect ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", e[0] || null);
    },
    applySelection(e) {
      if (Object.keys(this.terms).forEach(
        (n) => this.terms[n].selected = "unselected"
      ), e && this.isMultiSelect)
        e.forEach((n) => {
          let t = this.terms[n.name];
          t && (this.getAllChildren(t).length == 0 && (t.selected = "complete"), this.isMultiSelect && (this.getAllChildren(t).forEach(
            (o) => o.selected = "complete"
          ), this.getParents(t).forEach((o) => {
            o.children.every(
              (i) => i.selected === "complete"
            ) ? o.selected = "complete" : o.selected = "partial";
          })));
        });
      else if (e) {
        let n = this.terms[e.name];
        n && (n.selected = "complete", this.getParents(n).forEach((t) => {
          t.selected = "partial";
        }));
      }
      this.key++;
    }
  },
  watch: {
    search() {
      if (this.searchResultCount = 0, this.search) {
        Object.values(this.terms).forEach((n) => {
          n.visible = !1, n.selectable = !1;
        });
        let e = this.search.trim().split(/[\s,:]+/).filter((n) => n.trim().length > 0).map((n) => n.toLowerCase());
        Object.values(this.terms).forEach((n) => {
          if (e.every(
            (t) => n.name.toLowerCase().includes(t) || n.label?.toLowerCase().includes(t) || n.definition?.toLowerCase().includes(t) || n.code?.toLowerCase().includes(t) || n.codesystem?.toLowerCase().includes(t)
          )) {
            if (n.visible = !0, n.selectable = !0, this.searchResultCount++, n.parent) {
              let t = this.terms[n.parent.name];
              for (; t && !t.visible; )
                t.visible = !0, t.parent && (t = this.terms[t.parent.name]);
            }
            this.getAllChildren(n).forEach((t) => {
              t.visible = !0, t.selectable = !0;
            });
          }
        });
      } else
        Object.values(this.terms).forEach((e) => {
          e.visible = !0, e.selectable = !0, this.searchResultCount++;
        });
      Object.values(this.terms).filter((e) => e.visible).length < 50 && Object.values(this.terms).filter((e) => e.visible && e.children).forEach((e) => e.expanded = !0), this.key++;
    },
    modelValue: {
      deep: !0,
      handler() {
        this.applySelection(this.modelValue), this.key++;
      }
    },
    data() {
      if (this.data) {
        this.searchResultCount = 0;
        let e = {};
        this.data.forEach((n) => {
          e[n.name] ? (e[n.name].definition = n.definition, e[n.name].label = n.label, e[n.name].code = n.code, e[n.name].codesystem = n.codesystem, e[n.name].order = n.order) : e[n.name] = {
            name: n.name,
            visible: !0,
            selectable: !0,
            selected: "unselected",
            definition: n.definition,
            code: n.code,
            codesystem: n.codesystem,
            label: n.label,
            order: n.order
          }, n.parent && (e[n.name].parent = n.parent, e[n.parent.name] || (e[n.parent.name] = {
            name: n.parent.name,
            visible: !0,
            selectable: !0,
            selected: "unselected"
          }), e[n.parent.name].children || (e[n.parent.name].children = []), e[n.parent.name].children.push(e[n.name])), this.searchResultCount++;
        }), this.terms = e, this.applySelection(this.modelValue);
      }
    }
  },
  async mounted() {
    if (this.tableId) {
      const e = We.newClient(this.schemaId);
      this.data = await e.fetchOntologyOptions(this.tableId);
    }
  },
  created() {
    this.options ? (this.data = this.options, this.loading = !1) : this.limit = 1e5;
  }
};
function tl(e) {
  let n = [];
  return e.selected === "complete" ? n.push(e) : e.children && e.children.forEach(
    (t) => n.push(...tl(t))
  ), n;
}
const ay = ["onClick"], sy = {
  key: 0,
  class: "input-group-prepend"
}, ly = ["placeholder"], uy = { class: "d-inline-block float-right" }, dy = {
  key: 0,
  class: "p-2 fa fa-times",
  style: { "vertical-align": "middle" }
}, cy = {
  key: 0,
  class: "p-2 fa fa-caret-down",
  style: { "vertical-align": "middle" }
}, fy = {
  key: 0,
  class: "pl-4"
}, py = { key: 3 };
function hy(e, n, t, o, i, r) {
  const a = b("MessageError"), s = b("InputOntologySubtree"), u = b("Spinner"), d = b("FormGroup"), f = Ui("click-outside");
  return l(), F(d, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      i.error ? (l(), F(a, { key: 0 }, {
        default: C(() => [
          B(U(i.error), 1)
        ]),
        _: 1
      })) : (l(), c("div", {
        key: 1,
        class: G(["p-0 m-0", { dropdown: !t.showExpanded, "border rounded": !t.showExpanded }])
      }, [
        p("div", {
          class: "border-0 text-left form-control",
          style: { height: "auto", cursor: "pointer" },
          onClick: n[5] || (n[5] = (...K) => r.toggleFocus && r.toggleFocus(...K))
        }, [
          (l(!0), c(te, null, oe(r.selectionWithoutChildren.sort(
            (K, w) => K.order - w.order
          ), (K) => (l(), c("span", {
            class: "btn btn-sm btn-primary text-white mr-1",
            key: K,
            onClick: Ke((w) => r.deselect(K.name), ["stop"])
          }, [
            B(U(K.label ? K.label : K.name) + " ", 1),
            n[6] || (n[6] = p("span", { class: "fa fa-times" }, null, -1))
          ], 8, ay))), 128)),
          t.showExpanded && r.selectionWithoutChildren.length > 0 ? (l(), c("i", {
            key: 0,
            class: "p-2 fa fa-times",
            style: { "vertical-align": "middle" },
            onClick: n[0] || (n[0] = Ke((...K) => r.clearSelection && r.clearSelection(...K), ["stop"]))
          })) : v("", !0),
          p("span", {
            class: G({ "input-group": t.showExpanded })
          }, [
            t.showExpanded ? (l(), c("div", sy, [...n[7] || (n[7] = [
              p("button", {
                class: "btn border-right-0 border btn-outline-primary",
                type: "button"
              }, [
                p("i", { class: "fa fa-search" })
              ], -1)
            ])])) : v("", !0),
            Ye(p("input", {
              type: "text",
              ref: "search",
              placeholder: i.focus || t.showExpanded ? "Type to search" : "",
              class: G({
                "form-control": t.showExpanded,
                "border-0": !t.showExpanded
              }),
              "onUpdate:modelValue": n[1] || (n[1] = (K) => i.search = K),
              onClick: n[2] || (n[2] = Ke(() => {
              }, ["stop"])),
              onFocus: n[3] || (n[3] = (K) => i.focus = !0)
            }, null, 42, ly), [
              [Lo, i.search]
            ])
          ], 2),
          p("span", uy, [
            p("span", {
              onClick: n[4] || (n[4] = Ke((...K) => r.clearSelection && r.clearSelection(...K), ["prevent", "stop"])),
              style: { cursor: "pointer" }
            }, [
              !t.showExpanded && r.selectionWithoutChildren.length > 0 ? (l(), c("i", dy)) : v("", !0)
            ]),
            t.showExpanded ? v("", !0) : (l(), c("i", cy))
          ])
        ]),
        i.focus || t.showExpanded ? Ye((l(), c("div", {
          key: 0,
          class: G(["w-100 show p-0 overflow-auto", { "dropdown-menu": !t.showExpanded }])
        }, [
          i.search && Object.keys(i.terms).length > 50 && i.searchResultCount >= 0 ? (l(), c("span", fy, " found " + U(i.searchResultCount) + " terms. ", 1)) : v("", !0),
          r.rootTerms.length > 0 ? (l(), F(s, {
            key: i.key,
            terms: r.rootTerms,
            isMultiSelect: t.isMultiSelect,
            onSelect: r.select,
            onDeselect: r.deselect,
            onToggleExpand: r.toggleExpand,
            style: { "max-height": "100vh" },
            class: "pt-2 pl-0"
          }, null, 8, ["terms", "isMultiSelect", "onSelect", "onDeselect", "onToggleExpand"])) : i.loading ? (l(), F(u, { key: 2 })) : (l(), c("div", py, "No results found"))
        ], 2)), [
          [f, r.loseFocusWhenClickedOutside]
        ]) : v("", !0)
      ], 2))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Ri = /* @__PURE__ */ P(ry, [["render", hy]]), my = {
  name: "InputOntologyFilter",
  components: { InputOntology: Ri },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function Ay(e, n, t, o, i, r) {
  const a = b("InputOntology");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    isMultiSelect: !0,
    showExpanded: !0
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId"]);
}
const Do = /* @__PURE__ */ P(my, [["render", Ay]]), nl = /* @__PURE__ */ ke({
  __name: "RadioFilter",
  props: {
    id: {},
    condition: {},
    tableId: {},
    schemaId: {},
    refLabel: {},
    orderBy: {},
    filter: {}
  },
  emits: ["updateCondition", "clearCondition"],
  setup(e, { emit: n }) {
    const t = n, o = We.newClient(e.schemaId), i = me(), r = me({}), a = Pe(
      () => jt(e.condition || {}, e.refLabel)
    );
    u();
    function s(d) {
      d ? t("updateCondition", r.value[d]) : t("clearCondition", d);
    }
    async function u() {
      const d = {
        orderby: e.orderBy,
        filter: e.filter
      }, w = ((await o.fetchTableData(e.tableId, d))[e.tableId] || []).map(
        async (y) => jn(y, e.tableId, e.schemaId)
      ), k = await Promise.all(w);
      r.value = k.reduce((y, m) => {
        const g = jt(m, e.refLabel);
        return y[g] = m, y;
      }, {}), i.value = Object.keys(r.value).sort();
    }
    return (d, f) => i.value?.length ? (l(), F(sr, {
      key: 0,
      id: e.id,
      modelValue: a.value,
      tableId: e.tableId,
      schemaId: e.schemaId,
      refLabel: e.refLabel,
      options: i.value,
      "onUpdate:modelValue": s,
      direction: "vertical"
    }, null, 8, ["id", "modelValue", "tableId", "schemaId", "refLabel", "options"])) : v("", !0);
  }
}), gy = {
  props: {
    label: String
  }
}, yy = { class: "btn btn-sm btn-outline-primary mr-2 mb-2" };
function Ky(e, n, t, o, i, r) {
  return l(), c("button", yy, [
    B(U(t.label) + "  ", 1),
    n[0] || (n[0] = p("i", { class: "fa fa-times" }, null, -1))
  ]);
}
const il = /* @__PURE__ */ P(gy, [["render", Ky]]), Ka = {
  add: "plus",
  edit: "pencil-alt",
  delete: "trash",
  clone: "copy"
}, by = {
  components: {
    IconAction: ft,
    IconDanger: ar
  },
  props: {
    type: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(Ka).includes(e);
      }
    }
  },
  computed: {
    icon() {
      return Ka[this.type];
    }
  },
  emits: ["add", "edit", "delete", "clone"]
};
function vy(e, n, t, o, i, r) {
  return l(), c("span", null, [
    (l(), F(Et(t.type === "delete" ? "IconDanger" : "IconAction"), {
      icon: r.icon,
      onClick: n[0] || (n[0] = (a) => e.$emit(t.type))
    }, null, 8, ["icon"]))
  ]);
}
const Qt = /* @__PURE__ */ P(by, [["render", vy]]), ol = /* @__PURE__ */ ke({
  __name: "RowButtonAdd",
  props: {
    id: {},
    tableId: {},
    schemaId: {},
    label: { default: "" },
    defaultValue: {},
    visibleColumns: {}
  },
  emits: ["close", "update:newRow"],
  setup(e, { emit: n }) {
    const t = Da({
      loader: () => Promise.resolve().then(() => hl)
    });
    let o = me(!1);
    const i = n;
    function r() {
      o.value = !1, i("close");
    }
    return (a, s) => (l(), c("span", null, [
      e.label !== "" ? (l(), F(Bi, {
        key: 0,
        onClick: s[0] || (s[0] = (u) => Ki(o) ? o.value = !0 : o = !0)
      }, {
        default: C(() => [
          B(U(e.label), 1)
        ]),
        _: 1
      })) : (l(), F(Qt, {
        key: 1,
        type: "add",
        onAdd: s[1] || (s[1] = (u) => Ki(o) ? o.value = !0 : o = !0)
      })),
      ie(o) ? (l(), F(ie(t), {
        key: 2,
        id: e.id + "add-modal",
        tableId: e.tableId,
        isModalShown: ie(o),
        schemaId: e.schemaId,
        defaultValue: e.defaultValue,
        visibleColumns: e.visibleColumns,
        applyDefaultValues: !0,
        onClose: r,
        "onUpdate:newRow": s[2] || (s[2] = (u) => a.$emit("update:newRow", u))
      }, null, 8, ["id", "tableId", "isModalShown", "schemaId", "defaultValue", "visibleColumns"])) : v("", !0)
    ]));
  }
}), rl = /* @__PURE__ */ ke({
  __name: "StringDisplay",
  props: {
    data: { type: [String, Object, Number, Boolean] }
  },
  setup(e) {
    return (n, t) => (l(), c("div", null, U(e.data), 1));
  }
}), Cy = {
  name: "FileDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    fileSize() {
      const e = ["", "k", "M", "G", "T", "P", "E"], n = Math.log10(this.data.size) / 3 | 0;
      if (n == 0)
        return this.data.size;
      var t = e[n], o = Math.pow(10, n * 3), i = this.data.size / o;
      return i.toFixed(1) + t;
    }
  }
}, wy = ["href"];
function Fy(e, n, t, o, i, r) {
  return t.data.id ? (l(), c("a", {
    key: 0,
    href: t.data.url,
    target: "_blank"
  }, U(t.data?.filename ? t.data.filename : t.metadata.name + "." + t.data.extension) + " (" + U(r.fileSize) + ") ", 9, wy)) : v("", !0);
}
const al = /* @__PURE__ */ P(Cy, [["render", Fy]]), Ry = /* @__PURE__ */ ke({
  __name: "TextDisplay",
  props: {
    data: {}
  },
  setup(e) {
    return (n, t) => (l(), F($s, { text: e.data }, null, 8, ["text"]));
  }
}), ky = {
  name: "ObjectDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: [Object]
    }
  },
  computed: {
    hasTemplate() {
      return !!this.metadata.refLabel || !!this.metadata.refLabelDefault;
    },
    asTemplate() {
      const e = Object.keys(this.data), n = Object.values(this.data), t = this.metadata.refLabel ? this.metadata.refLabel : this.metadata.refLabelDefault;
      try {
        return new Function(...e, "return `" + t + "`;")(...n);
      } catch (o) {
        const i = JSON.stringify(e), r = JSON.stringify(n);
        return `${o.message} we got keys: ${i} vals: ${r} and template: ${t}`;
      }
    },
    asDotSeparatedString() {
      let e = "";
      return Object.keys(this.data).forEach((n) => {
        this.data[n] === null || (typeof this.data[n] == "object" ? e += sn(this.data[n]) : e += "." + this.data[n]);
      }), e.replace(/^\./, "");
    }
  }
}, Uy = { key: 0 }, Ey = { key: 1 };
function Sy(e, n, t, o, i, r) {
  return r.hasTemplate ? (l(), c("span", Uy, U(r.asTemplate), 1)) : (l(), c("span", Ey, U(r.asDotSeparatedString), 1));
}
const ur = /* @__PURE__ */ P(ky, [["render", Sy]]), Ty = {
  name: "EmailDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, Iy = ["href"];
function Dy(e, n, t, o, i, r) {
  return l(), c("a", {
    href: `mailto:${t.data}`
  }, U(t.data), 9, Iy);
}
const dr = /* @__PURE__ */ P(Ty, [["render", Dy]]), Oy = {
  name: "HyperlinkDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, _y = ["href"];
function Py(e, n, t, o, i, r) {
  return l(), c("a", {
    target: "_blank",
    href: t.data
  }, U(t.data), 9, _y);
}
const cr = /* @__PURE__ */ P(Oy, [["render", Py]]), My = {
  REF_ARRAY: "ObjectDisplay",
  MULTISELECT: "ObjectDisplay",
  CHECKBOX: "ObjectDisplay",
  ONTOLOGY_ARRAY: "ObjectDisplay",
  REFBACK: "ObjectDisplay",
  EMAIL_ARRAY: "EmailDisplay",
  HYPERLINK_ARRAY: "HyperlinkDisplay"
}, Ny = {
  name: "ListDisplay",
  components: { ObjectDisplay: ur, StringDisplay: rl, EmailDisplay: dr, HyperlinkDisplay: cr },
  data() {
    return {
      isFolded: !0
    };
  },
  props: {
    data: {
      type: [Array],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    },
    foldCuttOff: {
      type: Number,
      required: !1,
      default: () => 3
    }
  },
  computed: {
    cellTypeComponentName() {
      return My[this.metadata.columnType] || "StringDisplay";
    },
    visibleListItems() {
      return this.isFolded ? this.data.slice(0, this.foldCuttOff) : this.data;
    }
  },
  methods: {
    onFoldClicked(e) {
      this.isFolded = !this.isFolded, e.target.blur(), e.target.parentElement.blur();
    }
  }
}, By = {
  key: 0,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-down",
  class: "svg-inline--fa fa-chevron-down fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, Ly = {
  key: 1,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-up",
  class: "svg-inline--fa fa-chevron-up fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};
function xy(e, n, t, o, i, r) {
  return l(), c("div", null, [
    Ye(p("button", {
      onClick: n[0] || (n[0] = Ke((...a) => r.onFoldClicked && r.onFoldClicked(...a), ["stop", "prevent"])),
      class: "btn btn-sm float-right fold-btn"
    }, [
      p("template", null, [
        i.isFolded ? (l(), c("svg", By, [...n[1] || (n[1] = [
          p("path", {
            fill: "currentColor",
            d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
          }, null, -1)
        ])])) : (l(), c("svg", Ly, [...n[2] || (n[2] = [
          p("path", {
            fill: "currentColor",
            d: "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
          }, null, -1)
        ])]))
      ])
    ], 512), [
      [ki, t.data.length > t.foldCuttOff]
    ]),
    (l(!0), c(te, null, oe(r.visibleListItems, (a, s) => (l(), c("div", { key: s }, [
      (l(), F(Et(r.cellTypeComponentName), {
        data: a,
        metadata: t.metadata
      }, null, 8, ["data", "metadata"]))
    ]))), 128))
  ]);
}
const qy = /* @__PURE__ */ P(Ny, [["render", xy], ["__scopeId", "data-v-44c19699"]]), Vy = {
  FILE: "FileDisplay",
  TEXT: "TextDisplay",
  JSON: "TextDisplay",
  REFBACK: "ListDisplay",
  MULTISELECT: "ListDisplay",
  CHECKBOX: "ListDisplay",
  REF: "ObjectDisplay",
  SELECT: "ObjectDisplay",
  RADIO: "ObjectDisplay",
  ONTOLOGY: "ObjectDisplay",
  EMAIL: "EmailDisplay",
  HYPERLINK: "HyperlinkDisplay"
}, jy = ke({
  name: "DataDisplayCell",
  components: {
    StringDisplay: rl,
    FileDisplay: al,
    TextDisplay: Ry,
    ListDisplay: qy,
    ObjectDisplay: ur,
    EmailDisplay: dr,
    HyperlinkDisplay: cr
  },
  props: {
    data: {
      type: [String, Object, Array, Number, Boolean],
      required: !1
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cellTypeComponentName() {
      return this.isArrayType ? "ListDisplay" : Vy[this.metadata.columnType] || "StringDisplay";
    },
    isArrayType() {
      return this.metadata.columnType.includes("ARRAY") || this.metadata.columnType === "MULTISELECT" || this.metadata.columnType === "CHECKBOX";
    },
    isEmpty() {
      return this.data === void 0 || this.data === null || Array.isArray(this.data) && this.data.length === 0;
    }
  }
});
function Hy(e, n, t, o, i, r) {
  return e.isEmpty ? v("", !0) : (l(), F(Et(e.cellTypeComponentName), {
    key: 0,
    data: e.data,
    metadata: e.metadata
  }, null, 8, ["data", "metadata"]));
}
const sl = /* @__PURE__ */ P(jy, [["render", Hy]]), Gy = {
  name: "TableRow",
  components: { DataDisplayCell: sl },
  props: {
    row: {
      type: Object,
      required: !0
    },
    columns: { type: Array, required: !0 },
    tableId: { type: String, required: !0 },
    client: { type: Object, required: !0 },
    showSelect: { type: Boolean, required: !1 },
    selection: { type: Array, required: !1 }
  },
  data() {
    return {
      rowKey: null
    };
  },
  computed: {
    isSelected() {
      return !!this.selection?.find((e) => e && this.rowKey && tn(e, this.rowKey));
    }
  },
  methods: {
    isRefType: Ci,
    async convertRowToPrimaryKey(e) {
      return await this.client.convertRowToPrimaryKey(e, this.tableId);
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onCellClick(e) {
      const n = this.row[e.id];
      n && this.$emit("cellClick", {
        cellValue: Ve(n),
        column: Ve(e)
      });
    },
    onRowClick() {
      if (this.showSelect) {
        const e = this.isSelected ? "deselect" : "select";
        this.$emit(e, mo(this.rowKey));
      } else
        this.$emit("rowClick", mo(this.rowKey));
    },
    hasRowheader() {
      return this.showSelect || !!this.$slots.rowheader;
    }
  },
  mounted() {
    this.client.convertRowToPrimaryKey(this.row, this.tableId).then((e) => {
      this.rowKey = e;
    }).catch((e) => {
      console.log(e);
    });
  }
}, Qy = { key: 0 }, $y = { style: { display: "flex" } }, Jy = {
  key: 0,
  class: "form-check form-check-inline mr-1"
}, zy = ["checked"], Yy = {
  key: 0,
  class: "fas fa-user-edit"
}, Wy = ["onClick"];
function Xy(e, n, t, o, i, r) {
  const a = b("DataDisplayCell");
  return l(), c("tr", {
    class: G(
      (r.isSelected ? "table-primary" : "table-hover") + (t.row.mg_draft ? "alert alert-warning" : "")
    )
  }, [
    r.hasRowheader ? (l(), c("td", Qy, [
      p("div", $y, [
        t.showSelect ? (l(), c("div", Jy, [
          p("input", {
            type: "checkbox",
            class: "form-check-input position-static",
            checked: r.isSelected,
            onClick: n[0] || (n[0] = (...s) => r.onRowClick && r.onRowClick(...s))
          }, null, 8, zy)
        ])) : v("", !0),
        H(e.$slots, "rowheader", {
          row: t.row,
          rowKey: i.rowKey
        }, void 0, !0)
      ]),
      t.row.mg_draft ? (l(), c("i", Yy, "draft")) : v("", !0)
    ])) : v("", !0),
    (l(!0), c(te, null, oe(t.columns, (s) => (l(), c("td", {
      key: s.id + r.isSelected,
      style: Ei([{ cursor: "pointer" }, s.showColumn ? "" : "display: none"]),
      onClick: (u) => {
        r.onRowClick(), r.onCellClick(s);
      },
      class: G({ refType: r.isRefType(s.columnType) })
    }, [
      D(a, {
        data: t.row[s.id],
        metadata: s
      }, null, 8, ["data", "metadata"])
    ], 14, Wy))), 128))
  ], 2);
}
const Zy = /* @__PURE__ */ P(Gy, [["render", Xy], ["__scopeId", "data-v-e0c9e76a"]]), eK = {
  components: { TableRow: Zy },
  props: {
    selection: { type: Array, required: !1 },
    /** column metadata, two-way binded to allow for reorder
     * TODO: handle this through events since props are meant to be 1-way
     */
    columns: { type: Array, default: () => [] },
    tableMetadata: { type: Object, required: !1 },
    /** if tableMetadata is not supplied table id should be set */
    tableId: { type: String, required: !1 },
    data: { type: Array, default: () => [] },
    showSelect: { type: Boolean, default: !1 },
    schemaId: { type: String, required: !1 }
  },
  data() {
    return {
      client: We.newClient(this.schemaId)
    };
  },
  computed: {
    dataColumns() {
      return this.columns.filter(
        (n) => n.columnType !== "HEADING" && n.columnType !== "SECTION"
      ).map((n) => (n.showColumn == null && (n.showColumn = !0), n));
    }
  },
  methods: {
    hasColheader() {
      return this.showSelect || !!this.$slots.colheader;
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onRowSelect(e) {
      this.$emit("select", e), this.$emit("update:selection", [...mo(this.selection), e]);
    },
    onRowDeselect(e) {
      const n = JSON.stringify(
        e,
        Object.keys(e).sort()
      ), t = this.selection.map(
        (o) => JSON.stringify(o, Object.keys(o).sort())
      ).findIndex((o) => o === n);
      this.$emit("deselect", e), this.$emit("update:selection", this.selection.toSpliced(t, 1));
    }
  }
}, tK = { style: { "overflow-x": "scroll" } }, nK = { class: "table table-sm bg-white table-bordered table-hover" }, iK = {
  key: 0,
  slot: "header",
  scope: "col",
  style: { width: "1px" }
}, oK = { style: { "text-align": "left", "font-weight": "normal" } }, rK = ["onClick"], aK = { key: 0 }, sK = ["colspan"];
function lK(e, n, t, o, i, r) {
  const a = b("TableRow");
  return l(), c("div", tK, [
    p("table", nK, [
      p("thead", null, [
        r.hasColheader ? (l(), c("th", iK, [
          n[2] || (n[2] = p("h6", { class: "mb-0 mt-2 d-inline" }, "#", -1)),
          p("span", oK, [
            H(e.$slots, "rowcolheader", {}, void 0, !0)
          ])
        ])) : v("", !0),
        (l(!0), c(te, null, oe(r.dataColumns, (s) => (l(), c("th", {
          key: s.id + s.showColumn,
          scope: "col",
          class: "column-drag-header",
          style: Ei(s.showColumn ? "" : "display: none")
        }, [
          p("h6", {
            class: "mb-0 align-text-bottom text-nowrap",
            onClick: (u) => r.onColumnClick(s)
          }, [
            B(U(s.name) + " ", 1),
            H(e.$slots, "colheader", { col: s }, void 0, !0)
          ], 8, rK)
        ], 4))), 128))
      ]),
      p("tbody", null, [
        t.data && !t.data.length ? (l(), c("tr", aK, [
          p("td", {
            colspan: r.dataColumns.length + 1,
            class: "alert-warning"
          }, " No results found ", 8, sK)
        ])) : (l(!0), c(te, { key: 1 }, oe(t.data, (s) => (l(), F(a, {
          row: s,
          columns: r.dataColumns,
          tableId: t.tableId || t.tableMetadata.id,
          client: i.client,
          showSelect: t.showSelect,
          selection: t.selection,
          onCellClick: n[0] || (n[0] = (u) => e.$emit("cellClick", u)),
          onRowClick: n[1] || (n[1] = (u) => e.$emit("rowClick", u)),
          onSelect: r.onRowSelect,
          onDeselect: r.onRowDeselect
        }, {
          rowheader: C((u) => [
            H(e.$slots, "rowheader", {
              row: u.row,
              rowKey: u.rowKey
            }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["row", "columns", "tableId", "client", "showSelect", "selection", "onSelect", "onDeselect"]))), 256))
      ])
    ])
  ]);
}
const fr = /* @__PURE__ */ P(eK, [["render", lK], ["__scopeId", "data-v-3a1e9256"]]), uK = ["id", "aria-describedby", "placeholder"], pr = /* @__PURE__ */ ke({
  __name: "InputSearch",
  props: {
    modelValue: {},
    isClearBtnShown: { type: Boolean, default: !1 },
    isEmitOnType: { type: Boolean, default: !1 },
    id: {},
    label: {},
    description: {},
    errorMessage: {},
    placeholder: { default: "Search" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: n, emit: t }) {
    const o = e;
    n({ clearInput: u });
    const i = me(o.modelValue || ""), r = t;
    function a(d) {
      (d.key === "Enter" || o.isEmitOnType) && s();
    }
    function s() {
      r("update:modelValue", i.value);
    }
    function u() {
      i.value = "", s();
    }
    return (d, f) => (l(), F(Ue, {
      id: e.id,
      label: e.label,
      description: e.description,
      errorMessage: e.errorMessage
    }, {
      default: C(() => [
        D(Ne, null, {
          append: C(() => [
            e.isClearBtnShown ? (l(), c("button", {
              key: 0,
              onClick: u,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...f[1] || (f[1] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])])) : v("", !0),
            p("button", {
              onClick: s,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...f[2] || (f[2] = [
              p("i", { class: "fas fa-fw fa-search" }, null, -1)
            ])])
          ]),
          default: C(() => [
            Ye(p("input", {
              id: e.id,
              ref: e.id,
              "onUpdate:modelValue": f[0] || (f[0] = (K) => i.value = K),
              type: "text",
              class: "form-control",
              "aria-describedby": e.id,
              placeholder: e.placeholder,
              onKeyup: a
            }, null, 40, uK), [
              [Lo, i.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "label", "description", "errorMessage"]));
  }
}), dK = ke({
  props: {
    /** current page */
    modelValue: { type: Number, default: 1 },
    /** total records, i.e. sql count */
    count: { type: Number, required: !0 },
    /** number of records per page, i.e. sql limit */
    limit: { type: Number, default: 10 }
  },
  methods: {
    emitValue(e, n) {
      n || this.$emit("update:modelValue", e);
    },
    rowRange(e, n, t) {
      if (t === 0)
        return "-";
      {
        const o = (e - 1) * n + 1, i = Math.min(t, e * n);
        return `${o} - ${i} of ${t}`;
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.limit);
    },
    isFirstPage() {
      return this.modelValue === 1;
    },
    isLastPage() {
      return this.modelValue === this.totalPages || this.count === 0;
    }
  },
  watch: {
    value() {
      this.modelValue < 1 && this.$emit("update:modelValue", 1);
    },
    count() {
      this.modelValue > this.totalPages && this.$emit("update:modelValue", 1);
    }
  },
  created() {
    this.modelValue < 1 && this.$emit("update:modelValue", 1);
  }
}), cK = { "aria-label": "Pagination" }, fK = { class: "pagination justify-content-center mb-0" }, pK = { class: "page-item disabled" }, hK = {
  class: "page-link text-nowrap",
  href: "#"
};
function mK(e, n, t, o, i, r) {
  return l(), c("nav", cK, [
    p("ul", fK, [
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[0] || (n[0] = Ke((a) => e.emitValue(1, e.isFirstPage), ["prevent"]))
        }, [...n[4] || (n[4] = [
          p("span", { "aria-hidden": "true" }, "«", -1),
          p("span", { class: "sr-only" }, "First", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[1] || (n[1] = Ke((a) => e.emitValue(Math.max(e.modelValue - 1, 1), e.isFirstPage), ["prevent"]))
        }, [...n[5] || (n[5] = [
          p("span", { "aria-hidden": "true" }, "‹", -1),
          p("span", { class: "sr-only" }, "Previous", -1)
        ])])
      ], 2),
      p("li", pK, [
        p("a", hK, U(e.rowRange(e.modelValue, e.limit, e.count)), 1)
      ]),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[2] || (n[2] = Ke((a) => e.emitValue(Math.min(e.modelValue + 1, e.totalPages), e.isLastPage), ["prevent"]))
        }, [...n[6] || (n[6] = [
          p("span", { "aria-hidden": "true" }, "›", -1),
          p("span", { class: "sr-only" }, "Next", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[3] || (n[3] = Ke((a) => e.emitValue(e.totalPages, e.isLastPage), ["prevent"]))
        }, [...n[7] || (n[7] = [
          p("span", { "aria-hidden": "true" }, "»", -1),
          p("span", { class: "sr-only" }, "Last", -1)
        ])])
      ], 2)
    ])
  ]);
}
const ll = /* @__PURE__ */ P(dK, [["render", mK]]), AK = {
  name: "RowButtonEdit",
  components: {
    RowButton: Qt,
    EditModal: Da(() => Promise.resolve().then(() => hl))
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    pkey: {
      type: Object
    },
    visibleColumns: {
      type: Array,
      required: !1,
      default: () => null
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function gK(e, n, t, o, i, r) {
  const a = b("RowButton"), s = b("EditModal");
  return l(), c("span", null, [
    D(a, {
      type: "edit",
      onEdit: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(s, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      isModalShown: i.isModalShown,
      schemaId: t.schemaId,
      visibleColumns: t.visibleColumns,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "visibleColumns", "onClose"])) : v("", !0)
  ]);
}
const yK = /* @__PURE__ */ P(AK, [["render", gK]]), KK = {
  extends: He
};
function bK(e, n, t, o, i, r) {
  return l(), c("button", {
    type: "button",
    class: "btn btn-danger",
    onClick: n[0] || (n[0] = Ke((...a) => e.onClick && e.onClick(...a), ["prevent"]))
  }, [
    H(e.$slots, "default")
  ]);
}
const vK = /* @__PURE__ */ P(KK, [["render", bK]]), CK = {
  name: "ConfirmModal",
  components: {
    LayoutModal: vt,
    ButtonAlt: ot,
    ButtonAction: He,
    ButtonDanger: vK
  },
  props: {
    title: {
      type: String,
      required: !1
    },
    actionLabel: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    tableLabel: {
      type: String,
      required: !1
    },
    pkey: Object,
    actionType: {
      type: String,
      required: !1,
      default: () => "primary"
      // or danger
    }
  },
  methods: {
    flattenObject: sn
  },
  computed: {
    pkeyAsString() {
      return this.flattenObject(this.pkey);
    }
  }
}, wK = { key: 1 }, FK = { key: 0 }, RK = { key: 1 };
function kK(e, n, t, o, i, r) {
  const a = b("ButtonAlt"), s = b("ButtonDanger"), u = b("ButtonAction"), d = b("LayoutModal");
  return l(), F(d, {
    title: t.title,
    onClose: n[3] || (n[3] = (f) => e.$emit("close"))
  }, {
    body: C(() => [
      e.$slots.default ? H(e.$slots, "default", { key: 0 }) : (l(), c("div", wK, [
        B(U(t.actionLabel) + " ", 1),
        p("strong", null, [
          t.tableId ? (l(), c("span", FK, U(t.tableLabel), 1)) : v("", !0),
          t.pkey ? (l(), c("span", RK, "(" + U(r.pkeyAsString) + ")", 1)) : v("", !0)
        ]),
        n[4] || (n[4] = p("br", null, null, -1)),
        n[5] || (n[5] = B("Are you sure ? ", -1)),
        n[6] || (n[6] = p("br", null, null, -1))
      ]))
    ]),
    footer: C(() => [
      D(a, {
        onClick: n[0] || (n[0] = (f) => e.$emit("close"))
      }, {
        default: C(() => [...n[7] || (n[7] = [
          B("Close", -1)
        ])]),
        _: 1
      }),
      t.actionType === "danger" ? (l(), F(s, {
        key: 0,
        onClick: n[1] || (n[1] = (f) => e.$emit("confirmed"))
      }, {
        default: C(() => [
          B(U(t.actionLabel), 1)
        ]),
        _: 1
      })) : (l(), F(u, {
        key: 1,
        onClick: n[2] || (n[2] = (f) => e.$emit("confirmed"))
      }, {
        default: C(() => [
          B(U(t.actionLabel), 1)
        ]),
        _: 1
      }))
    ]),
    _: 3
  }, 8, ["title"]);
}
const hr = /* @__PURE__ */ P(CK, [["render", kK]]), UK = {
  name: "RowButtonDelete",
  components: { RowButton: Qt, ConfirmModal: hr },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    tableLabel: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1,
      client: null
    };
  },
  methods: {
    async handleExecuteDelete() {
      this.client || (this.client = We.newClient(this.schemaId)), await this.client.deleteRow(this.pkey, this.tableId).then(() => {
        this.$emit("success", {
          deletedKey: this.pkey,
          deleteFrom: this.tableId
        });
      }).catch((e) => {
        const n = e?.response?.data?.errors && Array.isArray(e?.response?.data?.errors) ? e.response.data.errors[0].message : "Failed to delete row data from table ";
        this.$emit("error", { errorMessage: n, error: e });
      }), this.handleClose();
    },
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function EK(e, n, t, o, i, r) {
  const a = b("RowButton"), s = b("ConfirmModal");
  return l(), c("span", null, [
    D(a, {
      type: "delete",
      onDelete: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(s, {
      key: 0,
      title: "Delete from " + t.tableId,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLable: t.tableLabel,
      pkey: t.pkey,
      onClose: r.handleClose,
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLable", "pkey", "onClose", "onConfirmed"])) : v("", !0)
  ]);
}
const SK = /* @__PURE__ */ P(UK, [["render", EK]]), TK = {
  name: "TableSearch",
  components: {
    TableMolgenis: fr,
    MessageError: rt,
    InputSearch: pr,
    Pagination: ll,
    Spinner: bt,
    RowButtonAdd: ol,
    RowButtonEdit: yK,
    RowButtonDelete: SK
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !0
    },
    selection: { type: Array, default: () => [] },
    /** enables checkbox to select rows */
    showSelect: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showColumns: {
      type: Array
    },
    canEdit: {
      type: Boolean,
      default: !1
    },
    canInsert: { default: !1 },
    canUpdate: { default: !1 },
    canDelete: { default: !1 },
    filter: {
      type: Object,
      required: !1
    }
  },
  data: function() {
    return {
      page: 1,
      limit: 20,
      count: 0,
      loading: !0,
      graphqlError: "",
      searchTerms: "",
      tableMetadata: {},
      data: void 0
    };
  },
  computed: {
    showHeaderIfNeeded() {
      return this.showHeader || this.count > this.limit;
    },
    columnsVisible() {
      return this.tableMetadata?.columns.filter(
        (e) => this.showColumns == null && !e.id.startsWith("mg_") || this.showColumns != null && this.showColumns.includes(e.id)
      );
    }
  },
  methods: {
    select(e) {
      this.$emit("select", e), this.$refs.inputSearch.clearInput();
    },
    selectNew(e) {
      this.$emit("update:newRow", e), this.$refs.inputSearch.clearInput();
    },
    deselect(e) {
      this.$emit("deselect", e), this.$refs.inputSearch.clearInput();
    },
    async loadData() {
      this.loading = !0;
      const e = {
        limit: this.limit,
        offset: this.limit * (this.page - 1),
        searchTerms: this.searchTerms,
        filter: this.filter
      }, n = We.newClient(this.schemaId), t = await n.fetchTableData(this.tableId, e).catch(() => this.graphqlError = "Failed to load data");
      this.tableMetadata = await n.fetchTableMetaData(this.tableId), this.data = t[this.tableId], this.count = t[`${this.tableId}_agg`].count, this.loading = !1;
    }
  },
  watch: {
    page() {
      this.loadData();
    },
    searchTerms() {
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
  emits: ["select", "update:newRow", "deselect"]
}, IK = {
  key: 1,
  style: { "text-align": "center" }
}, DK = {
  key: 0,
  class: "form-inline justify-content-between mb-2 bg-white"
}, OK = { key: 2 };
function _K(e, n, t, o, i, r) {
  const a = b("MessageError"), s = b("InputSearch"), u = b("Pagination"), d = b("Spinner"), f = b("RowButtonAdd"), K = b("RowButtonEdit"), w = b("RowButtonDelete"), k = b("TableMolgenis");
  return l(), c("div", null, [
    e.graphqlError ? (l(), F(a, { key: 0 }, {
      default: C(() => [
        B(U(e.graphqlError), 1)
      ]),
      _: 1
    })) : (l(), c("div", IK, [
      r.showHeaderIfNeeded ? (l(), c("form", DK, [
        t.tableId ? (l(), F(s, {
          key: 0,
          id: "input-search",
          modelValue: e.searchTerms,
          "onUpdate:modelValue": n[0] || (n[0] = (y) => e.searchTerms = y),
          ref: "inputSearch"
        }, null, 8, ["modelValue"])) : v("", !0),
        D(u, {
          class: "ml-2",
          modelValue: e.page,
          "onUpdate:modelValue": n[1] || (n[1] = (y) => e.page = y),
          limit: e.limit,
          count: e.count
        }, null, 8, ["modelValue", "limit", "count"])
      ])) : v("", !0),
      e.loading ? (l(), F(d, { key: 1 })) : (l(), c("div", OK, [
        D(k, {
          schemaId: t.schemaId,
          selection: t.selection,
          tableMetadata: e.tableMetadata,
          columns: r.columnsVisible,
          data: e.data,
          showSelect: t.showSelect,
          onSelect: r.select,
          onDeselect: r.deselect
        }, {
          header: C(() => [
            H(e.$slots, "colheader", Bo(Oa(e.$props))),
            p("label", null, U(e.count) + " records found", 1)
          ]),
          rowcolheader: C(() => [
            t.canInsert ?? t.canEdit ? (l(), F(f, {
              key: 0,
              id: "row-button-add-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              onClose: r.loadData,
              "onUpdate:newRow": r.selectNew,
              class: "d-inline p-0"
            }, null, 8, ["id", "tableId", "schemaId", "onClose", "onUpdate:newRow"])) : v("", !0)
          ]),
          colheader: C(() => [
            H(e.$slots, "colheader", Pn(e.$props, {
              canEdit: t.canEdit,
              reload: r.loadData,
              schemaId: t.schemaId
            }))
          ]),
          rowheader: C((y) => [
            H(e.$slots, "rowheader", {
              row: y.row,
              metadata: e.tableMetadata,
              rowKey: y.rowKey
            }),
            t.canUpdate ?? t.canEdit ? (l(), F(K, {
              key: 0,
              id: "row-button-edit-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              pkey: y.rowKey,
              onClose: r.loadData,
              class: "text-left"
            }, null, 8, ["id", "tableId", "schemaId", "pkey", "onClose"])) : v("", !0),
            t.canDelete ?? t.canEdit ? (l(), F(w, {
              key: 1,
              id: "row-button-del-" + t.tableId,
              tableId: t.tableId,
              tableLabel: e.tableMetadata.label,
              schemaId: t.schemaId,
              pkey: y.rowKey,
              onClose: r.loadData
            }, null, 8, ["id", "tableId", "tableLabel", "schemaId", "pkey", "onClose"])) : v("", !0)
          ]),
          _: 3
        }, 8, ["schemaId", "selection", "tableMetadata", "columns", "data", "showSelect", "onSelect", "onDeselect"])
      ]))
    ]))
  ]);
}
const ul = /* @__PURE__ */ P(TK, [["render", _K]]), PK = {
  extends: Ce,
  data: function() {
    return {
      client: null,
      showSelect: !1,
      data: [],
      selection: Ve(this.modelValue),
      count: 0,
      tableMetadata: null,
      loading: !1
    };
  },
  components: {
    FilterWell: il,
    TableSearch: ul,
    LayoutModal: vt,
    FormGroup: Ue,
    ButtonOutline: Bi,
    Spinner: bt,
    RowButtonAdd: ol,
    Tooltip: fn
  },
  props: {
    schemaId: {
      type: String,
      required: !1,
      default: ""
    },
    filter: Object,
    orderby: Object,
    multipleColumns: Boolean,
    maxNum: { type: Number, default: 11 },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    title() {
      return "Select " + (this.tableMetadata?.label || this.tableId);
    },
    showMultipleColumns() {
      return this.multipleColumns && this.count > 12;
    }
  },
  methods: {
    applyJsTemplate: jt,
    deselect(e) {
      this.selection = this.selection.filter(
        (n) => !tn(n, e)
      ), this.emitSelection();
    },
    clearValue() {
      this.selection = [], this.emitSelection();
    },
    handleUpdateSelection(e) {
      this.selection = [...e], this.emitSelection();
    },
    select(e) {
      this.selection = [...this.selection, e], this.emitSelection();
    },
    async selectNew(e) {
      const n = await Zt(
        e,
        this.tableId,
        this.schemaId
      );
      this.selection = [...this.selection, n], this.emitSelection(), this.loadOptions();
    },
    emitSelection() {
      this.selection.length ? this.$emit("update:modelValue", this.selection) : this.$emit("update:modelValue", null);
    },
    openSelect() {
      this.showSelect = !0;
    },
    toggle(e) {
      this.selection?.some(
        (n) => tn(n, e)
      ) ? this.selection = this.selection.filter(
        (n) => !tn(n, e)
      ) : this.selection = [...this.selection, e], this.emitSelection();
    },
    closeSelect() {
      this.loadOptions(), this.showSelect = !1;
    },
    async loadOptions() {
      if (!this.client) {
        console.error("Tried loading options before client is initialised");
        return;
      }
      this.loading = !0;
      const e = {
        limit: this.maxNum,
        filter: this.filter,
        orderby: this.orderby
      }, n = await this.client.fetchTableData(this.tableId, e), o = (n[this.tableId] || []).map(
        async (i) => Zt(i, this.tableId, this.schemaId)
      );
      this.count = n[this.tableId + "_agg"].count, this.data = await Promise.all(o), this.loading = !1, this.$emit("optionsLoaded", this.data);
    }
  },
  watch: {
    async modelValue() {
      if (!this.modelValue)
        this.selection = [];
      else {
        const e = Ve(this.modelValue).map(
          async (n) => Zt(n, this.tableId, this.schemaId)
        );
        this.selection = await Promise.all(e);
      }
    },
    filter() {
      this.loading || this.loadOptions();
    }
  },
  async created() {
    if (this.loading = !0, this.client = We.newClient(this.schemaId), this.tableMetadata = await this.client.fetchTableMetaData(this.tableId), await this.loadOptions(), this.loading = !0, !this.modelValue)
      this.selection = [];
    else {
      const e = Ve(this.modelValue).map(
        async (n) => Zt(n, this.tableId, this.schemaId)
      );
      this.selection = await Promise.all(e);
    }
    this.loading = !1;
  },
  emits: ["optionsLoaded", "update:modelValue"]
}, MK = ["id", "name", "value"], NK = ["for", "onClick"], BK = { key: 2 }, LK = { class: "m-1" };
function xK(e, n, t, o, i, r) {
  const a = b("FilterWell"), s = b("ButtonAlt"), u = b("Spinner"), d = b("RowButtonAdd"), f = b("ButtonOutline"), K = b("TableSearch"), w = b("LayoutModal"), k = b("FormGroup");
  return l(), F(k, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      p("div", null, [
        p("div", null, [
          p("div", null, [
            (l(!0), c(te, null, oe(e.selection, (y) => (l(), F(a, {
              key: JSON.stringify(y),
              label: r.applyJsTemplate(y, t.refLabel),
              onClick: (m) => r.deselect(y)
            }, null, 8, ["label", "onClick"]))), 128))
          ]),
          Array.isArray(e.modelValue) && e.modelValue.length ? (l(), F(s, {
            key: 0,
            class: "pl-1",
            icon: "fa fa-clear",
            onClick: r.clearValue
          }, {
            default: C(() => [...n[3] || (n[3] = [
              B(" clear selection ", -1)
            ])]),
            _: 1
          }, 8, ["onClick"])) : v("", !0)
        ]),
        p("div", {
          class: G(
            r.showMultipleColumns ? "d-flex align-content-stretch flex-wrap" : ""
          )
        }, [
          e.loading ? (l(), F(u, { key: 0 })) : e.data.length ? (l(!0), c(te, { key: 1 }, oe(e.data, (y, m) => (l(), c("div", {
            class: G(["form-check custom-control custom-checkbox", r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""]),
            key: m
          }, [
            Ye(p("input", {
              id: `${e.id}-${JSON.stringify(y)}`,
              name: e.id,
              type: "checkbox",
              value: y,
              "onUpdate:modelValue": n[0] || (n[0] = (g) => e.selection = g),
              onChange: n[1] || (n[1] = (...g) => r.emitSelection && r.emitSelection(...g)),
              class: G(["form-check-input", { "is-invalid": e.errorMessage }])
            }, null, 42, MK), [
              [Ta, e.selection]
            ]),
            p("label", {
              class: "form-check-label",
              for: `${e.id}-${JSON.stringify(y)}`,
              onClick: Ke((g) => r.toggle(y), ["prevent"])
            }, U(r.applyJsTemplate(y, t.refLabel)), 9, NK)
          ], 2))), 128)) : (l(), c("div", BK, "No entries found for " + U(e.label), 1))
        ], 2),
        p("div", LK, [
          t.canEdit ? (l(), F(d, {
            key: 0,
            id: "add-entry",
            label: `Add new ${e.label}`,
            tableId: t.tableId,
            schemaId: t.schemaId,
            "onUpdate:newRow": r.selectNew,
            class: "mr-1"
          }, null, 8, ["label", "tableId", "schemaId", "onUpdate:newRow"])) : v("", !0),
          D(f, {
            class: G(r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""),
            icon: "fa fa-search",
            onClick: r.openSelect
          }, {
            default: C(() => [
              B(U(e.count > t.maxNum ? `Show all ${e.count} options with details ` : "More details "), 1)
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]),
        e.showSelect ? (l(), F(w, {
          key: 0,
          title: r.title,
          onClose: r.closeSelect
        }, {
          body: C(() => [
            D(K, {
              selection: e.selection,
              "onUpdate:selection": n[2] || (n[2] = (y) => e.selection = y),
              schemaId: t.schemaId,
              tableId: t.tableId,
              canEdit: t.canEdit,
              showSelect: !0,
              filter: t.filter,
              limit: 10,
              onSelect: r.select,
              onDeselect: r.deselect,
              "onUpdate:newRow": r.selectNew
            }, null, 8, ["selection", "schemaId", "tableId", "canEdit", "filter", "onSelect", "onDeselect", "onUpdate:newRow"])
          ]),
          footer: C(() => [
            D(s, { onClick: r.closeSelect }, {
              default: C(() => [...n[4] || (n[4] = [
                B("Close", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["title", "onClose"])) : v("", !0)
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const mi = /* @__PURE__ */ P(PK, [["render", xK]]), qK = {
  name: "RefListFilter",
  components: { InputRefList: mi },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function VK(e, n, t, o, i, r) {
  const a = b("InputRefList");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    refLabel: t.refLabel
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId", "refLabel"]);
}
const Pt = /* @__PURE__ */ P(qK, [["render", VK]]), jK = {
  name: "StringFilter",
  components: { InputString: yt },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: String,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function HK(e, n, t, o, i, r) {
  const a = b("InputString");
  return l(), F(a, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: C(() => [
      t.condition ? (l(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (s) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : v("", !0),
      t.showAddButton && t.condition ? (l(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (s) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const tt = /* @__PURE__ */ P(jK, [["render", HK]]), ba = {
  AUTO_ID: tt,
  STRING: tt,
  STRING_ARRAY: tt,
  EMAIL: tt,
  EMAIL_ARRAY: tt,
  HYPERLINK: tt,
  HYPERLINK_ARRAY: tt,
  TEXT: tt,
  TEXT_ARRAY: tt,
  JSON: tt,
  UUID: tt,
  UUID_ARRAY: tt,
  INT: Io,
  INT_ARRAY: Io,
  DECIMAL: To,
  DECIMAL_ARRAY: To,
  LONG: ga,
  LONG_ARRAY: ga,
  DATE: Eo,
  DATE_ARRAY: Eo,
  DATETIME: So,
  DATETIME_ARRAY: So,
  BOOL: ko,
  BOOl_ARRAY: ko,
  SELECT: Pt,
  MULTISELECT: Pt,
  CHECKBOX: Pt,
  REF: Pt,
  REFBACK: Pt,
  REF_ARRAY: Pt,
  ONTOLOGY: Do,
  ONTOLOGY_ARRAY: Do,
  RADIO: nl
}, GK = {
  name: "FilterInput",
  components: {
    StringFilter: tt,
    IntegerFilter: Io,
    DecimalFilter: To,
    DateFilter: Eo,
    DateTimeFilter: So,
    BooleanFilter: ko,
    RefListFilter: Pt,
    OntologyFilter: Do,
    RadioFilter: nl
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    columnType: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(ba).includes(e);
      }
    },
    conditions: {
      type: Array,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      // used to add new empty field when adding conditions
      fieldCount: this.isMultiConditionFilter ? 1 : this.conditions.length || 1
    };
  },
  computed: {
    filterType() {
      return ba[this.columnType];
    },
    isMultiConditionFilter() {
      return [
        "MULTI_SELECT",
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY",
        "ONTOLOGY_ARRAY"
      ].includes(this.columnType);
    }
  },
  methods: {
    updateCondition(e, n) {
      if (this.isMultiConditionFilter)
        this.$emit("updateConditions", Ve(n));
      else if (!this.conditions.length)
        this.$emit("updateConditions", [n]);
      else {
        let t = Ve(this.conditions);
        t[e] = n, this.$emit("updateConditions", t);
      }
    },
    clearCondition(e) {
      let n = [...this.conditions];
      n.splice(e, 1), this.$emit("updateConditions", n), this.fieldCount > 1 && this.fieldCount--;
    }
  },
  watch: {
    conditions(e) {
      this.fieldCount = this.isMultiConditionFilter ? 1 : e.length || 1;
    }
  },
  emits: ["updateConditions"]
}, QK = { key: 0 };
function $K(e, n, t, o, i, r) {
  return l(), c("div", null, [
    r.isMultiConditionFilter ? (l(), c("div", QK, [
      (l(), F(Et(r.filterType), {
        id: t.id,
        condition: t.conditions,
        onUpdateCondition: n[0] || (n[0] = (a) => r.updateCondition(e.index - 1, a)),
        tableId: t.tableId,
        schemaId: t.schemaId,
        refLabel: t.refLabel
      }, null, 40, ["id", "condition", "tableId", "schemaId", "refLabel"]))
    ])) : (l(!0), c(te, { key: 1 }, oe(i.fieldCount, (a) => (l(), c("div", { key: a }, [
      (l(), F(Et(r.filterType), {
        id: t.id + a,
        condition: t.conditions[a - 1],
        onUpdateCondition: (s) => r.updateCondition(a - 1, s),
        onClearCondition: (s) => r.clearCondition(a - 1),
        onAddCondition: n[1] || (n[1] = (s) => i.fieldCount++),
        showAddButton: a === t.conditions.length,
        tableId: t.tableId,
        schemaId: t.schemaId,
        refLabel: t.refLabel
      }, null, 40, ["id", "condition", "onUpdateCondition", "onClearCondition", "showAddButton", "tableId", "schemaId", "refLabel"]))
    ]))), 128))
  ]);
}
const JK = /* @__PURE__ */ P(GK, [["render", $K]]), zK = {
  name: "FilterSidebar",
  components: {
    FilterInput: JK,
    FilterContainer: _A
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  computed: {
    visibleFilters() {
      return this.filters.filter(
        (e) => e.showFilter && !["HEADING", "SECTION"].includes(e.columnType)
      );
    }
  },
  methods: {
    handleUpdateFilter(e, n) {
      let t = [...this.visibleFilters];
      t[e].conditions = n, this.$emit("updateFilters", t);
    }
  }
}, YK = { class: "sidebar-container" };
function WK(e, n, t, o, i, r) {
  const a = b("FilterInput"), s = b("FilterContainer");
  return l(), c("div", YK, [
    (l(!0), c(te, null, oe(r.visibleFilters, (u, d) => (l(), F(s, {
      key: u.id,
      title: u.label,
      conditions: u.conditions
    }, {
      default: C(() => [
        D(a, {
          id: "filter-" + u.id,
          conditions: r.visibleFilters[d].conditions,
          onUpdateConditions: (f) => r.handleUpdateFilter(d, f),
          columnType: u.columnType,
          tableId: u.refTableId,
          schemaId: u.refSchemaId ? u.refSchemaId : t.schemaId,
          refLabel: u.refLabel ? u.refLabel : u.refLabelDefault
        }, null, 8, ["id", "conditions", "onUpdateConditions", "columnType", "tableId", "schemaId", "refLabel"])
      ]),
      _: 2
    }, 1032, ["title", "conditions"]))), 128))
  ]);
}
const XK = /* @__PURE__ */ P(zK, [["render", WK], ["__scopeId", "data-v-8ea81881"]]), ZK = {
  props: {
    /** two-way bindable array of column metadata. Will add 'conditions' property to hold filter values */
    filters: { type: Array, default: () => [] }
  },
  components: {
    FilterWell: il
  },
  computed: {
    countFilters() {
      let e = 0;
      return Array.isArray(this.filters) && this.filters.forEach((n) => {
        Array.isArray(n.conditions) && n.conditions.forEach((t) => {
          Array.isArray(t) ? (t[0] !== null || t[1] != null) && e++ : t != null && e++;
        });
      }), e;
    }
  },
  methods: {
    renderValue(e) {
      return typeof e == "object" && e !== null ? this.flattenObject(e) : e;
    },
    flattenObject(e) {
      let n = "";
      return Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n;
    },
    remove(e, n) {
      let t = this.filters;
      t[e].conditions.splice(n, 1), this.$emit("updateFilters", t);
    },
    removeAll() {
      let e = this.filters;
      for (let n in e)
        Array.isArray(e[n].conditions) && e[n].conditions.splice(0);
      this.$emit("updateFilters", e);
    },
    getSelectLabel(e, n) {
      const t = n.map(
        (o) => jt({ value: o }, e.refLabel || e.refLabelDefault)
      ).join(", ");
      return e.label + " contains:" + t;
    },
    isSelectType(e) {
      return ["MULTISELECT", "SELECT", "CHECKBOX"].includes(e);
    }
  }
}, eb = { key: 0 }, tb = { class: "d-flex align-items-center" }, nb = { key: 0 }, ib = { key: 1 };
function ob(e, n, t, o, i, r) {
  const a = b("FilterWell");
  return l(), c("span", null, [
    r.countFilters > 0 ? (l(), c("div", eb, [
      p("div", tb, [
        B(U(r.countFilters) + " filter " + U(r.countFilters > 1 ? "s" : "") + " ( ", 1),
        p("button", {
          type: "button",
          onClick: n[0] || (n[0] = (...s) => r.removeAll && r.removeAll(...s)),
          class: "btn btn-link pl-0 pr-0"
        }, " remove all filters "),
        n[1] || (n[1] = B(" ) : ", -1))
      ]),
      (l(!0), c(te, null, oe(t.filters, (s, u) => (l(), c("span", {
        key: s.id
      }, [
        (l(!0), c(te, null, oe(s.conditions, (d, f) => (l(), c("span", { key: f }, [
          Array.isArray(d) ? (l(), c("span", nb, [
            r.isSelectType(s.columnType) ? (l(), F(a, {
              key: 0,
              onClick: (K) => r.remove(u, f),
              label: r.getSelectLabel(s, d)
            }, null, 8, ["onClick", "label"])) : d[0] !== null && d[1] !== null ? (l(), F(a, {
              key: 1,
              onClick: (K) => r.remove(u, f),
              label: d[0] + " < " + s.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : d[0] !== null ? (l(), F(a, {
              key: 2,
              onClick: (K) => r.remove(u, f),
              label: d[0] + " < " + s.id
            }, null, 8, ["onClick", "label"])) : d[1] !== null ? (l(), F(a, {
              key: 3,
              onClick: (K) => r.remove(u, f),
              label: s.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : v("", !0)
          ])) : (l(), c("span", ib, [
            D(a, {
              onClick: (K) => r.remove(u, f),
              label: s.label + " = " + r.renderValue(d)
            }, null, 8, ["onClick", "label"])
          ]))
        ]))), 128))
      ]))), 128))
    ])) : v("", !0)
  ]);
}
const rb = /* @__PURE__ */ P(ZK, [["render", ob]]), ab = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    BaseInputDecimal: Zs,
    InputGroup: Ne
  }
};
function sb(e, n, t, o, i, r) {
  const a = b("BaseInputDecimal"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, null, {
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id,
            modelValue: e.modelValue,
            class: G({ "is-invalid": e.errorMessage }),
            placeholder: e.placeholder,
            required: e.required,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "class", "placeholder", "required"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const mr = /* @__PURE__ */ P(ab, [["render", sb]]), lb = {
  name: "InputEmail",
  components: { FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    stringLength: {
      type: Number,
      default: 255
    },
    additionalValidValidationStrings: {
      type: Array,
      default: []
    }
  },
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.validateEmail(this.modelValue) ? this.errorMessage : "Please enter a valid email address" : this.errorMessage;
    }
  },
  methods: {
    validateEmail(e) {
      return this.additionalValidValidationStrings.includes(e) || e?.match(Tt.EMAIL_REGEX);
    }
  }
}, ub = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function db(e, n, t, o, i, r) {
  const a = b("InputGroup"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: C(() => [
      D(a, null, {
        append: C(() => [
          H(e.$slots, "append", {}, void 0, !0)
        ]),
        default: C(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, ub)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const dl = /* @__PURE__ */ P(lb, [["render", db], ["__scopeId", "data-v-d474af2a"]]), cb = {
  name: "InputHyperlink",
  components: { FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.validateHyperlink(this.modelValue) ? this.errorMessage : "Please enter a valid hyperlink" : this.errorMessage;
    }
  },
  methods: {
    validateHyperlink(e) {
      return e?.match(Tt.HYPERLINK_REGEX);
    }
  }
}, fb = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function pb(e, n, t, o, i, r) {
  const a = b("InputGroup"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: C(() => [
      D(a, null, {
        append: C(() => [
          H(e.$slots, "append", {}, void 0, !0)
        ]),
        default: C(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (u) => (
              //@ts-ignore
              e.$emit("update:modelValue", u.target?.value)
            )),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, fb)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const cl = /* @__PURE__ */ P(cb, [["render", pb], ["__scopeId", "data-v-09994973"]]), hb = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    BaseInputInt: lr,
    InputGroup: Ne
  }
};
function mb(e, n, t, o, i, r) {
  const a = b("BaseInputInt"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, null, {
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Ar = /* @__PURE__ */ P(hb, [["render", mb]]), Ab = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    BaseInputLong: el,
    InputGroup: Ne
  }
};
function gb(e, n, t, o, i, r) {
  const a = b("BaseInputLong"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, null, {
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          D(a, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const gr = /* @__PURE__ */ P(Ab, [["render", gb]]), yb = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    InputGroup: Ne
  },
  methods: {
    resizeTextarea(e) {
      e.target.style.height = "auto", e.target.style.height = e.target.scrollHeight + "px";
    }
  },
  mounted() {
    const e = this.$refs.textarea;
    yi(() => {
      e.setAttribute(
        "style",
        "height:" + e.scrollHeight + "px;overflow-y:hidden;"
      );
    }), e.addEventListener("input", this.resizeTextarea);
  },
  beforeDestroy() {
    this.$refs.textarea.addEventListener("input", this.resizeTextarea);
  }
}, Kb = ["value", "aria-describedby", "placeholder", "readonly"];
function bb(e, n, t, o, i, r) {
  const a = b("InputGroup"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(a, null, {
        append: C(() => [
          H(e.$slots, "append")
        ]),
        default: C(() => [
          p("textarea", {
            ref: "textarea",
            value: e.modelValue,
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            "aria-describedby": e.id + "Help",
            placeholder: e.placeholder,
            readonly: e.readonly,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value))
          }, null, 42, Kb)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Qn = /* @__PURE__ */ P(yb, [["render", bb]]), yr = /* @__PURE__ */ ke({
  __name: "InputNonNegativeInt",
  props: /* @__PURE__ */ Ll({
    id: {},
    label: {},
    required: { type: Boolean },
    description: {},
    errorMessage: {},
    placeholder: {},
    readonly: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Bl(e, "modelValue"), o = Pe(() => typeof t.value == "number" && Go(t.value) ? ps : n.errorMessage);
    return (i, r) => (l(), F(Ue, {
      id: e.id,
      label: e.label,
      required: e.required,
      description: e.description,
      errorMessage: o.value
    }, {
      default: C(() => [
        D(Ne, null, {
          append: C(() => [
            H(i.$slots, "append")
          ]),
          default: C(() => [
            D(lr, {
              id: e.id,
              modelValue: t.value,
              placeholder: e.placeholder,
              readonly: e.readonly,
              required: e.required,
              class: G({ "is-invalid": o.value }),
              "onUpdate:modelValue": r[0] || (r[0] = (a) => i.$emit("update:modelValue", a))
            }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "label", "required", "description", "errorMessage"]));
  }
}), vb = {
  name: "ArrayInput",
  extends: Ce,
  components: { FormGroup: Ue },
  data() {
    return { values: this.modelValue?.length ? this.modelValue : [null] };
  },
  props: {
    columnType: {
      type: String,
      required: !0
    }
  },
  computed: {
    inputType() {
      return {
        BOOL_ARRAY: Li,
        DATE_ARRAY: xi,
        DATETIME_ARRAY: qi,
        DECIMAL_ARRAY: mr,
        PERIOD_ARRAY: yt,
        EMAIL_ARRAY: dl,
        HYPERLINK_ARRAY: cl,
        INT_ARRAY: Ar,
        NON_NEGATIVE_INT_ARRAY: yr,
        LONG_ARRAY: gr,
        STRING_ARRAY: yt,
        TEXT_ARRAY: Qn,
        UUID_ARRAY: yt
      }[this.columnType];
    }
  },
  methods: {
    addItem(e) {
      this.values.splice(e + 1, 0, null), this.$emit("update:modelValue", this.values);
    },
    clearInput(e) {
      this.values.length > 1 && this.values.splice(e, 1), this.$emit("update:modelValue", this.values);
    },
    handleUpdate(e, n) {
      this.values[n] = e, this.$emit("update:modelValue", this.values);
    }
  },
  emits: ["update:modelValue"]
}, Cb = ["onClick"], wb = ["onClick"];
function Fb(e, n, t, o, i, r) {
  const a = b("FormGroup");
  return l(), F(a, {
    id: e.id + "-0",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      (l(!0), c(te, null, oe(i.values, (s, u) => (l(), c("div", { key: u }, [
        (l(), F(Et(r.inputType), {
          id: e.id + "-" + u,
          modelValue: i.values[u],
          showAddButton: u === i.values.length,
          "onUpdate:modelValue": (d) => r.handleUpdate(d, u)
        }, {
          append: C(() => [
            i.values.length > 1 ? (l(), c("button", {
              key: 0,
              onClick: (d) => r.clearInput(u),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[0] || (n[0] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])], 8, Cb)) : v("", !0),
            p("button", {
              onClick: (d) => r.addItem(u),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[1] || (n[1] = [
              p("i", { class: "fas fa-fw fa-plus" }, null, -1)
            ])], 8, wb)
          ]),
          _: 2
        }, 1032, ["id", "modelValue", "showAddButton", "onUpdate:modelValue"]))
      ]))), 128))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const nt = /* @__PURE__ */ P(vb, [["render", Fb]]), Rb = {
  directives: {
    clickOutside: Vi.directive
  },
  props: {
    label: { type: String, required: !0 },
    icon: { type: String, default: "" },
    isMenuItem: { type: Boolean, required: !1 },
    placement: { type: String, default: "bottom-start" },
    closeOnClick: { type: Boolean, default: !1 }
  },
  data() {
    return {
      display: !1,
      popperInstance: null
    };
  },
  methods: {
    handleOnClick() {
      this.closeOnClick && (this.display = !this.display);
    },
    async toggle() {
      if (this.display = !this.display, this.display) {
        await this.$nextTick();
        const e = this.$refs.showInputButton, n = this.$refs.dropdown;
        this.popperInstance = Gs(e, n, {
          placement: this.placement,
          modifiers: { offset: { offset: "0,2px" } }
        });
      } else
        this.popperInstance.destroy();
    }
  }
}, kb = { key: 0 };
function Ub(e, n, t, o, i, r) {
  const a = Ui("click-outside");
  return l(), c("span", null, [
    p("button", {
      type: "button",
      ref: "showInputButton",
      class: G(["btn btn-outline-primary", { "dropdown-toggle": !t.icon, "nav-link": t.isMenuItem }]),
      onClick: n[0] || (n[0] = (...s) => r.toggle && r.toggle(...s))
    }, [
      t.label ? (l(), c("span", kb, U(t.label), 1)) : v("", !0),
      t.icon ? (l(), c("span", {
        key: 1,
        class: G("fa fa-" + t.icon + " fa-lg ml-2")
      }, null, 2)) : v("", !0)
    ], 2),
    i.display ? Ye((l(), c("span", {
      key: 0,
      class: "mg-dropdown-drop bg-white border rounded",
      ref: "dropdown",
      onClick: n[1] || (n[1] = (...s) => r.handleOnClick && r.handleOnClick(...s))
    }, [
      H(e.$slots, "default", { close: r.toggle }, void 0, !0)
    ])), [
      [a, r.toggle]
    ]) : v("", !0)
  ]);
}
const Kr = /* @__PURE__ */ P(Rb, [["render", Ub], ["__scopeId", "data-v-5663ccf8"]]), Eb = {
  components: { IconAction: ft },
  name: "InlineInput",
  props: {
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    }
  },
  data() {
    return {
      isEditing: !1,
      isInputFieldVisible: !1
    };
  },
  methods: {
    onfocusout() {
      this.isInputFieldVisible && (this.isEditing = !1, this.isInputFieldVisible = !1);
    },
    async openAndFocusInput() {
      this.isEditing = !0, this.isEditing = !0, await this.$nextTick(), this.isInputFieldVisible = !0, this.$refs.inlineInput.querySelector("input")?.focus();
    }
  }
}, Sb = { key: 0 };
function Tb(e, n, t, o, i, r) {
  const a = b("IconAction");
  return l(), c("span", {
    onFocusout: n[2] || (n[2] = (...s) => r.onfocusout && r.onfocusout(...s)),
    ref: "inlineInput"
  }, [
    i.isEditing ? (l(), c("span", Sb, [
      H(e.$slots, "default", {}, void 0, !0)
    ])) : (l(), c("span", {
      key: 1,
      onClick: n[0] || (n[0] = (s) => r.openAndFocusInput()),
      class: "editable"
    }, [
      H(e.$slots, "display", {}, () => [
        B(U(t.modelValue), 1)
      ], !0)
    ])),
    i.isEditing ? v("", !0) : (l(), F(a, {
      key: 2,
      icon: "pencil-alt",
      onClick: n[1] || (n[1] = (s) => r.openAndFocusInput())
    }))
  ], 544);
}
const Ib = /* @__PURE__ */ P(Eb, [["render", Tb], ["__scopeId", "data-v-de78a1fe"]]), Db = {
  extends: Ce,
  components: { FormGroup: Ue },
  data() {
    return {
      filename: this.modelValue instanceof File ? this.modelValue?.name : ""
    };
  },
  props: {
    modelValue: {
      default: null
    }
  },
  methods: {
    handleFileUpload(e) {
      const n = e.target;
      n?.files && (this.filename = n.files[0]?.name, this.$emit("update:modelValue", n.files[0]));
    },
    clearInput() {
      this.filename = null, this.$emit("update:modelValue", null);
    }
  }
}, Ob = { class: "input-group" }, _b = ["id"], Pb = ["placeholder"], Mb = { class: "input-group-append" }, Nb = { class: "input-group-append" }, Bb = { key: 0 }, Lb = ["href"];
function xb(e, n, t, o, i, r) {
  const a = b("FormGroup");
  return l(), F(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      p("div", Ob, [
        p("input", {
          id: e.id,
          ref: "file",
          type: "file",
          style: { display: "none" },
          onChange: n[0] || (n[0] = (...s) => r.handleFileUpload && r.handleFileUpload(...s))
        }, null, 40, _b),
        p("input", {
          class: G(["form-control active", { "is-invalid": e.errorMessage }]),
          placeholder: i.filename,
          onClick: n[1] || (n[1] = (s) => e.$refs.file.click()),
          onKeydown: n[2] || (n[2] = Ke(() => {
          }, ["prevent"]))
        }, null, 42, Pb),
        p("div", Mb, [
          p("button", {
            class: "btn bg-transparent text-primary",
            type: "button",
            title: "Toggle",
            "data-toggle": "",
            onClick: n[3] || (n[3] = (...s) => r.clearInput && r.clearInput(...s)),
            style: { "margin-left": "-40px", "z-index": "100" }
          }, [...n[5] || (n[5] = [
            p("i", { class: "fa fa-times" }, [
              p("span", {
                "aria-hidden": "true",
                class: "sr-only"
              }, "Clear")
            ], -1)
          ])])
        ]),
        p("div", Nb, [
          p("button", {
            class: "btn btn-outline-primary",
            type: "button",
            title: "Toggle",
            "data-toggle": "",
            onClick: n[4] || (n[4] = (s) => e.$refs.file.click())
          }, " Browse ")
        ])
      ]),
      t.modelValue ? (l(), c("div", Bb, [
        t.modelValue && t.modelValue.url ? (l(), c("a", {
          key: 0,
          href: t.modelValue.url
        }, " Previous value: " + U(t.modelValue?.filename ? t.modelValue.filename : t.modelValue.id + "." + t.modelValue.extension), 9, Lb)) : v("", !0)
      ])) : v("", !0)
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const fl = /* @__PURE__ */ P(Db, [["render", xb]]), qb = {
  components: { IconAction: ft },
  props: {
    inplace: Boolean,
    label: String,
    columnType: String,
    description: String,
    editMeta: Boolean
  },
  data() {
    return { focusLabel: !1, focusDescription: !1 };
  },
  methods: {
    toggleFocusLabel() {
      this.focusLabel = !this.focusLabel;
    },
    toggleFocusDescription() {
      this.focusDescription = !this.focusDescription;
    },
    stripHtml(e) {
      return e && e.replace(
        /(<\/?(?:h1|h2|h3|h4|p|label|a)[^>]*>)|<[^>]+>/gi,
        "$1"
      );
    }
  },
  emits: ["update:description", "update:label"]
}, Vb = {
  key: 0,
  class: "d-flex form-group bg-white rounded pt-4 pb-1 mb-1"
}, jb = { key: 0 }, Hb = ["value"], Gb = {
  key: 2,
  class: "d-flex form-group bg-white rounded pb-1 mb-1"
}, Qb = ["value", "aria-describedby"];
function $b(e, n, t, o, i, r) {
  const a = b("IconAction");
  return l(), c("div", null, [
    i.focusLabel ? (l(), c("input", {
      key: 1,
      value: t.label,
      class: "form-control",
      onInput: n[0] || (n[0] = (s) => e.$emit("update:label", s.target.value)),
      onBlur: n[1] || (n[1] = (...s) => r.toggleFocusLabel && r.toggleFocusLabel(...s))
    }, null, 40, Hb)) : (l(), c("span", Vb, [
      t.label !== "_top" ? (l(), c("h1", jb, U(t.label), 1)) : v("", !0),
      t.inplace || t.editMeta ? (l(), F(a, {
        key: 1,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusLabel
      }, null, 8, ["onClick"])) : v("", !0)
    ])),
    i.focusDescription ? (l(), c("textarea", {
      key: 3,
      value: t.description,
      class: G({
        "form-control": !0
      }),
      "aria-describedby": e.id + "Help",
      onInput: n[2] || (n[2] = (s) => e.$emit("update:description", s.target.value)),
      onBlur: n[3] || (n[3] = (...s) => r.toggleFocusDescription && r.toggleFocusDescription(...s))
    }, null, 40, Qb)) : (l(), c("div", Gb, [
      p("p", null, U(t.description), 1),
      t.inplace || t.editMeta ? (l(), F(a, {
        key: 0,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusDescription
      }, null, 8, ["onClick"])) : v("", !0)
    ]))
  ]);
}
const Oo = /* @__PURE__ */ P(qb, [["render", $b]]), Jb = {}, zb = {
  class: "alert alert-warning",
  role: "alert"
};
function Yb(e, n) {
  return l(), c("div", zb, [
    H(e.$slots, "default")
  ]);
}
const Wb = /* @__PURE__ */ P(Jb, [["render", Yb]]), Xb = {
  name: "InputRefBack",
  extends: Ce,
  components: {
    FormGroup: Ue,
    TableMolgenis: fr,
    RowButton: Qt,
    Spinner: bt,
    MessageWarning: Wb,
    ConfirmModal: hr,
    MessageError: rt
  },
  props: {
    /** name of the table from which is referred back to this field */
    tableId: {
      type: String,
      required: !0
    },
    /** id of the column in the other table */
    refBackId: {
      type: String,
      required: !0
    },
    /**
     * primary key of the current table that refback should point to
     * when empty ( in case of draft , add message is shown instead of the table)
     *  */
    pkey: {
      type: [Object, null],
      required: !0
    },
    expressionData: {
      type: Object,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    /**
     * if table (that has a column that is referred to by this table) can be edited
     *  */
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  data() {
    return {
      client: null,
      tableMetadata: null,
      data: null,
      isLoading: !1,
      isEditModalShown: !1,
      isDeleteModalShown: !1,
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: null,
      graphqlError: null,
      defaultValue: null
    };
  },
  computed: {
    tablePermission() {
      return this.tablePermissions?.find((e) => e.name === this.tableId);
    },
    canInsert() {
      return this.tablePermission?.canInsert ?? this.canEdit;
    },
    canModify() {
      return this.tablePermission?.canUpdate ?? this.canEdit;
    },
    canRemove() {
      return this.tablePermission?.canDelete ?? this.canEdit;
    },
    graphqlFilter() {
      return {
        [this.refBackId]: {
          equals: this.pkey
        }
      };
    },
    visibleColumnIds() {
      return this.visibleColumns.map((e) => e.id);
    },
    visibleColumns() {
      return this.tableMetadata && this.tableMetadata.columns ? this.tableMetadata.columns.filter(
        (e) => e.id != this.refBackId && !e.id.startsWith("mg_")
      ) : [];
    },
    hasPrimaryKey() {
      return this.pkey ? !!Object.values(this.pkey).length : !1;
    }
  },
  methods: {
    async reload() {
      this.isLoading = !0;
      const e = await this.client.fetchTableDataValues(this.tableId, {
        filter: this.graphqlFilter
      });
      this.data = Cs(e, this.tableMetadata), this.isLoading = !1;
    },
    handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = e, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      this.isDeleteModalShown = !1, await this.client.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError).then(this.reload());
      let e = this.modelValue.filter(
        (n) => !tn(n, this.editRowPrimaryKey)
      );
      this.$emit("update:modelValue", e);
    },
    handleError(e) {
      Array.isArray(e?.response?.data?.errors) ? this.graphqlError = e.response.data.errors[0].message : this.graphqlError = e, this.loading = !1;
    }
  },
  mounted: async function() {
    this.client = We.newClient(this.schemaId), this.isLoading = !0, this.tableMetadata = await this.client.fetchTableMetaData(this.tableId).catch((e) => this.graphqlError = e.message), this.defaultValue = new Object(), this.defaultValue[this.refBackId] = this.expressionData, await this.reload();
  }
};
function Zb(e, n, t, o, i, r) {
  const a = b("Spinner"), s = b("RowButton"), u = b("TableMolgenis"), d = b("MessageWarning"), f = b("MessageError"), K = b("EditModal"), w = b("ConfirmModal"), k = b("FormGroup");
  return l(), F(k, Bo(Oa(e.$props)), {
    default: C(() => [
      i.isLoading ? (l(), F(a, { key: 0 })) : r.hasPrimaryKey ? (l(), F(u, {
        key: 1,
        schemaId: t.schemaId,
        data: i.data,
        columns: r.visibleColumns,
        "table-metadata": i.tableMetadata,
        style: { "overflow-x": "scroll" }
      }, {
        rowcolheader: C(() => [
          H(e.$slots, "rowcolheader", Pn(e.$props, {
            canEdit: t.canEdit,
            reload: r.reload,
            schemaId: t.schemaId
          })),
          r.canInsert ? (l(), F(s, {
            key: 0,
            type: "add",
            onAdd: n[0] || (n[0] = (y) => r.handleRowAction("add")),
            class: "d-inline p-0"
          })) : v("", !0)
        ]),
        rowheader: C((y) => [
          H(e.$slots, "rowheader", {
            row: y.row,
            metadata: i.tableMetadata,
            rowKey: y.rowKey
          }),
          r.canModify ? (l(), F(s, {
            key: 0,
            type: "edit",
            table: t.tableId,
            schemaId: t.schemaId,
            "visible-columns": r.visibleColumnIds,
            pkey: y.rowKey,
            onClose: r.reload,
            onEdit: (m) => r.handleRowAction("edit", y.rowKey)
          }, null, 8, ["table", "schemaId", "visible-columns", "pkey", "onClose", "onEdit"])) : v("", !0),
          r.canInsert ? (l(), F(s, {
            key: 1,
            type: "clone",
            table: t.tableId,
            schemaId: t.schemaId,
            pkey: y.rowKey,
            "visible-columns": r.visibleColumnIds,
            onClose: r.reload,
            onClone: (m) => r.handleRowAction("clone", y.rowKey)
          }, null, 8, ["table", "schemaId", "pkey", "visible-columns", "onClose", "onClone"])) : v("", !0),
          r.canRemove ? (l(), F(s, {
            key: 2,
            type: "delete",
            onDelete: (m) => r.handleDeleteRowRequest(y.rowKey)
          }, null, 8, ["onDelete"])) : v("", !0)
        ]),
        _: 3
      }, 8, ["schemaId", "data", "columns", "table-metadata"])) : (l(), F(d, { key: 2 }, {
        default: C(() => [...n[2] || (n[2] = [
          B(" This can only be filled in after you have saved (or saved draft). ", -1)
        ])]),
        _: 1
      })),
      i.graphqlError ? (l(), F(f, { key: 3 }, {
        default: C(() => [
          B(U(i.graphqlError), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.isEditModalShown ? (l(), F(K, {
        key: 4,
        isModalShown: !0,
        id: t.tableId + "-edit-modal",
        tableId: t.tableId,
        pkey: i.editRowPrimaryKey,
        visibleColumns: r.visibleColumnIds,
        clone: i.editMode === "clone",
        schemaId: t.schemaId,
        defaultValue: i.defaultValue,
        applyDefaultValues: !0,
        onClose: r.handleModalClose
      }, null, 8, ["id", "tableId", "pkey", "visibleColumns", "clone", "schemaId", "defaultValue", "onClose"])) : v("", !0),
      i.isDeleteModalShown ? (l(), F(w, {
        key: 5,
        title: "Delete from " + t.tableId,
        actionLabel: "Delete",
        actionType: "danger",
        tableId: t.tableId,
        tableLabel: i.tableMetadata.label,
        pkey: i.editRowPrimaryKey,
        onClose: n[1] || (n[1] = (y) => i.isDeleteModalShown = !1),
        onConfirmed: r.handleExecuteDelete
      }, null, 8, ["title", "tableId", "tableLabel", "pkey", "onConfirmed"])) : v("", !0)
    ]),
    _: 3
  }, 16);
}
const pl = /* @__PURE__ */ P(Xb, [["render", Zb]]), ev = {
  name: "InputRefSelect",
  extends: Ce,
  data: function() {
    return {
      showSelect: !1
    };
  },
  components: {
    TableSearch: ul,
    LayoutModal: vt,
    FormGroup: Ue,
    ButtonAction: He,
    ButtonAlt: ot,
    InputGroup: Ne
  },
  props: {
    tableId: String,
    schemaId: {
      type: String,
      required: !1
    },
    filter: Object,
    refLabel: {
      type: String,
      required: !0
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    title() {
      return "Select " + this.tableId;
    },
    tablePermission() {
      return this.tablePermissions?.find((e) => e.id === this.tableId);
    }
  },
  methods: {
    applyJsTemplate: jt,
    async select(e) {
      this.showSelect = !1, this.$emit("update:modelValue", await e);
    }
  }
}, tv = ["value", "readonly"];
function nv(e, n, t, o, i, r) {
  const a = b("ButtonAction"), s = b("TableSearch"), u = b("ButtonAlt"), d = b("LayoutModal"), f = b("InputGroup"), K = b("FormGroup");
  return l(), F(K, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(f, null, {
        append: C(() => [
          e.modelValue && !this.readonly ? (l(), c("button", {
            key: 0,
            onClick: n[2] || (n[2] = (w) => e.$emit("update:modelValue", null)),
            class: "btn btn-outline-primary",
            type: "button"
          }, [...n[7] || (n[7] = [
            p("i", { class: "fas fa-fw fa-times" }, null, -1)
          ])])) : v("", !0)
        ]),
        default: C(() => [
          p("input", {
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            onClick: n[0] || (n[0] = (w) => e.showSelect = !this.readonly),
            onFocus: n[1] || (n[1] = (w) => e.showSelect = !this.readonly),
            value: r.applyJsTemplate(e.modelValue, t.refLabel),
            readonly: e.readonly
          }, null, 42, tv),
          e.showSelect ? (l(), F(d, {
            key: 0,
            title: r.title,
            onClose: n[6] || (n[6] = (w) => e.showSelect = !1)
          }, {
            body: C(() => [
              D(s, {
                tableId: t.tableId,
                filter: t.filter,
                schemaId: t.schemaId,
                canInsert: r.tablePermission?.canInsert,
                canUpdate: r.tablePermission?.canUpdate,
                canDelete: r.tablePermission?.canDelete,
                onSelect: n[3] || (n[3] = (w) => r.select(w)),
                onDeselect: n[4] || (n[4] = (w) => e.deselect(e.selectIdx))
              }, {
                rowheader: C((w) => [
                  D(a, {
                    onClick: (k) => r.select(w.row)
                  }, {
                    default: C(() => [...n[8] || (n[8] = [
                      B(" Select ", -1)
                    ])]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["tableId", "filter", "schemaId", "canInsert", "canUpdate", "canDelete"])
            ]),
            footer: C(() => [
              D(u, {
                onClick: n[5] || (n[5] = (w) => e.showSelect = !1)
              }, {
                default: C(() => [...n[9] || (n[9] = [
                  B("Close", -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])) : v("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Ai = /* @__PURE__ */ P(ev, [["render", nv]]), iv = {
  name: "InputJson",
  components: { FormGroup: Ue, InputGroup: Ne },
  extends: Ce,
  props: {
    modelValue: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    stringError() {
      if (typeof this.modelValue == "string") {
        try {
          if (!bs(JSON.parse(this.modelValue)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
        return this.errorMessage;
      } else
        return this.errorMessage;
    }
  }
}, ov = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function rv(e, n, t, o, i, r) {
  const a = b("InputGroup"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: C(() => [
      D(a, null, {
        default: C(() => [
          p("textarea", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: t.modelValue,
            onInput: n[0] || (n[0] = (u) => e.$emit("update:modelValue", u.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, ov)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const av = /* @__PURE__ */ P(iv, [["render", rv], ["__scopeId", "data-v-8abd8c88"]]), sv = {
  AUTO_ID: yt,
  HEADING: Oo,
  SECTION: Oo,
  EMAIL: dl,
  HYPERLINK: cl,
  STRING: yt,
  TEXT: Qn,
  JSON: av,
  INT: Ar,
  NON_NEGATIVE_INT: yr,
  LONG: gr,
  DECIMAL: mr,
  BOOL: Li,
  DATE: xi,
  REF: Ai,
  //bootstrap will be deprecated so here we don't differentiate
  SELECT: Ai,
  RADIO: Ai,
  REFBACK: pl,
  FILE: fl,
  DATETIME: qi,
  PERIOD: yt,
  ONTOLOGY: Ri,
  EMAIL_ARRAY: nt,
  BOOL_ARRAY: nt,
  DATE_ARRAY: nt,
  DATETIME_ARRAY: nt,
  PERIOD_ARRAY: nt,
  DECIMAL_ARRAY: nt,
  HYPERLINK_ARRAY: nt,
  INT_ARRAY: nt,
  NON_NEGATIVE_INT_ARRAY: nt,
  LONG_ARRAY: nt,
  ONTOLOGY_ARRAY: Ri,
  REF_ARRAY: mi,
  //bootstrap will be deprecated so here we don't differentiate
  CHECKBOX: mi,
  MULTISELECT: mi,
  STRING_ARRAY: nt,
  TEXT_ARRAY: nt
}, lv = {
  name: "FormInput",
  extends: Ce,
  props: {
    columnType: {
      type: String,
      required: !0
    },
    inplace: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    description: {
      type: String,
      default: null
    },
    editMeta: {
      type: Boolean,
      required: !1
    },
    filter: {
      type: Object,
      required: !1
    },
    pkey: {
      type: Object,
      required: !1,
      default: () => null
    },
    expressionData: {
      type: Object,
      required: !1
    },
    refBackId: {
      type: String,
      required: !1
    },
    refBackType: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  components: {
    InlineInput: Ib,
    ArrayInput: nt,
    InputString: yt,
    InputInt: Ar,
    InputNonNegativeInt: yr,
    InputLong: gr,
    InputDecimal: mr,
    InputBoolean: Li,
    InputDate: xi,
    InputDateTime: qi,
    InputFile: fl,
    InputText: Qn,
    InputHeading: Oo,
    InputOntology: Ri,
    InputRefBack: pl,
    InputRefSelect: Ai
  },
  computed: {
    typeToInput() {
      return sv[this.columnType];
    }
  },
  methods: {
    handleUpdate(e) {
      this.$emit("update:modelValue", e);
    }
  }
}, uv = { key: 1 };
function dv(e, n, t, o, i, r) {
  return l(), F(Et(t.inplace ? "InlineInput" : "span"), {
    value: e.modelValue,
    id: e.id
  }, {
    default: C(() => [
      r.typeToInput ? (l(), F(Et(r.typeToInput), Pn({
        key: 0,
        isMultiSelect: t.columnType === "ONTOLOGY_ARRAY"
      }, e.$props, { "onUpdate:modelValue": r.handleUpdate }), null, 16, ["isMultiSelect", "onUpdate:modelValue"])) : (l(), c("div", uv, "UNSUPPORTED TYPE '" + U(t.columnType) + "'", 1))
    ]),
    _: 1
  }, 8, ["value", "id"]);
}
const cv = /* @__PURE__ */ P(lv, [["render", dv]]), { AUTO_ID: fv } = Tt, pv = {
  name: "RowEdit",
  data() {
    return {
      internalValues: Ve(
        this.defaultValue ? this.defaultValue : this.modelValue
      ),
      refFilter: {}
    };
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    // id: used as html id for components
    id: {
      type: String,
      required: !0
    },
    // tableId: name of the molgenis table loaded
    tableId: {
      type: String,
      required: !0
    },
    // defines the form structure
    tableMetaData: {
      type: Object,
      required: !0
    },
    // pkey:  when updating existing record, this is the primary key value
    pkey: { type: Object },
    // clone: when you want to clone instead of update
    clone: {
      type: Boolean,
      required: !1
    },
    // visibleColumns:  visible columns, useful if you only want to allow partial edit (column of object)
    // examples ['name','description']
    visibleColumns: {
      type: Array,
      required: !1
    },
    // defaultValue: when creating new record, this is initialization value
    defaultValue: {
      type: Object,
      required: !1
    },
    // object with the whole schema, needed to create refLink filter
    schemaMetaData: {
      type: Object,
      required: !0
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    },
    errorPerColumn: {
      type: Object,
      default: () => ({})
    },
    applyDefaultValues: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["update:modelValue"],
  components: {
    FormInput: cv
  },
  computed: {
    shownColumnsWithoutMeta() {
      return (this?.tableMetaData?.columns ? this.tableMetaData.columns.filter(
        (n) => !n.id?.startsWith("mg_") && n.id !== "_mg_top_of_form"
      ) : []).filter(this.showColumn);
    }
  },
  methods: {
    showColumn(e) {
      return e.refLinkId ? this.internalValues[e.refLinkId] : (this.visibleColumns ? this.visibleColumns.includes(e.id) : !0) && this.isVisible(e) && e.id !== "mg_tableclass";
    },
    isVisible(e) {
      try {
        return Qo(
          e,
          this.internalValues,
          this.tableMetaData
        );
      } catch (n) {
        return console.log("isVisible expression error: ", n), this.errorPerColumn[e.id] = n, !0;
      }
    },
    applyComputed() {
      this.tableMetaData.columns.forEach((e) => {
        if (e.computed && e.columnType !== fv)
          try {
            this.internalValues[e.id] = an(
              e.computed,
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            console.log("Computed expression failed: ", n), this.errorPerColumn[e.id] = "Computed expression failed: " + n;
          }
      });
    },
    //update reflink filters and reset values if reflink changes
    async updateRefLinks(e) {
      const n = this.tableMetaData.columns.filter(
        (t) => this.internalValues[e.id] && t.refLinkId === e.id
      );
      for (const t of n) {
        const i = this.schemaMetaData.tables.find(
          (r) => r.id === t.refTableId
        ).columns.filter(
          (r) => r.key === 1 && r.refTableId === e.refTableId
        );
        for (const r of i)
          this.internalValues[t.id] = null, this.refFilter[t.id] = {
            [r.id]: {
              equals: await jn(
                this.internalValues[e.id],
                r.refTableId,
                r.refSchemaId || this.schemaMetaData.schemaId
              )
            }
          };
      }
    },
    handleModelValueUpdate(e, n) {
      this.internalValues[n.id] = e, this.updateRefLinks(n), this.onValuesUpdate();
    },
    onValuesUpdate() {
      this.applyComputed(), this.$emit("update:modelValue", this.internalValues);
    }
  },
  watch: {
    tableMetaData: {
      handler() {
        this.onValuesUpdate();
      },
      deep: !0
    }
  },
  created() {
    this.tableMetaData.columns.forEach((e) => {
      if (this.applyDefaultValues && e.defaultValue && !this.internalValues[e.id])
        if (e.defaultValue.startsWith("="))
          try {
            this.internalValues[e.id] = an(
              "(" + e.defaultValue.substr(1) + ")",
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            this.errorPerColumn[e.id] = "Default value expression failed: " + n;
          }
        else e.columnType === "BOOL" ? this.internalValues[e.id] = hv(
          e.defaultValue
        ) : this.internalValues[e.id] = e.defaultValue;
    }), this.onValuesUpdate();
  }
};
function hv(e) {
  return e === "TRUE" || e === "true" || e === !0 ? !0 : e === "FALSE" || e === "false" || e === !1 ? !1 : void 0;
}
function mv(e, n, t, o, i, r) {
  const a = b("FormInput");
  return l(), c("div", null, [
    (l(!0), c(te, null, oe(r.shownColumnsWithoutMeta, (s) => (l(), F(a, {
      key: JSON.stringify(s),
      id: `${t.id}-${s.id}`,
      modelValue: i.internalValues[s.id],
      expressionData: i.internalValues,
      columnType: s.columnType,
      description: s.description,
      errorMessage: t.errorPerColumn[s.id],
      label: s.formLabel ?? s.label,
      schemaId: s.refSchemaId || t.schemaMetaData.id,
      pkey: t.pkey,
      readonly: s.readonly || t.pkey && s.key === 1 && !t.clone || s.computed !== void 0 && s.computed.trim() !== "",
      refBackId: s.refBackId,
      refLabel: s.refLabel || s.refLabelDefault,
      required: s.required,
      tableId: s.refTableId,
      canEdit: t.canEdit,
      tablePermissions: t.tablePermissions,
      filter: i.refFilter[s.id],
      "onUpdate:modelValue": (u) => r.handleModelValueUpdate(u, s)
    }, null, 8, ["id", "modelValue", "expressionData", "columnType", "description", "errorMessage", "label", "schemaId", "pkey", "readonly", "refBackId", "refLabel", "required", "tableId", "canEdit", "tablePermissions", "filter", "onUpdate:modelValue"]))), 128))
  ]);
}
const Av = /* @__PURE__ */ P(pv, [["render", mv]]), gv = { class: "w-100" }, yv = {
  class: "d-flex",
  style: { gap: "0.5rem" }
}, Kv = /* @__PURE__ */ ke({
  __name: "RowEditFooter",
  props: {
    tableLabel: { default: "" },
    successMessage: {},
    errorMessage: {},
    saveDraftDisabledMessage: {},
    saveDisabledMessage: {}
  },
  setup(e) {
    const n = e, {
      tableLabel: t,
      successMessage: o,
      errorMessage: i,
      saveDraftDisabledMessage: r,
      saveDisabledMessage: a
    } = Mn(n);
    return (s, u) => (l(), c("div", gv, [
      p("div", null, [
        ie(o) ? (l(), F(mn, { key: 0 }, {
          default: C(() => [
            B(U(ie(o)), 1)
          ]),
          _: 1
        })) : v("", !0)
      ]),
      p("div", null, [
        ie(i) ? (l(), F(rt, { key: 0 }, {
          default: C(() => [
            B(U(ie(i)), 1)
          ]),
          _: 1
        })) : v("", !0)
      ]),
      p("div", yv, [
        H(s.$slots, "default"),
        D(ot, {
          onClick: u[0] || (u[0] = (d) => s.$emit("cancel"))
        }, {
          default: C(() => [...u[3] || (u[3] = [
            B(" Close", -1)
          ])]),
          _: 1
        }),
        D(fn, {
          name: "disabled-draft-tooltip",
          value: ie(r) ? ie(r) : "",
          placement: "bottom"
        }, {
          default: C(() => [
            D(Bi, {
              onClick: u[1] || (u[1] = (d) => s.$emit("saveDraft")),
              disabled: !!ie(r),
              class: "mr-2 pr-3"
            }, {
              default: C(() => [...u[4] || (u[4] = [
                B(" Save draft ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"]),
        D(fn, {
          name: "disabled-save-tooltip",
          value: ie(a) ? ie(a) : "",
          placement: "bottom"
        }, {
          default: C(() => [
            D(He, {
              onClick: u[2] || (u[2] = (d) => s.$emit("save")),
              disabled: !!ie(a)
            }, {
              default: C(() => [
                B(" Save " + U(ie(t)), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]));
  }
}), bv = {
  key: 0,
  class: "container"
}, vv = { class: "row" }, Cv = {
  key: 0,
  class: "col-2 border-left chapter-menu overflow-auto",
  style: { "max-height": "calc(100vh - 200px)" }
}, wv = ["onClick"], Fv = { class: "mr-auto" }, Rv = { key: 0 }, kv = /* @__PURE__ */ ke({
  __name: "EditModal",
  props: {
    id: {},
    tableId: {},
    isModalShown: { type: Boolean },
    schemaId: {},
    pkey: {},
    clone: { type: Boolean, default: !1 },
    visibleColumns: {},
    useChapters: { type: [Boolean, null], default: null },
    defaultValue: { default: null },
    applyDefaultValues: { type: Boolean },
    tablePermissions: { default: () => [] }
  },
  emits: ["update:newRow", "close"],
  setup(e, { emit: n }) {
    const t = e, {
      tablePermissions: o,
      applyDefaultValues: i,
      clone: r,
      defaultValue: a,
      id: s,
      pkey: u,
      schemaId: d,
      tableId: f,
      useChapters: K,
      visibleColumns: w
    } = t, { isModalShown: k } = Mn(t), { IS_CHAPTERS_ENABLED_FIELD_NAME: y } = Tt, m = me({}), g = me({}), I = me(), x = me(), E = me(), _ = me(""), q = me(!1), V = me(1), L = me(), $ = me(""), J = n, W = Pe(() => I.value?.label), se = Pe(() => u && r ? "copy" : u ? "update" : "insert"), fe = Pe(
      () => `${se.value} into table: ${W.value} (${f})`
    ), j = Pe(() => {
      const Te = zd(
        I.value?.columns || [],
        w
      ).filter(
        (ht) => {
          if (I.value)
            try {
              return Qo(ht, m.value, I.value);
            } catch (An) {
              return g.value[ht.id] = An, !0;
            }
        }
      ).filter(
        (ht) => !ht.id.startsWith("mg_")
      );
      return Yd(Te).filter(
        (ht) => ht.length > 1
      );
    }), ye = Pe(() => j.value.map((de) => {
      const pe = de.filter(
        (Te) => !!g.value[Te]
      );
      return {
        style: Wd(de, g.value),
        errorFields: pe
      };
    })), S = Pe(() => I.value?.columns.some(
      (pe) => pe.key === 1 && pe.columnType !== "AUTO_ID" && !ee(m.value[pe.id])
    ) ? "Cannot save draft: primary key is required" : ""), M = Pe(() => L.value && j.value.length > 1);
    _a(async () => {
      q.value = !1, E.value = We.newClient(d), x.value = await E.value.fetchSchemaMetaData();
      const de = await E.value.fetchSettings();
      if (K === null ? L.value = de.find(
        (pe) => pe.key === y
      )?.value !== "false" : L.value = !!K, I.value = await E.value.fetchTableMetaData(f), u) {
        const pe = await be();
        r ? m.value = Jd(I.value, pe) : m.value = pe;
      }
      m.value = { ...m.value, ...Ve(a) }, at(), q.value = !0;
    });
    function ee(de) {
      return de != null && de !== "";
    }
    function re(de) {
      V.value = de;
    }
    function Ae() {
      Ee({ ...m.value, mg_draft: !1 });
    }
    function ue() {
      Ee({ ...m.value, mg_draft: !0 });
    }
    async function Ee(de) {
      _.value = "";
      let pe;
      const Te = De(
        de,
        I.value
      );
      u && !r ? pe = await E.value?.updateDataRow(Te, f, d).catch(Be) : pe = await E.value?.insertDataRow(Te, f, d).catch(Be), pe && (J("update:newRow", de), we());
    }
    function De(de, pe) {
      if (pe) {
        let Te = { ...de };
        return pe.columns.forEach((Le) => {
          Le.columnType === "REFBACK" && delete Te[Le.id];
        }), Te;
      } else
        return de;
    }
    function Be(de) {
      de.response?.status === 403 ? _.value = "Schema doesn't exist or permission denied. Do you need to Sign In?" : _.value = de.response?.data?.errors[0]?.message || "An Error occurred during save";
    }
    async function be() {
      if (u) {
        const de = await E.value?.fetchRowData(f, u);
        if (!de)
          _.value = `Error, unable to fetch data for this row (${u})`;
        else
          return de;
      } else
        _.value = "No row key provided";
    }
    function we() {
      _.value = "", J("close");
    }
    function at() {
      I.value && (g.value = Bd(I.value, m.value)), $.value = Xd(g.value);
    }
    function pt(de) {
      const pe = I.value?.columns.find(
        (Te) => Te.id === de
      );
      return pe?.label || pe?.id || de;
    }
    return (de, pe) => (l(), F(vt, {
      title: fe.value,
      show: ie(k),
      onClose: we
    }, {
      body: C(() => [
        q.value && I.value ? (l(), c("div", bv, [
          p("div", vv, [
            p("div", {
              class: G(["overflow-auto mr-n3", { "col-10": M.value, "col-12": !M.value }]),
              style: { "max-height": "calc(100vh - 200px)" }
            }, [
              x.value ? (l(), F(Av, {
                key: 0,
                id: ie(s),
                modelValue: m.value,
                "onUpdate:modelValue": [
                  pe[0] || (pe[0] = (Te) => m.value = Te),
                  at
                ],
                pkey: ie(u),
                tableId: ie(f),
                tableMetaData: I.value,
                schemaMetaData: x.value,
                visibleColumns: L.value ? j.value[V.value - 1] : ie(w),
                clone: ie(r),
                errorPerColumn: g.value,
                applyDefaultValues: ie(i),
                tablePermissions: ie(o)
              }, null, 8, ["id", "modelValue", "pkey", "tableId", "tableMetaData", "schemaMetaData", "visibleColumns", "clone", "errorPerColumn", "applyDefaultValues", "tablePermissions"])) : v("", !0)
            ], 2),
            M.value ? (l(), c("div", Cv, [
              pe[3] || (pe[3] = p("div", { class: "mb-1" }, [
                p("b", null, "Chapters")
              ], -1)),
              (l(!0), c(te, null, oe(j.value, (Te, Le) => (l(), c("div", null, [
                D(fn, {
                  name: `chapter-${Te[0]}-error-tooltip`,
                  value: ye.value[Le].errorFields.length ? `errors in:
${ye.value[Le].errorFields}` : "",
                  placement: "left"
                }, {
                  default: C(() => [
                    p("button", {
                      type: "button",
                      class: G(["btn btn-link", { "font-weight-bold": Le + 1 === V.value }]),
                      onClick: (It) => re(Le + 1),
                      style: Ei(ye.value[Le].style)
                    }, U(pt(Te[0])), 15, wv)
                  ]),
                  _: 2
                }, 1032, ["name", "value"])
              ]))), 256))
            ])) : v("", !0)
          ])
        ])) : v("", !0)
      ]),
      footer: C(() => [
        D(Kv, {
          id: ie(s) + "-footer",
          tableLabel: W.value,
          errorMessage: _.value,
          saveDisabledMessage: $.value,
          saveDraftDisabledMessage: S.value,
          onCancel: we,
          onSaveDraft: ue,
          onSave: Ae
        }, {
          default: C(() => [
            p("div", Fv, [
              M.value ? (l(), c("div", Rv, [
                D(He, {
                  onClick: pe[1] || (pe[1] = (Te) => re(V.value - 1)),
                  disabled: V.value <= 1,
                  class: "mr-2 pr-3"
                }, {
                  default: C(() => [...pe[4] || (pe[4] = [
                    p("i", {
                      class: G("fas fa-fw fa-chevron-left")
                    }, null, -1),
                    B(" Previous ", -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"]),
                D(He, {
                  onClick: pe[2] || (pe[2] = (Te) => re(V.value + 1)),
                  disabled: V.value >= j.value.length,
                  class: "pl-3"
                }, {
                  default: C(() => [...pe[5] || (pe[5] = [
                    B(" Next ", -1),
                    p("i", {
                      class: G("fas fa-fw fa-chevron-right")
                    }, null, -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"])
              ])) : v("", !0)
            ])
          ]),
          _: 1
        }, 8, ["id", "tableLabel", "errorMessage", "saveDisabledMessage", "saveDraftDisabledMessage"])
      ]),
      _: 1
    }, 8, ["title", "show"]));
  }
}), br = /* @__PURE__ */ P(kv, [["__scopeId", "data-v-6f6bd0fd"]]), hl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: br
}, Symbol.toStringTag, { value: "Module" })), Uv = {
  directives: {
    clickOutside: Vi.directive
  },
  props: {
    buttonText: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    closeSelf(e) {
      this.$refs.HtmlDropdownMain.removeAttribute("open");
    }
  },
  computed: {
    buttonstateClass() {
      return this.active ? "bg-secondary text-white" : "border border-secondary";
    },
    containerstateClass() {
      return this.active ? "text-dark" : "";
    }
  }
};
function Ev(e, n, t, o, i, r) {
  const a = Ui("click-outside");
  return l(), c("details", {
    class: G(["dropdown-button p-0", r.buttonstateClass]),
    ref: "HtmlDropdownMain"
  }, [
    p("summary", null, [
      B(U(t.buttonText) + " ", 1),
      H(e.$slots, "counter", {}, void 0, !0),
      n[2] || (n[2] = p("span", { class: "fa-solid fa-caret-down" }, null, -1))
    ]),
    Ye((l(), c("div", null, [
      p("div", {
        class: G(["dropdown bg-white", r.containerstateClass]),
        onClick: n[0] || (n[0] = Ke(() => {
        }, ["stop"]))
      }, [
        H(e.$slots, "default", {}, void 0, !0)
      ], 2),
      p("div", {
        class: "close",
        onClick: n[1] || (n[1] = (...s) => r.closeSelf && r.closeSelf(...s))
      })
    ])), [
      [a, r.closeSelf]
    ])
  ], 2);
}
const _R = /* @__PURE__ */ P(Uv, [["render", Ev], ["__scopeId", "data-v-49b9263b"]]), Sv = {}, Tv = { style: { display: "flex", "align-self": "flex-end" } };
function Iv(e, n, t, o, i, r) {
  return l(), c("div", Tv, [
    p("label", null, [
      H(e.$slots, "default")
    ])
  ]);
}
const PR = /* @__PURE__ */ P(Sv, [["render", Iv]]), Dv = {
  name: "Info",
  data() {
    return {
      show: !1
    };
  }
}, Ov = { class: "tooltip-inner" };
function _v(e, n, t, o, i, r) {
  return l(), c("div", null, [
    p("span", {
      onMouseenter: n[0] || (n[0] = (a) => i.show = !0),
      onMouseleave: n[1] || (n[1] = (a) => i.show = !1)
    }, [...n[2] || (n[2] = [
      p("i", { class: "fa fa-question-circle text-primary" }, null, -1)
    ])], 32),
    p("div", {
      class: G(["tooltip bs-tooltip-top", { show: i.show }])
    }, [
      p("span", Ov, [
        p("span", null, [
          H(e.$slots, "default")
        ])
      ]),
      n[3] || (n[3] = p("span", { class: "arrow" }, null, -1))
    ], 2)
  ]);
}
const MR = /* @__PURE__ */ P(Dv, [["render", _v]]), Pv = {
  name: "InfoPopover",
  props: {
    boldText: {
      type: Boolean,
      default: !1
    },
    faIcon: {
      type: String,
      default: "fa-question-circle"
    },
    textColor: {
      type: String,
      default: "text-info"
    },
    iconBeforeLabel: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    popoverPlacement: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      isActive: !1
    };
  },
  computed: {
    placementClass() {
      return `tooltip-${this.popoverPlacement}`;
    }
  },
  methods: {
    activateTooltip() {
      this.updateTooltipPlacement(), this.isActive = !0;
    },
    deactivateTooltip() {
      this.isActive = !1;
    },
    updateTooltipPlacement() {
      if (!this.$refs.tooltipTrigger || !this.$refs.tooltipContent)
        return;
      const e = this.$refs.tooltipTrigger.getBoundingClientRect(), n = this.$refs.tooltipContent.getBoundingClientRect(), t = this.calculatePlacementStyle(
        e,
        n
      );
      Object.assign(this.$refs.tooltipContent.style, t);
    },
    calculatePlacementStyle(e, n) {
      const t = {};
      switch (this.popoverPlacement) {
        case "right":
          t.left = `${e.right + window.scrollX + 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "left":
          t.right = `${window.innerWidth - e.left + window.scrollX - 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "bottom":
          t.top = `${e.bottom + window.scrollY + 8}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
        default:
          t.top = `${e.top - n.height - 8 + window.scrollY}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
      }
      return t;
    }
  }
}, Mv = { key: 0 }, Nv = { key: 1 };
function Bv(e, n, t, o, i, r) {
  return l(), c("span", {
    class: G({ "font-weight-bold": t.boldText })
  }, [
    p("div", {
      class: "w3tooltip",
      tabindex: "0",
      onClick: n[0] || (n[0] = Ke(() => {
      }, ["prevent"])),
      onMouseenter: n[1] || (n[1] = (...a) => r.activateTooltip && r.activateTooltip(...a)),
      onMouseleave: n[2] || (n[2] = (...a) => r.deactivateTooltip && r.deactivateTooltip(...a)),
      onFocus: n[3] || (n[3] = (...a) => r.activateTooltip && r.activateTooltip(...a)),
      onBlur: n[4] || (n[4] = (...a) => r.deactivateTooltip && r.deactivateTooltip(...a)),
      ref: "tooltipTrigger"
    }, [
      t.label && !t.iconBeforeLabel ? (l(), c("span", Mv, U(t.label), 1)) : v("", !0),
      p("span", {
        class: G(["fa d-inline-block", [
          t.label ? t.iconBeforeLabel ? "mr-1" : "ml-1" : "",
          t.faIcon,
          t.textColor
        ]]),
        "aria-hidden": "true"
      }, null, 2),
      t.label && t.iconBeforeLabel ? (l(), c("span", Nv, U(t.label), 1)) : v("", !0)
    ], 544),
    (l(), F(xl, { to: "body" }, [
      p("span", {
        class: G(["tooltiptext", [r.placementClass, { active: i.isActive }]]),
        ref: "tooltipContent"
      }, [
        H(e.$slots, "default", {}, void 0, !0)
      ], 2)
    ]))
  ], 2);
}
const NR = /* @__PURE__ */ P(Pv, [["render", Bv], ["__scopeId", "data-v-b1569d5a"]]), Lv = {
  extends: Ce,
  components: {
    FormGroup: Ue,
    MessageError: rt
  },
  props: {
    options: { type: Array, required: !0 },
    noOptionsProvidedMessage: { type: String, default: "No options provided" }
  },
  methods: {
    updateModelValue: function(e) {
      this.$emit("update:modelValue", e == "" ? null : e);
    }
  }
}, xv = ["id", "modelValue", "readonly"], qv = ["selected"], Vv = ["value", "selected"], jv = ["id", "value"];
function Hv(e, n, t, o, i, r) {
  const a = b("MessageError"), s = b("FormGroup");
  return l(), F(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      !t.options || !t.options.length ? (l(), F(a, { key: 0 }, {
        default: C(() => [
          B(U(t.noOptionsProvidedMessage), 1)
        ]),
        _: 1
      })) : e.readonly ? (l(), c("input", {
        key: 2,
        id: e.id,
        class: "form-control",
        type: "text",
        readonly: "",
        value: e.modelValue
      }, null, 8, jv)) : (l(), c("select", {
        key: 1,
        id: e.id,
        modelValue: e.modelValue,
        readonly: e.readonly,
        class: "form-control",
        onChange: n[0] || (n[0] = (u) => r.updateModelValue(u.target.value))
      }, [
        e.required ? v("", !0) : (l(), c("option", {
          key: 0,
          selected: e.modelValue === void 0 || e.modelValue === null
        }, U(e.placeholder), 9, qv)),
        (l(!0), c(te, null, oe(t.options, (u, d) => (l(), c("option", {
          key: d + u,
          value: u,
          selected: e.modelValue == u
        }, U(u), 9, Vv))), 128))
      ], 40, xv))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Tn = /* @__PURE__ */ P(Lv, [["render", Hv]]), Gv = {
  directives: {
    clickOutside: Vi.directive
  },
  extends: Ce,
  components: {
    IconAction: ft
  },
  props: {
    options: Array
  },
  data() {
    return {
      focus: !1
    };
  },
  methods: {
    select(e) {
      this.toggleFocus(), this.$emit("update:modelValue", e);
    },
    toggleFocus() {
      this.focus = !this.focus;
    }
  }
}, Qv = {
  key: 0,
  class: "dropdown show"
}, $v = { class: "dropdown-menu show" }, Jv = ["onClick"];
function zv(e, n, t, o, i, r) {
  const a = b("IconAction"), s = Ui("click-outside");
  return l(), c("span", null, [
    i.focus ? Ye((l(), c("span", Qv, [
      p("span", $v, [
        e.required ? v("", !0) : (l(), c("button", {
          class: "btn btn-link dropdown-item",
          key: "empty-option",
          onClick: n[0] || (n[0] = Ke((u) => r.select(void 0), ["prevent"]))
        }, "   ")),
        (l(!0), c(te, null, oe(t.options, (u) => (l(), c("button", {
          class: G(["btn btn-link dropdown-item", { "text-primary": e.modelValue === u }]),
          key: u,
          onClick: Ke((d) => r.select(u), ["prevent"])
        }, U(u), 11, Jv))), 128))
      ])
    ])), [
      [s, r.toggleFocus]
    ]) : v("", !0),
    p("span", {
      onClick: n[1] || (n[1] = (...u) => r.toggleFocus && r.toggleFocus(...u)),
      onMouseover: n[2] || (n[2] = (u) => e.hover = !0),
      onMouseleave: n[3] || (n[3] = (u) => e.hover = !1),
      class: "inline-select"
    }, [
      B(U(e.modelValue) + " ", 1),
      D(a, {
        icon: "pencil-alt",
        class: "hoverIcon"
      })
    ], 32)
  ]);
}
const BR = /* @__PURE__ */ P(Gv, [["render", zv], ["__scopeId", "data-v-25a3f2e9"]]), Yv = {
  extends: Ce,
  //gives us 'options'
  components: {
    InputSelect: Tn,
    InputText: Qn,
    FormGroup: Ue,
    InputGroup: Ne
  },
  props: {
    locales: {
      type: Array,
      default: () => ["en"]
    }
  },
  data() {
    return {
      localeSelect: void 0
      //for selecting locale
    };
  },
  mounted() {
    const e = Array.isArray(this.modelValue) ? Ve(this.modelValue) : [{ locale: "en", value: "" }], n = Wv(this.locales, e);
    this.$emit("update:modelValue", n);
  }
};
function Wv(e, n) {
  let t = [...n];
  return e.forEach((o) => {
    o && !n.find((i) => i.locale === o) && t.push({ locale: o, value: "" }), n.find((i) => i.locale === "en") || t.push({ locale: o, value: "en" });
  }), t;
}
const Xv = { class: "table table-bordered table-sm mb-0" }, Zv = {
  key: 0,
  class: "pt-0 td-shrink text-right"
}, eC = { class: "p-0" };
function tC(e, n, t, o, i, r) {
  const a = b("InputText"), s = b("InputGroup"), u = b("FormGroup");
  return l(), F(u, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: C(() => [
      D(s, null, {
        default: C(() => [
          p("table", Xv, [
            (l(!0), c(te, null, oe(e.modelValue, (d, f) => (l(), c("tr", null, [
              e.modelValue.length > 1 ? (l(), c("td", Zv, U(d.locale) + ": ", 1)) : v("", !0),
              p("td", eC, [
                D(a, {
                  id: e.id + ":" + d.locale,
                  modelValue: e.modelValue[f].value,
                  "onUpdate:modelValue": (K) => e.modelValue[f].value = K,
                  class: "mb-0",
                  onInput: n[0] || (n[0] = () => {
                  })
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
              ])
            ]))), 256))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const LR = /* @__PURE__ */ P(Yv, [["render", tC]]), nC = {
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, iC = { class: "tooltip-component" }, oC = { class: "tooltip-text px-2" };
function rC(e, n, t, o, i, r) {
  return l(), c("div", iC, [
    H(e.$slots, "default", {}, () => [
      n[0] || (n[0] = B(" Default ", -1))
    ], !0),
    p("div", oC, U(t.text), 1)
  ]);
}
const xR = /* @__PURE__ */ P(nC, [["render", rC], ["__scopeId", "data-v-fa2001de"]]), aC = {
  name: "Breadcrumb",
  components: {
    InputSearch: pr,
    RouterLink: Ql
  },
  props: {
    /* list of crumbs, map of  {'label':'url'} */
    crumbs: Object,
    /* list of dropdown, map of  {'label':'url'} */
    dropdown: Object,
    useRouterLink: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showDropdown: !1,
      dropdownSearch: ""
    };
  },
  computed: {
    lastKey() {
      return Object.keys(this.crumbs)[Object.keys(this.crumbs).length - 1];
    },
    dropdownFiltered() {
      return this.dropdownSearch ? Object.fromEntries(
        Object.entries(this.dropdown).filter(
          ([e, n]) => e.toLowerCase().includes(this.dropdownSearch.toLowerCase())
        )
      ) : this.dropdown;
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  }
}, sC = { "aria-label": "breadcrumb" }, lC = { class: "breadcrumb" }, uC = {
  key: 0,
  class: "router-link"
}, dC = {
  key: 0,
  "aria-current": "page"
}, cC = {
  key: 1,
  class: "atag"
}, fC = {
  key: 0,
  "aria-current": "page"
}, pC = ["href"], hC = { class: "dropdown" }, mC = { key: 0 }, AC = {
  key: 0,
  class: "router-link"
}, gC = {
  key: 1,
  class: "atag"
}, yC = ["href"], KC = { key: 2 };
function bC(e, n, t, o, i, r) {
  const a = b("router-link"), s = b("InputSearch");
  return l(), c("nav", sC, [
    p("ol", lC, [
      (l(!0), c(te, null, oe(t.crumbs, (u, d, f) => (l(), c("li", {
        key: d,
        class: G(["breadcrumb-item", { active: d === r.lastKey }])
      }, [
        t.useRouterLink ? (l(), c("span", uC, [
          d === r.lastKey ? (l(), c("a", dC, U(d), 1)) : (l(), F(a, {
            key: 1,
            to: u
          }, {
            default: C(() => [
              B(U(d), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        ])) : (l(), c("span", cC, [
          d === r.lastKey ? (l(), c("a", fC, U(d), 1)) : (l(), c("a", {
            key: 1,
            href: u
          }, U(d), 9, pC))
        ])),
        p("span", hC, [
          t.dropdown && f === 0 ? (l(), c("span", mC, [
            p("i", {
              class: "text-primary dropdown-toggle dropdown-toggle-split pr-0",
              onClick: n[0] || (n[0] = (...K) => r.toggleDropdown && r.toggleDropdown(...K))
            }),
            p("div", {
              class: G(["dropdown-menu", { show: i.showDropdown }])
            }, [
              D(s, {
                id: "breadcrumb-dropdown-search",
                modelValue: i.dropdownSearch,
                "onUpdate:modelValue": n[1] || (n[1] = (K) => i.dropdownSearch = K),
                isClearBtnShown: !0,
                isEmitOnType: !0
              }, null, 8, ["modelValue"]),
              t.useRouterLink ? (l(), c("span", AC, [
                (l(!0), c(te, null, oe(r.dropdownFiltered, (K, w, k) => (l(), F(a, {
                  class: "dropdown-item text-primary",
                  to: K,
                  key: `${k}_routerlink`
                }, {
                  default: C(() => [
                    B(U(w), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))), 128))
              ])) : (l(), c("span", gC, [
                (l(!0), c(te, null, oe(r.dropdownFiltered, (K, w, k) => (l(), c("a", {
                  class: "dropdown-item text-primary",
                  href: K,
                  key: k
                }, U(w), 9, yC))), 128))
              ])),
              Object.keys(r.dropdownFiltered).length === 0 ? (l(), c("span", KC, " nothing found ")) : v("", !0)
            ], 2)
          ])) : v("", !0)
        ])
      ], 2))), 128))
    ])
  ]);
}
const vC = /* @__PURE__ */ P(aC, [["render", bC]]);
function CC(e) {
  return ql() ? (Vl(e), !0) : !1;
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var At = {}, va;
function wC() {
  if (va) return At;
  va = 1, Object.defineProperty(At, "__esModule", { value: !0 }), At.parseCookie = s, At.parse = s, At.stringifyCookie = u, At.stringifySetCookie = d, At.serialize = d, At.parseSetCookie = f, At.stringifySetCookie = d, At.serialize = d;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, n = /^[\u0021-\u003A\u003C-\u007E]*$/, t = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, o = /^[\u0020-\u003A\u003D-\u007E]*$/, i = /^-?\d+$/, r = Object.prototype.toString, a = /* @__PURE__ */ (() => {
    const g = function() {
    };
    return g.prototype = /* @__PURE__ */ Object.create(null), g;
  })();
  function s(g, I) {
    const x = new a(), E = g.length;
    if (E < 2)
      return x;
    const _ = I?.decode || y;
    let q = 0;
    do {
      const V = w(g, q, E);
      if (V === -1)
        break;
      const L = K(g, q, E);
      if (V > L) {
        q = g.lastIndexOf(";", V - 1) + 1;
        continue;
      }
      const $ = k(g, q, V);
      x[$] === void 0 && (x[$] = _(k(g, V + 1, L))), q = L + 1;
    } while (q < E);
    return x;
  }
  function u(g, I) {
    const x = I?.encode || encodeURIComponent, E = [];
    for (const _ of Object.keys(g)) {
      const q = g[_];
      if (q === void 0)
        continue;
      if (!e.test(_))
        throw new TypeError(`cookie name is invalid: ${_}`);
      const V = x(q);
      if (!n.test(V))
        throw new TypeError(`cookie val is invalid: ${q}`);
      E.push(`${_}=${V}`);
    }
    return E.join("; ");
  }
  function d(g, I, x) {
    const E = typeof g == "object" ? g : { ...x, name: g, value: String(I) }, q = (typeof I == "object" ? I : x)?.encode || encodeURIComponent;
    if (!e.test(E.name))
      throw new TypeError(`argument name is invalid: ${E.name}`);
    const V = E.value ? q(E.value) : "";
    if (!n.test(V))
      throw new TypeError(`argument val is invalid: ${E.value}`);
    let L = E.name + "=" + V;
    if (E.maxAge !== void 0) {
      if (!Number.isInteger(E.maxAge))
        throw new TypeError(`option maxAge is invalid: ${E.maxAge}`);
      L += "; Max-Age=" + E.maxAge;
    }
    if (E.domain) {
      if (!t.test(E.domain))
        throw new TypeError(`option domain is invalid: ${E.domain}`);
      L += "; Domain=" + E.domain;
    }
    if (E.path) {
      if (!o.test(E.path))
        throw new TypeError(`option path is invalid: ${E.path}`);
      L += "; Path=" + E.path;
    }
    if (E.expires) {
      if (!m(E.expires) || !Number.isFinite(E.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${E.expires}`);
      L += "; Expires=" + E.expires.toUTCString();
    }
    if (E.httpOnly && (L += "; HttpOnly"), E.secure && (L += "; Secure"), E.partitioned && (L += "; Partitioned"), E.priority)
      switch (typeof E.priority == "string" ? E.priority.toLowerCase() : void 0) {
        case "low":
          L += "; Priority=Low";
          break;
        case "medium":
          L += "; Priority=Medium";
          break;
        case "high":
          L += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${E.priority}`);
      }
    if (E.sameSite)
      switch (typeof E.sameSite == "string" ? E.sameSite.toLowerCase() : E.sameSite) {
        case !0:
        case "strict":
          L += "; SameSite=Strict";
          break;
        case "lax":
          L += "; SameSite=Lax";
          break;
        case "none":
          L += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${E.sameSite}`);
      }
    return L;
  }
  function f(g, I) {
    const x = I?.decode || y, E = g.length, _ = K(g, 0, E), q = w(g, 0, _), V = q === -1 ? { name: "", value: x(k(g, 0, _)) } : {
      name: k(g, 0, q),
      value: x(k(g, q + 1, _))
    };
    let L = _ + 1;
    for (; L < E; ) {
      const $ = K(g, L, E), J = w(g, L, $), W = J === -1 ? k(g, L, $) : k(g, L, J), se = J === -1 ? void 0 : k(g, J + 1, $);
      switch (W.toLowerCase()) {
        case "httponly":
          V.httpOnly = !0;
          break;
        case "secure":
          V.secure = !0;
          break;
        case "partitioned":
          V.partitioned = !0;
          break;
        case "domain":
          V.domain = se;
          break;
        case "path":
          V.path = se;
          break;
        case "max-age":
          se && i.test(se) && (V.maxAge = Number(se));
          break;
        case "expires":
          if (!se)
            break;
          const fe = new Date(se);
          Number.isFinite(fe.valueOf()) && (V.expires = fe);
          break;
        case "priority":
          if (!se)
            break;
          const j = se.toLowerCase();
          (j === "low" || j === "medium" || j === "high") && (V.priority = j);
          break;
        case "samesite":
          if (!se)
            break;
          const ye = se.toLowerCase();
          (ye === "lax" || ye === "strict" || ye === "none") && (V.sameSite = ye);
          break;
      }
      L = $ + 1;
    }
    return V;
  }
  function K(g, I, x) {
    const E = g.indexOf(";", I);
    return E === -1 ? x : E;
  }
  function w(g, I, x) {
    const E = g.indexOf("=", I);
    return E < x ? E : -1;
  }
  function k(g, I, x) {
    let E = I, _ = x;
    do {
      const q = g.charCodeAt(E);
      if (q !== 32 && q !== 9)
        break;
    } while (++E < _);
    for (; _ > E; ) {
      const q = g.charCodeAt(_ - 1);
      if (q !== 32 && q !== 9)
        break;
      _--;
    }
    return g.slice(E, _);
  }
  function y(g) {
    if (g.indexOf("%") === -1)
      return g;
    try {
      return decodeURIComponent(g);
    } catch {
      return g;
    }
  }
  function m(g) {
    return r.call(g) === "[object Date]";
  }
  return At;
}
var gi = /* @__PURE__ */ wC();
function FC() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function RC(e, n) {
  return typeof e == "string" ? gi.parse(e, n) : typeof e == "object" && e !== null ? e : {};
}
function kC(e, n) {
  return typeof n > "u" && (n = !e || e[0] !== "{" && e[0] !== "[" && e[0] !== '"'), !n;
}
function Ca(e, n) {
  n === void 0 && (n = {});
  var t = UC(e);
  if (kC(t, n.doNotParse))
    try {
      return JSON.parse(t);
    } catch {
    }
  return e;
}
function UC(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
var Nt = function() {
  return Nt = Object.assign || function(e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) {
      n = arguments[t];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, Nt.apply(this, arguments);
}, EC = (
  /** @class */
  (function() {
    function e(n, t) {
      var o = this;
      this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = RC(n, t), new Promise(function() {
        o.HAS_DOCUMENT_COOKIE = FC();
      }).catch(function() {
      });
    }
    return e.prototype._updateBrowserValues = function(n) {
      this.HAS_DOCUMENT_COOKIE && (this.cookies = gi.parse(document.cookie, n));
    }, e.prototype._emitChange = function(n) {
      for (var t = 0; t < this.changeListeners.length; ++t)
        this.changeListeners[t](n);
    }, e.prototype.get = function(n, t, o) {
      return t === void 0 && (t = {}), this._updateBrowserValues(o), Ca(this.cookies[n], t);
    }, e.prototype.getAll = function(n, t) {
      n === void 0 && (n = {}), this._updateBrowserValues(t);
      var o = {};
      for (var i in this.cookies)
        o[i] = Ca(this.cookies[i], n);
      return o;
    }, e.prototype.set = function(n, t, o) {
      var i;
      typeof t == "object" && (t = JSON.stringify(t)), this.cookies = Nt(Nt({}, this.cookies), (i = {}, i[n] = t, i)), this.HAS_DOCUMENT_COOKIE && (document.cookie = gi.serialize(n, t, o)), this._emitChange({ name: n, value: t, options: o });
    }, e.prototype.remove = function(n, t) {
      var o = t = Nt(Nt({}, t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
      this.cookies = Nt({}, this.cookies), delete this.cookies[n], this.HAS_DOCUMENT_COOKIE && (document.cookie = gi.serialize(n, "", o)), this._emitChange({ name: n, value: void 0, options: t });
    }, e.prototype.addChangeListener = function(n) {
      this.changeListeners.push(n);
    }, e.prototype.removeChangeListener = function(n) {
      var t = this.changeListeners.indexOf(n);
      t >= 0 && this.changeListeners.splice(t, 1);
    }, e;
  })()
);
function SC(e, { doNotParse: n = !1, autoUpdateDependencies: t = !1 } = {}, o = new EC()) {
  const i = t ? [...e || []] : e;
  let r = o.getAll({ doNotParse: !0 });
  const a = me(0), s = () => {
    const u = o.getAll({ doNotParse: !0 });
    TC(
      i || null,
      u,
      r
    ) && a.value++, r = u;
  };
  return o.addChangeListener(s), CC(() => {
    o.removeChangeListener(s);
  }), {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...u) => (t && i && !i.includes(u[0]) && i.push(u[0]), a.value, o.get(u[0], { doNotParse: n, ...u[1] })),
    /**
     * Reactive get all cookies
     */
    getAll: (...u) => (a.value, o.getAll({ doNotParse: n, ...u[0] })),
    set: (...u) => o.set(...u),
    remove: (...u) => o.remove(...u),
    addChangeListener: (...u) => o.addChangeListener(...u),
    removeChangeListener: (...u) => o.removeChangeListener(...u)
  };
}
function TC(e, n, t) {
  if (!e)
    return !0;
  for (const o of e)
    if (n[o] !== t[o])
      return !0;
  return !1;
}
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const _o = (e) => typeof e == "function", IC = Object.prototype.toString, DC = (e) => IC.call(e), ho = (e) => DC(e) === "[object Object]";
function Po(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function wa(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Mo(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? wa(Object(t), !0).forEach(function(o) {
      Po(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wa(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
var OC = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(o, i) {
    if (!(typeof document > "u")) {
      var r = document.head || document.getElementsByTagName("head")[0], a = document.createElement("script");
      if (a.async = !0, a.src = n, a.defer = t.defer, t.preconnectOrigin) {
        var s = document.createElement("link");
        s.href = t.preconnectOrigin, s.rel = "preconnect", r.appendChild(s);
      }
      r.appendChild(a), a.onload = o, a.onerror = i;
    }
  });
}, _C = function e(n) {
  for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    o[i - 1] = arguments[i];
  if (!o.length)
    return n;
  var r = o.shift();
  if (!(!ho(n) || !ho(r))) {
    for (var a in r)
      ho(r[a]) ? (n[a] || Object.assign(n, Po({}, a, {})), e(n[a], r[a])) : Object.assign(n, Po({}, a, r[a]));
    return e.apply(void 0, [n].concat(o));
  }
}, $n = function() {
  return !(typeof window > "u" || typeof document > "u");
}, Fa = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  !$n() || process.env.NODE_ENV === "production" || t && console.warn("[vue-gtag] ".concat(n));
}, PC = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Fa('Missing "appName" property inside the plugin options.', n.app_name == null), Fa('Missing "name" property in the route.', n.screen_name == null), n;
};
function MC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", t = e.split("/"), o = n.split("/");
  return t[0] === "" && n[n.length - 1] === "/" && t.shift(), o.join("/") + t.join("/");
}
var NC = function() {
  return {
    bootstrap: !0,
    onReady: null,
    onError: null,
    onBeforeTrack: null,
    onAfterTrack: null,
    pageTrackerTemplate: null,
    customResourceURL: "https://www.googletagmanager.com/gtag/js",
    customPreconnectOrigin: "https://www.googletagmanager.com",
    deferScriptLoad: !1,
    pageTrackerExcludedRoutes: [],
    pageTrackerEnabled: !0,
    enabled: !0,
    disableScriptLoad: !1,
    pageTrackerScreenviewEnabled: !1,
    appName: null,
    pageTrackerUseFullPath: !1,
    pageTrackerPrependBase: !0,
    pageTrackerSkipSamePath: !0,
    globalDataLayerName: "dataLayer",
    globalObjectName: "gtag",
    defaultGroupName: "default",
    includes: null,
    config: {
      id: null,
      params: {
        send_page_view: !1
      }
    }
  };
}, ml = {}, BC = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = NC();
  ml = _C(t, n);
}, Ct = function() {
  return ml;
}, No = (function() {
  var e, n = Ct(), t = n.globalObjectName;
  !$n() || typeof window[t] > "u" || (e = window)[t].apply(e, arguments);
}), Ra = function(n, t) {
  $n() && (window["ga-disable-".concat(n)] = t);
}, LC = (function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, n = Ct(), t = n.config, o = n.includes;
  Ra(t.id, e), Array.isArray(o) && o.forEach(function(i) {
    return Ra(i.id, e);
  });
}), xC = (function() {
  LC(!0);
}), qC, vr = function() {
  return qC;
}, Al = (function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = Ct(), o = t.includes, i = t.defaultGroupName;
  n.send_to == null && Array.isArray(o) && o.length && (n.send_to = o.map(function(r) {
    return r.id;
  }).concat(i)), No("event", e, n);
}), VC = (function(e) {
  if ($n()) {
    var n;
    if (typeof e == "string")
      n = {
        page_path: e
      };
    else if (e.path || e.fullPath) {
      var t = Ct(), o = t.pageTrackerUseFullPath, i = t.pageTrackerPrependBase, r = vr(), a = r && r.options.base, s = o ? e.fullPath : e.path;
      n = Mo(Mo({}, e.name && {
        page_title: e.name
      }), {}, {
        page_path: i ? MC(s, a) : s
      });
    } else
      n = e;
    n.page_location == null && (n.page_location = window.location.href), n.send_page_view == null && (n.send_page_view = !0), Al("page_view", n);
  }
}), jC = (function(e) {
  var n = Ct(), t = n.appName;
  if (e) {
    var o;
    typeof e == "string" ? o = {
      screen_name: e
    } : o = e, o.app_name = o.app_name || t, Al("screen_view", o);
  }
}), HC = (function() {
  if ($n()) {
    var e = Ct(), n = e.enabled, t = e.globalObjectName, o = e.globalDataLayerName;
    return window[t] == null && (window[o] = window[o] || [], window[t] = function() {
      window[o].push(arguments);
    }), window[t]("js", /* @__PURE__ */ new Date()), n || xC(), window[t];
  }
}), ka = function(n) {
  return Mo({
    send_page_view: !1
  }, n);
}, gl = (function() {
  var e = Ct(), n = e.config, t = e.includes;
  No("config", n.id, ka(n.params)), Array.isArray(t) && t.forEach(function(o) {
    No("config", o.id, ka(o.params));
  });
}), Ua = (function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = Ct(), o = t.appName, i = t.pageTrackerTemplate, r = t.pageTrackerScreenviewEnabled, a = t.pageTrackerSkipSamePath;
  if (!(a && e.path === n.path)) {
    var s = e;
    if (_o(i) ? s = i(e, n) : r && (s = PC({
      app_name: o,
      screen_name: e.name
    })), r) {
      jC(s);
      return;
    }
    VC(s);
  }
}), Ea = function(n) {
  var t = Ct(), o = t.pageTrackerExcludedRoutes;
  return o.includes(n.path) || o.includes(n.name);
}, GC = (function() {
  var e = Ct(), n = e.onBeforeTrack, t = e.onAfterTrack, o = vr();
  o.isReady().then(function() {
    yi().then(function() {
      var i = o.currentRoute;
      gl(), !Ea(i.value) && Ua(i.value);
    }), o.afterEach(function(i, r) {
      yi().then(function() {
        Ea(i) || (_o(n) && n(i, r), Ua(i, r), _o(t) && t(i, r));
      });
    });
  });
}), QC = (function() {
  var e = Ct(), n = e.onReady, t = e.onError, o = e.globalObjectName, i = e.globalDataLayerName, r = e.config, a = e.customResourceURL, s = e.customPreconnectOrigin, u = e.deferScriptLoad, d = e.pageTrackerEnabled, f = e.disableScriptLoad, K = !!(d && vr());
  if (HC(), K ? GC() : gl(), !f)
    return OC("".concat(a, "?id=").concat(r.id, "&l=").concat(i), {
      preconnectOrigin: s,
      defer: u
    }).then(function() {
      n && n(window[o]);
    }).catch(function(w) {
      return t && t(w), w;
    });
});
const $C = {
  name: "GTag",
  props: {
    tagId: {
      type: String,
      required: !0
    }
  },
  methods: {
    enablePlugin(e) {
      BC({
        config: { id: e }
      }), QC().then((n) => {
        console.log("start analytics for tagId: " + e);
      });
    }
  },
  async mounted() {
    this.enablePlugin(this.tagId);
  }
};
function JC(e, n, t, o, i, r) {
  return l(), c("div");
}
const zC = /* @__PURE__ */ P($C, [["render", JC]]), YC = ["innerHTML"], WC = { key: 1 }, XC = {
  __name: "CookieWall",
  props: {
    title: {
      type: String,
      default: "Would you like a cookie?"
    },
    acceptLabel: {
      type: String,
      default: "Accept"
    },
    rejectLabel: {
      type: String,
      default: "No thanks"
    },
    analyticsId: {
      type: String
    },
    htmlContentString: {
      type: String | null,
      default: null
    }
  },
  emits: ["acceptCookie"],
  setup(e, { emit: n }) {
    const t = SC(["mg_allow_analytics"]), o = n;
    let i = me(!1);
    const r = Pe(() => t.get("mg_allow_analytics") === void 0), a = {
      path: "/",
      maxAge: 1704085200,
      // one year,
      httpOnly: !1
    };
    function s() {
      t.set("mg_allow_analytics", !0, a), o("acceptCookie", !0), window.location.reload();
    }
    function u() {
      t.set("mg_allow_analytics", !1, a), o("acceptCookie", !1);
    }
    function d() {
      i.value = !0, o("acceptCookie", void 0);
    }
    const f = Pe(() => t.get("mg_allow_analytics") === !0);
    return (K, w) => (l(), c(te, null, [
      D(vt, {
        title: e.title,
        onClose: d,
        show: r.value && !ie(i)
      }, {
        body: C(() => [
          e.htmlContentString ? (l(), c("div", {
            key: 0,
            innerHTML: e.htmlContentString
          }, null, 8, YC)) : (l(), c("div", WC, [...w[0] || (w[0] = [
            p("p", null, ' We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, and personalize content. By clicking "Accept," you consent to the use of cookies. ', -1),
            p("p", null, " We value your privacy and are committed to protecting your personal information. Our use of cookies is solely for improving your experience on our website and ensuring its functionality. We do not sell or share your data with third parties. ", -1)
          ])]))
        ]),
        footer: C(() => [
          D(ot, { onClick: u }, {
            default: C(() => [
              B(U(e.rejectLabel), 1)
            ]),
            _: 1
          }),
          D(He, { onClick: s }, {
            default: C(() => [
              B(U(e.acceptLabel), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "show"]),
      f.value ? (l(), F(zC, {
        key: 0,
        tagId: e.analyticsId
      }, null, 8, ["tagId"])) : v("", !0)
    ], 64));
  }
}, ZC = {
  components: {
    IconAction: ft
  },
  props: {
    /** Title that is shown on the card (optional) */
    title: String,
    /** If the cared should be collapsed **/
    collapse: { type: Boolean, default: !1 }
  },
  data: function() {
    return {
      fullscreen: !1,
      collapsed: !0
    };
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    },
    toggleCollapse() {
      this.collapse && (this.collapsed = !this.collapsed);
    }
  },
  computed: {
    bodyheight() {
      if (this.$refs.header && this.fullscreen) {
        let e = this.$refs.header.clientHeight, n = this.$refs.footer.clientHeight;
        return `height: calc(100vh - ${e + n}px)`;
      }
      return "";
    }
  }
}, ew = { key: 0 };
function tw(e, n, t, o, i, r) {
  const a = b("IconAction");
  return l(), c("div", {
    class: G(["card", { "card-fullscreen": e.fullscreen }])
  }, [
    p("div", {
      ref: "header",
      class: "card-header text-center",
      onClick: n[0] || (n[0] = (...s) => r.toggleCollapse && r.toggleCollapse(...s))
    }, [
      t.title ? (l(), c("h4", ew, U(t.title), 1)) : v("", !0),
      H(e.$slots, "header", {}, void 0, !0),
      t.collapse ? v("", !0) : (l(), F(a, {
        key: 1,
        class: "card-fullscreen-icon",
        icon: e.fullscreen ? "compress" : "expand",
        onClick: r.toggle
      }, null, 8, ["icon", "onClick"]))
    ], 512),
    !this.collapse || !e.collapsed ? (l(), c("div", {
      key: 0,
      class: "card-body",
      style: Ei(r.bodyheight)
    }, [
      H(e.$slots, "default", {}, void 0, !0)
    ], 4)) : v("", !0)
  ], 2);
}
const qR = /* @__PURE__ */ P(ZC, [["render", tw], ["__scopeId", "data-v-adf17920"]]), nw = {}, iw = { class: "text-center" };
function ow(e, n) {
  return l(), c("div", iw, [
    n[0] || (n[0] = jl('<div data-v-3d70bd30> This database was created using the <a href="http://molgenis.org" data-v-3d70bd30>MOLGENIS</a>  <a href="http://github.com/molgenis/molgenis-emx2" data-v-3d70bd30> molgenis-emx2 </a> open source software (license: <a href="https://github.com/molgenis/molgenis-emx2/blob/master/LICENSE" data-v-3d70bd30> LGPLv3 </a> ). </div><div data-v-3d70bd30> Please cite <a href="https://www.ncbi.nlm.nih.gov/pubmed/30165396" data-v-3d70bd30> Van der Velde et al (2018) </a> or <a href="https://www.ncbi.nlm.nih.gov/pubmed/21210979" data-v-3d70bd30> Swertz et al (2010) </a> on use. </div>', 2)),
    H(e.$slots, "default", {}, void 0, !0)
  ]);
}
const rw = /* @__PURE__ */ P(nw, [["render", ow], ["__scopeId", "data-v-3d70bd30"]]), aw = {
  components: {
    ButtonDropdown: Kr
  },
  props: {
    /** the navbar items in format {name:'name', href:'href',role:[], submenu:[]}.
     * If href is null then you will return to baseURL.
     * Href is prefixed with 'baseURL' unless startwith 'http' or '/'.
     * If role then menu items are filtered based on session.roles.
     * Submenu is optional
     */
    items: Array,
    /** logo to show*/
    logo: String,
    /** session information, so we can check role permissions */
    session: Object,
    /** prefix for relative href. Will default to schema name, i.e. first directory in path, e.g. "/pet store/ */
    baseURL: {
      type: String,
      default: () => {
        let e = window.location.pathname.split("/")[1];
        return "/" + (e ? e + "/" : "");
      }
    }
  },
  data: function() {
    return {
      toggleMenuBar: !1
    };
  },
  computed: {
    permittedItems() {
      return this.items.filter(this.permitted);
    },
    homeUrl() {
      const e = (t) => t.find((o) => {
        if (o.href)
          return o;
        if (o.submenu)
          return e(o.submenu.filter(this.permitted));
      }), n = e(this.permittedItems);
      return n ? this.addBaseUrl(n.href) : this.baseURL;
    }
  },
  methods: {
    addBaseUrl(e) {
      return e && (e.startsWith("http://") || e.startsWith("https://") || e.startsWith("/") || e.startsWith("..")) ? e : this.baseURL + (e || "");
    },
    navigate(e) {
      return window.location.href = e, e.includes("#") && window.location.reload(!0), !1;
    },
    permitted(e) {
      return !e.role || this.session?.admin || e.role === "Signed in" && this.session?.email !== "anonymous" ? !0 : this.session?.roles?.includes(e.role);
    }
  }
}, sw = { class: "navbar bg-primary navbar-expand-lg navbar-dark" }, lw = {
  key: 0,
  class: "navbar-brand",
  href: "/"
}, uw = ["src"], dw = {
  key: 0,
  class: "navbar-nav"
}, cw = ["href", "target", "onClick"], fw = ["href", "target", "onClick"];
function pw(e, n, t, o, i, r) {
  const a = b("ButtonDropdown");
  return l(), c("nav", sw, [
    p("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation",
      onClick: n[0] || (n[0] = (s) => e.toggleMenuBar = !e.toggleMenuBar)
    }, [...n[1] || (n[1] = [
      p("span", { class: "navbar-toggler-icon" }, null, -1)
    ])]),
    t.logo ? (l(), c("a", lw, [
      p("img", {
        src: t.logo,
        alt: "brand-logo",
        height: "30"
      }, null, 8, uw)
    ])) : v("", !0),
    p("div", {
      class: G(["collapse navbar-collapse", { show: e.toggleMenuBar }]),
      id: "navbarNav"
    }, [
      t.items ? (l(), c("ul", dw, [
        (l(!0), c(te, null, oe(r.permittedItems, (s) => (l(), c("li", {
          key: s.label,
          class: G(["nav-item", {
            active: s.active,
            dropdown: s.submenu
          }])
        }, [
          s.submenu && s.submenu.length > 0 ? (l(), F(a, {
            key: 0,
            class: "nav-item",
            label: s.label,
            icon: "caret-down",
            isMenuItem: !0
          }, {
            default: C(() => [
              (l(!0), c(te, null, oe(s.submenu, (u) => (l(), c("a", {
                class: "dropdown-item",
                href: r.addBaseUrl(u.href),
                key: u.label,
                target: u.newWindow ? "_blank" : "_self",
                onClick: (d) => r.navigate(r.addBaseUrl(u.href))
              }, U(u.label), 9, cw))), 128))
            ]),
            _: 2
          }, 1032, ["label"])) : (l(), c("a", {
            key: 1,
            class: "nav-link",
            href: r.addBaseUrl(s.href),
            target: s.newWindow ? "_blank" : "_self",
            onClick: (u) => r.navigate(r.addBaseUrl(s.href))
          }, U(s.label), 9, fw))
        ], 2))), 128))
      ])) : v("", !0)
    ], 2),
    H(e.$slots, "default")
  ]);
}
const hw = /* @__PURE__ */ P(aw, [["render", pw]]), mw = { style: { "background-color": "#f4f4f4" } }, Aw = { style: { "min-height": "calc(100vh - 70px)" } }, gw = {
  class: "container-fluid p-3",
  style: { "padding-bottom": "50px" }
}, yw = { key: 0 }, Kw = ["innerHTML"], bw = { key: 0 }, vw = ["href"], Cw = { key: 0 }, VR = /* @__PURE__ */ ke({
  __name: "Molgenis",
  props: {
    title: {},
    menuItems: { default: () => [] },
    showCrumbs: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "error"],
  setup(e, { emit: n }) {
    const t = [
      {
        label: "Tables",
        href: "tables",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Schema",
        href: "schema",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Up/Download",
        href: "updownload",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Reports",
        href: "reports",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Jobs & Scripts",
        href: "tasks",
        role: "Manager",
        submenu: []
      },
      {
        label: "Graphql",
        href: "graphql-playground",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Settings",
        href: "settings",
        role: "Manager",
        submenu: []
      },
      {
        label: "Help",
        href: "docs",
        role: "Viewer",
        submenu: []
      }
    ], o = e, i = me([]);
    o.menuItems.length ? i.value = y(o.menuItems) : i.value = y(t);
    const r = n, a = me(null), s = me(null), u = me(Date.now()), d = me(null), f = me(null), K = Pe(() => {
      let m = {
        "list all databases": "/apps/central/"
      };
      return a.value?.schemas && a.value.schemas.sort(
        (g, I) => g.localeCompare(I, void 0, { sensitivity: "base" })
      ).forEach((g) => {
        m[g] = "/" + g + "/index";
      }), m;
    }), w = Pe(() => {
      let m = {};
      if (window && location) {
        let g = decodeURI(
          window.location.pathname.replace(location.search, "")
        ).split("/"), I = "/";
        if (window.location.pathname != "/apps/central/") {
          let x = "index";
          g.forEach((E) => {
            E !== "" && (I += E + "/", m[E] = I + x, x = "");
          });
        }
        g = decodeURI(location?.hash?.split("?")[0]).substr(1).split("/"), I += "#", g.forEach((x) => {
          x !== "" && (I += "/" + x, m[x] = I);
        });
      }
      return m;
    }), k = Pe(() => s.value ?? "/apps/molgenis-components/assets/img/molgenis_logo_white.png");
    bi(
      a,
      (m) => {
        m?.settings?.logoURL && (s.value = m.settings.logoURL);
        const g = m?.settings?.additionalJs;
        if (g)
          try {
            eval?.(`(function() {"use strict"; ${g}})()`);
          } catch (I) {
            console.log(I);
          }
        !o.menuItems.length && m?.settings?.menu && (i.value = m.settings.menu), r("update:modelValue", m);
      },
      { deep: !0 }
    ), bi(
      () => o.menuItems,
      (m) => {
        m.length ? i.value = y(m) : i.value = y(t);
      }
    );
    function y(m) {
      const g = window?.location?.pathname.split("/")?.filter(Boolean)[0];
      if (!g || g === "apps")
        return m;
      function I(E) {
        let _ = `/${g}/${E}`, q = _.indexOf("#");
        return q !== -1 && _.substring(q - 1, q) !== "/" && (_ = _.substring(0, q) + "/" + _.substring(q, _?.length)), q = _.indexOf("#"), q !== -1 || _.endsWith("/") ? _ : _ + "/";
      }
      return m.map((E) => (E.href = I(E.href), E.submenu = E.submenu.map((_) => (_.href = I(_.href), _)), E));
    }
    return _a(async () => {
      const g = await We.newClient().fetchSettings(), I = g.find(
        (E) => E.key === "ANALYTICS_ID"
      );
      d.value = I ? I.value : null;
      const x = g.find(
        (E) => E.key === "ANALYTICS_COOKIE_WALL_CONTENT"
      );
      f.value = x ? x.value : null;
    }), (m, g) => (l(), c("div", mw, [
      m.$slots.banner ? H(m.$slots, "banner", { key: 0 }) : v("", !0),
      d.value ? (l(), F(XC, {
        key: 1,
        analyticsId: d.value,
        htmlContentString: f.value
      }, null, 8, ["analyticsId", "htmlContentString"])) : v("", !0),
      p("div", Aw, [
        D(hw, {
          logo: k.value,
          active: "My search",
          items: i.value,
          session: a.value ?? void 0
        }, {
          default: C(() => [
            (l(), F(gm, {
              modelValue: a.value,
              "onUpdate:modelValue": g[0] || (g[0] = (I) => a.value = I),
              key: u.value,
              onError: g[1] || (g[1] = (I) => m.$emit("error", I))
            }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }, 8, ["logo", "items", "session"]),
        e.showCrumbs && Object.keys(w.value).length > 1 ? (l(), F(vC, {
          key: 0,
          crumbs: w.value,
          dropdown: K.value
        }, null, 8, ["crumbs", "dropdown"])) : v("", !0),
        p("main", gw, [
          e.title ? (l(), c("h1", yw, U(e.title), 1)) : v("", !0),
          H(m.$slots, "default")
        ])
      ]),
      p("footer", null, [
        a.value?.settings?.additionalFooterHtml ? (l(), c("div", {
          key: 0,
          innerHTML: a.value?.settings?.additionalFooterHtml
        }, null, 8, Kw)) : v("", !0),
        m.$slots.footer ? H(m.$slots, "footer", { key: 1 }) : (l(), F(rw, { key: 2 }, {
          default: C(() => [
            a.value?.manifest ? (l(), c("span", bw, [
              g[2] || (g[2] = B(" Software version: ", -1)),
              p("a", {
                href: "https://github.com/molgenis/molgenis-emx2/releases/tag/" + a.value.manifest.SpecificationVersion
              }, U(a.value.manifest.SpecificationVersion), 9, vw),
              g[3] || (g[3] = B(" . ", -1)),
              a.value.manifest.DatabaseVersion ? (l(), c("span", Cw, " Database version: " + U(a.value.manifest.DatabaseVersion) + ". ", 1)) : v("", !0)
            ])) : v("", !0)
          ]),
          _: 1
        }))
      ])
    ]));
  }
}), ww = {
  components: { ButtonAlt: ot },
  props: {
    title: { type: String, default: "debug" }
  },
  data() {
    return { show: !1 };
  },
  computed: {
    showLabel() {
      return "show " + this.title;
    },
    hideLabel() {
      return "hide " + this.title;
    }
  }
}, Fw = { key: 0 };
function Rw(e, n, t, o, i, r) {
  const a = b("ButtonAlt");
  return i.show ? (l(), c("div", Fw, [
    D(a, {
      onClick: n[0] || (n[0] = (s) => i.show = !1)
    }, {
      default: C(() => [
        B(U(r.hideLabel), 1)
      ]),
      _: 1
    }),
    H(e.$slots, "default")
  ])) : (l(), F(a, {
    key: 1,
    onClick: n[1] || (n[1] = (s) => i.show = !0)
  }, {
    default: C(() => [
      B(U(r.showLabel) + " ", 1),
      n[2] || (n[2] = p("br", null, null, -1))
    ]),
    _: 1
  }));
}
const jR = /* @__PURE__ */ P(ww, [["render", Rw]]), kw = {
  props: {
    open: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    bodyClass: {
      type: String,
      required: !1
    }
  },
  watch: {
    open(e) {
      e ? (this.$refs.modal.setAttribute("open", ""), document.getElementsByTagName("body")[0].style.overflow = "hidden") : (this.$refs.modal.removeAttribute("open"), document.getElementsByTagName("body")[0].style.removeProperty("overflow"));
    }
  }
}, Uw = { ref: "modal" }, Ew = { class: "d-flex pt-4" };
function Sw(e, n, t, o, i, r) {
  return l(), c("dialog", Uw, [
    p("article", {
      class: G(["border border-black bg-white p-2", t.bodyClass])
    }, [
      H(e.$slots, "default", {}, void 0, !0),
      H(e.$slots, "modal-footer", {}, () => [
        p("div", Ew, [
          p("button", {
            class: "btn btn-primary",
            onClick: n[0] || (n[0] = (a) => e.$emit("save"))
          }, "Save"),
          p("button", {
            class: "btn btn-dark ml-auto",
            onClick: n[1] || (n[1] = (a) => e.$emit("close"))
          }, " Cancel ")
        ])
      ], !0)
    ], 2)
  ], 512);
}
const HR = /* @__PURE__ */ P(kw, [["render", Sw], ["__scopeId", "data-v-32fc409a"]]), Tw = { class: "tabs-header row justify-content-start" }, Iw = ["onClick"], Dw = { class: "tabs-content" }, Ow = /* @__PURE__ */ ke({
  __name: "Tabs",
  props: {
    tabIds: {}
  },
  setup(e) {
    const n = me(e.tabIds[0]);
    function t(o) {
      n.value = o;
    }
    return (o, i) => (l(), c("div", null, [
      p("ul", Tw, [
        (l(!0), c(te, null, oe(e.tabIds, (r) => (l(), c("li", {
          key: r,
          class: G(["tabs-item", { selected: n.value === r }]),
          onClick: (a) => t(r)
        }, [
          H(o.$slots, `${r}-header`, {}, void 0, !0)
        ], 10, Iw))), 128)),
        i[0] || (i[0] = p("li", { class: "filler-line col" }, null, -1))
      ]),
      (l(!0), c(te, null, oe(e.tabIds, (r) => Ye((l(), c("div", Dw, [
        H(o.$slots, `${r}-body`, {}, void 0, !0)
      ], 512)), [
        [ki, r === n.value]
      ])), 256))
    ]));
  }
}), GR = /* @__PURE__ */ P(Ow, [["__scopeId", "data-v-22817d43"]]), _w = {
  props: {
    row: Object,
    template: String
  },
  render() {
    const e = {
      template: `<div>${this.template}</div>`,
      data: () => ({
        row: this.row
      })
    };
    return Ia(e);
  }
}, Pw = {
  name: "TableStickyHeaders",
  props: {
    columns: Array,
    rows: Array,
    data: Object
  }
}, Mw = {
  role: "region",
  class: "border border-light"
}, Nw = { class: "table table-sm bg-white table-bordered table-hover" }, Bw = { class: "rotated-title" };
function Lw(e, n, t, o, i, r) {
  return l(), c("div", Mw, [
    p("table", Nw, [
      p("thead", null, [
        p("tr", null, [
          n[0] || (n[0] = p("th", null, null, -1)),
          (l(!0), c(te, null, oe(t.columns, (a, s) => (l(), c("th", {
            key: `head-${s}`
          }, [
            p("div", Bw, [
              p("span", null, [
                H(e.$slots, "column", { value: a }, () => [
                  B(U(a), 1)
                ], !0)
              ])
            ])
          ]))), 128))
        ])
      ]),
      p("tbody", null, [
        (l(!0), c(te, null, oe(t.rows, (a, s) => (l(), c("tr", {
          key: `tr-${s}`
        }, [
          p("th", null, [
            H(e.$slots, "row", { value: a }, () => [
              B(U(a), 1)
            ], !0)
          ]),
          (l(!0), c(te, null, oe(t.columns, (u, d) => (l(), c("td", {
            key: `td-${d}`
          }, [
            H(e.$slots, "cell", {
              value: t.data[a][u]
            }, () => [
              B(U(t.data[a][u]), 1)
            ], !0)
          ]))), 128))
        ]))), 128))
      ])
    ])
  ]);
}
const xw = /* @__PURE__ */ P(Pw, [["render", Lw], ["__scopeId", "data-v-877018ce"]]), qw = {
  key: 1,
  class: "alert alert-warning"
}, Vw = {
  key: 2,
  class: "border d-inline-block p-2 bg-white"
}, jw = { class: "aggregate-options" }, Hw = { key: 0 }, Gw = { key: 1 }, Qw = {
  key: 0,
  class: "alert alert-danger"
}, $w = {
  key: 1,
  class: "alert alert-warning"
}, Jw = {
  key: 0,
  class: "text-center text-black-50"
}, zw = { key: 1 }, Yw = { key: 2 }, Ww = /* @__PURE__ */ ke({
  __name: "AggregateTable",
  props: {
    canView: { type: Boolean },
    schemaId: {},
    allColumns: {},
    tableId: {},
    minimumValue: { default: 1 },
    graphqlFilter: { default: () => ({}) }
  },
  setup(e) {
    const n = ["INT", "LONG", "DECIMAL"], t = e, o = me(""), i = me(""), r = me([]), a = me(!1), s = me("count"), u = me(
      t.allColumns.find((L) => n.includes(L.columnType))?.id || ""
    ), d = me([]), f = me([]), K = me({}), w = me(!1), k = me(void 0), y = me(We.newClient(t.schemaId)), m = Pe(() => t.allColumns.filter((L) => n.includes(L.columnType)).map((L) => L.id)), g = Pe(() => t.allColumns.reduce((L, $) => (L[$.id] = $, L), {}));
    q();
    async function I() {
      if (a.value = !0, k.value = void 0, d.value = [], f.value = [], K.value = {}, s.value === "sum" && !u.value) {
        a.value = !1;
        return;
      }
      const L = await x(
        g.value[i.value]
      ), $ = await x(
        g.value[o.value]
      );
      y.value.fetchAggregateData(
        t.tableId,
        {
          id: o.value,
          column: $
        },
        {
          id: i.value,
          column: L
        },
        t.graphqlFilter,
        s.value === "sum" ? "_sum" : "count",
        u.value
      ).then((J) => {
        J && J[t.tableId + "_groupBy"] ? (J[t.tableId + "_groupBy"].forEach(
          (W) => E(W)
        ), w.value = !f.value.length) : w.value = !0, a.value = !1;
      }).catch((J) => {
        k.value = J, a.value = !1;
      });
    }
    async function x(L) {
      if (L.columnType.startsWith("ONTOLOGY"))
        return "name";
      if (L.columnType === "REFBACK") {
        const se = await y.value.getPrimaryKeyFields(
          t.schemaId,
          t.tableId
        );
        return `${L.refBackId} { ${se.join(",")} }`;
      }
      const $ = L.refSchemaId || t.schemaId, J = L.refTableId || t.tableId, W = await y.value.getPrimaryKeyFields($, J);
      if (W.length)
        return W.join(",");
      throw new Error(
        `Could not determine primary key for column ${L.id} in table ${J}`
      );
    }
    function E(L) {
      const $ = g.value[i.value], J = g.value[o.value], W = _(J, L), se = _($, L), fe = s.value === "sum" ? L._sum[u.value] : L[s.value];
      K.value[se] ? K.value[se][W] = fe : K.value[se] = { [W]: fe }, f.value.includes(W) || f.value.push(W), d.value.includes(se) || d.value.push(se);
    }
    function _(L, $) {
      const J = $[L.id];
      return J ? L.columnType === "REFBACK" ? J[L.refBackId]?.name || "not specified" : J?.name || "not specified" : "not specified";
    }
    function q() {
      t.allColumns.length > 0 && (r.value = V(
        t.allColumns,
        t.canView
      )), r.value?.length && (o.value = r.value[0], i.value = r.value[1] || r.value[0], I());
    }
    function V(L, $) {
      return L.filter((J) => J.columnType.startsWith("REF") && $ || J.columnType.startsWith("ONTOLOGY") || J.columnType === "RADIO" && $).map((J) => J.id);
    }
    return (L, $) => {
      const J = b("Spinner");
      return l(), c("div", null, [
        a.value ? (l(), F(J, {
          key: 0,
          class: "m-3"
        })) : r.value.length === 0 ? (l(), c("div", qw, " Not enough input to create an aggregate table. Need at least 1 column with permission that can be used as group by. ")) : (l(), c("div", Vw, [
          p("div", jw, [
            p("table", null, [
              p("tbody", null, [
                p("tr", null, [
                  $[4] || ($[4] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3",
                      for: "aggregate-column-select"
                    }, " Column: ")
                  ], -1)),
                  p("td", null, [
                    D(Tn, {
                      class: "mb-0",
                      id: "aggregate-column-select",
                      modelValue: o.value,
                      "onUpdate:modelValue": [
                        $[0] || ($[0] = (W) => o.value = W),
                        I
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                p("tr", null, [
                  $[5] || ($[5] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0",
                      for: "aggregate-row-select"
                    }, " Row: ")
                  ], -1)),
                  p("td", null, [
                    D(Tn, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: i.value,
                      "onUpdate:modelValue": [
                        $[1] || ($[1] = (W) => i.value = W),
                        I
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                m.value.length ? (l(), c("tr", Hw, [
                  $[6] || ($[6] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Aggregate function: ")
                  ], -1)),
                  p("td", null, [
                    D(sr, {
                      id: "input-radio-2",
                      modelValue: s.value,
                      "onUpdate:modelValue": [
                        $[2] || ($[2] = (W) => s.value = W),
                        I
                      ],
                      options: ["count", "sum"],
                      isClearable: !1
                    }, null, 8, ["modelValue"])
                  ])
                ])) : v("", !0),
                s.value === "sum" ? (l(), c("tr", Gw, [
                  $[7] || ($[7] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Summation field: ")
                  ], -1)),
                  p("td", null, [
                    D(Tn, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: u.value,
                      "onUpdate:modelValue": [
                        $[3] || ($[3] = (W) => u.value = W),
                        I
                      ],
                      options: m.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])) : v("", !0)
              ])
            ])
          ]),
          k.value ? (l(), c("div", Qw, U(k.value), 1)) : w.value ? (l(), c("div", $w, " No results found ")) : (l(), F(xw, {
            key: 2,
            columns: f.value,
            rows: d.value,
            data: K.value,
            class: "mb-n3"
          }, {
            column: C((W) => [
              B(U(W.value), 1)
            ]),
            row: C((W) => [
              B(U(W.value), 1)
            ]),
            cell: C((W) => [
              W.value ? W.value < e.minimumValue ? (l(), c("div", zw, "﹤" + U(e.minimumValue), 1)) : (l(), c("div", Yw, U(W.value), 1)) : (l(), c("div", Jw, "-"))
            ]),
            _: 1
          }, 8, ["columns", "rows", "data"]))
        ]))
      ]);
    };
  }
}), Xw = ke({
  name: "SubTask",
  props: {
    task: {
      type: Object,
      required: !0
    }
  },
  computed: {
    color() {
      switch (this.task.status) {
        case "COMPLETED":
          return "text-success";
        case "ERROR":
          return "text-danger";
        case "WARNING":
          return "text-warning";
        case "SKIPPED":
          return "text-muted";
        default:
          return "text-primary";
      }
    },
    icon() {
      switch (this.task.status) {
        case "COMPLETED":
          return "fa-check";
        case "ERROR":
          return "fa-times";
        case "WARNING":
          return "fa-exclamation-circle";
        case "SKIPPED":
          return "fa-check";
        case "RUNNING":
          return "fa-spinner fa-spin";
        default:
          return "fa-question";
      }
    }
  }
}), Zw = { class: "fa-ul" };
function e0(e, n, t, o, i, r) {
  const a = b("SubTask", !0);
  return l(), c("ul", Zw, [
    e.task ? (l(), c("li", {
      key: 0,
      class: G(e.color)
    }, [
      p("i", {
        class: G(["fa-li fa", e.icon])
      }, null, 2),
      B(" " + U(e.task.description) + " ", 1),
      (l(!0), c(te, null, oe(e.task.subTasks, (s, u) => (l(), F(a, {
        task: s,
        key: u
      }, null, 8, ["task"]))), 128))
    ], 2)) : v("", !0)
  ]);
}
const t0 = /* @__PURE__ */ P(Xw, [["render", e0]]), n0 = ke({
  name: "Task",
  components: {
    SubTask: t0,
    Spinner: bt
  },
  props: {
    taskId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      task: null,
      loading: !0,
      error: !1
    };
  },
  methods: {
    async startMonitorTask() {
      for (; !this.error && !this.task || this.task && !["COMPLETED", "ERROR"].includes(this.task.status); ) {
        const e = `{
          _tasks(id:"${this.taskId}")
          {
            id, description, status, subTasks
            {
              id, description, status, subTasks
              {
                id, description, status, subTasks
                {
                  id, description, status, subTasks
                    {
                      id, description, status
                    }
                }
              }
            }
          }
        }`;
        Me("graphql", e).then((n) => {
          this.task = n._tasks[0], this.$emit("taskUpdated", this.task), this.loading = !1;
        }).catch((n) => {
          console.log(JSON.stringify(n)), this.error = n, this.loading = !1;
        }), await i0(500);
      }
    }
  },
  created() {
    this.startMonitorTask();
  }
});
function i0(e) {
  return new Promise((n) => setTimeout(n, e));
}
const o0 = { key: 2 };
function r0(e, n, t, o, i, r) {
  const a = b("Spinner"), s = b("SubTask");
  return l(), c("div", null, [
    e.loading ? (l(), F(a, { key: 0 })) : e.task ? (l(), F(s, {
      key: 1,
      task: e.task
    }, null, 8, ["task"])) : (l(), c("span", o0, "Task with id = '" + U(e.taskId) + "' not found", 1))
  ]);
}
const yl = /* @__PURE__ */ P(n0, [["render", r0]]), a0 = {
  props: {
    row: Object,
    col: Object
  },
  components: {
    HyperlinkDisplay: cr,
    EmailDisplay: dr,
    FileDisplay: al
  },
  methods: {
    applyJsTemplate: jt,
    getValue(e, n) {
      return this.getRefLabel(e) ? jt(n[e.id], this.getRefLabel(e)) : n[e.id];
    },
    getRefLabel(e) {
      return e.refLabel ? e.refLabel : e.refLabelDefault;
    }
  }
}, s0 = { key: 0 }, l0 = { key: 2 }, u0 = { key: 1 }, d0 = { key: 3 };
function c0(e, n, t, o, i, r) {
  const a = b("HyperlinkDisplay"), s = b("EmailDisplay"), u = b("FileDisplay");
  return t.row[t.col.id] && Array.isArray(t.row[t.col.id]) ? (l(), c("span", s0, [
    (l(!0), c(te, null, oe(t.row[t.col.id], (d, f) => (l(), c("span", {
      key: f,
      class: "pr-1"
    }, [
      t.col.columnType === "HYPERLINK_ARRAY" ? (l(), F(a, {
        key: 0,
        data: d
      }, null, 8, ["data"])) : t.col.columnType === "EMAIL_ARRAY" ? (l(), F(s, {
        key: 1,
        data: d
      }, null, 8, ["data"])) : (l(), c("span", l0, U(r.getRefLabel(t.col) ? r.applyJsTemplate(d, r.getRefLabel(t.col)) : d), 1))
    ]))), 128))
  ])) : t.row[t.col.id] ? (l(), c("span", u0, [
    t.col.columnType === "HYPERLINK" ? (l(), F(a, {
      key: 0,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "EMAIL" ? (l(), F(s, {
      key: 1,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "FILE" ? (l(), F(u, {
      key: 2,
      data: t.row[t.col.id],
      metadata: t.col
    }, null, 8, ["data", "metadata"])) : (l(), c("span", d0, U(r.getValue(t.col, t.row)), 1))
  ])) : v("", !0);
}
const f0 = /* @__PURE__ */ P(a0, [["render", c0]]), p0 = {
  components: {
    RenderValue: f0,
    RowButton: Qt,
    VueTemplate: _w
  },
  props: {
    columns: Array,
    tableId: String,
    row: Object,
    template: String,
    canUpdate: Boolean,
    canDelete: Boolean
  },
  methods: {
    getKey(e) {
      let n = {};
      return this.columns.filter((t) => t.key == 1).map((t) => n[t.id] = e[t.id]), n;
    },
    showItem(e, n) {
      return n.showColumn && e[n.id] && n.id != "mg_tableclass";
    }
  }
}, h0 = { class: "card" }, m0 = { class: "card-text" }, A0 = { class: "float-right" }, g0 = { key: 1 }, y0 = {
  key: 0,
  class: "pr-3 pb-1"
}, K0 = {
  key: 1,
  class: "pl-3"
};
function b0(e, n, t, o, i, r) {
  const a = b("RowButton"), s = b("VueTemplate"), u = b("RenderValue");
  return l(), c("div", h0, [
    p("div", {
      class: "card-body",
      onClick: n[4] || (n[4] = (d) => e.$emit("click", t.row))
    }, [
      p("div", m0, [
        p("span", A0, [
          t.canUpdate ? (l(), F(a, {
            key: 0,
            type: "edit",
            class: "d-inline",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[0] || (n[0] = (d) => e.$emit("reload")),
            onEdit: n[1] || (n[1] = (d) => e.$emit("edit", t.row))
          }, null, 8, ["tableId", "pkey"])) : v("", !0),
          t.canDelete ? (l(), F(a, {
            key: 1,
            type: "delete",
            class: "mt-0",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[2] || (n[2] = (d) => e.$emit("reload")),
            onDelete: n[3] || (n[3] = (d) => e.$emit("delete", t.row))
          }, null, 8, ["tableId", "pkey"])) : v("", !0)
        ]),
        t.template ? (l(), F(s, {
          key: 0,
          template: t.template,
          row: t.row
        }, null, 8, ["template", "row"])) : (l(), c("dl", g0, [
          (l(!0), c(te, null, oe(t.columns, (d) => (l(), c(te, {
            key: d.id
          }, [
            r.showItem(t.row, d) ? (l(), c(te, { key: 0 }, [
              r.showItem(t.row, d) ? (l(), c("dt", y0, U(d.label), 1)) : v("", !0),
              r.showItem(t.row, d) ? (l(), c("dd", K0, [
                D(u, {
                  col: d,
                  row: t.row
                }, null, 8, ["col", "row"])
              ])) : v("", !0)
            ], 64)) : v("", !0)
          ], 64))), 128))
        ]))
      ])
    ])
  ]);
}
const v0 = /* @__PURE__ */ P(p0, [["render", b0], ["__scopeId", "data-v-cc98901e"]]), C0 = ke({
  name: "RecordCards",
  components: { RowCard: v0 },
  props: {
    id: { type: String, required: !0 },
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    tableId: { type: String, required: !0 },
    canUpdate: { type: Boolean, default: !1 },
    canDelete: { type: Boolean, default: !1 },
    template: { type: String, required: !1 }
  }
}), w0 = {
  key: 0,
  class: "alert alert-warning"
};
function F0(e, n, t, o, i, r) {
  const a = b("RowCard");
  return l(), c("div", null, [
    e.data.length ? (l(!0), c(te, { key: 1 }, oe(e.data, (s, u) => (l(), F(a, {
      key: e.id + "-" + u,
      row: s,
      columns: e.columns,
      tableId: e.tableId,
      canUpdate: e.canUpdate,
      canDelete: e.canDelete,
      template: e.template,
      onReload: n[0] || (n[0] = (d) => e.$emit("reload")),
      onEdit: n[1] || (n[1] = (d) => e.$emit("edit", d)),
      onDelete: n[2] || (n[2] = (d) => e.$emit("delete", d)),
      onClick: n[3] || (n[3] = (d) => e.$emit("click", d))
    }, null, 8, ["row", "columns", "tableId", "canUpdate", "canDelete", "template"]))), 128)) : (l(), c("div", w0, "No results found"))
  ]);
}
const R0 = /* @__PURE__ */ P(C0, [["render", F0]]), k0 = { class: "mb-4" }, U0 = { class: "ml-1" }, E0 = { class: "table table-sm mb-2" }, S0 = { class: "key border-right" }, T0 = ["onClick"], I0 = {
  key: 0,
  class: "text-black-50"
}, D0 = { key: 0 }, O0 = { key: 0 }, _0 = { key: 1 }, P0 = { key: 0 }, M0 = { key: 1 }, N0 = /* @__PURE__ */ ke({
  __name: "RefTable",
  props: {
    reference: {},
    tableId: {},
    schema: {},
    showDataOwner: { type: Boolean },
    startsCollapsed: { type: Boolean }
  },
  emits: ["refCellClicked"],
  setup(e, { emit: n }) {
    const t = e, { reference: o, startsCollapsed: i } = Mn(t), r = n;
    let a = Pe(() => f(o.value)), s = Pe(() => Object.keys(a.value).length > 5);
    const u = me({});
    t.tableId && t.schema && We.newClient(t.schema).convertRowToPrimaryKey(o.value, t.tableId).then((m) => {
      u.value = m;
    });
    let d = me(i.value && s.value);
    function f(y) {
      const m = { ...y };
      return delete m.mg_insertedBy, delete m.mg_insertedOn, delete m.mg_updatedBy, delete m.mg_updatedOn, delete m.mg_draft, delete m.metadata, m;
    }
    function K(y) {
      const m = o.value.metadata;
      if (w(m) && m.columns)
        return m.columns.find((g) => g.id === y) || {};
      throw "Error: Metadata for RefTable not found";
    }
    function w(y) {
      return y.id !== void 0;
    }
    function k(y) {
      const m = o.value, g = m.metadata.columns?.find((I) => I.id === y);
      g && Ci(g.columnType) && r("refCellClicked", {
        refColumn: g,
        refTableRow: m
      });
    }
    return (y, m) => (l(), c("div", k0, [
      p("h5", U0, [
        u.value ? (l(), F(ur, {
          key: 0,
          data: u.value,
          metadata: ie(o).metadata,
          class: "mr-1"
        }, null, 8, ["data", "metadata"])) : v("", !0),
        ie(s) ? (l(), c("button", {
          key: 1,
          class: "btn p-0 m-0 btn-outline-primary border-0 ml-auto float-right",
          onClick: m[0] || (m[0] = (g) => Ki(d) ? d.value = !ie(d) : d = !ie(d))
        }, [
          p("i", {
            class: G(`fas fa-fw fa-angle-${ie(d) ? "up" : "down"}`)
          }, null, 2)
        ])) : v("", !0)
      ]),
      p("div", null, [
        p("div", {
          class: G({ "collapsed-table": ie(d) })
        }, [
          p("table", E0, [
            (l(!0), c(te, null, oe(ie(a), (g, I) => (l(), c("tr", null, [
              p("td", S0, U(I), 1),
              p("td", {
                onClick: (x) => k(I),
                class: G({
                  refType: ie(Ci)(K(I).columnType)
                })
              }, [
                D(sl, {
                  data: g,
                  metadata: K(I)
                }, null, 8, ["data", "metadata"])
              ], 10, T0)
            ]))), 256))
          ])
        ], 2),
        ie(d) ? (l(), c("div", {
          key: 0,
          class: "collapsed-tag border-top rounded-bottom mb-3",
          onClick: m[1] || (m[1] = (g) => Ki(d) ? d.value = !1 : d = !1)
        }, [...m[2] || (m[2] = [
          p("small", { class: "px-3 link-color" }, " Show all records... ", -1)
        ])])) : v("", !0)
      ]),
      e.showDataOwner ? (l(), c("small", I0, [
        ie(o).mg_insertedBy ? (l(), c("div", D0, [
          B(" Inserted by '" + U(ie(o).mg_insertedBy) + "' ", 1),
          ie(o).mg_insertedOn ? (l(), c("span", O0, " On " + U(new Date(ie(o).mg_insertedOn).toLocaleString()), 1)) : v("", !0)
        ])) : v("", !0),
        ie(o).mg_updatedBy ? (l(), c("div", _0, [
          B(" Updated by '" + U(ie(o).mg_updatedBy) + "' ", 1),
          ie(o).mg_updatedOn ? (l(), c("span", P0, " On " + U(new Date(ie(o).mg_updatedOn).toLocaleString()), 1)) : v("", !0)
        ])) : v("", !0)
      ])) : v("", !0),
      ie(o).mg_draft ? (l(), c("div", M0, [...m[3] || (m[3] = [
        p("span", { class: "badge badge-secondary" }, "Draft", -1)
      ])])) : v("", !0)
    ]));
  }
}), B0 = /* @__PURE__ */ P(N0, [["__scopeId", "data-v-029d60a6"]]), L0 = {
  class: "modal-dialog modal-dialog-scrollable",
  role: "document"
}, x0 = { class: "modal-content" }, q0 = { class: "modal-header" }, V0 = { class: "modal-title" }, j0 = { class: "modal-body bg-light" }, H0 = { class: "modal-footer" }, G0 = /* @__PURE__ */ ke({
  __name: "SideModal",
  props: {
    label: {},
    isCloseButtonShown: { type: Boolean, default: !0 },
    isVisible: { type: Boolean, default: !0 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { isVisible: o } = Mn(t);
    let i = me(!1);
    a(), bi(o, () => {
      a();
    });
    const r = n;
    Hl(() => {
      document?.addEventListener && document.addEventListener("keydown", s);
    }), Gl(() => {
      document?.removeEventListener && document.removeEventListener("keydown", s);
    });
    function a() {
      setTimeout(() => {
        i.value = o.value;
      });
    }
    function s(d) {
      d.key === "Escape" && u();
    }
    function u() {
      i.value = !1, setTimeout(() => {
        r("onClose");
      }, 200);
    }
    return (d, f) => (l(), c("div", {
      class: G(["modal fade", { show: ie(i) }])
    }, [
      p("div", L0, [
        p("div", x0, [
          p("div", q0, [
            p("h5", V0, U(e.label), 1),
            e.isCloseButtonShown ? (l(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: Ke(u, ["prevent"])
            }, [...f[0] || (f[0] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : v("", !0)
          ]),
          p("div", j0, [
            H(d.$slots, "default", {}, void 0, !0)
          ]),
          p("div", H0, [
            H(d.$slots, "footer", { close: u }, void 0, !0)
          ])
        ])
      ])
    ], 2));
  }
}), Q0 = /* @__PURE__ */ P(G0, [["__scopeId", "data-v-0cf264cb"]]), $0 = { key: 0 }, J0 = { key: 1 }, z0 = { key: 1 }, Y0 = /* @__PURE__ */ ke({
  __name: "RefSideModal",
  props: {
    column: {},
    rows: { default: () => [] },
    schema: {},
    showDataOwner: { type: Boolean, default: !1 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { column: o, rows: i } = Mn(t), r = n;
    let a = me(!0), s = me([]), u = me("");
    d(i.value, o.value.refTableId), bi([o, i], () => {
      d(i.value, o.value.refTableId);
    });
    async function d(k, y, m) {
      const g = m || o.value.refSchemaId || t.schema;
      g && y && (u.value = "", a.value = !0, s.value = await f(g, k, y), a.value = !1);
    }
    async function f(k, y, m) {
      let g = [];
      const I = We.newClient(k), x = await I.fetchTableMetaData(m);
      for (const E of y) {
        const q = await jn(E, m, k);
        let V = await I.fetchRowData(m, q, 2).catch(w);
        V.metadata = x, g.push(V);
      }
      return g;
    }
    async function K({
      refColumn: k,
      refTableRow: y
    }) {
      const m = k.refTableId, g = k.refSchemaId || o.value.refSchemaId || t.schema;
      if (m && g) {
        const I = [y[k.id]].flat();
        d(I, m, g);
      } else
        u.value = "Failed to load reference data";
    }
    function w(k) {
      u.value = `Failed to load reference data, because: ${k.message}`;
    }
    return (k, y) => (l(), F(Q0, {
      label: ie(o).label,
      isVisible: !0,
      onOnClose: y[0] || (y[0] = (m) => r("onClose"))
    }, {
      footer: C((m) => [
        D(He, {
          onClick: (g) => m.close()
        }, {
          default: C(() => [...y[1] || (y[1] = [
            B("Close", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: C(() => [
        ie(a) ? (l(), c("div", $0, [
          D(bt)
        ])) : (l(), c("div", J0, [
          ie(u) ? (l(), F(rt, { key: 0 }, {
            default: C(() => [
              B(U(ie(u)), 1)
            ]),
            _: 1
          })) : v("", !0),
          ie(s).length ? v("", !0) : (l(), c("div", z0, " The selected reference was not found in the database ")),
          (l(!0), c(te, null, oe(ie(s), (m) => (l(), c("div", null, [
            D(B0, {
              reference: m,
              showDataOwner: e.showDataOwner,
              startsCollapsed: ie(s).length > 1,
              tableId: ie(o).refTableId,
              schemaId: ie(o).refSchemaId || t.schema,
              onRefCellClicked: K
            }, null, 8, ["reference", "showDataOwner", "startsCollapsed", "tableId", "schemaId"])
          ]))), 256))
        ]))
      ]),
      _: 1
    }, 8, ["label"]));
  }
}), W0 = {
  components: {
    IconAction: ft,
    ButtonAlt: ot,
    LayoutModal: vt
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expand: !1
    };
  },
  methods: {
    flattenObject: sn,
    deselect(e) {
      let n = this.selection;
      n.splice(e, 1), this.$emit("update:selection", n);
    },
    clear() {
      let e = this.selection;
      e.splice(0, e.length), this.$emit("update:selection", e);
    },
    toggle() {
      this.expand = !this.expand;
    }
  },
  emits: ["update:selection"]
}, X0 = {
  key: 0,
  class: "badge badge-pill badge-danger",
  style: { top: "-7px", left: "-7px" }
}, Z0 = { key: 0 };
function eF(e, n, t, o, i, r) {
  const a = b("ButtonAlt"), s = b("IconAction"), u = b("LayoutModal");
  return l(), c("div", null, [
    D(a, { onClick: r.toggle }, {
      default: C(() => [
        n[1] || (n[1] = B(" Selection ", -1)),
        n[2] || (n[2] = p("i", { class: "fa fa-lg fa-check-square-o" }, null, -1)),
        t.selection && t.selection.filter((d) => d != null).length > 0 ? (l(), c("span", X0, U(Array.isArray(t.selection) ? t.selection.filter((d) => d != null).length : 0), 1)) : v("", !0)
      ]),
      _: 1
    }, 8, ["onClick"]),
    i.expand ? (l(), F(u, {
      key: 0,
      onClose: n[0] || (n[0] = (d) => i.expand = !1),
      title: "Show selection"
    }, {
      body: C(() => [
        !Array.isArray(t.selection) || t.selection.filter((d) => d != null).length == 0 ? (l(), c("span", Z0, " No items selected ")) : (l(!0), c(te, { key: 1 }, oe(t.selection.filter((d) => d != null), (d, f) => (l(), c("span", {
          class: "btn-outline-primary btn-sm mr-2",
          key: JSON.stringify(d)
        }, [
          B(U(r.flattenObject(d)) + " ", 1),
          D(s, {
            icon: "times",
            onClick: (K) => r.deselect(f)
          }, null, 8, ["onClick"])
        ]))), 128))
      ]),
      footer: C(() => [
        Array.isArray(t.selection) && t.selection.length > 0 ? (l(), F(a, {
          key: 0,
          onClick: r.clear
        }, {
          default: C(() => [...n[3] || (n[3] = [
            B(" clear selection ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : v("", !0)
      ]),
      _: 1
    })) : v("", !0)
  ]);
}
const tF = /* @__PURE__ */ P(W0, [["render", eF]]), nF = {
  components: { ButtonAlt: ot, ButtonDropdown: Kr, IconAction: ft },
  props: {
    label: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    columns: Array,
    exclude: {
      type: Array,
      default: () => []
    },
    checkAttribute: String,
    defaultValue: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    value(e) {
      return e[this.checkAttribute] == null ? this.defaultValue : e[this.checkAttribute];
    },
    change(e, n) {
      let t = JSON.parse(JSON.stringify(this.columns));
      t[e][this.checkAttribute] = n, this.$emit("update:columns", t);
    },
    hideAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !1);
      this.$emit("update:columns", n);
    },
    showAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !0);
      this.$emit("update:columns", n);
    }
  },
  emits: ["update:columns"]
}, iF = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, oF = { key: 0 }, rF = {
  key: 0,
  class: "ml-0"
}, aF = {
  key: 1,
  class: "form-check"
}, sF = ["checked", "onInput", "id"], lF = ["for"];
function uF(e, n, t, o, i, r) {
  const a = b("IconAction"), s = b("ButtonAlt"), u = b("ButtonDropdown");
  return l(), F(u, {
    icon: t.icon,
    label: t.label
  }, {
    default: C((d) => [
      p("form", iF, [
        D(a, {
          icon: "times",
          onClick: d.close,
          class: "float-right"
        }, null, 8, ["onClick"]),
        p("h6", null, U(t.label), 1),
        p("b", null, [
          n[6] || (n[6] = B(" data ( ", -1)),
          D(s, {
            class: "pl-0",
            onClick: n[0] || (n[0] = (f) => r.showAll(!0))
          }, {
            default: C(() => [...n[4] || (n[4] = [
              B("all", -1)
            ])]),
            _: 1
          }),
          D(s, {
            class: "p-0",
            onClick: n[1] || (n[1] = (f) => r.hideAll(!0))
          }, {
            default: C(() => [...n[5] || (n[5] = [
              B("none", -1)
            ])]),
            _: 1
          }),
          n[7] || (n[7] = B(" ) ", -1))
        ]),
        (l(!0), c(te, null, oe(t.columns, (f, K) => (l(), c("div", { key: K }, [
          t.exclude.length == 0 || !t.exclude.includes(f.columnType) ? (l(), c("span", oF, [
            f.id == "mg_draft" ? (l(), c("b", rF, [
              n[10] || (n[10] = B(" metadata ( ", -1)),
              D(s, {
                class: "pl-0",
                onClick: n[2] || (n[2] = (w) => r.showAll(!1))
              }, {
                default: C(() => [...n[8] || (n[8] = [
                  B("all", -1)
                ])]),
                _: 1
              }),
              D(s, {
                class: "p-0",
                onClick: n[3] || (n[3] = (w) => r.hideAll(!1))
              }, {
                default: C(() => [...n[9] || (n[9] = [
                  B("none", -1)
                ])]),
                _: 1
              }),
              n[11] || (n[11] = B(" ) ", -1))
            ])) : v("", !0),
            f.columnType != "HEADING" ? (l(), c("div", aF, [
              p("input", {
                class: "form-check-input",
                type: "checkbox",
                checked: f[t.checkAttribute] == null ? t.defaultValue : f[t.checkAttribute],
                onInput: Ke((w) => r.change(K, !f[t.checkAttribute]), ["prevent"]),
                id: f.id
              }, null, 40, sF),
              p("label", {
                class: "form-check-label",
                for: f.id
              }, U(f.label), 9, lF)
            ])) : v("", !0)
          ])) : v("", !0)
        ]))), 128))
      ])
    ]),
    _: 1
  }, 8, ["icon", "label"]);
}
const dF = /* @__PURE__ */ P(nF, [["render", uF]]), cF = {
  name: "TableSettings",
  components: {
    Spinner: bt,
    MessageError: rt,
    MessageSuccess: mn,
    IconAction: ft,
    InputText: Qn,
    ButtonAction: He,
    LayoutModal: vt,
    ButtonAlt: ot
  },
  props: {
    schemaId: {
      type: String,
      required: !1
    },
    tableMetadata: { type: Object, required: !0 }
  },
  data() {
    return {
      show: !1,
      graphqlError: null,
      success: null,
      loading: !1
    };
  },
  computed: {
    cardTemplate() {
      return this.tableMetadata.settings?.filter((e) => e.key === "cardTemplate").map((e) => e.value)[0];
    },
    recordTemplate() {
      return this.tableMetadata.settings?.filter((e) => e.key === "recordTemplate").map((e) => e.value)[0];
    }
  },
  methods: {
    emitCardTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "cardTemplate"
      ), this.tableMetadata.settings.push({ key: "cardTemplate", value: e });
    },
    emitRecordTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "recordTemplate"
      ), this.tableMetadata.settings.push({ key: "recordTemplate", value: e });
    },
    async saveSettings() {
      this.loading = !0, this.graphqlError = null, this.success = null;
      const e = this.tableMetadata.settings.map((t) => ({
        tableId: this.tableMetadata.id,
        key: t.key,
        value: t.value
      })), n = await Me(
        this.schemaId ? "/" + this.schemaId + "/graphql" : "graphql",
        "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
        { settings: e }
      ).catch((t) => {
        this.graphqlError = t.errors[0].message;
      });
      this.success = n.change.message, this.loading = !1, this.$emit("update:settings");
    }
  },
  created() {
    this.tableMetadata && !this.tableMetadata.settings && (this.tableMetadata.settings = []);
  },
  emits: ["update:settings"]
}, fF = { key: 3 };
function pF(e, n, t, o, i, r) {
  const a = b("IconAction"), s = b("MessageSuccess"), u = b("MessageError"), d = b("Spinner"), f = b("InputText"), K = b("ButtonAlt"), w = b("ButtonAction"), k = b("LayoutModal");
  return i.show ? (l(), F(k, {
    key: 1,
    title: "Table Settings",
    onClose: n[2] || (n[2] = (y) => i.show = !1),
    show: i.show
  }, {
    body: C(() => [
      i.success ? (l(), F(s, { key: 0 }, {
        default: C(() => [
          B(U(i.success), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.graphqlError ? (l(), F(u, { key: 1 }, {
        default: C(() => [
          B(U(i.graphqlError), 1)
        ]),
        _: 1
      })) : v("", !0),
      i.loading ? (l(), F(d, { key: 2 })) : (l(), c("form", fF, [
        n[5] || (n[5] = p("p", null, [
          B(" The data is in variable 'row'. For example, "),
          p("tt", null, "{{ row }}"),
          B(" will show all values available. "),
          p("tt", null, "{{ row.name }}"),
          B(" will get the 'name' column ")
        ], -1)),
        D(f, {
          id: "table-settings-card-template",
          name: "cardTemplate",
          label: "cardTemplate",
          modelValue: r.cardTemplate,
          "onUpdate:modelValue": r.emitCardTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        D(f, {
          id: "table-settings-record-template",
          name: "recordTemplate",
          label: "recordTemplate",
          modelValue: r.recordTemplate,
          "onUpdate:modelValue": r.emitRecordTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        D(K, {
          onClick: n[1] || (n[1] = (y) => i.show = !1)
        }, {
          default: C(() => [...n[3] || (n[3] = [
            B("Close", -1)
          ])]),
          _: 1
        }),
        D(w, { onClick: r.saveSettings }, {
          default: C(() => [...n[4] || (n[4] = [
            B("Save settings", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]))
    ]),
    _: 1
  }, 8, ["show"])) : (l(), F(a, {
    key: 0,
    icon: "cog",
    onClick: n[0] || (n[0] = (y) => i.show = !0)
  }));
}
const hF = /* @__PURE__ */ P(cF, [["render", pF]]), Lt = {
  TABLE: "table",
  CARDS: "cards",
  RECORD: "record",
  AGGREGATE: "aggregate"
}, mF = {
  table: { id: Lt.TABLE, label: "Table", icon: "th" },
  cards: { id: Lt.CARDS, label: "Card", icon: "list-alt" },
  record: {
    id: Lt.RECORD,
    label: "Record",
    icon: "th-list",
    limitOverride: 1
  },
  aggregate: {
    id: Lt.AGGREGATE,
    label: "Aggregate",
    icon: "object-group"
  }
}, AF = {
  name: "TableExplorer",
  components: {
    LayoutModal: vt,
    Task: yl,
    ShowHide: dF,
    Pagination: ll,
    ButtonAlt: ot,
    ButtonDropdown: Kr,
    IconAction: ft,
    IconDanger: ar,
    InputSearch: pr,
    InputSelect: Tn,
    MessageError: rt,
    SelectionBox: tF,
    Spinner: bt,
    TableMolgenis: fr,
    FilterSidebar: XK,
    FilterWells: rb,
    RecordCards: R0,
    RowButton: Qt,
    TableSettings: hF,
    EditModal: br,
    ConfirmModal: hr,
    AggregateTable: Ww,
    RefSideModal: Y0
  },
  data() {
    return {
      cardTemplate: "",
      client: null,
      columns: [],
      count: 0,
      dataRows: [],
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: void 0,
      graphqlError: "",
      taskId: "",
      taskDone: !1,
      success: !1,
      isDeleteAllModalShown: !1,
      isTaskModalShown: !1,
      isDeleteModalShown: !1,
      isEditModalShown: !1,
      limit: this.showLimit,
      loading: !1,
      order: this.showOrder,
      orderByColumn: this.showOrderBy,
      page: this.showPage,
      recordTemplate: "",
      searchTerms: "",
      selectedItems: [],
      tableMetadata: null,
      view: this.canView ? this.showView : Lt.AGGREGATE,
      refSideModalProps: void 0
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      default: () => ""
    },
    showSelect: {
      type: Boolean,
      default: () => !1
    },
    showHeader: {
      type: Boolean,
      default: () => !0
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    },
    showView: {
      type: String,
      default: Lt.TABLE
    },
    showPage: {
      type: Number,
      default: 1
    },
    showLimit: {
      type: Number,
      default: 10
    },
    urlConditions: {
      type: Object,
      default: () => ({})
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    showOrderBy: {
      type: String,
      required: !1
    },
    showOrder: {
      type: String,
      default: () => "ASC"
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canInsert: {
      type: Boolean,
      default: () => !1
    },
    canUpdate: {
      type: Boolean,
      default: () => !1
    },
    canDelete: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    View() {
      return Lt;
    },
    ViewButtons() {
      return mF;
    },
    filterCount() {
      return this.columns?.filter((e) => e.showFilter).length || 0;
    },
    graphqlFilter() {
      let e = this.filter;
      const n = (t) => {
        this.graphqlError = t;
      };
      return Zd(e, this.columns, n);
    },
    rowsWithComputed() {
      return this.tableMetadata ? Cs(this.dataRows, this.tableMetadata) : [];
    }
  },
  methods: {
    convertRowToPrimaryKey: Zt,
    setSearchTerms(e) {
      this.searchTerms = e, this.$emit("searchTerms", e), this.reload();
    },
    taskUpdated(e) {
      ["COMPLETED", "ERROR"].includes(e.status) && (this.success = !0, this.taskDone = !0, this.reload());
    },
    async handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = await n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    async handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = await e, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      this.isDeleteModalShown = !1, await this.client?.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError) && this.reload();
    },
    async handelExecuteDeleteAll() {
      await this.client.deleteAllTableData(this.tableMetadata?.id).then((e) => {
        e.data.data.truncate.taskId ? (this.taskId = e.data.data.truncate.taskId, this.isTaskModalShown = !0, this.isDeleteAllModalShown = !1) : (this.success = e.data.data.truncate.message, this.loading = !1);
      }).catch((e) => {
        this.isDeleteAllModalShown = !1, this.handleError(e);
      });
    },
    handleCellClick(e) {
      const { column: n, cellValue: t } = e, o = [t].flat();
      Ci(n?.columnType) && (this.refSideModalProps = {
        column: n,
        rows: o
      });
    },
    setView(e) {
      this.view = e.id, e.limitOverride ? this.limit = e.limitOverride : this.limit = this.showLimit, this.page = 1, this.$emit("updateShowView", e.id, this.limit), this.reload();
    },
    onColumnClick(e) {
      const n = this.orderByColumn;
      let t = this.order;
      n !== e.id ? t = "ASC" : t === "ASC" ? t = "DESC" : t = "ASC", this.order = t, this.orderByColumn = e.id, this.$emit("updateShowOrder", {
        direction: t,
        column: e.id
      }), this.reload();
    },
    emitColumns(e) {
      this.columns = e, this.$emit("updateShowColumns", Sa(this.columns, "showColumn"));
    },
    emitFilters(e) {
      this.columns = e, this.$emit("updateShowFilters", Sa(e, "showFilter"));
    },
    emitConditions() {
      this.page = 1, this.$emit("updateConditions", this.columns), this.reload();
    },
    setPage(e) {
      this.page = e, this.$emit("updateShowPage", e), this.reload();
    },
    setLimit(e) {
      this.limit = parseInt(e), (!Number.isInteger(this.limit) || this.limit < 1) && (this.limit = 20), this.page = 1, this.$emit("updateShowLimit", e), this.reload();
    },
    handleError(e) {
      if (Array.isArray(e?.response?.data?.errors)) {
        const n = e.response.data.errors[0].message;
        n.includes("FieldUndefined") ? this.graphqlError = "This table contains a reference to data you don't have permission to view. Contact your administrator to request access." : this.graphqlError = n;
      } else
        this.graphqlError = e;
      this.loading = !1;
    },
    setTableMetadata(e) {
      this.columns = e.columns.map((n) => {
        const t = this.showColumns.length ? this.showColumns.includes(n.id) : !n.id.startsWith("mg_"), o = gF(
          n.columnType,
          this.urlConditions[n.id]
        );
        return {
          ...n,
          showColumn: t,
          showFilter: this.showFilters.includes(n.id),
          conditions: o
        };
      }), e.settings?.forEach((n) => {
        n.key === "cardTemplate" ? this.cardTemplate = n.value : n.key === "recordTemplate" && (this.recordTemplate = n.value);
      }), this.tableMetadata = e;
    },
    async reloadMetadata() {
      this.client = We.newClient(this.schemaId);
      const e = await this.client.fetchTableMetaData(this.tableId).catch(this.handleError);
      this.setTableMetadata(e), this.canView && this.reload();
    },
    async reload() {
      if (!this.canView) return;
      this.loading = !0, this.graphqlError = "";
      const e = this.limit * (this.page - 1), n = this.orderByColumn ? { [this.orderByColumn]: this.order } : {}, t = await this.client.fetchTableData(this.tableId, {
        limit: this.limit,
        offset: e,
        filter: this.graphqlFilter,
        searchTerms: this.searchTerms,
        orderby: n
      }).catch(this.handleError);
      this.dataRows = t[this.tableId], this.count = t[this.tableId + "_agg"].count, this.loading = !1;
    }
  },
  mounted: async function() {
    await this.reloadMetadata();
  },
  emits: [
    "updateShowFilters",
    "rowClick",
    "updateShowLimit",
    "updateShowPage",
    "updateConditions",
    "updateShowColumns",
    "updateShowOrder",
    "updateShowView",
    "searchTerms"
  ]
};
function Sa(e, n) {
  return e.filter(
    (t) => (
      //@ts-ignore TODO: remove column input modification in TableMolgenis
      t[n] && t.columnType !== "HEADING" && t.columnType !== "SECTION"
    )
  ).map((t) => t.id);
}
function gF(e, n) {
  if (n)
    switch (e) {
      case "REF":
      case "REF_ARRAY":
      case "REFBACK":
      case "ONTOLOGY":
      case "ONTOLOGY_ARRAY":
      case "RADIO":
      case "SELECT":
      case "MULTISELECT":
      case "CHECKBOX":
        return JSON.parse(n);
      case "DATE":
      case "DATETIME":
      case "INT":
      case "LONG":
      case "DECIMAL":
        return n.split(",").map((t) => t.split(".."));
      default:
        return n.split(",");
    }
  else
    return [];
}
const yF = { key: 0 }, KF = { key: 1 }, bF = { key: 2 }, vF = { class: "btn-toolbar mb-3" }, CF = { class: "btn-group" }, wF = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, FF = { key: 0 }, RF = { key: 0 }, kF = { key: 2 }, UF = ["onClick"], EF = {
  key: 2,
  class: "btn-group m-0"
}, SF = {
  key: 3,
  class: "btn-group"
}, TF = { class: "d-flex" }, IF = {
  key: 0,
  class: "col-3 pl-0"
}, DF = { key: 0 }, OF = { key: 1 };
function _F(e, n, t, o, i, r) {
  const a = b("MessageError"), s = b("ShowHide"), u = b("IconAction"), d = b("ButtonAlt"), f = b("ButtonDropdown"), K = b("InputSearch"), w = b("Pagination"), k = b("InputSelect"), y = b("SelectionBox"), m = b("TableSettings"), g = b("IconDanger"), I = b("FilterSidebar"), x = b("FilterWells"), E = b("Spinner"), _ = b("AggregateTable"), q = b("RecordCards"), V = b("RowButton"), L = b("TableMolgenis"), $ = b("EditModal"), J = b("ConfirmModal"), W = b("Task"), se = b("LayoutModal"), fe = b("RefSideModal");
  return i.tableMetadata ? (l(), c("div", yF, [
    i.graphqlError ? (l(), F(a, { key: 0 }, {
      default: C(() => [
        B(U(i.graphqlError), 1)
      ]),
      _: 1
    })) : v("", !0),
    t.showHeader && i.tableMetadata ? (l(), c("h1", KF, U(i.tableMetadata.label), 1)) : v("", !0),
    t.showHeader && i.tableMetadata ? (l(), c("p", bF, U(i.tableMetadata.label), 1)) : v("", !0),
    p("div", vF, [
      p("div", CF, [
        D(s, {
          columns: i.columns,
          "onUpdate:columns": r.emitFilters,
          checkAttribute: "showFilter",
          exclude: ["HEADING", "FILE", "SECTION"],
          label: "filters",
          icon: "filter"
        }, null, 8, ["columns", "onUpdate:columns"]),
        i.view !== r.View.AGGREGATE ? (l(), F(s, {
          key: 0,
          columns: i.columns,
          "onUpdate:columns": r.emitColumns,
          checkAttribute: "showColumn",
          exclude: ["HEADING", "SECTION"],
          label: "columns",
          icon: "columns",
          id: "showColumn",
          defaultValue: !0
        }, null, 8, ["columns", "onUpdate:columns"])) : v("", !0),
        t.canView ? (l(), F(f, {
          key: 1,
          label: "download",
          icon: "download"
        }, {
          default: C((j) => [
            p("form", wF, [
              D(u, {
                icon: "times",
                onClick: j.close,
                class: "float-right"
              }, null, 8, ["onClick"]),
              n[33] || (n[33] = p("h6", null, "download", -1)),
              p("div", null, [
                p("div", null, [
                  n[20] || (n[20] = p("span", { class: "fixed-width" }, "zip", -1)),
                  D(d, {
                    href: "/" + t.schemaId + "/api/zip/" + t.tableId
                  }, {
                    default: C(() => [...n[19] || (n[19] = [
                      B(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[24] || (n[24] = p("span", { class: "fixed-width" }, "csv", -1)),
                  D(d, {
                    href: "/" + t.schemaId + "/api/csv/" + t.tableId
                  }, {
                    default: C(() => [...n[21] || (n[21] = [
                      B(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (l(), c("span", FF, [
                    n[23] || (n[23] = B(" | ", -1)),
                    D(d, {
                      href: "/" + t.schemaId + "/api/csv/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: C(() => [...n[22] || (n[22] = [
                        B(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : v("", !0)
                ]),
                p("div", null, [
                  n[28] || (n[28] = p("span", { class: "fixed-width" }, "excel", -1)),
                  D(d, {
                    href: "/" + t.schemaId + "/api/excel/" + t.tableId
                  }, {
                    default: C(() => [...n[25] || (n[25] = [
                      B("all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (l(), c("span", RF, [
                    n[27] || (n[27] = B(" | ", -1)),
                    D(d, {
                      href: "/" + t.schemaId + "/api/excel/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: C(() => [...n[26] || (n[26] = [
                        B(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : v("", !0)
                ]),
                p("div", null, [
                  n[30] || (n[30] = p("span", { class: "fixed-width" }, "jsonld", -1)),
                  D(d, {
                    href: "/" + t.schemaId + "/api/jsonld/" + t.tableId
                  }, {
                    default: C(() => [...n[29] || (n[29] = [
                      B(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[32] || (n[32] = p("span", { class: "fixed-width" }, "ttl", -1)),
                  D(d, {
                    href: "/" + t.schemaId + "/api/ttl/" + t.tableId
                  }, {
                    default: C(() => [...n[31] || (n[31] = [
                      B(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ])
              ])
            ])
          ]),
          _: 1
        })) : v("", !0),
        t.canView ? (l(), c("span", kF, [
          D(f, {
            closeOnClick: !0,
            label: r.ViewButtons[i.view].label,
            icon: r.ViewButtons[i.view].icon
          }, {
            default: C(() => [
              (l(!0), c(te, null, oe(r.ViewButtons, (j) => (l(), c("div", {
                class: "dropdown-item",
                onClick: (ye) => r.setView(j),
                role: "button"
              }, [
                p("i", {
                  class: G(["fas fa-fw", "fa-" + j.icon])
                }, null, 2),
                B(" " + U(j.label), 1)
              ], 8, UF))), 256))
            ]),
            _: 1
          }, 8, ["label", "icon"])
        ])) : v("", !0)
      ]),
      t.canView ? (l(), F(K, {
        key: 0,
        class: "mx-1 inline-form-group",
        id: "explorer-table-search" + Date.now(),
        modelValue: i.searchTerms,
        "onUpdate:modelValue": n[0] || (n[0] = (j) => r.setSearchTerms(j))
      }, null, 8, ["id", "modelValue"])) : v("", !0),
      i.view !== r.View.AGGREGATE ? (l(), F(w, {
        key: 1,
        modelValue: i.page,
        "onUpdate:modelValue": n[1] || (n[1] = (j) => r.setPage(j)),
        limit: i.limit,
        count: i.count
      }, null, 8, ["modelValue", "limit", "count"])) : v("", !0),
      i.view !== r.View.RECORD && i.view !== r.View.AGGREGATE ? (l(), c("div", EF, [
        n[34] || (n[34] = p("span", { class: "btn" }, "Rows per page:", -1)),
        D(k, {
          id: "explorer-table-page-limit-select",
          modelValue: i.limit,
          options: [10, 20, 50, 100],
          clear: !1,
          required: !0,
          "onUpdate:modelValue": n[2] || (n[2] = (j) => r.setLimit(j)),
          class: "mb-0"
        }, null, 8, ["modelValue"]),
        t.showSelect ? (l(), F(y, {
          key: 0,
          selection: i.selectedItems,
          "onUpdate:selection": n[3] || (n[3] = (j) => i.selectedItems = j)
        }, null, 8, ["selection"])) : v("", !0)
      ])) : v("", !0),
      t.canManage ? (l(), c("div", SF, [
        i.tableMetadata ? (l(), F(m, {
          key: 0,
          tableMetadata: i.tableMetadata,
          schemaId: t.schemaId,
          "onUpdate:settings": r.reloadMetadata
        }, null, 8, ["tableMetadata", "schemaId", "onUpdate:settings"])) : v("", !0),
        D(g, {
          icon: "bomb",
          onClick: n[4] || (n[4] = (j) => i.isDeleteAllModalShown = !0)
        }, {
          default: C(() => [...n[35] || (n[35] = [
            B(" Delete All ", -1)
          ])]),
          _: 1
        })
      ])) : v("", !0)
    ]),
    p("div", TF, [
      r.filterCount ? (l(), c("div", IF, [
        D(I, {
          filters: i.columns,
          onUpdateFilters: r.emitConditions,
          schemaId: t.schemaId
        }, null, 8, ["filters", "onUpdateFilters", "schemaId"])
      ])) : v("", !0),
      p("div", {
        class: G(["flex-grow-1 pr-0 pl-0", r.filterCount ? "col-9" : "col-12"])
      }, [
        D(x, {
          filters: i.columns,
          onUpdateFilters: r.emitConditions,
          class: "border-top pt-3 pb-3"
        }, null, 8, ["filters", "onUpdateFilters"]),
        i.loading ? (l(), c("div", DF, [
          D(E)
        ])) : v("", !0),
        i.loading ? v("", !0) : (l(), c("div", OF, [
          i.view === r.View.AGGREGATE ? (l(), F(_, {
            key: 0,
            canView: t.canView,
            allColumns: i.columns,
            tableId: t.tableId,
            schemaId: t.schemaId,
            minimumValue: 1,
            graphqlFilter: r.graphqlFilter
          }, null, 8, ["canView", "allColumns", "tableId", "schemaId", "graphqlFilter"])) : v("", !0),
          i.view === r.View.CARDS ? (l(), F(q, {
            key: 1,
            class: "card-columns",
            id: "cards",
            data: r.rowsWithComputed,
            columns: i.columns,
            tableId: t.tableId,
            canUpdate: t.canUpdate,
            canDelete: t.canDelete,
            template: i.cardTemplate,
            onClick: n[5] || (n[5] = (j) => e.$emit("rowClick", j)),
            onReload: r.reload,
            onEdit: n[6] || (n[6] = (j) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(j, i.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[7] || (n[7] = (j) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(j, i.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canUpdate", "canDelete", "template", "onReload"])) : v("", !0),
          i.view === r.View.RECORD ? (l(), F(q, {
            key: 2,
            id: "records",
            data: r.rowsWithComputed,
            columns: i.columns,
            tableId: t.tableId,
            canEdit: t.canEdit,
            template: i.recordTemplate,
            onClick: n[8] || (n[8] = (j) => e.$emit("rowClick", j)),
            onReload: r.reload,
            onEdit: n[9] || (n[9] = (j) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(j, i.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[10] || (n[10] = (j) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(j, i.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canEdit", "template", "onReload"])) : v("", !0),
          i.view === r.View.TABLE ? (l(), F(L, {
            key: 3,
            schemaId: t.schemaId,
            selection: i.selectedItems,
            "onUpdate:selection": n[12] || (n[12] = (j) => i.selectedItems = j),
            columns: i.columns,
            "onUpdate:columns": n[13] || (n[13] = (j) => i.columns = j),
            "table-metadata": i.tableMetadata,
            data: r.rowsWithComputed,
            showSelect: t.showSelect,
            onColumnClick: r.onColumnClick,
            onRowClick: n[14] || (n[14] = (j) => e.$emit("rowClick", j)),
            onCellClick: r.handleCellClick
          }, {
            header: C(() => [
              p("label", null, U(i.count) + " records found", 1)
            ]),
            rowcolheader: C(() => [
              t.canInsert ? (l(), F(V, {
                key: 0,
                type: "add",
                tableId: t.tableId,
                schemaId: t.schemaId,
                onAdd: n[11] || (n[11] = (j) => r.handleRowAction("add")),
                class: "d-inline p-0"
              }, null, 8, ["tableId", "schemaId"])) : v("", !0),
              H(e.$slots, "rowcolheader", {}, void 0, !0)
            ]),
            colheader: C((j) => [
              j.col && i.orderByColumn === j.col.id ? (l(), F(u, {
                key: 0,
                icon: i.order === "ASC" ? "sort-alpha-down" : "sort-alpha-up",
                class: "d-inline p-0"
              }, null, 8, ["icon"])) : v("", !0)
            ]),
            rowheader: C((j) => [
              t.canUpdate ? (l(), F(V, {
                key: 0,
                type: "edit",
                onEdit: (ye) => r.handleRowAction(
                  "edit",
                  r.convertRowToPrimaryKey(
                    j.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onEdit"])) : v("", !0),
              t.canInsert ? (l(), F(V, {
                key: 1,
                type: "clone",
                onClone: (ye) => r.handleRowAction(
                  "clone",
                  r.convertRowToPrimaryKey(
                    j.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onClone"])) : v("", !0),
              t.canDelete ? (l(), F(V, {
                key: 2,
                type: "delete",
                onDelete: (ye) => r.handleDeleteRowRequest(
                  r.convertRowToPrimaryKey(
                    j.row,
                    i.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onDelete"])) : v("", !0),
              H(e.$slots, "rowheader", {
                row: j.row,
                metadata: i.tableMetadata,
                rowKey: r.convertRowToPrimaryKey(
                  j.row,
                  i.tableMetadata.id,
                  t.schemaId
                )
              }, void 0, !0)
            ]),
            _: 3
          }, 8, ["schemaId", "selection", "columns", "table-metadata", "data", "showSelect", "onColumnClick", "onCellClick"])) : v("", !0)
        ]))
      ], 2)
    ]),
    i.isEditModalShown ? (l(), F($, {
      key: 3,
      isModalShown: !0,
      id: t.tableId + "-edit-modal",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      pkey: i.editRowPrimaryKey,
      clone: i.editMode === "clone",
      schemaId: t.schemaId,
      tablePermissions: t.tablePermissions,
      onClose: r.handleModalClose,
      "apply-default-values": i.editMode === "add"
    }, null, 8, ["id", "tableId", "tableLabel", "pkey", "clone", "schemaId", "tablePermissions", "onClose", "apply-default-values"])) : v("", !0),
    i.isDeleteModalShown ? (l(), F(J, {
      key: 4,
      title: "Delete from " + i.tableMetadata.label,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      pkey: i.editRowPrimaryKey,
      onClose: n[15] || (n[15] = (j) => i.isDeleteModalShown = !1),
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLabel", "pkey", "onConfirmed"])) : v("", !0),
    i.isDeleteAllModalShown ? (l(), F(J, {
      key: 5,
      title: "Truncate " + i.tableMetadata.label,
      actionLabel: "Truncate",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: i.tableMetadata.label,
      onClose: n[16] || (n[16] = (j) => i.isDeleteAllModalShown = !1),
      onConfirmed: r.handelExecuteDeleteAll
    }, {
      default: C(() => [
        p("p", null, [
          n[36] || (n[36] = B(" Truncate ", -1)),
          p("strong", null, U(i.tableMetadata.label), 1)
        ]),
        p("p", null, " Are you sure that you want to delete ALL rows in table '" + U(i.tableMetadata.label) + "'? ", 1)
      ]),
      _: 1
    }, 8, ["title", "tableId", "tableLabel", "onConfirmed"])) : v("", !0),
    i.isTaskModalShown ? (l(), F(se, {
      key: 6,
      title: "Truncating table",
      onClose: n[17] || (n[17] = (j) => i.isTaskModalShown = !1)
    }, {
      body: C(() => [
        D(W, {
          taskId: i.taskId,
          onTaskUpdated: r.taskUpdated
        }, null, 8, ["taskId", "onTaskUpdated"])
      ]),
      _: 1
    })) : v("", !0),
    i.refSideModalProps ? (l(), F(fe, {
      key: 7,
      column: i.refSideModalProps.column,
      rows: i.refSideModalProps.rows,
      schema: t.schemaId,
      onOnClose: n[18] || (n[18] = (j) => i.refSideModalProps = void 0),
      showDataOwner: t.canManage
    }, null, 8, ["column", "rows", "schema", "showDataOwner"])) : v("", !0)
  ])) : v("", !0);
}
const PF = /* @__PURE__ */ P(AF, [["render", _F], ["__scopeId", "data-v-387f39a3"]]), MF = {
  name: "RoutedTableExplorer",
  components: {
    TableExplorer: PF
  },
  data() {
    return {
      allColumns: []
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canInsert: {
      type: Boolean,
      default: () => !1
    },
    canUpdate: {
      type: Boolean,
      default: () => !1
    },
    canDelete: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      default: () => []
    },
    showOrderBy: {
      type: String,
      default: ""
    },
    showOrder: {
      type: String,
      default: "ASC"
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getOrderBy() {
      return this.$route.query._orderBy ? this.$route.query._orderBy : this.showOrderBy;
    },
    getOrder() {
      return this.$route.query._order ? this.$route.query._order : this.showOrder;
    },
    getColumns() {
      return this.$route.query._col ? Array.isArray(this.$route.query._col) ? this.$route.query._col : this.$route.query._col.split(",") : Ve(this.showColumns);
    },
    getFilters() {
      return this.$route.query._filter ? Array.isArray(this.$route.query._filter) ? this.$route.query._filter : this.$route.query._filter.split(",") : Ve(this.showFilters);
    },
    getPage() {
      return this.$route.query._page ? parseInt(this.$route.query._page) : 1;
    },
    getLimit() {
      return this.$route.query._limit ? parseInt(this.$route.query._limit) : 20;
    },
    getView() {
      return this.$route.query._view ? this.$route.query._view : "table";
    },
    getConditions() {
      let e = {};
      return Object.keys(this.$route.query).forEach((n) => {
        n.startsWith("_") || (e[n] = this.$route.query[n]);
      }), e;
    },
    updatePage(e) {
      const n = Object.assign({}, this.$route.query);
      n._page = e, this.updateRoute(n);
    },
    updateOrder(e) {
      const n = Object.assign({}, this.$route.query);
      n._order = e.direction, n._orderBy = e.column, this.updateRoute(n);
    },
    updateView(e, n) {
      const t = Object.assign({}, this.$route.query);
      t._view = e, t._limit = n, delete t._page, this.updateRoute(t);
    },
    updateLimit(e) {
      const n = Object.assign({}, this.$route.query);
      n._limit = e, delete n._page, this.updateRoute(n);
    },
    updateColumns(e) {
      const n = Object.assign({}, this.$route.query);
      e.length ? n._col = e.join(",") : delete n._col, this.updateRoute(n);
    },
    updateAllColumns(e) {
      this.allColumns = e;
    },
    updateFilters(e) {
      const n = Object.assign({}, this.$route.query);
      e.length > 0 ? n._filter = e.join(",") : delete n._filter, this.updateRoute(n);
    },
    updateConditions(e) {
      let n = Object.assign({}, this.$route.query);
      delete n._page, e.forEach((t) => {
        const o = t.conditions;
        if (o?.length)
          switch (t.columnType) {
            case "REF":
            case "REF_ARRAY":
            case "REFBACK":
            case "ONTOLOGY":
            case "ONTOLOGY_ARRAY":
            case "RADIO":
            case "SELECT":
            case "MULTISELECT":
            case "CHECKBOX":
              n[t.id] = JSON.stringify(o);
              break;
            case "DATE":
            case "DATETIME":
            case "INT":
            case "LONG":
            case "DECIMAL":
              const i = o.map((r) => r.join("..")).join(",");
              i !== ".." ? n[t.id] = i : delete n[t.id];
              break;
            default:
              n[t.id] = o.join(",");
          }
        else
          delete n[t.id];
      }), this.updateRoute(n);
    },
    updateRoute(e) {
      JSON.stringify(e) !== JSON.stringify(this.$route.query) && this.$router.push({ query: e });
    }
  },
  emits: ["rowClick"]
};
function NF(e, n, t, o, i, r) {
  const a = b("TableExplorer");
  return l(), c("div", null, [
    D(a, {
      tableId: t.tableId,
      schemaId: t.schemaId,
      canView: t.canView,
      canEdit: t.canEdit,
      canInsert: t.canInsert,
      canUpdate: t.canUpdate,
      canDelete: t.canDelete,
      canManage: t.canManage,
      tablePermissions: t.tablePermissions,
      onUpdateConditions: r.updateConditions,
      onUpdateShowColumns: r.updateColumns,
      onUpdateShowFilters: r.updateFilters,
      onUpdateShowPage: r.updatePage,
      onUpdateShowLimit: r.updateLimit,
      onUpdateShowOrder: r.updateOrder,
      onUpdateShowView: r.updateView,
      showView: r.getView(),
      showColumns: r.getColumns(),
      showFilters: r.getFilters(),
      urlConditions: r.getConditions(),
      showPage: r.getPage(),
      showLimit: r.getLimit(),
      showOrderBy: r.getOrderBy(),
      showOrder: r.getOrder(),
      onRowClick: n[0] || (n[0] = (s) => e.$emit("rowClick", s))
    }, {
      rowcolheader: C(() => [
        H(e.$slots, "rowcolheader")
      ]),
      rowheader: C((s) => [
        H(e.$slots, "rowheader", {
          row: s.row,
          metadata: s.metadata,
          rowKey: s.rowKey
        })
      ]),
      _: 3
    }, 8, ["tableId", "schemaId", "canView", "canEdit", "canInsert", "canUpdate", "canDelete", "canManage", "tablePermissions", "onUpdateConditions", "onUpdateShowColumns", "onUpdateShowFilters", "onUpdateShowPage", "onUpdateShowLimit", "onUpdateShowOrder", "onUpdateShowView", "showView", "showColumns", "showFilters", "urlConditions", "showPage", "showLimit", "showOrderBy", "showOrder"])
  ]);
}
const QR = /* @__PURE__ */ P(MF, [["render", NF]]), BF = {
  name: "RowButtonClone",
  components: { RowButton: Qt, EditModal: br },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function LF(e, n, t, o, i, r) {
  const a = b("RowButton"), s = b("EditModal");
  return l(), c("div", null, [
    D(a, {
      type: "clone",
      onClone: n[0] || (n[0] = (u) => i.isModalShown = !0)
    }),
    i.isModalShown ? (l(), F(s, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      clone: !0,
      isModalShown: i.isModalShown,
      schemaId: t.schemaId,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "onClose"])) : v("", !0)
  ]);
}
const $R = /* @__PURE__ */ P(BF, [["render", LF]]), xF = {
  props: {
    /** the column names */
    columns: Array,
    /** list of rows matching column names */
    rows: Array,
    /** set to create select boxes that will yield this columns value when selected. */
    selectColumn: String,
    /** default value */
    defaultValue: Array
  },
  data: function() {
    return {
      selectedItems: []
    };
  },
  created() {
    Array.isArray(this.defaultValue) ? this.selectedItems = this.defaultValue : this.defaultValue !== null ? this.selectedItems.push(this.defaultValue) : this.selectedItems = [];
  },
  computed: {
    tableHover() {
      return this.selectColumn;
    },
    hasColheader() {
      return this.selectColumn || !!this.$slots.colheader || !!this.$slots.rowheader;
    }
  },
  methods: {
    flattenObject(e) {
      let n = "";
      return e && e.length > 0 && typeof e == "object" ? (Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n.replace(/^\./, "")) : e;
    },
    isSelected(e) {
      return this.selectedItems !== null && this.selectedItems.includes(e[this.selectColumn]);
    },
    toggleSelect(e) {
      this.isSelected(e) ? (this.selectedItems = this.selectedItems.filter(
        (n) => n !== e[this.selectColumn]
      ), this.$emit("deselect", e[this.selectColumn])) : (this.selectedItems.push(e[this.selectColumn]), this.$emit("select", e[this.selectColumn])), this.$emit("update:modelValue", this.selectedItems);
    },
    onRowClick(e) {
      this.$emit("rowClick", e);
    }
  }
}, qF = { class: "table-responsive" }, VF = {
  key: 0,
  scope: "col",
  style: { width: "1px" }
}, jF = { key: 0 }, HF = { style: { display: "flex" } }, GF = ["checked", "onClick"], QF = ["onClick"], $F = {
  key: 0,
  class: "list-unstyled"
}, JF = { key: 1 };
function zF(e, n, t, o, i, r) {
  return l(), c("div", qF, [
    p("table", {
      class: G(["table table-bordered", { "table-hover": r.tableHover }])
    }, [
      p("thead", null, [
        p("tr", null, [
          r.hasColheader ? (l(), c("th", VF, [
            H(e.$slots, "colheader", {}, void 0, !0)
          ])) : v("", !0),
          (l(!0), c(te, null, oe(t.columns, (a) => (l(), c("th", {
            key: a,
            scope: "col"
          }, U(a), 1))), 128))
        ])
      ]),
      p("tbody", null, [
        (l(!0), c(te, null, oe(t.rows, (a) => (l(), c("tr", {
          key: JSON.stringify(a)
        }, [
          r.hasColheader ? (l(), c("td", jF, [
            p("div", HF, [
              t.selectColumn ? (l(), c("input", {
                key: 0,
                class: "form-check form-check-inline mr-1",
                type: "checkbox",
                checked: r.isSelected(a),
                onClick: Ke((s) => r.toggleSelect(a), ["stop"])
              }, null, 8, GF)) : v("", !0),
              H(e.$slots, "rowheader", { row: a }, void 0, !0)
            ])
          ])) : v("", !0),
          (l(!0), c(te, null, oe(t.columns, (s) => (l(), c("td", {
            key: s,
            onClick: (u) => r.onRowClick(a),
            style: { cursor: "pointer" }
          }, [
            Array.isArray(a[s]) ? (l(), c("ul", $F, [
              (l(!0), c(te, null, oe(a[s], (u, d) => (l(), c("li", { key: d }, U(u), 1))), 128))
            ])) : a[s] !== void 0 ? (l(), c("span", JF, U(r.flattenObject(a[s])), 1)) : v("", !0)
          ], 8, QF))), 128))
        ]))), 128))
      ])
    ], 2)
  ]);
}
const JR = /* @__PURE__ */ P(xF, [["render", zF], ["__scopeId", "data-v-3297a3f0"]]), YF = ke({
  name: "TaskList",
  components: {
    MessageError: rt
  },
  data() {
    return {
      loading: !1,
      tasks: [],
      error: null
    };
  },
  methods: {
    retrieveTasks() {
      this.loading = !0, this.error = null, Me("graphql", "{_tasks{id,description,status}}").then((e) => {
        this.tasks = e._tasks, this.loading = !1;
      }).catch((e) => {
        Array.isArray(e.response.errors) ? this.error = e.response.errors[0].message : this.error = e, this.loading = !1;
      });
    }
  },
  mounted() {
    this.retrieveTasks();
  }
}), WF = { class: "table table-bordered" }, XF = ["onClick"];
function ZF(e, n, t, o, i, r) {
  const a = b("MessageError");
  return l(), c("div", null, [
    e.error ? (l(), F(a, { key: 0 }, {
      default: C(() => [
        B(U(e.error), 1)
      ]),
      _: 1
    })) : v("", !0),
    p("table", WF, [
      n[0] || (n[0] = p("thead", null, [
        p("th", { scope: "col" }, "Task Description"),
        p("th", null, "Task Status")
      ], -1)),
      p("tbody", null, [
        (l(!0), c(te, null, oe(e.tasks, (s) => (l(), c("tr", {
          key: s.id
        }, [
          p("td", null, [
            p("button", {
              onClick: Ke((u) => e.$emit("select", s.id), ["prevent", "stop"]),
              type: "button",
              class: "btn btn-link"
            }, U(s.description), 9, XF)
          ]),
          p("td", null, U(s.status), 1)
        ]))), 128))
      ])
    ])
  ]);
}
const eR = /* @__PURE__ */ P(YF, [["render", ZF]]), tR = ke({
  name: "TaskManager",
  components: { Task: yl, TaskList: eR, IconAction: ft },
  data() {
    return {
      selectedTaskId: null
    };
  },
  methods: {
    selectTask(e) {
      this.selectedTaskId = e;
    },
    clearSelection() {
      this.selectedTaskId = null;
    }
  }
}), nR = { key: 0 }, iR = { key: 1 };
function oR(e, n, t, o, i, r) {
  const a = b("IconAction"), s = b("Task"), u = b("TaskList");
  return l(), c("div", null, [
    e.selectedTaskId ? (l(), c("span", nR, [
      p("span", {
        onClick: n[0] || (n[0] = (...d) => e.clearSelection && e.clearSelection(...d))
      }, [
        D(a, { icon: "angle-left" }),
        n[1] || (n[1] = B(" Back to task list ", -1))
      ]),
      n[2] || (n[2] = p("h1", null, "Task details", -1)),
      D(s, { taskId: e.selectedTaskId }, null, 8, ["taskId"])
    ])) : (l(), c("div", iR, [
      n[3] || (n[3] = p("h1", null, "Task list", -1)),
      D(u, { onSelect: e.selectTask }, null, 8, ["onSelect"])
    ]))
  ]);
}
const zR = /* @__PURE__ */ P(tR, [["render", oR]]);
export {
  Ww as AggregateTable,
  nt as ArrayInput,
  vC as Breadcrumb,
  He as ButtonAction,
  ot as ButtonAlt,
  vK as ButtonDanger,
  Kr as ButtonDropdown,
  Bi as ButtonOutline,
  Nh as ButtonSubmit,
  We as Client,
  hr as ConfirmModal,
  UR as ContactDisplay,
  XC as CookieWall,
  sl as DataDisplayCell,
  br as EditModal,
  dr as EmailDisplay,
  al as FileDisplay,
  _A as FilterContainer,
  JK as FilterInput,
  XK as FilterSidebar,
  il as FilterWell,
  rb as FilterWells,
  Ue as FormGroup,
  cv as FormInput,
  xh as FormMolgenis,
  zC as GTag,
  Vm as GridBlock,
  _R as HtmlDropdown,
  cr as HyperlinkDisplay,
  ft as IconAction,
  PR as IconBar,
  ar as IconDanger,
  ER as ImageCard,
  SR as ImageDisplay,
  MR as Info,
  NR as InfoPopover,
  Ib as InlineInput,
  Li as InputBoolean,
  Gh as InputCheckbox,
  xi as InputDate,
  qi as InputDateTime,
  mr as InputDecimal,
  dl as InputEmail,
  fl as InputFile,
  Ne as InputGroup,
  Oo as InputHeading,
  cl as InputHyperlink,
  Ar as InputInt,
  av as InputJson,
  gr as InputLong,
  Ri as InputOntology,
  ty as InputOntologySubtree,
  Xo as InputPassword,
  sr as InputRadio,
  Xs as InputRangeDate,
  hg as InputRangeDateTime,
  Fg as InputRangeDecimal,
  Og as InputRangeInt,
  Vg as InputRangeLong,
  pl as InputRefBack,
  mi as InputRefList,
  Ai as InputRefSelect,
  pr as InputSearch,
  Tn as InputSelect,
  BR as InputSelectInplace,
  yt as InputString,
  Qn as InputText,
  LR as InputTextLocalized,
  TR as KeyValueBlock,
  qR as LayoutCard,
  Zh as LayoutForm,
  vt as LayoutModal,
  IR as LinksList,
  qy as ListDisplay,
  dm as LocaleSwitch,
  rt as MessageError,
  mn as MessageSuccess,
  Wb as MessageWarning,
  VR as Molgenis,
  Th as MolgenisAccount,
  rw as MolgenisFooter,
  hw as MolgenisMenu,
  gm as MolgenisSession,
  Yh as MolgenisSignin,
  nm as MolgenisSignup,
  ur as ObjectDisplay,
  DR as PageHeader,
  ll as Pagination,
  Rm as PersonDetails,
  kR as QueryEMX2,
  $s as ReadMore,
  QR as RoutedTableExplorer,
  Qt as RowButton,
  ol as RowButtonAdd,
  $R as RowButtonClone,
  SK as RowButtonDelete,
  yK as RowButtonEdit,
  Av as RowEdit,
  Kv as RowEditFooter,
  dF as ShowHide,
  jR as ShowMore,
  HR as SimpleModal,
  bt as Spinner,
  rl as StringDisplay,
  t0 as SubTask,
  OR as TableDisplay,
  PF as TableExplorer,
  fr as TableMolgenis,
  JR as TableSimple,
  xw as TableStickyHeaders,
  GR as Tabs,
  yl as Task,
  eR as TaskList,
  zR as TaskManager,
  Ry as TextDisplay,
  Uh as TokenManager,
  fn as Tooltip,
  xR as TooltipComponent,
  _w as VueTemplate,
  jt as applyJsTemplate,
  Tt as constants,
  Ve as deepClone,
  sn as flattenObject,
  Bd as getRowErrors,
  Td as privacyConstants,
  Me as request
};
